var _defs, _g, _path, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109, _g110, _g111, _g112, _g113, _g114, _g115, _g116, _g117, _g118, _g119, _g120, _g121, _g122, _g123, _g124, _g125, _g126, _g127, _g128, _g129, _g130, _g131, _g132, _g133, _g134, _g135, _g136, _g137, _g138, _g139, _g140, _g141, _g142, _g143, _g144, _g145, _g146, _g147, _g148, _g149, _g150, _g151, _g152, _g153, _g154, _g155, _g156, _g157, _g158, _g159, _g160, _g161, _g162, _g163, _g164, _g165, _g166, _g167, _g168, _g169, _g170, _g171, _g172, _g173, _g174, _g175, _g176, _g177, _g178, _g179, _g180, _g181, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path31, _line11, _line12, _line13, _line14, _line15, _path32, _line16, _line17, _line18, _line19, _path33, _line20, _line21, _line22, _line23, _g182, _path34, _g183, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _g184, _path43, _path44, _path45, _path46, _path47, _path48, _g185, _path49, _path50, _path51, _g186, _g187, _g188, _g189, _g190, _g191, _g192, _g193, _g194, _g195, _g196, _g197, _g198, _g199, _g200, _g201, _g202, _g203, _g204, _g205, _g206, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _line24, _line25, _path63, _path64, _path65, _path66, _g207, _g208, _g209, _g210, _g211, _g212, _g213, _g214, _g215, _g216, _g217, _g218, _g219, _g220, _g221, _g222, _g223, _g224, _g225, _g226, _g227, _g228, _g229, _g230, _g231, _g232, _g233, _g234, _g235, _g236, _g237, _g238, _g239, _g240, _g241, _g242, _g243, _g244, _g245, _g246, _g247, _g248, _g249, _g250, _g251, _g252, _g253, _g254, _g255, _g256, _g257, _g258, _g259, _g260, _g261, _g262, _g263, _g264, _g265, _g266, _g267, _g268, _g269, _g270, _g271, _g272, _path67, _path68, _path69, _path70, _path71, _path72, _path73;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferImgeInvite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 257.806,
    height: 279.458,
    viewBox: "0 0 257.806 279.458",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0e279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e5ca53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f956"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffca53"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-8",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-9",
    cx: 0.491,
    cy: 0.575,
    r: 1.091,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-12",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-14",
    cx: 0.491,
    cy: 0.575,
    r: 1.091,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-18",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-19",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-20",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-21",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-23",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-26",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-34",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-36",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-38",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-43",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-45",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-47",
    cx: 0.491,
    cy: 0.575,
    r: 1.091,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-65",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-72",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-94",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-106",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-111",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-146",
    cx: 0.491,
    cy: 0.575,
    r: 1.091,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-147",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-149",
    cx: 0.491,
    cy: 0.575,
    r: 1.091,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-165",
    cx: 0.491,
    cy: 0.575,
    r: 1.091,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-178",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-181",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-182",
    cx: 0.491,
    cy: 0.575,
    r: 1.092,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-184",
    cx: 0.526,
    cy: 0.591,
    r: 0.724,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-187",
    cx: 0.477,
    cy: 0.593,
    r: 0.768,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-189",
    cx: 0.467,
    cy: 0.584,
    r: 0.624,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-190",
    cx: 0.449,
    cy: 0.564,
    r: 0.486,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-193",
    cx: 0.449,
    cy: 0.564,
    r: 0.486,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-194",
    cx: 0.467,
    cy: 0.584,
    r: 0.624,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-217",
    cx: 0.467,
    cy: 0.584,
    r: 0.624,
    xlinkHref: "#radial-gradient-4"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-230",
    cx: 0.467,
    cy: 0.584,
    r: 0.624,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-236",
    cx: 0.474,
    cy: 0.591,
    r: 0.718,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-260",
    cx: 0.551,
    cy: 0.564,
    r: 0.487,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-261",
    cx: 0.533,
    cy: 0.584,
    r: 0.626,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-262",
    cx: 0.533,
    cy: 0.584,
    r: 0.626,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-263",
    cx: 0.551,
    cy: 0.564,
    r: 0.487,
    xlinkHref: "#radial-gradient"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41648",
    "data-name": "Group 41648",
    transform: "translate(0 0)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40508",
    "data-name": "Group 40508",
    transform: "translate(70.764 11.172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72779",
    "data-name": "Path 72779",
    d: "M184.74,109.363l156.919-3.521L344.4,228.06,194.463,193.62Z",
    transform: "translate(-178.192 -105.842)",
    fill: "#8c5d29"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72780",
    "data-name": "Path 72780",
    d: "M310.668,208.5s11.967,2.314,12.5,1.106-3.367-1.685-3.367-1.685l-3.006-.179-2.9-.924s-1.347-.885-.026-1.324,1.047-.4-.372-.778-4.09-.869-4.09-.869l-4.414-1.241",
    transform: "translate(-203.379 -126.108)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72781",
    "data-name": "Path 72781",
    d: "M365.88,211.2a50.911,50.911,0,0,0-5.613-.956c-2.081-.155-5.465,1.362-7.493-.585s-6.3-3.165-6.3-3.165l-3.521-1.8",
    transform: "translate(-211.329 -126.545)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72782",
    "data-name": "Path 72782",
    d: "M350.379,181.5s-15.063-5.146-15.9-6.9-6.623-.212-6.623-.212l-11.692-2.882",
    transform: "translate(-205.719 -119.595)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72783",
    "data-name": "Path 72783",
    d: "M333.914,131.541s-6.721-1.8-6.786-2.331-2.357-1.278-2.357-1.278l-4.849-.312",
    transform: "translate(-206.505 -110.403)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72784",
    "data-name": "Path 72784",
    d: "M377.256,243.692s-6.087-1.446-8.387-1.161-4.508,4.679-7.162,4.32-8.212-5.305-8.212-5.305",
    transform: "translate(-213.537 -134.264)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72785",
    "data-name": "Path 72785",
    d: "M271.118,126.224s-15.085-8.646-18.436-7.407a13.18,13.18,0,0,1-6.162.762l-3.564-1.414-1.689-3.478-2.335-.557",
    transform: "translate(-189.542 -107.578)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72786",
    "data-name": "Path 72786",
    d: "M315.51,222.359s-19.764-6.487-22.657-6.542-9.972-1.749-9.972-1.749l-3.793-.67-3.382-.682L272.595,212",
    transform: "translate(-196.593 -128.077)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72787",
    "data-name": "Path 72787",
    d: "M302.287,176.669s-15.3-4.792-11.688-1.723-.073,3.178-.073,3.178l-4.7-4.159-7.989-3.89",
    transform: "translate(-197.692 -119.295)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72788",
    "data-name": "Path 72788",
    d: "M251.383,164.891s-4.059-.6-7.694-1.109",
    transform: "translate(-190.539 -117.977)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72789",
    "data-name": "Path 72789",
    d: "M227.852,158.845s-11.281-.118-14.175.929",
    transform: "translate(-184.253 -116.942)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72790",
    "data-name": "Path 72790",
    d: "M338.792,195.5s-11.449-1.47-14.866-1.322",
    transform: "translate(-207.344 -124.342)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72791",
    "data-name": "Path 72791",
    d: "M290.541,207.431s-17.056-11.082-19.172-14.941",
    transform: "translate(-196.336 -123.99)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72792",
    "data-name": "Path 72792",
    d: "M223.5,203.944s-4.192-1.68-7.581-3.527a37.67,37.67,0,0,0-5.944-2.508c-1.528-.691-4.952-1.711-4.952-1.711",
    transform: "translate(-182.441 -124.767)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72793",
    "data-name": "Path 72793",
    d: "M224.039,180.137s11.114,3.471,9.111,2.842S231.6,186,231.6,186l3.519-.435,5.758,2.123a2.754,2.754,0,0,0,1.829,3.68",
    transform: "translate(-186.423 -121.403)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72794",
    "data-name": "Path 72794",
    d: "M306.593,156.153s-10.351-.368-14-1.568a72.513,72.513,0,0,1-9.843-4.758",
    transform: "translate(-198.719 -115.054)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72795",
    "data-name": "Path 72795",
    d: "M258.882,210.061s9.33,4.342,6.623,4.678-2.625,1.12-2.433,2.622.077.554,1.689,2.484.46,4,2.489,4.708,7.46,2.527,7.46,2.527",
    transform: "translate(-193.721 -127.67)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72796",
    "data-name": "Path 72796",
    d: "M205.053,128.19s7.8,1.922,7.506,2.92-1.893.234-1.893.234-4.9.364-3.467.856,3.683,1.866,2.136,1.645-6.077-2.41-6.077-2.41a2.083,2.083,0,0,1-1.814-1.323,6.884,6.884,0,0,0-1.633-2.1s3.821.9,2.4.527",
    transform: "translate(-181.349 -110.486)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72797",
    "data-name": "Path 72797",
    d: "M255.844,141.224s-3.822-.923-6.6-.029-.523,2.444-4.363,1.386-7.32-5.851-7.32-5.851",
    transform: "translate(-189.256 -112.311)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72798",
    "data-name": "Path 72798",
    d: "M311.732,132.133s-7.554-4.424-10.343-5.317",
    transform: "translate(-202.624 -110.235)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_61",
    "data-name": "Line 61",
    x1: 5.201,
    y1: 0.946,
    transform: "translate(67.806 58.753)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_62",
    "data-name": "Line 62",
    x1: 2.63,
    y1: 2.697,
    transform: "translate(70.126 50.85)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_63",
    "data-name": "Line 63",
    x1: 3.765,
    y1: 1.27,
    transform: "translate(50.911 55.475)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_64",
    "data-name": "Line 64",
    x1: 3.707,
    y1: 0.765,
    transform: "translate(66.275 74.232)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_65",
    "data-name": "Line 65",
    x1: 7.617,
    y1: 1.876,
    transform: "translate(101.128 99.468)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_66",
    "data-name": "Line 66",
    x1: 5.855,
    y1: 3.465,
    transform: "translate(112.525 42.585)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_67",
    "data-name": "Line 67",
    x1: 7.366,
    y2: 0.087,
    transform: "translate(82.17 43.16)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_68",
    "data-name": "Line 68",
    x1: 2.54,
    y1: 4.427,
    transform: "translate(43.036 26.238)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_69",
    "data-name": "Line 69",
    x1: 3.385,
    y1: 1.814,
    transform: "translate(40.059 7.727)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_70",
    "data-name": "Line 70",
    x1: 3.033,
    y1: 1.195,
    transform: "translate(133.395 97.602)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72799",
    "data-name": "Path 72799",
    d: "M338.711,239.775s-6.388-3.331-7.351-4.449",
    transform: "translate(-208.901 -132.962)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_71",
    "data-name": "Line 71",
    x1: 7.425,
    y1: 0.044,
    transform: "translate(146.274 89.937)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_72",
    "data-name": "Line 72",
    x1: 6.116,
    y1: 2.232,
    transform: "translate(141.281 66.784)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_73",
    "data-name": "Line 73",
    x1: 8.144,
    y1: 2.9,
    transform: "translate(146.755 52.17)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_74",
    "data-name": "Line 74",
    x2: 5.894,
    y2: 0.438,
    transform: "translate(135.765 22.027)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_75",
    "data-name": "Line 75",
    x1: 4.812,
    y1: 0.574,
    transform: "translate(16.232 28.384)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72800",
    "data-name": "Path 72800",
    d: "M204.976,165.78a22.966,22.966,0,0,0-4.1-3.135",
    transform: "translate(-181.572 -117.739)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_76",
    "data-name": "Line 76",
    x1: 6.992,
    y1: 3.207,
    transform: "translate(18.435 62.726)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_77",
    "data-name": "Line 77",
    x1: 4.921,
    y1: 1.453,
    transform: "translate(19.705 6.629)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_78",
    "data-name": "Line 78",
    x1: 11.053,
    y1: 3.366,
    transform: "translate(36.421 87.643)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_79",
    "data-name": "Line 79",
    x2: 157.54,
    y2: 24.24,
    transform: "translate(6.733 11.711)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_80",
    "data-name": "Line 80",
    x1: 164.509,
    y1: 31.265,
    transform: "translate(0 28.228)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x1: 164.731,
    y1: 37.898,
    transform: "translate(0.616 45.963)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x1: 164.214,
    y1: 37.626,
    transform: "translate(1.534 64.045)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72801",
    "data-name": "Path 72801",
    d: "M258.408,302.931,87.492,243.688l88.449-32.714,151.243,37.142Z",
    transform: "translate(-87.06 -116.689)",
    fill: "#9a662d"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40512",
    "data-name": "Group 40512",
    transform: "translate(176.547 118.097)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40510",
    "data-name": "Group 40510",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_83",
    "data-name": "Line 83",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40509",
    "data-name": "Group 40509",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72802",
    "data-name": "Path 72802",
    d: "M328.966,249.3,314.338,243.7l-3.131-1.2-.87,2.273c-.673,1.76,3.457,4.974,9.227,7.181s10.99,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-310.266 -242.502)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72803",
    "data-name": "Path 72803",
    d: "M332.328,250.2c-.674,1.759-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.182,5.894-1.395,11.663.811S333,248.441,332.328,250.2Z",
    transform: "translate(-310.497 -241.094)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72804",
    "data-name": "Path 72804",
    d: "M316.336,241.665s-4.422-.31-4.323,1.086,6.559,5.2,6.865,5.177c0,0-6.471-3.794-6.432-5.1S316.336,241.665,316.336,241.665Z",
    transform: "translate(-310.632 -241.208)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40511",
    "data-name": "Group 40511",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72805",
    "data-name": "Path 72805",
    d: "M335.358,250.681c.67-1.759-3.458-4.976-9.227-7.181-.1-.037-.2-.07-.3-.108a66.145,66.145,0,0,1,4.9,8.3C333.217,251.974,334.984,251.653,335.358,250.681Z",
    transform: "translate(-325.836 -243.392)",
    fill: "#ffee2f"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40516",
    "data-name": "Group 40516",
    transform: "translate(158.42 117.618)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40514",
    "data-name": "Group 40514",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40513",
    "data-name": "Group 40513",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72806",
    "data-name": "Path 72806",
    d: "M290.977,243.766l15.535,1.973,3.327.421-.307,2.415c-.238,1.867-5.4,2.751-11.525,1.974s-10.9-2.925-10.663-4.792l.307-2.413Z",
    transform: "translate(-287.336 -243.344)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72807",
    "data-name": "Path 72807",
    d: "M287.733,242.746c-.238,1.868,4.537,4.014,10.664,4.792s11.288-.108,11.524-1.976-4.537-4.013-10.665-4.79S287.97,240.879,287.733,242.746Z",
    transform: "translate(-287.418 -240.489)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72808",
    "data-name": "Path 72808",
    d: "M309.5,243.331s4.044,1.814,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.291,8.078-1.459S309.5,243.331,309.5,243.331Z",
    transform: "translate(-290.89 -241.084)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40515",
    "data-name": "Group 40515",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72809",
    "data-name": "Path 72809",
    d: "M287.733,242.746c.237-1.867,5.4-2.754,11.523-1.974.105.013.206.03.311.043a66.387,66.387,0,0,0-8.239,5.007C289.009,244.9,287.6,243.78,287.733,242.746Z",
    transform: "translate(-287.724 -240.489)",
    fill: "#ffee2f"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40520",
    "data-name": "Group 40520",
    transform: "translate(189.612 136.894)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40518",
    "data-name": "Group 40518",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 0.305,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40517",
    "data-name": "Group 40517",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72810",
    "data-name": "Path 72810",
    d: "M330.432,268.148l15.535,1.972,3.327.421-.307,2.415c-.238,1.868-5.4,2.752-11.523,1.975s-10.9-2.925-10.663-4.792l.305-2.414Z",
    transform: "translate(-326.792 -267.726)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72811",
    "data-name": "Path 72811",
    d: "M327.187,267.128c-.236,1.867,4.537,4.015,10.665,4.792s11.286-.107,11.522-1.976-4.537-4.013-10.665-4.79S327.424,265.259,327.187,267.128Z",
    transform: "translate(-326.873 -264.871)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72812",
    "data-name": "Path 72812",
    d: "M348.96,267.713s4.044,1.817,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.292,8.076-1.46S348.96,267.713,348.96,267.713Z",
    transform: "translate(-330.346 -265.466)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40519",
    "data-name": "Group 40519",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72813",
    "data-name": "Path 72813",
    d: "M327.187,267.128c.237-1.869,5.4-2.753,11.523-1.974.107.013.207.029.311.044a66.177,66.177,0,0,0-8.238,5.006C328.464,269.28,327.056,268.161,327.187,267.128Z",
    transform: "translate(-327.178 -264.871)",
    fill: "#ffee2f"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40524",
    "data-name": "Group 40524",
    transform: "translate(198.784 130.254)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40522",
    "data-name": "Group 40522",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40521",
    "data-name": "Group 40521",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72814",
    "data-name": "Path 72814",
    d: "M342.035,259.749l15.535,1.973,3.327.422-.307,2.414c-.236,1.868-5.395,2.752-11.524,1.974s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-338.394 -259.328)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72815",
    "data-name": "Path 72815",
    d: "M338.79,258.73c-.236,1.868,4.537,4.014,10.665,4.791s11.287-.106,11.525-1.974-4.539-4.013-10.665-4.792S339.028,256.861,338.79,258.73Z",
    transform: "translate(-338.475 -256.472)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72816",
    "data-name": "Path 72816",
    d: "M360.562,259.315s4.045,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.076-1.459S360.562,259.315,360.562,259.315Z",
    transform: "translate(-341.949 -257.068)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40523",
    "data-name": "Group 40523",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72817",
    "data-name": "Path 72817",
    d: "M338.79,258.73c.238-1.869,5.4-2.754,11.524-1.975.105.014.206.03.311.045a66.254,66.254,0,0,0-8.24,5.007C340.067,260.882,338.658,259.764,338.79,258.73Z",
    transform: "translate(-338.781 -256.472)",
    fill: "#ffdf2f"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40528",
    "data-name": "Group 40528",
    transform: "translate(178.446 130.639)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40526",
    "data-name": "Group 40526",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_87",
    "data-name": "Line 87",
    x1: 0.868,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40525",
    "data-name": "Group 40525",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72818",
    "data-name": "Path 72818",
    d: "M331.367,265.162l-14.626-5.6-3.131-1.2-.87,2.273c-.674,1.759,3.457,4.973,9.226,7.181s10.99,2.568,11.663.812l.868-2.272Z",
    transform: "translate(-312.669 -258.367)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72819",
    "data-name": "Path 72819",
    d: "M334.728,266.065c-.672,1.757-5.894,1.4-11.663-.812s-9.9-5.422-9.224-7.181,5.9-1.395,11.661.813S335.4,264.306,334.728,266.065Z",
    transform: "translate(-312.899 -256.959)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72820",
    "data-name": "Path 72820",
    d: "M318.739,257.53s-4.424-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.47-3.795-6.43-5.1S318.739,257.53,318.739,257.53Z",
    transform: "translate(-313.034 -257.073)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40527",
    "data-name": "Group 40527",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72821",
    "data-name": "Path 72821",
    d: "M337.759,266.547c.673-1.759-3.455-4.977-9.226-7.181-.1-.039-.2-.072-.294-.109a66.536,66.536,0,0,1,4.9,8.3C335.617,267.84,337.387,267.519,337.759,266.547Z",
    transform: "translate(-328.239 -259.257)",
    fill: "#ffee2f"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40532",
    "data-name": "Group 40532",
    transform: "translate(160.319 130.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40530",
    "data-name": "Group 40530",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_88",
    "data-name": "Line 88",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40529",
    "data-name": "Group 40529",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72822",
    "data-name": "Path 72822",
    d: "M293.38,259.631l15.535,1.973,3.326.421-.306,2.414c-.238,1.867-5.4,2.752-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-289.739 -259.208)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72823",
    "data-name": "Path 72823",
    d: "M290.135,258.61c-.236,1.869,4.537,4.015,10.665,4.792s11.288-.106,11.523-1.975-4.537-4.014-10.664-4.792S290.373,256.743,290.135,258.61Z",
    transform: "translate(-289.82 -256.353)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72824",
    "data-name": "Path 72824",
    d: "M311.907,259.2s4.044,1.815,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.078-1.459S311.907,259.2,311.907,259.2Z",
    transform: "translate(-293.293 -256.949)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40531",
    "data-name": "Group 40531",
    transform: "translate(0.306 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72825",
    "data-name": "Path 72825",
    d: "M290.135,258.61c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.045a66.364,66.364,0,0,0-8.24,5.006C291.412,260.762,290,259.645,290.135,258.61Z",
    transform: "translate(-290.126 -256.353)",
    fill: "#ffee2f"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40536",
    "data-name": "Group 40536",
    transform: "translate(169.491 123.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40534",
    "data-name": "Group 40534",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_89",
    "data-name": "Line 89",
    x1: 0.308,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40533",
    "data-name": "Group 40533",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72826",
    "data-name": "Path 72826",
    d: "M304.982,251.233l15.537,1.974,3.326.42-.306,2.414c-.238,1.869-5.4,2.753-11.525,1.974s-10.9-2.923-10.664-4.792l.308-2.413Z",
    transform: "translate(-301.341 -250.811)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72827",
    "data-name": "Path 72827",
    d: "M301.739,250.213c-.238,1.868,4.537,4.014,10.663,4.792s11.288-.108,11.525-1.976-4.537-4.012-10.665-4.791S301.977,248.345,301.739,250.213Z",
    transform: "translate(-301.423 -247.955)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72828",
    "data-name": "Path 72828",
    d: "M323.51,250.8s4.045,1.814,3.3,3-8.232,1.483-8.494,1.323c0,0,7.5-.29,8.078-1.459S323.51,250.8,323.51,250.8Z",
    transform: "translate(-304.896 -248.551)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40535",
    "data-name": "Group 40535",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72829",
    "data-name": "Path 72829",
    d: "M301.739,250.213c.238-1.868,5.4-2.754,11.522-1.975.105.013.207.031.311.045a66.645,66.645,0,0,0-8.24,5.006C303.015,252.365,301.607,251.246,301.739,250.213Z",
    transform: "translate(-301.73 -247.955)",
    fill: "#ffdf2f"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40540",
    "data-name": "Group 40540",
    transform: "translate(187.558 125.457)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40538",
    "data-name": "Group 40538",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x1: 0.308,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40537",
    "data-name": "Group 40537",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72830",
    "data-name": "Path 72830",
    d: "M327.835,253.682l15.537,1.972,3.324.422-.3,2.414c-.24,1.868-5.4,2.753-11.526,1.974s-10.9-2.923-10.664-4.791l.307-2.414Z",
    transform: "translate(-324.194 -253.259)",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72831",
    "data-name": "Path 72831",
    d: "M324.592,252.661c-.238,1.869,4.535,4.014,10.663,4.793s11.288-.108,11.523-1.976-4.537-4.014-10.664-4.792S324.828,250.794,324.592,252.661Z",
    transform: "translate(-324.276 -250.404)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72832",
    "data-name": "Path 72832",
    d: "M346.362,253.248s4.045,1.814,3.3,3-8.234,1.485-8.5,1.323c0,0,7.5-.292,8.079-1.461S346.362,253.248,346.362,253.248Z",
    transform: "translate(-327.748 -251)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40539",
    "data-name": "Group 40539",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72833",
    "data-name": "Path 72833",
    d: "M324.592,252.661c.236-1.867,5.395-2.753,11.522-1.974.1.013.207.031.311.045a66.4,66.4,0,0,0-8.238,5.006C325.869,254.814,324.461,253.7,324.592,252.661Z",
    transform: "translate(-324.583 -250.404)",
    fill: "#ffee2f"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40544",
    "data-name": "Group 40544",
    transform: "translate(194.577 140.516)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40542",
    "data-name": "Group 40542",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40541",
    "data-name": "Group 40541",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72834",
    "data-name": "Path 72834",
    d: "M336.714,272.73,352.25,274.7l3.326.422-.306,2.414c-.238,1.869-5.4,2.753-11.526,1.976s-10.9-2.924-10.664-4.793l.306-2.414Z",
    transform: "translate(-333.072 -272.308)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72835",
    "data-name": "Path 72835",
    d: "M333.468,271.71c-.236,1.868,4.539,4.015,10.665,4.793s11.288-.107,11.525-1.976-4.537-4.012-10.665-4.791S333.707,269.843,333.468,271.71Z",
    transform: "translate(-333.153 -269.453)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72836",
    "data-name": "Path 72836",
    d: "M355.241,272.3s4.044,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.292,8.078-1.46S355.241,272.3,355.241,272.3Z",
    transform: "translate(-336.627 -270.049)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40543",
    "data-name": "Group 40543",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72837",
    "data-name": "Path 72837",
    d: "M333.468,271.71c.24-1.867,5.4-2.754,11.524-1.973.105.013.207.03.311.044a66.333,66.333,0,0,0-8.24,5.006C334.746,273.862,333.338,272.745,333.468,271.71Z",
    transform: "translate(-333.46 -269.453)",
    fill: "#ffdf2f"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40548",
    "data-name": "Group 40548",
    transform: "translate(147.16 127.641)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40546",
    "data-name": "Group 40546",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_92",
    "data-name": "Line 92",
    x1: 0.871,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40545",
    "data-name": "Group 40545",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72838",
    "data-name": "Path 72838",
    d: "M291.793,261.37l-14.626-5.6-3.132-1.2-.87,2.273c-.673,1.759,3.458,4.974,9.227,7.181s10.99,2.569,11.662.81l.87-2.271Z",
    transform: "translate(-273.093 -254.575)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72839",
    "data-name": "Path 72839",
    d: "M295.155,262.273c-.674,1.759-5.9,1.4-11.665-.811s-9.9-5.422-9.226-7.181,5.9-1.4,11.664.812S295.827,260.514,295.155,262.273Z",
    transform: "translate(-273.324 -253.167)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72840",
    "data-name": "Path 72840",
    d: "M279.163,253.738s-4.422-.309-4.323,1.087,6.559,5.2,6.865,5.177c0,0-6.471-3.8-6.432-5.1S279.163,253.738,279.163,253.738Z",
    transform: "translate(-273.459 -253.28)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40547",
    "data-name": "Group 40547",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72841",
    "data-name": "Path 72841",
    d: "M298.186,262.754c.671-1.759-3.459-4.975-9.227-7.181-.1-.038-.2-.071-.295-.108a66.217,66.217,0,0,1,4.9,8.3C296.044,264.048,297.812,263.727,298.186,262.754Z",
    transform: "translate(-288.665 -255.466)",
    fill: "#ffee2f"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40552",
    "data-name": "Group 40552",
    transform: "translate(129.032 127.162)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40550",
    "data-name": "Group 40550",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_93",
    "data-name": "Line 93",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40549",
    "data-name": "Group 40549",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72842",
    "data-name": "Path 72842",
    d: "M253.8,255.839l15.535,1.973,3.327.421-.307,2.414c-.237,1.869-5.4,2.753-11.524,1.974s-10.9-2.923-10.664-4.792l.307-2.414Z",
    transform: "translate(-250.163 -255.416)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72843",
    "data-name": "Path 72843",
    d: "M250.56,254.818c-.237,1.869,4.537,4.015,10.664,4.792s11.288-.108,11.524-1.976-4.537-4.013-10.665-4.791S250.8,252.951,250.56,254.818Z",
    transform: "translate(-250.245 -252.561)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72844",
    "data-name": "Path 72844",
    d: "M272.331,255.4s4.045,1.816,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S272.331,255.4,272.331,255.4Z",
    transform: "translate(-253.718 -253.157)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40551",
    "data-name": "Group 40551",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72845",
    "data-name": "Path 72845",
    d: "M250.56,254.818c.238-1.867,5.4-2.753,11.523-1.974.105.013.206.031.311.045a66.386,66.386,0,0,0-8.239,5.006C251.837,256.971,250.429,255.852,250.56,254.818Z",
    transform: "translate(-250.551 -252.561)",
    fill: "#ffee2f"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40556",
    "data-name": "Group 40556",
    transform: "translate(138.206 120.523)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40554",
    "data-name": "Group 40554",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_94",
    "data-name": "Line 94",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40553",
    "data-name": "Group 40553",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72846",
    "data-name": "Path 72846",
    d: "M265.408,247.441l15.535,1.974,3.327.421-.308,2.414c-.236,1.868-5.395,2.752-11.525,1.973s-10.9-2.923-10.663-4.791l.306-2.413Z",
    transform: "translate(-261.767 -247.02)",
    fill: "url(#radial-gradient-12)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72847",
    "data-name": "Path 72847",
    d: "M262.163,246.422c-.236,1.867,4.538,4.014,10.665,4.792s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.791S262.4,244.553,262.163,246.422Z",
    transform: "translate(-261.848 -244.163)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72848",
    "data-name": "Path 72848",
    d: "M283.937,247.007s4.044,1.814,3.293,3-8.232,1.484-8.491,1.323c0,0,7.5-.291,8.076-1.46S283.937,247.007,283.937,247.007Z",
    transform: "translate(-265.322 -244.759)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40555",
    "data-name": "Group 40555",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72849",
    "data-name": "Path 72849",
    d: "M262.163,246.422c.238-1.869,5.4-2.755,11.524-1.975.105.013.207.03.311.044a66.433,66.433,0,0,0-8.24,5.007C263.44,248.574,262.032,247.454,262.163,246.422Z",
    transform: "translate(-262.154 -244.163)",
    fill: "#ffdf2f"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40560",
    "data-name": "Group 40560",
    transform: "translate(168.784 132.768)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40558",
    "data-name": "Group 40558",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40557",
    "data-name": "Group 40557",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72850",
    "data-name": "Path 72850",
    d: "M319.145,267.854l-14.626-5.595-3.131-1.2-.87,2.274c-.674,1.758,3.457,4.973,9.227,7.181s10.99,2.569,11.662.81l.869-2.271Z",
    transform: "translate(-300.447 -261.06)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72851",
    "data-name": "Path 72851",
    d: "M322.508,268.758c-.674,1.759-5.9,1.4-11.663-.81s-9.9-5.424-9.226-7.183,5.894-1.4,11.663.812S323.181,267,322.508,268.758Z",
    transform: "translate(-300.677 -259.652)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72852",
    "data-name": "Path 72852",
    d: "M306.517,260.223s-4.422-.31-4.323,1.087,6.559,5.2,6.865,5.176c0,0-6.471-3.795-6.432-5.1S306.517,260.223,306.517,260.223Z",
    transform: "translate(-300.813 -259.765)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40559",
    "data-name": "Group 40559",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72853",
    "data-name": "Path 72853",
    d: "M325.538,269.239c.673-1.76-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.3-.108a66.172,66.172,0,0,1,4.9,8.3C323.4,270.533,325.165,270.212,325.538,269.239Z",
    transform: "translate(-316.017 -261.95)",
    fill: "#ffee2f"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40564",
    "data-name": "Group 40564",
    transform: "translate(150.657 132.289)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40562",
    "data-name": "Group 40562",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40561",
    "data-name": "Group 40561",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72854",
    "data-name": "Path 72854",
    d: "M281.158,262.325l15.535,1.972,3.327.421-.307,2.414c-.238,1.868-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-277.517 -261.901)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72855",
    "data-name": "Path 72855",
    d: "M277.914,261.3c-.238,1.868,4.537,4.014,10.664,4.792s11.288-.107,11.524-1.975-4.537-4.013-10.665-4.792S278.151,259.436,277.914,261.3Z",
    transform: "translate(-277.599 -259.046)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72856",
    "data-name": "Path 72856",
    d: "M299.685,261.889s4.044,1.816,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S299.685,261.889,299.685,261.889Z",
    transform: "translate(-281.072 -259.641)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40563",
    "data-name": "Group 40563",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72857",
    "data-name": "Path 72857",
    d: "M277.914,261.3c.237-1.867,5.4-2.754,11.523-1.974.105.013.206.031.311.045a66.362,66.362,0,0,0-8.24,5.006C279.19,263.455,277.782,262.337,277.914,261.3Z",
    transform: "translate(-277.905 -259.046)",
    fill: "#ffee2f"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40568",
    "data-name": "Group 40568",
    transform: "translate(159.829 125.65)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40566",
    "data-name": "Group 40566",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x1: 0.308,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40565",
    "data-name": "Group 40565",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72858",
    "data-name": "Path 72858",
    d: "M292.762,253.926,308.3,255.9l3.326.421-.306,2.414c-.238,1.869-5.4,2.754-11.526,1.975s-10.9-2.925-10.664-4.792l.308-2.413Z",
    transform: "translate(-289.119 -253.504)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72859",
    "data-name": "Path 72859",
    d: "M289.517,252.906c-.238,1.867,4.537,4.014,10.665,4.792s11.287-.107,11.523-1.976-4.537-4.013-10.664-4.792S289.753,251.039,289.517,252.906Z",
    transform: "translate(-289.201 -250.649)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72860",
    "data-name": "Path 72860",
    d: "M311.289,253.491s4.045,1.817,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.078-1.459S311.289,253.491,311.289,253.491Z",
    transform: "translate(-292.674 -251.244)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40567",
    "data-name": "Group 40567",
    transform: "translate(0.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72861",
    "data-name": "Path 72861",
    d: "M289.517,252.906c.236-1.867,5.4-2.753,11.524-1.975.1.013.206.03.311.045a66.113,66.113,0,0,0-8.24,5.007C290.793,255.057,289.385,253.939,289.517,252.906Z",
    transform: "translate(-289.508 -250.649)",
    fill: "#ffdf2f"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40572",
    "data-name": "Group 40572",
    transform: "translate(138.287 136.862)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40570",
    "data-name": "Group 40570",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40569",
    "data-name": "Group 40569",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72862",
    "data-name": "Path 72862",
    d: "M280.57,273.035l-14.628-5.6-3.131-1.2-.87,2.272c-.673,1.76,3.459,4.975,9.227,7.182s10.99,2.568,11.662.809l.87-2.27Z",
    transform: "translate(-261.87 -266.24)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72863",
    "data-name": "Path 72863",
    d: "M283.931,273.938c-.673,1.757-5.9,1.4-11.664-.81s-9.9-5.423-9.225-7.182,5.9-1.4,11.663.812S284.6,272.178,283.931,273.938Z",
    transform: "translate(-262.101 -264.831)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72864",
    "data-name": "Path 72864",
    d: "M267.941,265.4s-4.423-.308-4.323,1.089,6.559,5.195,6.863,5.176c0,0-6.47-3.8-6.43-5.1S267.941,265.4,267.941,265.4Z",
    transform: "translate(-262.236 -264.945)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40571",
    "data-name": "Group 40571",
    transform: "translate(12.31 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72865",
    "data-name": "Path 72865",
    d: "M286.962,274.419c.673-1.76-3.457-4.975-9.226-7.181-.1-.039-.2-.072-.295-.109a66.413,66.413,0,0,1,4.9,8.3C284.82,275.713,286.59,275.39,286.962,274.419Z",
    transform: "translate(-277.441 -267.129)",
    fill: "#ffee2f"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40576",
    "data-name": "Group 40576",
    transform: "translate(120.161 136.384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40574",
    "data-name": "Group 40574",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40573",
    "data-name": "Group 40573",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72866",
    "data-name": "Path 72866",
    d: "M242.582,267.5l15.535,1.973,3.326.421-.306,2.414c-.238,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.662-4.791l.306-2.414Z",
    transform: "translate(-238.941 -267.082)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72867",
    "data-name": "Path 72867",
    d: "M239.337,266.484c-.237,1.867,4.538,4.014,10.665,4.792s11.286-.108,11.522-1.976-4.537-4.013-10.664-4.79S239.575,264.616,239.337,266.484Z",
    transform: "translate(-239.022 -264.226)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72868",
    "data-name": "Path 72868",
    d: "M261.108,267.069s4.045,1.816,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.29,8.078-1.459S261.108,267.069,261.108,267.069Z",
    transform: "translate(-242.495 -264.822)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40575",
    "data-name": "Group 40575",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72869",
    "data-name": "Path 72869",
    d: "M239.337,266.484c.238-1.868,5.4-2.754,11.523-1.974.105.013.206.029.312.044a66.221,66.221,0,0,0-8.239,5.007C240.614,268.635,239.206,267.518,239.337,266.484Z",
    transform: "translate(-239.328 -264.226)",
    fill: "#ffee2f"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40580",
    "data-name": "Group 40580",
    transform: "translate(129.333 129.745)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40578",
    "data-name": "Group 40578",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40577",
    "data-name": "Group 40577",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72870",
    "data-name": "Path 72870",
    d: "M254.184,259.106l15.537,1.973,3.327.421-.307,2.415c-.237,1.867-5.4,2.751-11.526,1.972s-10.9-2.923-10.663-4.792l.307-2.413Z",
    transform: "translate(-250.543 -258.684)",
    fill: "url(#radial-gradient-18)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72871",
    "data-name": "Path 72871",
    d: "M250.94,258.086c-.237,1.868,4.537,4.014,10.664,4.792s11.289-.106,11.526-1.975-4.539-4.013-10.666-4.792S251.178,256.218,250.94,258.086Z",
    transform: "translate(-250.625 -255.828)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72872",
    "data-name": "Path 72872",
    d: "M272.711,258.671s4.045,1.816,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.29,8.079-1.459S272.711,258.671,272.711,258.671Z",
    transform: "translate(-254.098 -256.423)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40579",
    "data-name": "Group 40579",
    transform: "translate(0.307 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72873",
    "data-name": "Path 72873",
    d: "M250.94,258.086c.238-1.868,5.4-2.754,11.523-1.975l.311.045a66.236,66.236,0,0,0-8.239,5.007C252.217,260.238,250.809,259.119,250.94,258.086Z",
    transform: "translate(-250.931 -255.828)",
    fill: "#ffdf2f"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40584",
    "data-name": "Group 40584",
    transform: "translate(141.953 126.035)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40582",
    "data-name": "Group 40582",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_101",
    "data-name": "Line 101",
    x1: 0.871,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40581",
    "data-name": "Group 40581",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72874",
    "data-name": "Path 72874",
    d: "M285.207,259.339l-14.626-5.6-3.131-1.2-.871,2.273c-.673,1.757,3.459,4.973,9.227,7.181s10.989,2.569,11.662.81l.87-2.271Z",
    transform: "translate(-266.507 -252.545)",
    fill: "url(#radial-gradient-19)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72875",
    "data-name": "Path 72875",
    d: "M288.57,260.242c-.674,1.759-5.9,1.4-11.665-.81s-9.9-5.424-9.224-7.181,5.894-1.4,11.661.811S289.241,258.482,288.57,260.242Z",
    transform: "translate(-266.738 -251.136)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72876",
    "data-name": "Path 72876",
    d: "M272.579,251.707s-4.423-.309-4.324,1.087,6.558,5.2,6.864,5.177c0,0-6.471-3.8-6.431-5.1S272.579,251.707,272.579,251.707Z",
    transform: "translate(-266.873 -251.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40583",
    "data-name": "Group 40583",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72877",
    "data-name": "Path 72877",
    d: "M291.6,260.723c.671-1.76-3.459-4.975-9.227-7.181-.1-.038-.2-.071-.294-.108a66.237,66.237,0,0,1,4.9,8.3C289.458,262.016,291.227,261.7,291.6,260.723Z",
    transform: "translate(-282.079 -253.434)",
    fill: "#ffee2f"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40588",
    "data-name": "Group 40588",
    transform: "translate(123.827 125.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40586",
    "data-name": "Group 40586",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_102",
    "data-name": "Line 102",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40585",
    "data-name": "Group 40585",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72878",
    "data-name": "Path 72878",
    d: "M247.219,253.807l15.536,1.974,3.326.422-.307,2.414c-.238,1.867-5.4,2.751-11.524,1.972s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-243.578 -253.386)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72879",
    "data-name": "Path 72879",
    d: "M243.974,252.788c-.236,1.868,4.538,4.014,10.665,4.792s11.286-.107,11.522-1.974-4.536-4.014-10.665-4.792S244.212,250.919,243.974,252.788Z",
    transform: "translate(-243.659 -250.53)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72880",
    "data-name": "Path 72880",
    d: "M265.746,253.373s4.044,1.815,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.29,8.076-1.459S265.746,253.373,265.746,253.373Z",
    transform: "translate(-247.133 -251.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40587",
    "data-name": "Group 40587",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72881",
    "data-name": "Path 72881",
    d: "M243.974,252.788c.238-1.869,5.4-2.754,11.523-1.975.105.013.207.03.311.045a66.224,66.224,0,0,0-8.239,5.007C245.251,254.94,243.843,253.821,243.974,252.788Z",
    transform: "translate(-243.965 -250.53)",
    fill: "#ffee2f"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40592",
    "data-name": "Group 40592",
    transform: "translate(132.999 118.918)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40590",
    "data-name": "Group 40590",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_103",
    "data-name": "Line 103",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40589",
    "data-name": "Group 40589",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72882",
    "data-name": "Path 72882",
    d: "M258.822,245.409l15.537,1.974,3.326.421-.306,2.414c-.238,1.868-5.4,2.752-11.526,1.974s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-255.181 -244.988)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72883",
    "data-name": "Path 72883",
    d: "M255.578,244.39c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.791S255.815,242.523,255.578,244.39Z",
    transform: "translate(-255.263 -242.133)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72884",
    "data-name": "Path 72884",
    d: "M277.35,244.975s4.044,1.815,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.078-1.459S277.35,244.975,277.35,244.975Z",
    transform: "translate(-258.736 -242.728)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40591",
    "data-name": "Group 40591",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72885",
    "data-name": "Path 72885",
    d: "M255.578,244.39c.237-1.867,5.4-2.753,11.523-1.974.105.013.207.029.311.044a66.182,66.182,0,0,0-8.239,5.007C256.855,246.542,255.447,245.423,255.578,244.39Z",
    transform: "translate(-255.569 -242.133)",
    fill: "#ffdf2f"
  })))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40596",
    "data-name": "Group 40596",
    transform: "translate(163.574 160.325)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40594",
    "data-name": "Group 40594",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_104",
    "data-name": "Line 104",
    x1: 0.868,
    y2: 2.271,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40593",
    "data-name": "Group 40593",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72886",
    "data-name": "Path 72886",
    d: "M312.555,302.713l-14.625-5.6-3.132-1.2-.87,2.273c-.673,1.76,3.458,4.973,9.226,7.181s10.99,2.569,11.664.81l.868-2.271Z",
    transform: "translate(-293.856 -295.919)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72887",
    "data-name": "Path 72887",
    d: "M315.916,303.616c-.673,1.759-5.894,1.4-11.664-.811s-9.9-5.422-9.224-7.181,5.894-1.4,11.662.811S316.589,301.857,315.916,303.616Z",
    transform: "translate(-294.087 -294.51)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72888",
    "data-name": "Path 72888",
    d: "M299.926,295.08s-4.423-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.471-3.795-6.431-5.1S299.926,295.08,299.926,295.08Z",
    transform: "translate(-294.222 -294.623)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40595",
    "data-name": "Group 40595",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72889",
    "data-name": "Path 72889",
    d: "M318.947,304.1c.673-1.758-3.458-4.975-9.226-7.181-.1-.038-.2-.072-.295-.108a66.4,66.4,0,0,1,4.9,8.3C316.807,305.391,318.574,305.07,318.947,304.1Z",
    transform: "translate(-309.426 -296.808)",
    fill: "#ffee2f"
  })))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40600",
    "data-name": "Group 40600",
    transform: "translate(151.351 155.66)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40598",
    "data-name": "Group 40598",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_105",
    "data-name": "Line 105",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40597",
    "data-name": "Group 40597",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72890",
    "data-name": "Path 72890",
    d: "M282.036,291.885l15.536,1.972,3.326.422-.307,2.414c-.237,1.869-5.4,2.753-11.525,1.975s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-278.395 -291.464)",
    fill: "url(#radial-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72891",
    "data-name": "Path 72891",
    d: "M278.792,290.866c-.238,1.867,4.537,4.015,10.664,4.791s11.288-.105,11.524-1.975-4.537-4.012-10.665-4.79S279.03,289,278.792,290.866Z",
    transform: "translate(-278.477 -288.609)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72892",
    "data-name": "Path 72892",
    d: "M300.563,291.451s4.045,1.817,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.292,8.078-1.46S300.563,291.451,300.563,291.451Z",
    transform: "translate(-281.95 -289.204)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40599",
    "data-name": "Group 40599",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72893",
    "data-name": "Path 72893",
    d: "M278.792,290.866c.238-1.869,5.4-2.753,11.523-1.974.1.012.207.029.311.044a66.446,66.446,0,0,0-8.239,5.005C280.069,293.018,278.661,291.9,278.792,290.866Z",
    transform: "translate(-278.783 -288.609)",
    fill: "#ffee2f"
  })))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40604",
    "data-name": "Group 40604",
    transform: "translate(160.525 149.021)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40602",
    "data-name": "Group 40602",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_106",
    "data-name": "Line 106",
    x1: 0.305,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40601",
    "data-name": "Group 40601",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72894",
    "data-name": "Path 72894",
    d: "M293.639,283.487l15.537,1.974,3.327.421L312.2,288.3c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.925-10.663-4.792l.305-2.413Z",
    transform: "translate(-289.999 -283.066)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72895",
    "data-name": "Path 72895",
    d: "M290.394,282.468c-.236,1.867,4.539,4.014,10.664,4.791s11.289-.105,11.526-1.975-4.539-4.012-10.666-4.79S290.631,280.6,290.394,282.468Z",
    transform: "translate(-290.08 -280.211)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72896",
    "data-name": "Path 72896",
    d: "M312.167,283.053s4.045,1.817,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.293,8.078-1.46S312.167,283.053,312.167,283.053Z",
    transform: "translate(-293.553 -280.806)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40603",
    "data-name": "Group 40603",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72897",
    "data-name": "Path 72897",
    d: "M290.394,282.468c.237-1.869,5.4-2.753,11.523-1.974.105.012.207.029.311.043a66.425,66.425,0,0,0-8.238,5.007C291.671,284.62,290.264,283.5,290.394,282.468Z",
    transform: "translate(-290.386 -280.211)",
    fill: "#ffdf2f"
  })))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40608",
    "data-name": "Group 40608",
    transform: "translate(140.186 149.405)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40606",
    "data-name": "Group 40606",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_107",
    "data-name": "Line 107",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40605",
    "data-name": "Group 40605",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72898",
    "data-name": "Path 72898",
    d: "M282.971,288.9l-14.625-5.6-3.131-1.2-.87,2.272c-.672,1.761,3.459,4.974,9.227,7.181s10.99,2.57,11.662.81l.87-2.271Z",
    transform: "translate(-264.272 -282.106)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72899",
    "data-name": "Path 72899",
    d: "M286.334,289.8c-.674,1.76-5.9,1.4-11.664-.811s-9.9-5.422-9.225-7.181,5.894-1.4,11.661.811S287.006,288.045,286.334,289.8Z",
    transform: "translate(-264.503 -280.697)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72900",
    "data-name": "Path 72900",
    d: "M270.342,281.268s-4.422-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.47-3.795-6.431-5.1S270.342,281.268,270.342,281.268Z",
    transform: "translate(-264.638 -280.81)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40607",
    "data-name": "Group 40607",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72901",
    "data-name": "Path 72901",
    d: "M289.364,290.284c.672-1.757-3.458-4.974-9.227-7.181-.1-.038-.2-.073-.295-.108a66.361,66.361,0,0,1,4.9,8.3C287.223,291.578,288.99,291.257,289.364,290.284Z",
    transform: "translate(-279.842 -282.996)",
    fill: "#ffee2f"
  })))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40612",
    "data-name": "Group 40612",
    transform: "translate(122.06 148.927)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40610",
    "data-name": "Group 40610",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_108",
    "data-name": "Line 108",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40609",
    "data-name": "Group 40609",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72902",
    "data-name": "Path 72902",
    d: "M244.984,283.369l15.535,1.972,3.326.421-.307,2.415c-.237,1.868-5.4,2.751-11.524,1.975s-10.9-2.925-10.663-4.792l.306-2.413Z",
    transform: "translate(-241.343 -282.948)",
    fill: "url(#radial-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72903",
    "data-name": "Path 72903",
    d: "M241.739,282.35c-.237,1.867,4.537,4.013,10.665,4.791s11.287-.107,11.523-1.976-4.537-4.013-10.665-4.789S241.977,280.481,241.739,282.35Z",
    transform: "translate(-241.424 -280.092)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72904",
    "data-name": "Path 72904",
    d: "M263.51,282.935s4.045,1.815,3.3,3-8.234,1.485-8.494,1.325c0,0,7.5-.292,8.077-1.46S263.51,282.935,263.51,282.935Z",
    transform: "translate(-244.897 -280.688)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40611",
    "data-name": "Group 40611",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72905",
    "data-name": "Path 72905",
    d: "M241.739,282.35c.238-1.869,5.4-2.754,11.523-1.974.105.012.207.029.311.043a66.41,66.41,0,0,0-8.239,5.006C243.016,284.5,241.608,283.384,241.739,282.35Z",
    transform: "translate(-241.73 -280.092)",
    fill: "#ffee2f"
  })))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40616",
    "data-name": "Group 40616",
    transform: "translate(131.232 142.288)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40614",
    "data-name": "Group 40614",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_109",
    "data-name": "Line 109",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40613",
    "data-name": "Group 40613",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72906",
    "data-name": "Path 72906",
    d: "M256.587,274.971l15.535,1.973,3.327.421-.307,2.415c-.238,1.867-5.4,2.751-11.525,1.974s-10.9-2.925-10.663-4.793l.306-2.413Z",
    transform: "translate(-252.946 -274.549)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72907",
    "data-name": "Path 72907",
    d: "M253.342,273.951c-.236,1.869,4.538,4.014,10.665,4.792s11.288-.105,11.524-1.975-4.537-4.014-10.665-4.791S253.58,272.083,253.342,273.951Z",
    transform: "translate(-253.027 -271.694)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72908",
    "data-name": "Path 72908",
    d: "M275.114,274.538s4.045,1.814,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.292,8.079-1.46S275.114,274.538,275.114,274.538Z",
    transform: "translate(-256.5 -272.29)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40615",
    "data-name": "Group 40615",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72909",
    "data-name": "Path 72909",
    d: "M253.342,273.951c.238-1.868,5.4-2.753,11.524-1.974.105.013.206.03.311.043a66.358,66.358,0,0,0-8.239,5.007C254.619,276.1,253.211,274.985,253.342,273.951Z",
    transform: "translate(-253.333 -271.694)",
    fill: "#ffdf2f"
  })))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40620",
    "data-name": "Group 40620",
    transform: "translate(167.426 144.701)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40618",
    "data-name": "Group 40618",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40617",
    "data-name": "Group 40617",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72910",
    "data-name": "Path 72910",
    d: "M317.427,282.951l-14.626-5.6-3.131-1.2-.87,2.274c-.674,1.757,3.457,4.973,9.226,7.181s10.99,2.569,11.664.81l.869-2.271Z",
    transform: "translate(-298.729 -276.156)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72911",
    "data-name": "Path 72911",
    d: "M320.79,283.853c-.674,1.759-5.9,1.4-11.665-.809s-9.9-5.424-9.224-7.183,5.894-1.4,11.661.811S321.461,282.094,320.79,283.853Z",
    transform: "translate(-298.959 -274.747)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72912",
    "data-name": "Path 72912",
    d: "M304.8,275.319s-4.423-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.47-3.794-6.43-5.1S304.8,275.319,304.8,275.319Z",
    transform: "translate(-299.094 -274.861)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40619",
    "data-name": "Group 40619",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72913",
    "data-name": "Path 72913",
    d: "M323.82,284.335c.671-1.76-3.457-4.975-9.227-7.181-.1-.038-.2-.07-.294-.107a66.045,66.045,0,0,1,4.9,8.3C321.678,285.629,323.447,285.308,323.82,284.335Z",
    transform: "translate(-314.299 -277.047)",
    fill: "#ffee2f"
  })))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40624",
    "data-name": "Group 40624",
    transform: "translate(149.299 144.223)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40622",
    "data-name": "Group 40622",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40621",
    "data-name": "Group 40621",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72914",
    "data-name": "Path 72914",
    d: "M279.44,277.421l15.535,1.973,3.327.42L298,282.228c-.238,1.869-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.791l.306-2.414Z",
    transform: "translate(-275.799 -276.997)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72915",
    "data-name": "Path 72915",
    d: "M276.195,276.4c-.237,1.869,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.537-4.013-10.666-4.79S276.433,274.532,276.195,276.4Z",
    transform: "translate(-275.88 -274.143)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72916",
    "data-name": "Path 72916",
    d: "M297.967,276.985s4.044,1.817,3.3,3-8.234,1.485-8.494,1.322c0,0,7.5-.291,8.078-1.458S297.967,276.985,297.967,276.985Z",
    transform: "translate(-279.354 -274.738)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40623",
    "data-name": "Group 40623",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72917",
    "data-name": "Path 72917",
    d: "M276.195,276.4c.238-1.867,5.4-2.753,11.522-1.973.105.013.207.03.312.043a66.461,66.461,0,0,0-8.24,5.006C277.471,278.552,276.063,277.434,276.195,276.4Z",
    transform: "translate(-276.186 -274.143)",
    fill: "#ffee2f"
  })))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40628",
    "data-name": "Group 40628",
    transform: "translate(158.473 137.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40626",
    "data-name": "Group 40626",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x1: 0.305,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40625",
    "data-name": "Group 40625",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72918",
    "data-name": "Path 72918",
    d: "M291.043,269.022,306.58,271l3.326.422-.306,2.413c-.238,1.867-5.4,2.753-11.526,1.973s-10.9-2.923-10.662-4.792l.3-2.413Z",
    transform: "translate(-287.403 -268.599)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72919",
    "data-name": "Path 72919",
    d: "M287.8,268c-.236,1.869,4.539,4.015,10.666,4.792s11.287-.108,11.523-1.973-4.537-4.015-10.665-4.792S288.036,266.134,287.8,268Z",
    transform: "translate(-287.484 -265.745)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72920",
    "data-name": "Path 72920",
    d: "M309.57,268.586s4.044,1.817,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.077-1.457S309.57,268.586,309.57,268.586Z",
    transform: "translate(-290.957 -266.34)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40627",
    "data-name": "Group 40627",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72921",
    "data-name": "Path 72921",
    d: "M287.8,268c.24-1.867,5.4-2.753,11.524-1.973.105.013.207.029.312.045a65.89,65.89,0,0,0-8.24,5C289.075,270.154,287.667,269.036,287.8,268Z",
    transform: "translate(-287.789 -265.745)",
    fill: "#ffdf2f"
  })))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40632",
    "data-name": "Group 40632",
    transform: "translate(176.012 146.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40630",
    "data-name": "Group 40630",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40629",
    "data-name": "Group 40629",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72922",
    "data-name": "Path 72922",
    d: "M313.23,280.409l15.536,1.972,3.326.421-.307,2.414c-.237,1.868-5.4,2.752-11.525,1.974s-10.9-2.925-10.663-4.792l.307-2.413Z",
    transform: "translate(-309.589 -279.986)",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72923",
    "data-name": "Path 72923",
    d: "M309.986,279.388c-.236,1.867,4.537,4.015,10.665,4.792s11.286-.107,11.522-1.976-4.537-4.012-10.665-4.792S310.224,277.52,309.986,279.388Z",
    transform: "translate(-309.671 -277.13)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72924",
    "data-name": "Path 72924",
    d: "M331.757,279.973s4.046,1.817,3.3,3-8.234,1.484-8.492,1.323c0,0,7.494-.292,8.076-1.462S331.757,279.973,331.757,279.973Z",
    transform: "translate(-313.144 -277.726)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40631",
    "data-name": "Group 40631",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72925",
    "data-name": "Path 72925",
    d: "M309.986,279.388c.238-1.868,5.4-2.753,11.523-1.975.105.013.206.031.312.044a66.277,66.277,0,0,0-8.238,5.006C311.263,281.54,309.854,280.422,309.986,279.388Z",
    transform: "translate(-309.977 -277.13)",
    fill: "#ffee2f"
  })))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40636",
    "data-name": "Group 40636",
    transform: "translate(185.186 143.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40634",
    "data-name": "Group 40634",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40633",
    "data-name": "Group 40633",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72926",
    "data-name": "Path 72926",
    d: "M324.835,277.087l15.535,1.972,3.327.422-.307,2.413c-.238,1.868-5.4,2.752-11.525,1.975s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-321.194 -276.663)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72927",
    "data-name": "Path 72927",
    d: "M321.59,276.065c-.237,1.868,4.538,4.014,10.665,4.793s11.288-.108,11.524-1.975-4.537-4.014-10.665-4.792S321.828,274.2,321.59,276.065Z",
    transform: "translate(-321.275 -273.808)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72928",
    "data-name": "Path 72928",
    d: "M343.362,276.651s4.045,1.815,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.291,8.078-1.459S343.362,276.651,343.362,276.651Z",
    transform: "translate(-324.748 -274.404)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40635",
    "data-name": "Group 40635",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72929",
    "data-name": "Path 72929",
    d: "M321.59,276.065c.238-1.866,5.4-2.753,11.524-1.974.1.013.206.03.311.045a66.339,66.339,0,0,0-8.24,5.005C322.867,278.217,321.459,277.1,321.59,276.065Z",
    transform: "translate(-321.581 -273.808)",
    fill: "#ffdf2f"
  })))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40640",
    "data-name": "Group 40640",
    transform: "translate(174.524 134.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40638",
    "data-name": "Group 40638",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40637",
    "data-name": "Group 40637",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72930",
    "data-name": "Path 72930",
    d: "M311.348,265.749l15.535,1.972,3.327.422-.307,2.414c-.236,1.867-5.4,2.751-11.525,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-307.707 -265.326)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72931",
    "data-name": "Path 72931",
    d: "M308.1,264.728c-.236,1.869,4.537,4.014,10.664,4.792s11.288-.106,11.524-1.974-4.537-4.014-10.665-4.792S308.341,262.86,308.1,264.728Z",
    transform: "translate(-307.789 -262.471)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72932",
    "data-name": "Path 72932",
    d: "M329.875,265.314s4.045,1.815,3.3,3-8.234,1.483-8.492,1.323c0,0,7.494-.292,8.076-1.46S329.875,265.314,329.875,265.314Z",
    transform: "translate(-311.262 -263.066)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40639",
    "data-name": "Group 40639",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72933",
    "data-name": "Path 72933",
    d: "M308.1,264.728c.237-1.868,5.4-2.753,11.523-1.974.105.013.207.031.311.044A66.225,66.225,0,0,0,311.7,267.8C309.381,266.88,307.972,265.761,308.1,264.728Z",
    transform: "translate(-308.095 -262.471)",
    fill: "#ffee2f"
  })))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40644",
    "data-name": "Group 40644",
    transform: "translate(183.698 128.357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40642",
    "data-name": "Group 40642",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_116",
    "data-name": "Line 116",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40641",
    "data-name": "Group 40641",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72934",
    "data-name": "Path 72934",
    d: "M322.952,257.35l15.535,1.974,3.326.421-.3,2.414c-.238,1.868-5.4,2.753-11.526,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-319.311 -256.928)",
    fill: "url(#radial-gradient-34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72935",
    "data-name": "Path 72935",
    d: "M319.707,256.33c-.236,1.868,4.537,4.014,10.665,4.792s11.288-.107,11.523-1.975-4.537-4.013-10.664-4.791S319.945,254.462,319.707,256.33Z",
    transform: "translate(-319.392 -254.073)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72936",
    "data-name": "Path 72936",
    d: "M341.479,256.916s4.045,1.815,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.291,8.076-1.458S341.479,256.916,341.479,256.916Z",
    transform: "translate(-322.866 -254.668)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40643",
    "data-name": "Group 40643",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72937",
    "data-name": "Path 72937",
    d: "M319.707,256.33c.238-1.868,5.4-2.754,11.524-1.974.105.013.207.03.311.043a66.561,66.561,0,0,0-8.24,5.007C320.983,258.482,319.576,257.364,319.707,256.33Z",
    transform: "translate(-319.698 -254.073)",
    fill: "#ffdf2f"
  })))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40648",
    "data-name": "Group 40648",
    transform: "translate(143.458 161.742)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40646",
    "data-name": "Group 40646",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40645",
    "data-name": "Group 40645",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72938",
    "data-name": "Path 72938",
    d: "M272.052,299.58l15.535,1.972,3.327.421-.307,2.414c-.238,1.867-5.4,2.751-11.523,1.974s-10.9-2.923-10.665-4.792l.307-2.413Z",
    transform: "translate(-268.411 -299.157)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72939",
    "data-name": "Path 72939",
    d: "M268.808,298.559c-.236,1.867,4.537,4.014,10.664,4.792s11.288-.107,11.524-1.976-4.537-4.014-10.665-4.791S269.045,296.692,268.808,298.559Z",
    transform: "translate(-268.493 -296.302)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72940",
    "data-name": "Path 72940",
    d: "M290.579,299.144s4.045,1.816,3.3,3-8.233,1.484-8.494,1.322c0,0,7.5-.289,8.078-1.459S290.579,299.144,290.579,299.144Z",
    transform: "translate(-271.965 -296.897)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40647",
    "data-name": "Group 40647",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72941",
    "data-name": "Path 72941",
    d: "M268.808,298.559c.237-1.867,5.4-2.754,11.523-1.974.105.013.206.031.311.043a66.244,66.244,0,0,0-8.239,5.007C270.084,300.711,268.676,299.593,268.808,298.559Z",
    transform: "translate(-268.799 -296.302)",
    fill: "#ffee2f"
  })))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40652",
    "data-name": "Group 40652",
    transform: "translate(153.789 165.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40650",
    "data-name": "Group 40650",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_118",
    "data-name": "Line 118",
    x1: 0.305,
    y2: 2.413,
    transform: "translate(0.008 2.256)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40649",
    "data-name": "Group 40649",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72942",
    "data-name": "Path 72942",
    d: "M285.119,304.543l15.535,1.974,3.327.421-.305,2.413c-.24,1.867-5.4,2.753-11.526,1.974s-10.9-2.923-10.663-4.792l.305-2.413Z",
    transform: "translate(-281.478 -304.12)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72943",
    "data-name": "Path 72943",
    d: "M281.873,303.522c-.236,1.867,4.539,4.014,10.665,4.792s11.288-.107,11.524-1.974-4.537-4.014-10.665-4.792S282.112,301.655,281.873,303.522Z",
    transform: "translate(-281.559 -301.265)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72944",
    "data-name": "Path 72944",
    d: "M303.646,304.107s4.045,1.816,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.078-1.461S303.646,304.107,303.646,304.107Z",
    transform: "translate(-285.033 -301.861)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40651",
    "data-name": "Group 40651",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72945",
    "data-name": "Path 72945",
    d: "M281.873,303.522c.239-1.867,5.4-2.753,11.525-1.974.105.013.206.031.311.043a66.3,66.3,0,0,0-8.239,5.007C283.15,305.674,281.743,304.556,281.873,303.522Z",
    transform: "translate(-281.865 -301.265)",
    fill: "#ffdf2f"
  })))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40656",
    "data-name": "Group 40656",
    transform: "translate(167.556 156.508)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40654",
    "data-name": "Group 40654",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_119",
    "data-name": "Line 119",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40653",
    "data-name": "Group 40653",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72946",
    "data-name": "Path 72946",
    d: "M302.533,292.959l15.537,1.973,3.326.422-.306,2.414c-.238,1.866-5.4,2.751-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-298.893 -292.537)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72947",
    "data-name": "Path 72947",
    d: "M299.289,291.939c-.237,1.869,4.537,4.014,10.665,4.792s11.287-.107,11.523-1.975-4.537-4.014-10.664-4.792S299.527,290.072,299.289,291.939Z",
    transform: "translate(-298.974 -289.682)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72948",
    "data-name": "Path 72948",
    d: "M321.059,292.526s4.045,1.814,3.3,3-8.234,1.483-8.493,1.323c0,0,7.5-.29,8.077-1.459S321.059,292.526,321.059,292.526Z",
    transform: "translate(-302.447 -290.278)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40655",
    "data-name": "Group 40655",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72949",
    "data-name": "Path 72949",
    d: "M299.289,291.939c.238-1.867,5.4-2.753,11.524-1.975.1.014.206.032.311.047a66.243,66.243,0,0,0-8.24,5C300.566,294.089,299.157,292.972,299.289,291.939Z",
    transform: "translate(-299.28 -289.682)",
    fill: "#ffee2f"
  })))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40660",
    "data-name": "Group 40660",
    transform: "translate(173.929 150.24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40658",
    "data-name": "Group 40658",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_120",
    "data-name": "Line 120",
    x1: 0.308,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40657",
    "data-name": "Group 40657",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72950",
    "data-name": "Path 72950",
    d: "M310.6,285.03,326.132,287l3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.525,1.974s-10.9-2.923-10.665-4.791l.308-2.414Z",
    transform: "translate(-306.954 -284.609)",
    fill: "url(#radial-gradient-38)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72951",
    "data-name": "Path 72951",
    d: "M307.353,284.011c-.238,1.869,4.535,4.013,10.662,4.792s11.289-.107,11.525-1.976-4.539-4.013-10.666-4.792S307.59,282.143,307.353,284.011Z",
    transform: "translate(-307.036 -281.753)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72952",
    "data-name": "Path 72952",
    d: "M329.124,284.6s4.044,1.814,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.291,8.078-1.459S329.124,284.6,329.124,284.6Z",
    transform: "translate(-310.509 -282.349)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40659",
    "data-name": "Group 40659",
    transform: "translate(0.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72953",
    "data-name": "Path 72953",
    d: "M307.353,284.011c.237-1.868,5.395-2.754,11.522-1.975.105.014.207.031.311.045a66.646,66.646,0,0,0-8.239,5.007C308.629,286.163,307.221,285.045,307.353,284.011Z",
    transform: "translate(-307.344 -281.753)",
    fill: "#ffdf2f"
  })))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40664",
    "data-name": "Group 40664",
    transform: "translate(108.47 99.354)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40662",
    "data-name": "Group 40662",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_121",
    "data-name": "Line 121",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40661",
    "data-name": "Group 40661",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72954",
    "data-name": "Path 72954",
    d: "M242.853,225.589l-14.627-5.595-3.131-1.2-.87,2.273c-.674,1.758,3.458,4.973,9.227,7.181s10.989,2.569,11.662.81l.869-2.272Z",
    transform: "translate(-224.153 -218.795)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72955",
    "data-name": "Path 72955",
    d: "M246.214,226.492c-.673,1.759-5.894,1.4-11.663-.81s-9.9-5.425-9.226-7.182,5.9-1.4,11.663.811S246.886,224.733,246.214,226.492Z",
    transform: "translate(-224.383 -217.386)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72956",
    "data-name": "Path 72956",
    d: "M230.224,217.956s-4.422-.308-4.322,1.089,6.558,5.195,6.864,5.175c0,0-6.471-3.795-6.432-5.1S230.224,217.956,230.224,217.956Z",
    transform: "translate(-224.519 -217.499)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40663",
    "data-name": "Group 40663",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72957",
    "data-name": "Path 72957",
    d: "M249.245,226.973c.672-1.759-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.295-.108a66.548,66.548,0,0,1,4.9,8.3C247.1,228.267,248.872,227.946,249.245,226.973Z",
    transform: "translate(-239.724 -219.684)",
    fill: "#ffee2f"
  })))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40668",
    "data-name": "Group 40668",
    transform: "translate(139.661 118.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40666",
    "data-name": "Group 40666",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_122",
    "data-name": "Line 122",
    x1: 0.868,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40665",
    "data-name": "Group 40665",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72958",
    "data-name": "Path 72958",
    d: "M282.306,249.971l-14.626-5.6-3.131-1.2-.87,2.274c-.674,1.758,3.457,4.974,9.227,7.181s10.988,2.569,11.662.81l.868-2.272Z",
    transform: "translate(-263.608 -243.176)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72959",
    "data-name": "Path 72959",
    d: "M285.668,250.874c-.673,1.758-5.894,1.4-11.664-.811s-9.9-5.422-9.224-7.181,5.894-1.395,11.663.813S286.34,249.115,285.668,250.874Z",
    transform: "translate(-263.838 -241.768)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72960",
    "data-name": "Path 72960",
    d: "M269.678,242.339s-4.422-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.47-3.794-6.43-5.1S269.678,242.339,269.678,242.339Z",
    transform: "translate(-263.974 -241.882)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40667",
    "data-name": "Group 40667",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72961",
    "data-name": "Path 72961",
    d: "M288.7,251.355c.672-1.759-3.456-4.975-9.225-7.18-.1-.038-.2-.072-.3-.108a66.233,66.233,0,0,1,4.9,8.3C286.558,252.649,288.326,252.328,288.7,251.355Z",
    transform: "translate(-279.178 -244.067)",
    fill: "#ffee2f"
  })))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40672",
    "data-name": "Group 40672",
    transform: "translate(121.534 118.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40670",
    "data-name": "Group 40670",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_123",
    "data-name": "Line 123",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40669",
    "data-name": "Group 40669",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72962",
    "data-name": "Path 72962",
    d: "M244.319,244.44l15.536,1.974,3.327.421-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.412Z",
    transform: "translate(-240.678 -244.018)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72963",
    "data-name": "Path 72963",
    d: "M241.074,243.42c-.236,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.524-1.975-4.537-4.014-10.665-4.792S241.312,241.552,241.074,243.42Z",
    transform: "translate(-240.759 -241.162)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72964",
    "data-name": "Path 72964",
    d: "M262.846,244s4.044,1.816,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S262.846,244,262.846,244Z",
    transform: "translate(-244.232 -241.758)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40671",
    "data-name": "Group 40671",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72965",
    "data-name": "Path 72965",
    d: "M241.074,243.42c.238-1.868,5.4-2.753,11.523-1.975.105.013.207.031.312.046a66.094,66.094,0,0,0-8.239,5C242.351,245.572,240.943,244.454,241.074,243.42Z",
    transform: "translate(-241.065 -241.162)",
    fill: "#ffee2f"
  })))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40676",
    "data-name": "Group 40676",
    transform: "translate(130.707 111.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40674",
    "data-name": "Group 40674",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_124",
    "data-name": "Line 124",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40673",
    "data-name": "Group 40673",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72966",
    "data-name": "Path 72966",
    d: "M255.922,236.042l15.536,1.974,3.326.421-.306,2.414c-.238,1.868-5.4,2.753-11.525,1.973s-10.9-2.923-10.663-4.792l.307-2.413Z",
    transform: "translate(-252.281 -235.62)",
    fill: "url(#radial-gradient-34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72967",
    "data-name": "Path 72967",
    d: "M252.678,235.022c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.108,11.524-1.976-4.537-4.014-10.665-4.792S252.916,233.154,252.678,235.022Z",
    transform: "translate(-252.363 -232.764)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72968",
    "data-name": "Path 72968",
    d: "M274.45,235.608s4.045,1.815,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.289,8.077-1.459S274.45,235.608,274.45,235.608Z",
    transform: "translate(-255.836 -233.36)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40675",
    "data-name": "Group 40675",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72969",
    "data-name": "Path 72969",
    d: "M252.678,235.022c.238-1.868,5.4-2.754,11.523-1.975.105.013.206.031.311.045a66.317,66.317,0,0,0-8.24,5.006C253.954,237.175,252.547,236.055,252.678,235.022Z",
    transform: "translate(-252.669 -232.764)",
    fill: "#ffdf2f"
  })))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40680",
    "data-name": "Group 40680",
    transform: "translate(110.369 111.896)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40678",
    "data-name": "Group 40678",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_125",
    "data-name": "Line 125",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40677",
    "data-name": "Group 40677",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72970",
    "data-name": "Path 72970",
    d: "M245.254,241.454l-14.626-5.6-3.131-1.2-.87,2.273c-.673,1.759,3.458,4.975,9.227,7.182s10.989,2.568,11.662.81l.869-2.272Z",
    transform: "translate(-226.555 -234.659)",
    fill: "url(#radial-gradient-43)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72971",
    "data-name": "Path 72971",
    d: "M248.616,242.357c-.673,1.759-5.894,1.4-11.663-.81s-9.9-5.423-9.226-7.182,5.9-1.395,11.662.811S249.289,240.6,248.616,242.357Z",
    transform: "translate(-226.786 -233.251)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72972",
    "data-name": "Path 72972",
    d: "M232.626,233.823s-4.423-.309-4.323,1.087,6.558,5.195,6.864,5.176c0,0-6.47-3.8-6.431-5.1S232.626,233.823,232.626,233.823Z",
    transform: "translate(-226.921 -233.365)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40679",
    "data-name": "Group 40679",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72973",
    "data-name": "Path 72973",
    d: "M251.647,242.838c.673-1.758-3.457-4.975-9.227-7.181-.1-.038-.2-.07-.294-.108a66.266,66.266,0,0,1,4.9,8.3C249.505,244.132,251.274,243.81,251.647,242.838Z",
    transform: "translate(-242.126 -235.549)",
    fill: "#ffee2f"
  })))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40684",
    "data-name": "Group 40684",
    transform: "translate(92.241 111.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40682",
    "data-name": "Group 40682",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_126",
    "data-name": "Line 126",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40681",
    "data-name": "Group 40681",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72974",
    "data-name": "Path 72974",
    d: "M207.266,235.924,222.8,237.9l3.327.421-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.412Z",
    transform: "translate(-203.625 -235.502)",
    fill: "url(#radial-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72975",
    "data-name": "Path 72975",
    d: "M204.022,234.9c-.237,1.868,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.013-10.665-4.791S204.26,233.036,204.022,234.9Z",
    transform: "translate(-203.707 -232.646)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72976",
    "data-name": "Path 72976",
    d: "M225.793,235.488s4.045,1.816,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.077-1.459S225.793,235.488,225.793,235.488Z",
    transform: "translate(-207.18 -233.241)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40683",
    "data-name": "Group 40683",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72977",
    "data-name": "Path 72977",
    d: "M204.022,234.9c.238-1.868,5.4-2.754,11.524-1.975.1.013.206.031.311.043a66.407,66.407,0,0,0-8.24,5.007C205.3,237.055,203.891,235.937,204.022,234.9Z",
    transform: "translate(-204.013 -232.646)",
    fill: "#ffee2f"
  })))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40688",
    "data-name": "Group 40688",
    transform: "translate(101.415 104.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40686",
    "data-name": "Group 40686",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_127",
    "data-name": "Line 127",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40685",
    "data-name": "Group 40685",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72978",
    "data-name": "Path 72978",
    d: "M218.87,227.526l15.537,1.972,3.327.421-.307,2.414c-.239,1.868-5.4,2.752-11.526,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-215.229 -227.104)",
    fill: "url(#radial-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72979",
    "data-name": "Path 72979",
    d: "M215.625,226.506c-.237,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.525-1.976-4.538-4.012-10.665-4.791S215.863,224.638,215.625,226.506Z",
    transform: "translate(-215.31 -224.248)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72980",
    "data-name": "Path 72980",
    d: "M237.4,227.092s4.045,1.814,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.078-1.459S237.4,227.092,237.4,227.092Z",
    transform: "translate(-218.783 -224.844)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40687",
    "data-name": "Group 40687",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72981",
    "data-name": "Path 72981",
    d: "M215.625,226.506c.238-1.868,5.4-2.754,11.524-1.975.105.013.206.031.311.043a66.519,66.519,0,0,0-8.239,5.007C216.9,228.657,215.494,227.539,215.625,226.506Z",
    transform: "translate(-215.616 -224.248)",
    fill: "#ffdf2f"
  })))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40692",
    "data-name": "Group 40692",
    transform: "translate(137.608 107.193)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40690",
    "data-name": "Group 40690",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_128",
    "data-name": "Line 128",
    x1: 0.868,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40689",
    "data-name": "Group 40689",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72982",
    "data-name": "Path 72982",
    d: "M279.71,235.5l-14.627-5.6-3.131-1.2-.87,2.273c-.674,1.759,3.459,4.975,9.227,7.182s10.99,2.567,11.662.81l.868-2.271Z",
    transform: "translate(-261.011 -228.71)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72983",
    "data-name": "Path 72983",
    d: "M283.071,236.408c-.673,1.757-5.894,1.4-11.662-.811s-9.9-5.423-9.226-7.182,5.9-1.395,11.662.812S283.744,234.649,283.071,236.408Z",
    transform: "translate(-261.241 -227.302)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72984",
    "data-name": "Path 72984",
    d: "M267.082,227.873s-4.423-.309-4.322,1.087,6.557,5.195,6.864,5.176c0,0-6.47-3.794-6.43-5.1S267.082,227.873,267.082,227.873Z",
    transform: "translate(-261.377 -227.415)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40691",
    "data-name": "Group 40691",
    transform: "translate(12.309 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72985",
    "data-name": "Path 72985",
    d: "M286.1,236.889c.673-1.76-3.456-4.976-9.226-7.181-.1-.039-.2-.071-.295-.109a66.561,66.561,0,0,1,4.9,8.3C283.962,238.183,285.73,237.862,286.1,236.889Z",
    transform: "translate(-276.581 -229.599)",
    fill: "#ffee2f"
  })))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40696",
    "data-name": "Group 40696",
    transform: "translate(119.481 106.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40694",
    "data-name": "Group 40694",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_129",
    "data-name": "Line 129",
    x1: 0.307,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40693",
    "data-name": "Group 40693",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72986",
    "data-name": "Path 72986",
    d: "M241.722,229.975l15.536,1.972,3.326.421-.306,2.414c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-238.081 -229.551)",
    fill: "url(#radial-gradient-47)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72987",
    "data-name": "Path 72987",
    d: "M238.478,228.953c-.237,1.869,4.538,4.015,10.665,4.792s11.286-.107,11.523-1.975-4.538-4.014-10.664-4.791S238.716,227.086,238.478,228.953Z",
    transform: "translate(-238.163 -226.697)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72988",
    "data-name": "Path 72988",
    d: "M260.25,229.539s4.045,1.815,3.3,3-8.234,1.483-8.494,1.321c0,0,7.5-.29,8.078-1.459S260.25,229.539,260.25,229.539Z",
    transform: "translate(-241.635 -227.292)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40695",
    "data-name": "Group 40695",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72989",
    "data-name": "Path 72989",
    d: "M238.478,228.953c.238-1.867,5.4-2.753,11.524-1.973.1.013.206.029.311.043a66.269,66.269,0,0,0-8.239,5.007C239.755,231.105,238.347,229.988,238.478,228.953Z",
    transform: "translate(-238.469 -226.697)",
    fill: "#ffee2f"
  })))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40700",
    "data-name": "Group 40700",
    transform: "translate(135.454 128.892)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40698",
    "data-name": "Group 40698",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_130",
    "data-name": "Line 130",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40697",
    "data-name": "Group 40697",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72990",
    "data-name": "Path 72990",
    d: "M276.984,262.952l-14.626-5.6-3.131-1.2-.87,2.273c-.673,1.758,3.457,4.973,9.227,7.181s10.99,2.568,11.662.81l.869-2.272Z",
    transform: "translate(-258.286 -256.158)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72991",
    "data-name": "Path 72991",
    d: "M280.347,263.855c-.672,1.759-5.9,1.4-11.663-.81s-9.9-5.424-9.226-7.181,5.894-1.4,11.663.811S281.02,262.095,280.347,263.855Z",
    transform: "translate(-258.517 -254.749)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72992",
    "data-name": "Path 72992",
    d: "M264.357,255.319s-4.423-.308-4.323,1.088,6.558,5.2,6.863,5.176c0,0-6.47-3.795-6.43-5.1S264.357,255.319,264.357,255.319Z",
    transform: "translate(-258.652 -254.862)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40699",
    "data-name": "Group 40699",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72993",
    "data-name": "Path 72993",
    d: "M283.377,264.336c.673-1.76-3.457-4.975-9.226-7.181-.1-.038-.2-.072-.3-.108a66.5,66.5,0,0,1,4.9,8.3C281.236,265.63,283.006,265.309,283.377,264.336Z",
    transform: "translate(-273.856 -257.047)",
    fill: "#ffee2f"
  })))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40704",
    "data-name": "Group 40704",
    transform: "translate(117.327 128.413)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40702",
    "data-name": "Group 40702",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_131",
    "data-name": "Line 131",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40701",
    "data-name": "Group 40701",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72994",
    "data-name": "Path 72994",
    d: "M239,257.421l15.535,1.973,3.328.421-.308,2.414c-.238,1.867-5.4,2.752-11.524,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-235.356 -256.999)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72995",
    "data-name": "Path 72995",
    d: "M235.753,256.4c-.237,1.867,4.537,4.014,10.665,4.792s11.287-.107,11.525-1.976-4.539-4.013-10.666-4.792S235.991,254.533,235.753,256.4Z",
    transform: "translate(-235.438 -254.143)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72996",
    "data-name": "Path 72996",
    d: "M257.524,256.986s4.045,1.815,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.078-1.459S257.524,256.986,257.524,256.986Z",
    transform: "translate(-238.911 -254.739)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40703",
    "data-name": "Group 40703",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72997",
    "data-name": "Path 72997",
    d: "M235.753,256.4c.238-1.868,5.4-2.753,11.523-1.975.105.013.206.03.311.045a66.342,66.342,0,0,0-8.239,5.007C237.029,258.552,235.622,257.434,235.753,256.4Z",
    transform: "translate(-235.744 -254.143)",
    fill: "#ffee2f"
  })))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40708",
    "data-name": "Group 40708",
    transform: "translate(126.5 121.774)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40706",
    "data-name": "Group 40706",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_132",
    "data-name": "Line 132",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40705",
    "data-name": "Group 40705",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_72998",
    "data-name": "Path 72998",
    d: "M250.6,249.023,266.137,251l3.327.421-.307,2.414c-.238,1.868-5.4,2.752-11.526,1.974s-10.9-2.924-10.662-4.792l.306-2.413Z",
    transform: "translate(-246.96 -248.601)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_72999",
    "data-name": "Path 72999",
    d: "M247.356,248c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.108,11.525-1.976-4.539-4.013-10.665-4.792S247.594,246.135,247.356,248Z",
    transform: "translate(-247.041 -245.745)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73000",
    "data-name": "Path 73000",
    d: "M269.128,248.588s4.045,1.815,3.3,3-8.233,1.485-8.493,1.323c0,0,7.5-.29,8.077-1.459S269.128,248.588,269.128,248.588Z",
    transform: "translate(-250.514 -246.341)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40707",
    "data-name": "Group 40707",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73001",
    "data-name": "Path 73001",
    d: "M247.356,248c.238-1.868,5.4-2.754,11.524-1.975.105.013.206.031.311.045a66.184,66.184,0,0,0-8.24,5.007C248.633,250.155,247.225,249.036,247.356,248Z",
    transform: "translate(-247.347 -245.745)",
    fill: "#ffdf2f"
  })))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40712",
    "data-name": "Group 40712",
    transform: "translate(153.192 115.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40710",
    "data-name": "Group 40710",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_133",
    "data-name": "Line 133",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40709",
    "data-name": "Group 40709",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73002",
    "data-name": "Path 73002",
    d: "M299.422,245.926l-14.626-5.6-3.131-1.2L280.8,241.4c-.674,1.758,3.457,4.973,9.227,7.181s10.988,2.569,11.661.811l.87-2.273Z",
    transform: "translate(-280.724 -239.131)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73003",
    "data-name": "Path 73003",
    d: "M302.785,246.829c-.674,1.758-5.9,1.4-11.663-.81s-9.9-5.423-9.227-7.182,5.894-1.395,11.662.812S303.456,245.07,302.785,246.829Z",
    transform: "translate(-280.954 -237.723)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73004",
    "data-name": "Path 73004",
    d: "M286.794,238.294s-4.424-.309-4.323,1.087,6.558,5.2,6.864,5.176c0,0-6.47-3.794-6.43-5.1S286.794,238.294,286.794,238.294Z",
    transform: "translate(-281.089 -237.837)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40711",
    "data-name": "Group 40711",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73005",
    "data-name": "Path 73005",
    d: "M305.816,247.31c.671-1.758-3.457-4.974-9.227-7.181-.1-.038-.2-.071-.294-.108a66.649,66.649,0,0,1,4.9,8.3C303.672,248.6,305.442,248.283,305.816,247.31Z",
    transform: "translate(-296.294 -240.022)",
    fill: "#ffee2f"
  })))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40716",
    "data-name": "Group 40716",
    transform: "translate(135.064 114.953)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40714",
    "data-name": "Group 40714",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_134",
    "data-name": "Line 134",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40713",
    "data-name": "Group 40713",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73006",
    "data-name": "Path 73006",
    d: "M261.435,240.4l15.535,1.974,3.326.42-.306,2.415c-.238,1.868-5.4,2.753-11.525,1.973s-10.9-2.923-10.663-4.791l.307-2.414Z",
    transform: "translate(-257.793 -239.973)",
    fill: "url(#radial-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73007",
    "data-name": "Path 73007",
    d: "M258.19,239.375c-.237,1.868,4.537,4.014,10.665,4.793s11.286-.108,11.523-1.977-4.537-4.012-10.664-4.79S258.428,237.507,258.19,239.375Z",
    transform: "translate(-257.875 -237.118)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73008",
    "data-name": "Path 73008",
    d: "M279.962,239.961s4.044,1.816,3.3,3-8.234,1.483-8.493,1.323c0,0,7.5-.292,8.077-1.459S279.962,239.961,279.962,239.961Z",
    transform: "translate(-261.348 -237.713)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40715",
    "data-name": "Group 40715",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73009",
    "data-name": "Path 73009",
    d: "M258.19,239.375c.238-1.868,5.4-2.753,11.524-1.974.105.013.206.03.311.045a66.27,66.27,0,0,0-8.24,5.006C259.467,241.528,258.059,240.409,258.19,239.375Z",
    transform: "translate(-258.181 -237.118)",
    fill: "#ffee2f"
  })))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40720",
    "data-name": "Group 40720",
    transform: "translate(142.279 113.355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40718",
    "data-name": "Group 40718",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_135",
    "data-name": "Line 135",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40717",
    "data-name": "Group 40717",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73010",
    "data-name": "Path 73010",
    d: "M285.619,243.3,270.992,237.7l-3.131-1.2-.87,2.273c-.674,1.758,3.458,4.973,9.227,7.181s10.988,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-266.92 -236.505)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73011",
    "data-name": "Path 73011",
    d: "M288.981,244.2c-.673,1.758-5.9,1.4-11.664-.81s-9.9-5.425-9.226-7.182,5.9-1.4,11.664.811S289.654,242.443,288.981,244.2Z",
    transform: "translate(-267.15 -235.096)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73012",
    "data-name": "Path 73012",
    d: "M272.99,235.668s-4.423-.311-4.323,1.086,6.559,5.2,6.864,5.177c0,0-6.47-3.8-6.43-5.1S272.99,235.668,272.99,235.668Z",
    transform: "translate(-267.286 -235.21)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40719",
    "data-name": "Group 40719",
    transform: "translate(12.309 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73013",
    "data-name": "Path 73013",
    d: "M292.012,244.683c.673-1.759-3.458-4.975-9.226-7.181-.1-.038-.2-.071-.3-.108a66.5,66.5,0,0,1,4.9,8.3C289.871,245.977,291.638,245.656,292.012,244.683Z",
    transform: "translate(-282.49 -237.394)",
    fill: "#ffee2f"
  })))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40724",
    "data-name": "Group 40724",
    transform: "translate(124.152 112.876)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40722",
    "data-name": "Group 40722",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_136",
    "data-name": "Line 136",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40721",
    "data-name": "Group 40721",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73014",
    "data-name": "Path 73014",
    d: "M247.631,237.768l15.536,1.973,3.326.421-.306,2.414c-.238,1.869-5.4,2.753-11.525,1.975s-10.9-2.924-10.664-4.792l.306-2.414Z",
    transform: "translate(-243.99 -237.345)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73015",
    "data-name": "Path 73015",
    d: "M244.386,236.747c-.236,1.868,4.538,4.016,10.665,4.793s11.287-.108,11.523-1.976-4.538-4.013-10.664-4.791S244.624,234.879,244.386,236.747Z",
    transform: "translate(-244.071 -234.491)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73016",
    "data-name": "Path 73016",
    d: "M266.157,237.333s4.045,1.815,3.3,3-8.233,1.484-8.494,1.323c0,0,7.5-.29,8.078-1.459S266.157,237.333,266.157,237.333Z",
    transform: "translate(-247.545 -235.086)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40723",
    "data-name": "Group 40723",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73017",
    "data-name": "Path 73017",
    d: "M244.386,236.747c.238-1.868,5.4-2.753,11.525-1.973.1.013.206.029.311.044a66.3,66.3,0,0,0-8.24,5.006C245.663,238.9,244.255,237.782,244.386,236.747Z",
    transform: "translate(-244.377 -234.491)",
    fill: "#ffee2f"
  })))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40728",
    "data-name": "Group 40728",
    transform: "translate(133.326 106.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40726",
    "data-name": "Group 40726",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_137",
    "data-name": "Line 137",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40725",
    "data-name": "Group 40725",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73018",
    "data-name": "Path 73018",
    d: "M259.235,229.37l15.536,1.973,3.328.421-.308,2.414c-.238,1.867-5.4,2.753-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-255.594 -228.948)",
    fill: "url(#radial-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73019",
    "data-name": "Path 73019",
    d: "M255.99,228.35c-.237,1.867,4.538,4.014,10.665,4.792s11.288-.108,11.526-1.976-4.539-4.013-10.666-4.791S256.228,226.482,255.99,228.35Z",
    transform: "translate(-255.675 -226.093)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73020",
    "data-name": "Path 73020",
    d: "M277.762,228.936s4.045,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S277.762,228.936,277.762,228.936Z",
    transform: "translate(-259.148 -226.689)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40727",
    "data-name": "Group 40727",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73021",
    "data-name": "Path 73021",
    d: "M255.99,228.35c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.029.309.044a66.243,66.243,0,0,0-8.238,5.007C257.267,230.5,255.859,229.383,255.99,228.35Z",
    transform: "translate(-255.981 -226.093)",
    fill: "#ffdf2f"
  })))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40732",
    "data-name": "Group 40732",
    transform: "translate(173.47 132.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40730",
    "data-name": "Group 40730",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_138",
    "data-name": "Line 138",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40729",
    "data-name": "Group 40729",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73022",
    "data-name": "Path 73022",
    d: "M325.073,267.679l-14.625-5.593-3.132-1.2-.87,2.274c-.673,1.757,3.458,4.973,9.227,7.18s10.99,2.568,11.662.81l.87-2.272Z",
    transform: "translate(-306.374 -260.887)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73023",
    "data-name": "Path 73023",
    d: "M328.436,268.584c-.673,1.758-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.181,5.9-1.4,11.664.81S329.108,266.825,328.436,268.584Z",
    transform: "translate(-306.604 -259.478)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73024",
    "data-name": "Path 73024",
    d: "M312.445,260.049s-4.422-.309-4.321,1.087,6.558,5.2,6.863,5.177c0,0-6.471-3.8-6.431-5.1S312.445,260.049,312.445,260.049Z",
    transform: "translate(-306.74 -259.591)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40731",
    "data-name": "Group 40731",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73025",
    "data-name": "Path 73025",
    d: "M331.467,269.065c.672-1.759-3.458-4.974-9.226-7.181-.1-.037-.2-.07-.295-.107a66.408,66.408,0,0,1,4.9,8.3C329.325,270.359,331.094,270.038,331.467,269.065Z",
    transform: "translate(-321.946 -261.777)",
    fill: "#ffee2f"
  })))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40736",
    "data-name": "Group 40736",
    transform: "translate(155.343 132.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40734",
    "data-name": "Group 40734",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_139",
    "data-name": "Line 139",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40733",
    "data-name": "Group 40733",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73026",
    "data-name": "Path 73026",
    d: "M287.085,262.15l15.537,1.973,3.325.421-.307,2.414c-.237,1.868-5.4,2.753-11.523,1.973s-10.9-2.923-10.665-4.792l.307-2.413Z",
    transform: "translate(-283.444 -261.728)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73027",
    "data-name": "Path 73027",
    d: "M283.841,261.13c-.236,1.868,4.539,4.014,10.664,4.792s11.288-.106,11.524-1.975-4.537-4.013-10.665-4.792S284.08,259.262,283.841,261.13Z",
    transform: "translate(-283.526 -258.872)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73028",
    "data-name": "Path 73028",
    d: "M305.612,261.716s4.045,1.815,3.3,3-8.235,1.484-8.5,1.323c0,0,7.5-.291,8.078-1.46S305.612,261.716,305.612,261.716Z",
    transform: "translate(-286.999 -259.468)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40735",
    "data-name": "Group 40735",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73029",
    "data-name": "Path 73029",
    d: "M283.841,261.13c.24-1.868,5.4-2.754,11.523-1.975.105.013.207.031.311.045a66.479,66.479,0,0,0-8.239,5.006C285.118,263.282,283.71,262.163,283.841,261.13Z",
    transform: "translate(-283.832 -258.872)",
    fill: "#ffee2f"
  })))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40740",
    "data-name": "Group 40740",
    transform: "translate(164.516 125.512)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40738",
    "data-name": "Group 40738",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_140",
    "data-name": "Line 140",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40737",
    "data-name": "Group 40737",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73030",
    "data-name": "Path 73030",
    d: "M298.689,253.752l15.537,1.974,3.326.42-.308,2.414c-.238,1.869-5.4,2.753-11.523,1.975s-10.9-2.924-10.665-4.792l.306-2.414Z",
    transform: "translate(-295.048 -253.33)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73031",
    "data-name": "Path 73031",
    d: "M295.444,252.732c-.237,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.525-1.976-4.539-4.011-10.665-4.791S295.682,250.864,295.444,252.732Z",
    transform: "translate(-295.129 -250.474)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73032",
    "data-name": "Path 73032",
    d: "M317.218,253.318s4.044,1.814,3.295,3-8.234,1.485-8.493,1.323c0,0,7.494-.291,8.076-1.459S317.218,253.318,317.218,253.318Z",
    transform: "translate(-298.603 -251.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40739",
    "data-name": "Group 40739",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73033",
    "data-name": "Path 73033",
    d: "M295.444,252.732c.238-1.868,5.4-2.753,11.524-1.975.105.014.206.031.311.044a66.4,66.4,0,0,0-8.24,5.007C296.72,254.884,295.313,253.765,295.444,252.732Z",
    transform: "translate(-295.435 -250.474)",
    fill: "#ffdf2f"
  })))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40744",
    "data-name": "Group 40744",
    transform: "translate(144.179 125.897)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40742",
    "data-name": "Group 40742",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_141",
    "data-name": "Line 141",
    x1: 0.868,
    y2: 2.271,
    transform: "translate(20.962 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40741",
    "data-name": "Group 40741",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73034",
    "data-name": "Path 73034",
    d: "M288.022,259.164l-14.627-5.6-3.131-1.2-.869,2.273c-.674,1.758,3.457,4.974,9.226,7.181s10.99,2.569,11.664.81l.868-2.271Z",
    transform: "translate(-269.323 -252.369)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73035",
    "data-name": "Path 73035",
    d: "M291.383,260.067c-.673,1.758-5.894,1.4-11.664-.811s-9.9-5.422-9.225-7.182,5.894-1.4,11.663.812S292.055,258.308,291.383,260.067Z",
    transform: "translate(-269.553 -250.961)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73036",
    "data-name": "Path 73036",
    d: "M275.393,251.533s-4.423-.31-4.323,1.086,6.558,5.2,6.864,5.177c0,0-6.47-3.795-6.43-5.1S275.393,251.533,275.393,251.533Z",
    transform: "translate(-269.689 -251.075)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40743",
    "data-name": "Group 40743",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73037",
    "data-name": "Path 73037",
    d: "M294.414,260.549c.672-1.76-3.456-4.977-9.226-7.181-.1-.039-.2-.07-.295-.108a66.235,66.235,0,0,1,4.9,8.3C292.272,261.842,294.041,261.521,294.414,260.549Z",
    transform: "translate(-284.893 -253.26)",
    fill: "#ffee2f"
  })))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40748",
    "data-name": "Group 40748",
    transform: "translate(126.052 125.419)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40746",
    "data-name": "Group 40746",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_142",
    "data-name": "Line 142",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40745",
    "data-name": "Group 40745",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73038",
    "data-name": "Path 73038",
    d: "M250.034,253.634l15.536,1.973,3.327.421-.307,2.414c-.239,1.867-5.4,2.752-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-246.393 -253.211)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73039",
    "data-name": "Path 73039",
    d: "M246.789,252.613c-.236,1.868,4.537,4.014,10.665,4.792s11.288-.108,11.524-1.976-4.539-4.013-10.665-4.792S247.027,250.746,246.789,252.613Z",
    transform: "translate(-246.474 -250.356)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73040",
    "data-name": "Path 73040",
    d: "M268.56,253.2s4.044,1.816,3.3,3-8.234,1.484-8.495,1.322c0,0,7.5-.29,8.079-1.459S268.56,253.2,268.56,253.2Z",
    transform: "translate(-249.947 -250.951)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40747",
    "data-name": "Group 40747",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73041",
    "data-name": "Path 73041",
    d: "M246.789,252.613c.238-1.867,5.4-2.753,11.523-1.975l.311.045a66.185,66.185,0,0,0-8.24,5.007C248.066,254.765,246.658,253.647,246.789,252.613Z",
    transform: "translate(-246.78 -250.356)",
    fill: "#ffee2f"
  })))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40752",
    "data-name": "Group 40752",
    transform: "translate(135.225 118.779)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40750",
    "data-name": "Group 40750",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_143",
    "data-name": "Line 143",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40749",
    "data-name": "Group 40749",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73042",
    "data-name": "Path 73042",
    d: "M261.637,245.236l15.537,1.972,3.326.422-.306,2.414c-.238,1.868-5.4,2.753-11.525,1.974s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-257.996 -244.813)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73043",
    "data-name": "Path 73043",
    d: "M258.392,244.215c-.237,1.868,4.538,4.014,10.664,4.792s11.288-.106,11.525-1.974-4.538-4.014-10.665-4.792S258.631,242.347,258.392,244.215Z",
    transform: "translate(-258.077 -241.958)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73044",
    "data-name": "Path 73044",
    d: "M280.165,244.8s4.044,1.815,3.3,3-8.234,1.483-8.493,1.322c0,0,7.5-.289,8.077-1.459S280.165,244.8,280.165,244.8Z",
    transform: "translate(-261.551 -242.553)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40751",
    "data-name": "Group 40751",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73045",
    "data-name": "Path 73045",
    d: "M258.392,244.215c.239-1.868,5.4-2.754,11.523-1.974.105.013.207.03.311.044a66.573,66.573,0,0,0-8.239,5.006C259.669,246.367,258.261,245.249,258.392,244.215Z",
    transform: "translate(-258.384 -241.958)",
    fill: "#ffdf2f"
  })))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40756",
    "data-name": "Group 40756",
    transform: "translate(171.418 121.194)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40754",
    "data-name": "Group 40754",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_144",
    "data-name": "Line 144",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40753",
    "data-name": "Group 40753",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73046",
    "data-name": "Path 73046",
    d: "M322.476,253.214l-14.624-5.595-3.132-1.2-.87,2.273c-.673,1.759,3.459,4.974,9.227,7.181s10.989,2.569,11.661.81l.87-2.27Z",
    transform: "translate(-303.778 -246.42)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73047",
    "data-name": "Path 73047",
    d: "M325.839,254.118c-.673,1.757-5.9,1.4-11.663-.811s-9.9-5.423-9.226-7.182,5.9-1.4,11.663.812S326.512,252.359,325.839,254.118Z",
    transform: "translate(-304.009 -245.012)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73048",
    "data-name": "Path 73048",
    d: "M309.849,245.583s-4.422-.309-4.321,1.087,6.558,5.2,6.864,5.176c0,0-6.472-3.795-6.432-5.1S309.849,245.583,309.849,245.583Z",
    transform: "translate(-304.144 -245.125)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40755",
    "data-name": "Group 40755",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73049",
    "data-name": "Path 73049",
    d: "M328.869,254.6c.673-1.76-3.457-4.977-9.226-7.181-.1-.038-.2-.071-.3-.107a66.187,66.187,0,0,1,4.9,8.3C326.728,255.893,328.5,255.573,328.869,254.6Z",
    transform: "translate(-319.348 -247.311)",
    fill: "#ffee2f"
  })))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40760",
    "data-name": "Group 40760",
    transform: "translate(153.291 120.716)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40758",
    "data-name": "Group 40758",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_145",
    "data-name": "Line 145",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40757",
    "data-name": "Group 40757",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73050",
    "data-name": "Path 73050",
    d: "M284.489,247.684l15.535,1.972,3.327.422-.305,2.414c-.24,1.867-5.4,2.751-11.526,1.974s-10.9-2.924-10.664-4.792l.306-2.414Z",
    transform: "translate(-280.848 -247.261)",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73051",
    "data-name": "Path 73051",
    d: "M281.244,246.663c-.236,1.869,4.537,4.015,10.665,4.792s11.288-.106,11.524-1.975-4.538-4.013-10.664-4.791S281.482,244.8,281.244,246.663Z",
    transform: "translate(-280.929 -244.407)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73052",
    "data-name": "Path 73052",
    d: "M303.016,247.249s4.045,1.816,3.3,3-8.235,1.484-8.493,1.323c0,0,7.5-.291,8.076-1.459S303.016,247.249,303.016,247.249Z",
    transform: "translate(-284.403 -245.002)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40759",
    "data-name": "Group 40759",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73053",
    "data-name": "Path 73053",
    d: "M281.244,246.663c.238-1.867,5.4-2.753,11.524-1.973.105.013.206.029.311.044a66.264,66.264,0,0,0-8.238,5.006C282.52,248.815,281.113,247.7,281.244,246.663Z",
    transform: "translate(-281.235 -244.407)",
    fill: "#ffee2f"
  })))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40764",
    "data-name": "Group 40764",
    transform: "translate(162.464 114.076)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40762",
    "data-name": "Group 40762",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_146",
    "data-name": "Line 146",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40761",
    "data-name": "Group 40761",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73054",
    "data-name": "Path 73054",
    d: "M296.092,239.286l15.536,1.974,3.326.42-.306,2.414c-.236,1.868-5.4,2.753-11.526,1.974s-10.9-2.923-10.662-4.792l.306-2.412Z",
    transform: "translate(-292.452 -238.864)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73055",
    "data-name": "Path 73055",
    d: "M292.848,238.266c-.238,1.868,4.537,4.014,10.665,4.792s11.287-.107,11.523-1.976-4.537-4.012-10.664-4.791S293.086,236.4,292.848,238.266Z",
    transform: "translate(-292.533 -236.008)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73056",
    "data-name": "Path 73056",
    d: "M314.619,238.852s4.046,1.815,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.078-1.459S314.619,238.852,314.619,238.852Z",
    transform: "translate(-296.007 -236.604)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40763",
    "data-name": "Group 40763",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73057",
    "data-name": "Path 73057",
    d: "M292.848,238.266c.238-1.868,5.4-2.753,11.524-1.975.1.013.206.031.311.045a66.2,66.2,0,0,0-8.24,5.006C294.125,240.417,292.716,239.3,292.848,238.266Z",
    transform: "translate(-292.839 -236.008)",
    fill: "#ffdf2f"
  })))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40768",
    "data-name": "Group 40768",
    transform: "translate(210.337 125.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40766",
    "data-name": "Group 40766",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_147",
    "data-name": "Line 147",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.96 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40765",
    "data-name": "Group 40765",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73058",
    "data-name": "Path 73058",
    d: "M371.707,258.669l-14.627-5.6-3.131-1.2-.87,2.274c-.674,1.758,3.458,4.973,9.226,7.181s10.99,2.569,11.662.81l.87-2.271Z",
    transform: "translate(-353.008 -251.874)",
    fill: "url(#radial-gradient-65)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73059",
    "data-name": "Path 73059",
    d: "M375.068,259.572c-.673,1.76-5.9,1.4-11.662-.811s-9.9-5.422-9.226-7.181,5.894-1.4,11.662.812S375.741,257.813,375.068,259.572Z",
    transform: "translate(-353.238 -250.466)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73060",
    "data-name": "Path 73060",
    d: "M359.078,251.037s-4.423-.309-4.323,1.088,6.558,5.195,6.864,5.176c0,0-6.471-3.8-6.432-5.1S359.078,251.037,359.078,251.037Z",
    transform: "translate(-353.374 -250.58)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40767",
    "data-name": "Group 40767",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73061",
    "data-name": "Path 73061",
    d: "M378.1,260.053c.673-1.758-3.458-4.975-9.226-7.181-.1-.038-.2-.071-.295-.108a66.469,66.469,0,0,1,4.9,8.3C375.957,261.347,377.726,261.026,378.1,260.053Z",
    transform: "translate(-368.578 -252.765)",
    fill: "#ffee2f"
  })))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40772",
    "data-name": "Group 40772",
    transform: "translate(180.005 123.078)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40770",
    "data-name": "Group 40770",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_148",
    "data-name": "Line 148",
    x1: 0.305,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40769",
    "data-name": "Group 40769",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73062",
    "data-name": "Path 73062",
    d: "M318.28,250.672l15.537,1.973,3.327.421-.307,2.414c-.239,1.868-5.4,2.753-11.525,1.974s-10.9-2.924-10.663-4.792l.305-2.413Z",
    transform: "translate(-314.64 -250.251)",
    fill: "url(#radial-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73063",
    "data-name": "Path 73063",
    d: "M315.035,249.653c-.235,1.867,4.537,4.013,10.665,4.792s11.286-.108,11.524-1.976-4.539-4.012-10.666-4.791S315.274,247.785,315.035,249.653Z",
    transform: "translate(-314.721 -247.395)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73064",
    "data-name": "Path 73064",
    d: "M336.808,250.238s4.044,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.078-1.46S336.808,250.238,336.808,250.238Z",
    transform: "translate(-318.194 -247.991)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40771",
    "data-name": "Group 40771",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73065",
    "data-name": "Path 73065",
    d: "M315.035,249.653c.239-1.868,5.4-2.754,11.523-1.975.107.013.207.03.311.044a66.493,66.493,0,0,0-8.238,5.007C316.312,251.8,314.905,250.685,315.035,249.653Z",
    transform: "translate(-315.027 -247.395)",
    fill: "#ffee2f"
  })))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40776",
    "data-name": "Group 40776",
    transform: "translate(169.053 139.122)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40774",
    "data-name": "Group 40774",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_149",
    "data-name": "Line 149",
    x1: 0.868,
    y2: 2.273,
    transform: "translate(20.963 9.104)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40773",
    "data-name": "Group 40773",
    transform: "translate(0 1.112)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73066",
    "data-name": "Path 73066",
    d: "M319.486,275.891,304.861,270.3l-3.132-1.2-.87,2.274c-.672,1.758,3.459,4.973,9.227,7.18s10.989,2.569,11.664.811l.868-2.274Z",
    transform: "translate(-300.787 -269.097)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73067",
    "data-name": "Path 73067",
    d: "M322.849,276.794c-.673,1.76-5.9,1.4-11.664-.809s-9.9-5.423-9.226-7.182,5.9-1.394,11.664.812S323.521,275.037,322.849,276.794Z",
    transform: "translate(-301.018 -267.69)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73068",
    "data-name": "Path 73068",
    d: "M306.859,268.262s-4.423-.311-4.323,1.085,6.559,5.2,6.864,5.175c0,0-6.472-3.792-6.433-5.1S306.859,268.262,306.859,268.262Z",
    transform: "translate(-301.153 -267.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40775",
    "data-name": "Group 40775",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73069",
    "data-name": "Path 73069",
    d: "M325.88,277.275c.673-1.757-3.458-4.973-9.226-7.18-.1-.038-.2-.071-.295-.108a66.116,66.116,0,0,1,4.9,8.3C323.738,278.569,325.507,278.249,325.88,277.275Z",
    transform: "translate(-316.359 -269.988)",
    fill: "#ffee2f"
  })))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40780",
    "data-name": "Group 40780",
    transform: "translate(151.135 142.414)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40778",
    "data-name": "Group 40778",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_150",
    "data-name": "Line 150",
    x1: 0.308,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40777",
    "data-name": "Group 40777",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73070",
    "data-name": "Path 73070",
    d: "M281.763,275.132,297.3,277.1l3.325.422-.305,2.414c-.239,1.867-5.4,2.753-11.525,1.974s-10.9-2.924-10.665-4.792l.308-2.414Z",
    transform: "translate(-278.122 -274.708)",
    fill: "url(#radial-gradient-6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73071",
    "data-name": "Path 73071",
    d: "M278.521,274.11c-.238,1.87,4.537,4.015,10.662,4.792s11.288-.106,11.524-1.974-4.537-4.015-10.663-4.792S278.758,272.242,278.521,274.11Z",
    transform: "translate(-278.204 -271.854)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73072",
    "data-name": "Path 73072",
    d: "M300.29,274.7s4.045,1.815,3.3,3-8.234,1.484-8.5,1.322c0,0,7.5-.29,8.08-1.458S300.29,274.7,300.29,274.7Z",
    transform: "translate(-281.677 -272.449)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40779",
    "data-name": "Group 40779",
    transform: "translate(0.308)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73073",
    "data-name": "Path 73073",
    d: "M278.521,274.11c.237-1.868,5.4-2.753,11.523-1.973.1.012.206.029.309.044a66.187,66.187,0,0,0-8.238,5.007C279.8,276.263,278.389,275.144,278.521,274.11Z",
    transform: "translate(-278.512 -271.854)",
    fill: "#ffee2f"
  })))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40784",
    "data-name": "Group 40784",
    transform: "translate(160.309 135.775)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40782",
    "data-name": "Group 40782",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_151",
    "data-name": "Line 151",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40781",
    "data-name": "Group 40781",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73074",
    "data-name": "Path 73074",
    d: "M293.367,266.733l15.537,1.973,3.326.421-.306,2.414c-.24,1.868-5.4,2.753-11.525,1.975s-10.9-2.924-10.665-4.792l.306-2.413Z",
    transform: "translate(-289.726 -266.311)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73075",
    "data-name": "Path 73075",
    d: "M290.122,265.713c-.236,1.869,4.538,4.014,10.665,4.791s11.288-.106,11.525-1.974-4.537-4.013-10.665-4.791S290.36,263.845,290.122,265.713Z",
    transform: "translate(-289.807 -263.456)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73076",
    "data-name": "Path 73076",
    d: "M311.9,266.3s4.044,1.815,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.291,8.077-1.459S311.9,266.3,311.9,266.3Z",
    transform: "translate(-293.281 -264.051)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40783",
    "data-name": "Group 40783",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73077",
    "data-name": "Path 73077",
    d: "M290.122,265.713c.238-1.868,5.4-2.753,11.524-1.974.105.013.206.03.311.044a66.192,66.192,0,0,0-8.24,5.007C291.4,267.865,289.992,266.746,290.122,265.713Z",
    transform: "translate(-290.114 -263.456)",
    fill: "#ffdf2f"
  })))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40788",
    "data-name": "Group 40788",
    transform: "translate(187.001 129.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40786",
    "data-name": "Group 40786",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_152",
    "data-name": "Line 152",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40785",
    "data-name": "Group 40785",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73078",
    "data-name": "Path 73078",
    d: "M342.188,263.635l-14.624-5.594-3.131-1.2-.87,2.274c-.673,1.757,3.457,4.973,9.227,7.18s10.99,2.569,11.662.811l.869-2.273Z",
    transform: "translate(-323.49 -256.842)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73079",
    "data-name": "Path 73079",
    d: "M345.551,264.539c-.674,1.76-5.9,1.4-11.663-.809s-9.9-5.424-9.225-7.182,5.894-1.4,11.662.812S346.222,262.78,345.551,264.539Z",
    transform: "translate(-323.721 -255.433)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73080",
    "data-name": "Path 73080",
    d: "M329.56,256s-4.422-.309-4.323,1.088,6.559,5.2,6.865,5.176c0,0-6.471-3.8-6.432-5.1S329.56,256,329.56,256Z",
    transform: "translate(-323.856 -255.547)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40787",
    "data-name": "Group 40787",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73081",
    "data-name": "Path 73081",
    d: "M348.581,265.02c.671-1.759-3.457-4.974-9.226-7.18-.1-.039-.2-.072-.3-.108a66.113,66.113,0,0,1,4.9,8.3C346.44,266.314,348.208,265.993,348.581,265.02Z",
    transform: "translate(-339.06 -257.732)",
    fill: "#ffee2f"
  })))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40792",
    "data-name": "Group 40792",
    transform: "translate(168.874 128.954)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40790",
    "data-name": "Group 40790",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_153",
    "data-name": "Line 153",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40789",
    "data-name": "Group 40789",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73082",
    "data-name": "Path 73082",
    d: "M304.2,258.105l15.535,1.973,3.327.421-.307,2.414c-.238,1.868-5.395,2.753-11.523,1.974s-10.9-2.924-10.665-4.792l.307-2.414Z",
    transform: "translate(-300.56 -257.683)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73083",
    "data-name": "Path 73083",
    d: "M300.957,257.085c-.236,1.868,4.537,4.015,10.664,4.793s11.288-.108,11.524-1.976-4.537-4.012-10.665-4.792S301.194,255.217,300.957,257.085Z",
    transform: "translate(-300.642 -254.828)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73084",
    "data-name": "Path 73084",
    d: "M322.728,257.671s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.459S322.728,257.671,322.728,257.671Z",
    transform: "translate(-304.115 -255.423)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40791",
    "data-name": "Group 40791",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73085",
    "data-name": "Path 73085",
    d: "M300.957,257.085c.237-1.868,5.4-2.753,11.523-1.975.105.014.206.031.311.046a66.249,66.249,0,0,0-8.239,5.007C302.233,259.238,300.826,258.118,300.957,257.085Z",
    transform: "translate(-300.948 -254.828)",
    fill: "#ffee2f"
  })))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40796",
    "data-name": "Group 40796",
    transform: "translate(178.048 122.315)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40794",
    "data-name": "Group 40794",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_154",
    "data-name": "Line 154",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40793",
    "data-name": "Group 40793",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73086",
    "data-name": "Path 73086",
    d: "M315.805,249.709l15.535,1.972,3.326.421-.306,2.414c-.236,1.867-5.4,2.751-11.526,1.973s-10.9-2.923-10.662-4.792l.306-2.413Z",
    transform: "translate(-312.164 -249.286)",
    fill: "url(#radial-gradient-72)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73087",
    "data-name": "Path 73087",
    d: "M312.56,248.688c-.238,1.867,4.537,4.013,10.665,4.792s11.287-.108,11.523-1.976-4.537-4.013-10.664-4.792S312.8,246.821,312.56,248.688Z",
    transform: "translate(-312.245 -246.43)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73088",
    "data-name": "Path 73088",
    d: "M334.332,249.273s4.045,1.815,3.3,3-8.235,1.483-8.494,1.322c0,0,7.494-.291,8.076-1.459S334.332,249.273,334.332,249.273Z",
    transform: "translate(-315.719 -247.026)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40795",
    "data-name": "Group 40795",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73089",
    "data-name": "Path 73089",
    d: "M312.56,248.688c.238-1.867,5.4-2.753,11.524-1.976.105.014.206.031.311.045a66.385,66.385,0,0,0-8.24,5.007C313.837,250.84,312.429,249.72,312.56,248.688Z",
    transform: "translate(-312.551 -246.43)",
    fill: "#ffdf2f"
  })))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40800",
    "data-name": "Group 40800",
    transform: "translate(74.501 108.047)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40798",
    "data-name": "Group 40798",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_155",
    "data-name": "Line 155",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40797",
    "data-name": "Group 40797",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73090",
    "data-name": "Path 73090",
    d: "M199.885,236.585l-14.627-5.6-3.131-1.2-.87,2.274c-.672,1.759,3.459,4.974,9.228,7.181s10.99,2.568,11.662.81l.87-2.271Z",
    transform: "translate(-181.184 -229.789)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73091",
    "data-name": "Path 73091",
    d: "M203.247,237.488c-.673,1.758-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.183,5.9-1.395,11.663.813S203.919,235.729,203.247,237.488Z",
    transform: "translate(-181.415 -228.382)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73092",
    "data-name": "Path 73092",
    d: "M187.256,228.953s-4.424-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.471-3.795-6.433-5.1S187.256,228.953,187.256,228.953Z",
    transform: "translate(-181.55 -228.495)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40799",
    "data-name": "Group 40799",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73093",
    "data-name": "Path 73093",
    d: "M206.277,237.969c.672-1.759-3.458-4.974-9.227-7.181-.1-.038-.2-.07-.295-.108a66.333,66.333,0,0,1,4.9,8.3C204.136,239.263,205.9,238.942,206.277,237.969Z",
    transform: "translate(-196.756 -230.681)",
    fill: "#ffee2f"
  })))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40804",
    "data-name": "Group 40804",
    transform: "translate(56.374 107.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40802",
    "data-name": "Group 40802",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_156",
    "data-name": "Line 156",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40801",
    "data-name": "Group 40801",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73094",
    "data-name": "Path 73094",
    d: "M161.9,231.054l15.536,1.972,3.327.421-.307,2.414c-.238,1.868-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-158.255 -230.632)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73095",
    "data-name": "Path 73095",
    d: "M158.651,230.034c-.236,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.524-1.976-4.538-4.012-10.665-4.791S158.889,228.166,158.651,230.034Z",
    transform: "translate(-158.336 -227.776)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73096",
    "data-name": "Path 73096",
    d: "M180.423,230.62s4.045,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S180.423,230.62,180.423,230.62Z",
    transform: "translate(-161.81 -228.372)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40803",
    "data-name": "Group 40803",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73097",
    "data-name": "Path 73097",
    d: "M158.651,230.034c.238-1.868,5.4-2.753,11.524-1.975.105.013.206.031.311.045a66.116,66.116,0,0,0-8.239,5.006C159.928,232.185,158.52,231.067,158.651,230.034Z",
    transform: "translate(-158.642 -227.776)",
    fill: "#ffee2f"
  })))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40808",
    "data-name": "Group 40808",
    transform: "translate(65.547 100.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40806",
    "data-name": "Group 40806",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_157",
    "data-name": "Line 157",
    x1: 0.307,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40805",
    "data-name": "Group 40805",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73098",
    "data-name": "Path 73098",
    d: "M173.5,222.656l15.535,1.974,3.327.42-.307,2.414c-.238,1.869-5.4,2.753-11.525,1.975s-10.9-2.924-10.663-4.792l.307-2.414Z",
    transform: "translate(-169.859 -222.234)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73099",
    "data-name": "Path 73099",
    d: "M170.256,221.636c-.237,1.868,4.537,4.014,10.664,4.793s11.288-.108,11.524-1.977-4.538-4.012-10.665-4.79S170.493,219.768,170.256,221.636Z",
    transform: "translate(-169.941 -219.379)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73100",
    "data-name": "Path 73100",
    d: "M192.027,222.222s4.044,1.814,3.3,3-8.234,1.483-8.495,1.323c0,0,7.5-.292,8.078-1.46S192.027,222.222,192.027,222.222Z",
    transform: "translate(-173.413 -219.974)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40807",
    "data-name": "Group 40807",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73101",
    "data-name": "Path 73101",
    d: "M170.256,221.636c.237-1.868,5.4-2.753,11.523-1.974.1.012.206.03.311.044a66.319,66.319,0,0,0-8.239,5.007C171.533,223.789,170.124,222.67,170.256,221.636Z",
    transform: "translate(-170.247 -219.379)",
    fill: "#ffdf2f"
  })))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40812",
    "data-name": "Group 40812",
    transform: "translate(96.125 113.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40810",
    "data-name": "Group 40810",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_158",
    "data-name": "Line 158",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40809",
    "data-name": "Group 40809",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73102",
    "data-name": "Path 73102",
    d: "M227.238,243.07l-14.627-5.595-3.131-1.2-.87,2.273c-.673,1.758,3.459,4.973,9.227,7.181s10.99,2.569,11.663.81l.869-2.271Z",
    transform: "translate(-208.538 -236.276)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73103",
    "data-name": "Path 73103",
    d: "M230.6,243.973c-.673,1.759-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.182,5.9-1.4,11.664.811S231.272,242.214,230.6,243.973Z",
    transform: "translate(-208.769 -234.867)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73104",
    "data-name": "Path 73104",
    d: "M214.609,235.437s-4.423-.309-4.323,1.088,6.558,5.2,6.864,5.176c0,0-6.471-3.795-6.432-5.1S214.609,235.437,214.609,235.437Z",
    transform: "translate(-208.904 -234.98)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40811",
    "data-name": "Group 40811",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73105",
    "data-name": "Path 73105",
    d: "M233.63,244.454c.672-1.758-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.3-.108a66.412,66.412,0,0,1,4.9,8.3C231.489,245.748,233.258,245.427,233.63,244.454Z",
    transform: "translate(-224.109 -237.165)",
    fill: "#ffee2f"
  })))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40816",
    "data-name": "Group 40816",
    transform: "translate(77.998 112.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40814",
    "data-name": "Group 40814",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_159",
    "data-name": "Line 159",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40813",
    "data-name": "Group 40813",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73106",
    "data-name": "Path 73106",
    d: "M189.249,237.539l15.536,1.974,3.326.421-.306,2.414c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.414Z",
    transform: "translate(-185.608 -237.117)",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73107",
    "data-name": "Path 73107",
    d: "M186,236.519c-.237,1.868,4.537,4.014,10.664,4.791s11.287-.106,11.524-1.973-4.537-4.014-10.665-4.792S186.243,234.65,186,236.519Z",
    transform: "translate(-185.69 -234.261)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73108",
    "data-name": "Path 73108",
    d: "M207.776,237.1s4.045,1.814,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.077-1.459S207.776,237.1,207.776,237.1Z",
    transform: "translate(-189.163 -234.857)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40815",
    "data-name": "Group 40815",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73109",
    "data-name": "Path 73109",
    d: "M186,236.519c.238-1.869,5.4-2.754,11.523-1.975.105.013.206.031.311.045a66.326,66.326,0,0,0-8.239,5.006C187.281,238.671,185.874,237.552,186,236.519Z",
    transform: "translate(-185.996 -234.261)",
    fill: "#ffee2f"
  })))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40820",
    "data-name": "Group 40820",
    transform: "translate(87.171 106.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40818",
    "data-name": "Group 40818",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_160",
    "data-name": "Line 160",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40817",
    "data-name": "Group 40817",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73110",
    "data-name": "Path 73110",
    d: "M200.852,229.14l15.537,1.974,3.326.422-.307,2.414c-.237,1.867-5.4,2.751-11.525,1.973s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-197.211 -228.719)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73111",
    "data-name": "Path 73111",
    d: "M197.608,228.121c-.237,1.868,4.538,4.014,10.665,4.792s11.288-.108,11.524-1.975-4.538-4.014-10.665-4.792S197.846,226.252,197.608,228.121Z",
    transform: "translate(-197.293 -225.864)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73112",
    "data-name": "Path 73112",
    d: "M219.38,228.706s4.044,1.816,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.29,8.078-1.459S219.38,228.706,219.38,228.706Z",
    transform: "translate(-200.766 -226.459)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40819",
    "data-name": "Group 40819",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73113",
    "data-name": "Path 73113",
    d: "M197.608,228.121c.238-1.869,5.4-2.753,11.523-1.975l.311.045a66.2,66.2,0,0,0-8.24,5.007C198.885,230.273,197.477,229.155,197.608,228.121Z",
    transform: "translate(-197.599 -225.864)",
    fill: "#ffdf2f"
  })))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40824",
    "data-name": "Group 40824",
    transform: "translate(65.629 117.268)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40822",
    "data-name": "Group 40822",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_161",
    "data-name": "Line 161",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40821",
    "data-name": "Group 40821",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73114",
    "data-name": "Path 73114",
    d: "M188.661,248.25l-14.626-5.6-3.131-1.2-.87,2.273c-.674,1.76,3.458,4.974,9.227,7.181s10.989,2.569,11.662.81l.869-2.272Z",
    transform: "translate(-169.962 -241.455)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73115",
    "data-name": "Path 73115",
    d: "M192.023,249.152c-.673,1.757-5.894,1.4-11.663-.81s-9.9-5.423-9.226-7.182,5.894-1.4,11.663.812S192.695,247.393,192.023,249.152Z",
    transform: "translate(-170.192 -240.046)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73116",
    "data-name": "Path 73116",
    d: "M176.032,240.618s-4.422-.31-4.323,1.086,6.559,5.2,6.864,5.176c0,0-6.47-3.794-6.431-5.1S176.032,240.618,176.032,240.618Z",
    transform: "translate(-170.328 -240.16)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40823",
    "data-name": "Group 40823",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73117",
    "data-name": "Path 73117",
    d: "M195.054,249.634c.672-1.759-3.457-4.975-9.226-7.181-.1-.038-.2-.072-.295-.108a66.53,66.53,0,0,1,4.9,8.3C192.912,250.927,194.681,250.607,195.054,249.634Z",
    transform: "translate(-185.533 -242.345)",
    fill: "#ffee2f"
  })))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40828",
    "data-name": "Group 40828",
    transform: "translate(47.501 116.79)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40826",
    "data-name": "Group 40826",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_162",
    "data-name": "Line 162",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40825",
    "data-name": "Group 40825",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73118",
    "data-name": "Path 73118",
    d: "M150.673,242.719l15.536,1.973,3.326.421-.307,2.414c-.238,1.868-5.4,2.753-11.524,1.975s-10.9-2.924-10.664-4.792l.306-2.414Z",
    transform: "translate(-147.032 -242.296)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73119",
    "data-name": "Path 73119",
    d: "M147.428,241.7c-.236,1.868,4.538,4.014,10.665,4.793s11.286-.107,11.523-1.976-4.538-4.012-10.665-4.791S147.666,239.83,147.428,241.7Z",
    transform: "translate(-147.113 -239.441)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73120",
    "data-name": "Path 73120",
    d: "M169.2,242.284s4.046,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S169.2,242.284,169.2,242.284Z",
    transform: "translate(-150.586 -240.036)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40827",
    "data-name": "Group 40827",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73121",
    "data-name": "Path 73121",
    d: "M147.428,241.7c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.03.311.045a66.365,66.365,0,0,0-8.239,5.006C148.705,243.851,147.3,242.733,147.428,241.7Z",
    transform: "translate(-147.419 -239.441)",
    fill: "#ffee2f"
  })))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40832",
    "data-name": "Group 40832",
    transform: "translate(56.674 110.151)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40830",
    "data-name": "Group 40830",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_163",
    "data-name": "Line 163",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40829",
    "data-name": "Group 40829",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73122",
    "data-name": "Path 73122",
    d: "M162.276,234.321l15.536,1.973,3.327.421-.306,2.414c-.238,1.868-5.4,2.752-11.526,1.973s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-158.635 -233.899)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73123",
    "data-name": "Path 73123",
    d: "M159.032,233.3c-.237,1.867,4.537,4.014,10.664,4.792s11.288-.107,11.525-1.976-4.538-4.013-10.665-4.791S159.269,231.433,159.032,233.3Z",
    transform: "translate(-158.717 -231.043)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73124",
    "data-name": "Path 73124",
    d: "M180.8,233.886s4.045,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.078-1.459S180.8,233.886,180.8,233.886Z",
    transform: "translate(-162.19 -231.639)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40831",
    "data-name": "Group 40831",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73125",
    "data-name": "Path 73125",
    d: "M159.032,233.3c.237-1.868,5.4-2.754,11.523-1.974.105.013.206.029.311.044a66.419,66.419,0,0,0-8.239,5.006C160.308,235.453,158.9,234.335,159.032,233.3Z",
    transform: "translate(-159.023 -231.043)",
    fill: "#ffdf2f"
  })))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40836",
    "data-name": "Group 40836",
    transform: "translate(69.294 106.441)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40834",
    "data-name": "Group 40834",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_164",
    "data-name": "Line 164",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40833",
    "data-name": "Group 40833",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73126",
    "data-name": "Path 73126",
    d: "M193.3,234.553l-14.627-5.595-3.131-1.2-.87,2.273c-.674,1.757,3.458,4.973,9.227,7.18s10.99,2.569,11.662.811l.87-2.273Z",
    transform: "translate(-174.599 -227.76)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73127",
    "data-name": "Path 73127",
    d: "M196.661,235.456c-.674,1.76-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.181,5.9-1.4,11.663.811S197.333,233.7,196.661,235.456Z",
    transform: "translate(-174.829 -226.351)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73128",
    "data-name": "Path 73128",
    d: "M180.67,226.922s-4.423-.309-4.323,1.088,6.558,5.195,6.864,5.176c0,0-6.47-3.8-6.43-5.1S180.67,226.922,180.67,226.922Z",
    transform: "translate(-174.965 -226.465)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40835",
    "data-name": "Group 40835",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73129",
    "data-name": "Path 73129",
    d: "M199.691,235.937c.672-1.758-3.458-4.974-9.227-7.18-.1-.038-.2-.07-.295-.108a66.342,66.342,0,0,1,4.9,8.3C197.55,237.231,199.319,236.91,199.691,235.937Z",
    transform: "translate(-190.17 -228.65)",
    fill: "#ffee2f"
  })))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40840",
    "data-name": "Group 40840",
    transform: "translate(51.168 105.963)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40838",
    "data-name": "Group 40838",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_165",
    "data-name": "Line 165",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40837",
    "data-name": "Group 40837",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73130",
    "data-name": "Path 73130",
    d: "M155.311,229.023,170.847,231l3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.526,1.973s-10.9-2.922-10.662-4.791l.306-2.413Z",
    transform: "translate(-151.67 -228.601)",
    fill: "url(#radial-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73131",
    "data-name": "Path 73131",
    d: "M152.066,228c-.237,1.868,4.538,4.014,10.665,4.792s11.287-.107,11.524-1.975-4.539-4.013-10.665-4.792S152.3,226.135,152.066,228Z",
    transform: "translate(-151.751 -225.746)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73132",
    "data-name": "Path 73132",
    d: "M173.837,228.588s4.045,1.816,3.3,3-8.234,1.482-8.494,1.322c0,0,7.5-.29,8.077-1.459S173.837,228.588,173.837,228.588Z",
    transform: "translate(-155.224 -226.341)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40839",
    "data-name": "Group 40839",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73133",
    "data-name": "Path 73133",
    d: "M152.066,228c.238-1.868,5.4-2.753,11.523-1.975l.311.045a66.133,66.133,0,0,0-8.239,5.007C153.343,230.155,151.935,229.036,152.066,228Z",
    transform: "translate(-152.057 -225.746)",
    fill: "#ffee2f"
  })))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40844",
    "data-name": "Group 40844",
    transform: "translate(35.236 114.484)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40842",
    "data-name": "Group 40842",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_166",
    "data-name": "Line 166",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40841",
    "data-name": "Group 40841",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73134",
    "data-name": "Path 73134",
    d: "M135.158,239.8l15.536,1.972,3.327.422-.307,2.414c-.238,1.867-5.4,2.751-11.526,1.974s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-131.517 -239.378)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73135",
    "data-name": "Path 73135",
    d: "M131.913,238.78c-.236,1.868,4.538,4.015,10.665,4.792s11.288-.108,11.525-1.975-4.538-4.014-10.665-4.791S132.151,236.913,131.913,238.78Z",
    transform: "translate(-131.598 -236.524)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73136",
    "data-name": "Path 73136",
    d: "M153.685,239.365s4.046,1.817,3.3,3-8.234,1.483-8.495,1.321c0,0,7.5-.29,8.079-1.459S153.685,239.365,153.685,239.365Z",
    transform: "translate(-135.071 -237.119)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40843",
    "data-name": "Group 40843",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73137",
    "data-name": "Path 73137",
    d: "M131.913,238.78c.238-1.867,5.4-2.753,11.524-1.973.1.013.206.029.311.043a66.232,66.232,0,0,0-8.239,5.007C133.19,240.932,131.782,239.815,131.913,238.78Z",
    transform: "translate(-131.904 -236.524)",
    fill: "#ffdf2f"
  })))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40848",
    "data-name": "Group 40848",
    transform: "translate(24.295 118.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40846",
    "data-name": "Group 40846",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_167",
    "data-name": "Line 167",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40845",
    "data-name": "Group 40845",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73138",
    "data-name": "Path 73138",
    d: "M121.318,244.376l15.536,1.973,3.327.421-.307,2.414c-.238,1.867-5.4,2.751-11.526,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-117.677 -243.953)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73139",
    "data-name": "Path 73139",
    d: "M118.074,243.355c-.237,1.868,4.537,4.015,10.664,4.793s11.288-.108,11.525-1.976-4.538-4.014-10.665-4.791S118.312,241.488,118.074,243.355Z",
    transform: "translate(-117.759 -241.099)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73140",
    "data-name": "Path 73140",
    d: "M139.846,243.941s4.045,1.816,3.3,3-8.234,1.483-8.495,1.322c0,0,7.5-.291,8.078-1.459S139.846,243.941,139.846,243.941Z",
    transform: "translate(-121.232 -241.694)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40847",
    "data-name": "Group 40847",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73141",
    "data-name": "Path 73141",
    d: "M118.074,243.355c.238-1.867,5.4-2.753,11.523-1.973.105.013.206.03.311.043a66.384,66.384,0,0,0-8.239,5.007C119.35,245.507,117.943,244.39,118.074,243.355Z",
    transform: "translate(-118.065 -241.099)",
    fill: "#ffdf2f"
  })))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40852",
    "data-name": "Group 40852",
    transform: "translate(96.819 136.544)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40850",
    "data-name": "Group 40850",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_168",
    "data-name": "Line 168",
    x1: 0.869,
    y2: 2.273,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40849",
    "data-name": "Group 40849",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73142",
    "data-name": "Path 73142",
    d: "M228.116,272.632l-14.627-5.6-3.131-1.2-.87,2.273c-.673,1.759,3.458,4.974,9.227,7.181s10.99,2.569,11.663.811l.87-2.273Z",
    transform: "translate(-209.416 -265.837)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73143",
    "data-name": "Path 73143",
    d: "M231.478,273.534c-.674,1.759-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.182,5.9-1.4,11.663.812S232.149,271.776,231.478,273.534Z",
    transform: "translate(-209.646 -264.428)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73144",
    "data-name": "Path 73144",
    d: "M215.486,265s-4.422-.309-4.322,1.087,6.558,5.195,6.864,5.176c0,0-6.47-3.795-6.431-5.1S215.486,265,215.486,265Z",
    transform: "translate(-209.782 -264.542)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40851",
    "data-name": "Group 40851",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73145",
    "data-name": "Path 73145",
    d: "M234.508,274.015c.671-1.758-3.458-4.973-9.227-7.18-.1-.038-.2-.071-.295-.108a66.4,66.4,0,0,1,4.9,8.3C232.367,275.309,234.135,274.989,234.508,274.015Z",
    transform: "translate(-224.987 -266.727)",
    fill: "#ffee2f"
  })))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40856",
    "data-name": "Group 40856",
    transform: "translate(78.693 136.066)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40854",
    "data-name": "Group 40854",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_169",
    "data-name": "Line 169",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40853",
    "data-name": "Group 40853",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73146",
    "data-name": "Path 73146",
    d: "M190.128,267.1l15.536,1.972,3.326.422-.306,2.414c-.238,1.867-5.4,2.751-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-186.487 -266.678)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73147",
    "data-name": "Path 73147",
    d: "M186.883,266.08c-.236,1.869,4.538,4.015,10.665,4.792s11.287-.107,11.523-1.975-4.538-4.014-10.665-4.791S187.121,264.213,186.883,266.08Z",
    transform: "translate(-186.568 -263.824)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73148",
    "data-name": "Path 73148",
    d: "M208.655,266.665s4.044,1.817,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.289,8.077-1.459S208.655,266.665,208.655,266.665Z",
    transform: "translate(-190.041 -264.419)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40855",
    "data-name": "Group 40855",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73149",
    "data-name": "Path 73149",
    d: "M186.883,266.08c.238-1.867,5.4-2.753,11.523-1.973.105.013.207.03.311.044a66.383,66.383,0,0,0-8.24,5.007C188.16,268.232,186.752,267.115,186.883,266.08Z",
    transform: "translate(-186.874 -263.824)",
    fill: "#ffee2f"
  })))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40860",
    "data-name": "Group 40860",
    transform: "translate(87.866 129.426)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40858",
    "data-name": "Group 40858",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_170",
    "data-name": "Line 170",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40857",
    "data-name": "Group 40857",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73150",
    "data-name": "Path 73150",
    d: "M201.731,258.7l15.536,1.972,3.327.421-.306,2.414c-.238,1.869-5.4,2.753-11.526,1.974s-10.9-2.923-10.663-4.791l.306-2.414Z",
    transform: "translate(-198.09 -258.281)",
    fill: "url(#radial-gradient-34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73151",
    "data-name": "Path 73151",
    d: "M198.486,257.683c-.237,1.868,4.537,4.014,10.665,4.792s11.288-.107,11.524-1.976-4.537-4.012-10.665-4.791S198.724,255.815,198.486,257.683Z",
    transform: "translate(-198.171 -255.425)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73152",
    "data-name": "Path 73152",
    d: "M220.259,258.269s4.044,1.815,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.292,8.077-1.46S220.259,258.269,220.259,258.269Z",
    transform: "translate(-201.645 -256.021)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40859",
    "data-name": "Group 40859",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73153",
    "data-name": "Path 73153",
    d: "M198.486,257.683c.238-1.868,5.4-2.754,11.523-1.975.106.013.207.031.311.044a66.347,66.347,0,0,0-8.239,5.007C199.762,259.835,198.355,258.716,198.486,257.683Z",
    transform: "translate(-198.477 -255.425)",
    fill: "#ffdf2f"
  })))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40864",
    "data-name": "Group 40864",
    transform: "translate(67.528 129.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40862",
    "data-name": "Group 40862",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_171",
    "data-name": "Line 171",
    x1: 0.869,
    y2: 2.27,
    transform: "translate(20.961 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40861",
    "data-name": "Group 40861",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73154",
    "data-name": "Path 73154",
    d: "M191.063,264.114l-14.626-5.595-3.131-1.2-.87,2.273c-.674,1.758,3.458,4.974,9.227,7.181s10.99,2.569,11.663.81l.869-2.27Z",
    transform: "translate(-172.364 -257.32)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73155",
    "data-name": "Path 73155",
    d: "M194.425,265.018c-.673,1.758-5.9,1.4-11.663-.811s-9.9-5.424-9.226-7.182,5.894-1.4,11.663.812S195.1,263.259,194.425,265.018Z",
    transform: "translate(-172.594 -255.912)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73156",
    "data-name": "Path 73156",
    d: "M178.435,256.483s-4.422-.309-4.322,1.087,6.558,5.2,6.864,5.177c0,0-6.47-3.8-6.431-5.1S178.435,256.483,178.435,256.483Z",
    transform: "translate(-172.73 -256.025)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40863",
    "data-name": "Group 40863",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73157",
    "data-name": "Path 73157",
    d: "M197.456,265.5c.672-1.76-3.457-4.976-9.226-7.181-.1-.039-.2-.071-.295-.108a66.444,66.444,0,0,1,4.9,8.3C195.314,266.793,197.083,266.472,197.456,265.5Z",
    transform: "translate(-187.935 -258.211)",
    fill: "#ffee2f"
  })))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40868",
    "data-name": "Group 40868",
    transform: "translate(49.4 129.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40866",
    "data-name": "Group 40866",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_172",
    "data-name": "Line 172",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40865",
    "data-name": "Group 40865",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73158",
    "data-name": "Path 73158",
    d: "M153.075,258.584l15.536,1.973,3.326.421-.307,2.414c-.238,1.867-5.4,2.752-11.524,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-149.434 -258.162)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73159",
    "data-name": "Path 73159",
    d: "M149.831,257.564c-.237,1.868,4.537,4.014,10.665,4.792s11.287-.108,11.523-1.976-4.538-4.013-10.665-4.792S150.069,255.7,149.831,257.564Z",
    transform: "translate(-149.516 -255.307)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73160",
    "data-name": "Path 73160",
    d: "M171.6,258.149s4.045,1.817,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.29,8.078-1.459S171.6,258.149,171.6,258.149Z",
    transform: "translate(-152.989 -255.902)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40867",
    "data-name": "Group 40867",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73161",
    "data-name": "Path 73161",
    d: "M149.831,257.564c.238-1.867,5.4-2.753,11.523-1.975.105.014.206.031.311.044a66.3,66.3,0,0,0-8.239,5.007C151.107,259.716,149.7,258.6,149.831,257.564Z",
    transform: "translate(-149.822 -255.307)",
    fill: "#ffee2f"
  })))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40872",
    "data-name": "Group 40872",
    transform: "translate(58.573 122.694)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40870",
    "data-name": "Group 40870",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_173",
    "data-name": "Line 173",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40869",
    "data-name": "Group 40869",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73162",
    "data-name": "Path 73162",
    d: "M164.678,250.186l15.536,1.973,3.327.421L183.234,255c-.238,1.868-5.4,2.751-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.413Z",
    transform: "translate(-161.037 -249.764)",
    fill: "url(#radial-gradient-72)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73163",
    "data-name": "Path 73163",
    d: "M161.434,249.166c-.237,1.869,4.537,4.014,10.664,4.792s11.288-.107,11.526-1.976-4.539-4.013-10.666-4.791S161.672,247.3,161.434,249.166Z",
    transform: "translate(-161.119 -246.909)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73164",
    "data-name": "Path 73164",
    d: "M183.206,249.752s4.045,1.815,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.291,8.078-1.459S183.206,249.752,183.206,249.752Z",
    transform: "translate(-164.592 -247.505)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40871",
    "data-name": "Group 40871",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73165",
    "data-name": "Path 73165",
    d: "M161.434,249.166c.238-1.868,5.4-2.753,11.523-1.974.105.013.206.03.311.043a66.459,66.459,0,0,0-8.239,5.007C162.71,251.318,161.3,250.2,161.434,249.166Z",
    transform: "translate(-161.425 -246.909)",
    fill: "#ffdf2f"
  })))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40876",
    "data-name": "Group 40876",
    transform: "translate(94.767 125.107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40874",
    "data-name": "Group 40874",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40873",
    "data-name": "Group 40873",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73166",
    "data-name": "Path 73166",
    d: "M225.519,258.165l-14.626-5.595-3.132-1.2-.869,2.273c-.674,1.759,3.458,4.974,9.227,7.181s10.99,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-206.82 -251.371)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73167",
    "data-name": "Path 73167",
    d: "M228.881,259.068c-.673,1.759-5.894,1.4-11.663-.81s-9.9-5.424-9.227-7.182,5.9-1.4,11.664.811S229.553,257.309,228.881,259.068Z",
    transform: "translate(-207.05 -249.962)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73168",
    "data-name": "Path 73168",
    d: "M212.891,250.534s-4.423-.309-4.322,1.087,6.558,5.195,6.864,5.177c0,0-6.471-3.8-6.431-5.1S212.891,250.534,212.891,250.534Z",
    transform: "translate(-207.186 -250.076)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40875",
    "data-name": "Group 40875",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73169",
    "data-name": "Path 73169",
    d: "M231.911,259.549c.672-1.758-3.457-4.975-9.226-7.181-.1-.038-.2-.07-.3-.107a66.267,66.267,0,0,1,4.9,8.3C229.77,260.844,231.539,260.523,231.911,259.549Z",
    transform: "translate(-222.39 -252.262)",
    fill: "#ffee2f"
  })))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40880",
    "data-name": "Group 40880",
    transform: "translate(76.64 124.63)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40878",
    "data-name": "Group 40878",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_175",
    "data-name": "Line 175",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40877",
    "data-name": "Group 40877",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73170",
    "data-name": "Path 73170",
    d: "M187.531,252.635l15.535,1.973,3.327.421-.307,2.414c-.237,1.867-5.4,2.751-11.525,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-183.89 -252.212)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73171",
    "data-name": "Path 73171",
    d: "M184.287,251.614c-.237,1.869,4.537,4.015,10.664,4.792s11.288-.107,11.524-1.975-4.538-4.014-10.665-4.791S184.525,249.747,184.287,251.614Z",
    transform: "translate(-183.972 -249.358)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73172",
    "data-name": "Path 73172",
    d: "M206.058,252.2s4.044,1.816,3.3,3-8.234,1.483-8.494,1.321c0,0,7.5-.29,8.078-1.459S206.058,252.2,206.058,252.2Z",
    transform: "translate(-187.445 -249.953)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40879",
    "data-name": "Group 40879",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73173",
    "data-name": "Path 73173",
    d: "M184.287,251.614c.238-1.867,5.4-2.753,11.523-1.973.105.013.206.029.311.043a66.441,66.441,0,0,0-8.239,5.007C185.563,253.766,184.156,252.648,184.287,251.614Z",
    transform: "translate(-184.278 -249.358)",
    fill: "#ffee2f"
  })))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40884",
    "data-name": "Group 40884",
    transform: "translate(85.813 117.99)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40882",
    "data-name": "Group 40882",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_176",
    "data-name": "Line 176",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40881",
    "data-name": "Group 40881",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73174",
    "data-name": "Path 73174",
    d: "M199.134,244.237l15.537,1.974,3.326.42-.307,2.415c-.238,1.867-5.4,2.751-11.525,1.973s-10.9-2.923-10.664-4.792l.307-2.412Z",
    transform: "translate(-195.493 -243.815)",
    fill: "url(#radial-gradient-94)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73175",
    "data-name": "Path 73175",
    d: "M195.89,243.217c-.237,1.868,4.537,4.014,10.665,4.792s11.288-.107,11.524-1.976-4.538-4.013-10.665-4.791S196.128,241.349,195.89,243.217Z",
    transform: "translate(-195.575 -240.959)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73176",
    "data-name": "Path 73176",
    d: "M217.662,243.8s4.045,1.816,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.077-1.459S217.662,243.8,217.662,243.8Z",
    transform: "translate(-199.048 -241.555)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40883",
    "data-name": "Group 40883",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73177",
    "data-name": "Path 73177",
    d: "M195.89,243.217c.238-1.868,5.4-2.754,11.523-1.975.105.013.206.031.311.046a66.214,66.214,0,0,0-8.239,5.005C197.167,245.368,195.759,244.251,195.89,243.217Z",
    transform: "translate(-195.881 -240.959)",
    fill: "#ffdf2f"
  })))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40888",
    "data-name": "Group 40888",
    transform: "translate(121.481 127.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40886",
    "data-name": "Group 40886",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_177",
    "data-name": "Line 177",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40885",
    "data-name": "Group 40885",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73178",
    "data-name": "Path 73178",
    d: "M259.31,261.154l-14.626-5.6-3.131-1.2-.87,2.274c-.673,1.757,3.458,4.973,9.227,7.18s10.989,2.569,11.663.81l.869-2.272Z",
    transform: "translate(-240.611 -254.36)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73179",
    "data-name": "Path 73179",
    d: "M262.672,262.056c-.673,1.759-5.9,1.4-11.664-.811s-9.9-5.422-9.225-7.181,5.894-1.4,11.663.811S263.344,260.3,262.672,262.056Z",
    transform: "translate(-240.842 -252.951)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73180",
    "data-name": "Path 73180",
    d: "M246.682,253.522s-4.422-.309-4.322,1.088,6.558,5.195,6.864,5.176c0,0-6.47-3.8-6.431-5.1S246.682,253.522,246.682,253.522Z",
    transform: "translate(-240.977 -253.064)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40887",
    "data-name": "Group 40887",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73181",
    "data-name": "Path 73181",
    d: "M265.7,262.538c.672-1.759-3.457-4.974-9.226-7.181-.1-.039-.2-.071-.3-.108a66.363,66.363,0,0,1,4.9,8.3C263.561,263.831,265.329,263.511,265.7,262.538Z",
    transform: "translate(-256.181 -255.25)",
    fill: "#ffee2f"
  })))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40892",
    "data-name": "Group 40892",
    transform: "translate(103.354 126.992)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40890",
    "data-name": "Group 40890",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_178",
    "data-name": "Line 178",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40889",
    "data-name": "Group 40889",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73182",
    "data-name": "Path 73182",
    d: "M221.322,255.623l15.535,1.973,3.327.421-.306,2.414c-.239,1.87-5.4,2.754-11.525,1.975s-10.9-2.924-10.664-4.792L218,255.2Z",
    transform: "translate(-217.681 -255.201)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73183",
    "data-name": "Path 73183",
    d: "M218.078,254.6c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.107,11.524-1.975-4.537-4.014-10.665-4.792S218.315,252.735,218.078,254.6Z",
    transform: "translate(-217.763 -252.346)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73184",
    "data-name": "Path 73184",
    d: "M239.849,255.189s4.044,1.815,3.3,3-8.234,1.484-8.495,1.322c0,0,7.5-.289,8.078-1.459S239.849,255.189,239.849,255.189Z",
    transform: "translate(-221.236 -252.941)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40891",
    "data-name": "Group 40891",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73185",
    "data-name": "Path 73185",
    d: "M218.078,254.6c.237-1.868,5.4-2.753,11.523-1.975.105.013.206.031.311.045a66.289,66.289,0,0,0-8.239,5.007C219.355,256.755,217.947,255.636,218.078,254.6Z",
    transform: "translate(-218.069 -252.346)",
    fill: "#ffee2f"
  })))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40896",
    "data-name": "Group 40896",
    transform: "translate(112.526 120.353)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40894",
    "data-name": "Group 40894",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_179",
    "data-name": "Line 179",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40893",
    "data-name": "Group 40893",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73186",
    "data-name": "Path 73186",
    d: "M232.925,247.225l15.536,1.974,3.327.421-.307,2.414c-.237,1.868-5.4,2.752-11.526,1.974s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-229.284 -246.804)",
    fill: "url(#radial-gradient-72)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73187",
    "data-name": "Path 73187",
    d: "M229.681,246.206c-.237,1.867,4.537,4.013,10.665,4.792s11.287-.108,11.524-1.975-4.538-4.013-10.665-4.792S229.919,244.337,229.681,246.206Z",
    transform: "translate(-229.366 -243.948)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73188",
    "data-name": "Path 73188",
    d: "M251.453,246.791s4.045,1.814,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.291,8.076-1.46S251.453,246.791,251.453,246.791Z",
    transform: "translate(-232.839 -244.543)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40895",
    "data-name": "Group 40895",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73189",
    "data-name": "Path 73189",
    d: "M229.681,246.206c.238-1.869,5.4-2.753,11.523-1.976.105.014.206.031.311.045a66.345,66.345,0,0,0-8.239,5.007C230.958,248.358,229.55,247.238,229.681,246.206Z",
    transform: "translate(-229.672 -243.948)",
    fill: "#ffdf2f"
  })))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40900",
    "data-name": "Group 40900",
    transform: "translate(119.993 115.881)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40898",
    "data-name": "Group 40898",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_180",
    "data-name": "Line 180",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40897",
    "data-name": "Group 40897",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73190",
    "data-name": "Path 73190",
    d: "M257.427,246.494,242.8,240.9l-3.131-1.2-.87,2.272c-.674,1.76,3.458,4.975,9.227,7.182s10.989,2.568,11.661.81l.87-2.271Z",
    transform: "translate(-238.729 -239.7)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73191",
    "data-name": "Path 73191",
    d: "M260.79,247.4c-.673,1.757-5.9,1.4-11.663-.811s-9.9-5.422-9.226-7.181,5.894-1.4,11.663.811S261.462,245.638,260.79,247.4Z",
    transform: "translate(-238.959 -238.291)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73192",
    "data-name": "Path 73192",
    d: "M244.8,238.862s-4.423-.309-4.324,1.087,6.559,5.2,6.864,5.177c0,0-6.47-3.795-6.431-5.1S244.8,238.862,244.8,238.862Z",
    transform: "translate(-239.095 -238.404)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40899",
    "data-name": "Group 40899",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73193",
    "data-name": "Path 73193",
    d: "M263.82,247.879c.672-1.76-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.3-.108a66.458,66.458,0,0,1,4.9,8.3C261.679,249.172,263.448,248.851,263.82,247.879Z",
    transform: "translate(-254.299 -240.589)",
    fill: "#ffee2f"
  })))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40904",
    "data-name": "Group 40904",
    transform: "translate(101.866 115.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40902",
    "data-name": "Group 40902",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_181",
    "data-name": "Line 181",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40901",
    "data-name": "Group 40901",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73194",
    "data-name": "Path 73194",
    d: "M219.44,240.964l15.536,1.973,3.326.421L238,245.772c-.237,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.412Z",
    transform: "translate(-215.799 -240.542)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73195",
    "data-name": "Path 73195",
    d: "M216.195,239.944c-.236,1.867,4.538,4.014,10.665,4.791s11.288-.106,11.524-1.975-4.538-4.014-10.665-4.791S216.433,238.075,216.195,239.944Z",
    transform: "translate(-215.88 -237.686)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73196",
    "data-name": "Path 73196",
    d: "M237.967,240.528s4.045,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.078-1.459S237.967,240.528,237.967,240.528Z",
    transform: "translate(-219.354 -238.281)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40903",
    "data-name": "Group 40903",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73197",
    "data-name": "Path 73197",
    d: "M216.195,239.944c.238-1.869,5.4-2.754,11.524-1.975.105.013.206.03.311.044a66.27,66.27,0,0,0-8.239,5.006C217.472,242.094,216.064,240.977,216.195,239.944Z",
    transform: "translate(-216.186 -237.686)",
    fill: "#ffee2f"
  })))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40908",
    "data-name": "Group 40908",
    transform: "translate(111.038 108.763)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40906",
    "data-name": "Group 40906",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_182",
    "data-name": "Line 182",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40905",
    "data-name": "Group 40905",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73198",
    "data-name": "Path 73198",
    d: "M231.043,232.565l15.537,1.973,3.326.421-.306,2.414c-.238,1.868-5.4,2.753-11.526,1.974s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-227.402 -232.143)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73199",
    "data-name": "Path 73199",
    d: "M227.8,231.545c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.106,11.524-1.975-4.538-4.012-10.665-4.792S228.037,229.677,227.8,231.545Z",
    transform: "translate(-227.484 -229.287)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73200",
    "data-name": "Path 73200",
    d: "M249.571,232.131s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.46S249.571,232.131,249.571,232.131Z",
    transform: "translate(-230.957 -229.883)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40907",
    "data-name": "Group 40907",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73201",
    "data-name": "Path 73201",
    d: "M227.8,231.545c.238-1.868,5.4-2.754,11.523-1.975l.311.045a66.386,66.386,0,0,0-8.24,5.007C229.076,233.7,227.668,232.579,227.8,231.545Z",
    transform: "translate(-227.79 -229.287)",
    fill: "#ffdf2f"
  })))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40912",
    "data-name": "Group 40912",
    transform: "translate(92.613 146.805)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40910",
    "data-name": "Group 40910",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_183",
    "data-name": "Line 183",
    x1: 0.869,
    y2: 2.273,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40909",
    "data-name": "Group 40909",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73202",
    "data-name": "Path 73202",
    d: "M222.794,285.612l-14.626-5.595-3.131-1.2-.87,2.274c-.674,1.759,3.458,4.973,9.227,7.181s10.99,2.569,11.663.811l.869-2.273Z",
    transform: "translate(-204.095 -278.817)",
    fill: "url(#radial-gradient-65)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73203",
    "data-name": "Path 73203",
    d: "M226.156,286.514c-.674,1.759-5.9,1.4-11.664-.809s-9.9-5.424-9.225-7.183,5.894-1.395,11.662.813S226.828,284.756,226.156,286.514Z",
    transform: "translate(-204.325 -277.409)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73204",
    "data-name": "Path 73204",
    d: "M210.165,277.982s-4.422-.311-4.323,1.085,6.559,5.2,6.864,5.177c0,0-6.471-3.793-6.431-5.1S210.165,277.982,210.165,277.982Z",
    transform: "translate(-204.461 -277.523)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40911",
    "data-name": "Group 40911",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73205",
    "data-name": "Path 73205",
    d: "M229.186,287c.672-1.758-3.457-4.975-9.227-7.179-.1-.04-.2-.073-.295-.11a66.24,66.24,0,0,1,4.9,8.306C227.045,288.29,228.813,287.969,229.186,287Z",
    transform: "translate(-219.665 -279.707)",
    fill: "#ffee2f"
  })))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40916",
    "data-name": "Group 40916",
    transform: "translate(74.486 146.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40914",
    "data-name": "Group 40914",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_184",
    "data-name": "Line 184",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40913",
    "data-name": "Group 40913",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73206",
    "data-name": "Path 73206",
    d: "M184.806,280.083l15.535,1.972,3.327.421-.306,2.414c-.239,1.867-5.4,2.751-11.526,1.974s-10.9-2.925-10.663-4.792l.306-2.414Z",
    transform: "translate(-181.165 -279.659)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73207",
    "data-name": "Path 73207",
    d: "M181.561,279.061c-.236,1.869,4.538,4.015,10.665,4.792s11.287-.108,11.524-1.975-4.538-4.014-10.665-4.79S181.8,277.194,181.561,279.061Z",
    transform: "translate(-181.246 -276.805)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73208",
    "data-name": "Path 73208",
    d: "M203.333,279.647s4.045,1.814,3.3,3-8.234,1.483-8.494,1.321c0,0,7.5-.29,8.077-1.459S203.333,279.647,203.333,279.647Z",
    transform: "translate(-184.719 -277.4)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40915",
    "data-name": "Group 40915",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73209",
    "data-name": "Path 73209",
    d: "M181.561,279.061c.238-1.867,5.4-2.754,11.524-1.972.1.011.206.029.311.042a66.592,66.592,0,0,0-8.239,5.007C182.838,281.213,181.43,280.1,181.561,279.061Z",
    transform: "translate(-181.552 -276.805)",
    fill: "#ffee2f"
  })))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40920",
    "data-name": "Group 40920",
    transform: "translate(83.659 139.688)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40918",
    "data-name": "Group 40918",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_185",
    "data-name": "Line 185",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40917",
    "data-name": "Group 40917",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73210",
    "data-name": "Path 73210",
    d: "M196.41,271.683l15.536,1.974,3.327.422-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.973s-10.9-2.924-10.663-4.792l.305-2.413Z",
    transform: "translate(-192.769 -271.261)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73211",
    "data-name": "Path 73211",
    d: "M193.164,270.663c-.236,1.868,4.538,4.014,10.665,4.792s11.288-.106,11.524-1.973-4.538-4.014-10.665-4.792S193.4,268.8,193.164,270.663Z",
    transform: "translate(-192.85 -268.406)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73212",
    "data-name": "Path 73212",
    d: "M214.937,271.249s4.044,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.29,8.078-1.459S214.937,271.249,214.937,271.249Z",
    transform: "translate(-196.323 -269.001)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40919",
    "data-name": "Group 40919",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73213",
    "data-name": "Path 73213",
    d: "M193.164,270.663c.239-1.867,5.4-2.753,11.524-1.974.105.013.206.03.311.045a66.424,66.424,0,0,0-8.239,5.006C194.441,272.816,193.034,271.7,193.164,270.663Z",
    transform: "translate(-193.156 -268.406)",
    fill: "#ffdf2f"
  })))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40924",
    "data-name": "Group 40924",
    transform: "translate(110.35 133.347)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40922",
    "data-name": "Group 40922",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_186",
    "data-name": "Line 186",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40921",
    "data-name": "Group 40921",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73214",
    "data-name": "Path 73214",
    d: "M245.231,268.587l-14.626-5.6-3.131-1.2-.87,2.273c-.674,1.758,3.458,4.973,9.227,7.181s10.99,2.569,11.662.81l.87-2.271Z",
    transform: "translate(-226.532 -261.793)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73215",
    "data-name": "Path 73215",
    d: "M248.593,269.49c-.673,1.758-5.9,1.4-11.663-.812s-9.9-5.422-9.226-7.181,5.894-1.4,11.662.811S249.265,267.731,248.593,269.49Z",
    transform: "translate(-226.762 -260.384)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73216",
    "data-name": "Path 73216",
    d: "M232.6,260.955s-4.423-.309-4.322,1.087,6.558,5.2,6.864,5.177c0,0-6.47-3.8-6.431-5.1S232.6,260.955,232.6,260.955Z",
    transform: "translate(-226.898 -260.498)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40923",
    "data-name": "Group 40923",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73217",
    "data-name": "Path 73217",
    d: "M251.623,269.972c.672-1.76-3.458-4.976-9.227-7.181-.1-.038-.2-.071-.295-.108a66.4,66.4,0,0,1,4.9,8.3C249.482,271.265,251.251,270.944,251.623,269.972Z",
    transform: "translate(-242.102 -262.683)",
    fill: "#ffee2f"
  })))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40928",
    "data-name": "Group 40928",
    transform: "translate(92.223 132.868)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40926",
    "data-name": "Group 40926",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_187",
    "data-name": "Line 187",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40925",
    "data-name": "Group 40925",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73218",
    "data-name": "Path 73218",
    d: "M207.243,263.056l15.537,1.973,3.326.421-.306,2.414c-.239,1.869-5.4,2.752-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-203.602 -262.634)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73219",
    "data-name": "Path 73219",
    d: "M204,262.036c-.236,1.868,4.538,4.014,10.665,4.791s11.287-.107,11.523-1.975-4.538-4.012-10.665-4.792S204.237,260.168,204,262.036Z",
    transform: "translate(-203.683 -259.778)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73220",
    "data-name": "Path 73220",
    d: "M225.77,262.622s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.46S225.77,262.622,225.77,262.622Z",
    transform: "translate(-207.157 -260.374)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40927",
    "data-name": "Group 40927",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73221",
    "data-name": "Path 73221",
    d: "M204,262.036c.239-1.868,5.4-2.754,11.524-1.975.105.013.206.031.311.045a66.338,66.338,0,0,0-8.239,5.007C205.275,264.187,203.867,263.07,204,262.036Z",
    transform: "translate(-203.989 -259.778)",
    fill: "#ffee2f"
  })))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40932",
    "data-name": "Group 40932",
    transform: "translate(101.397 126.229)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40930",
    "data-name": "Group 40930",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_188",
    "data-name": "Line 188",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40929",
    "data-name": "Group 40929",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73222",
    "data-name": "Path 73222",
    d: "M218.847,254.658l15.536,1.974,3.327.421-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-215.206 -254.236)",
    fill: "url(#radial-gradient-106)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73223",
    "data-name": "Path 73223",
    d: "M215.6,253.638c-.237,1.868,4.537,4.014,10.665,4.792s11.288-.107,11.524-1.975-4.538-4.012-10.665-4.792S215.84,251.771,215.6,253.638Z",
    transform: "translate(-215.287 -251.381)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73224",
    "data-name": "Path 73224",
    d: "M237.374,254.224s4.044,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.078-1.459S237.374,254.224,237.374,254.224Z",
    transform: "translate(-218.76 -251.976)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40931",
    "data-name": "Group 40931",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73225",
    "data-name": "Path 73225",
    d: "M215.6,253.638c.238-1.867,5.4-2.753,11.523-1.975.105.014.206.031.311.045a66.227,66.227,0,0,0-8.238,5.007C216.879,255.79,215.471,254.671,215.6,253.638Z",
    transform: "translate(-215.593 -251.381)",
    fill: "#ffdf2f"
  })))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40936",
    "data-name": "Group 40936",
    transform: "translate(120.455 111.649)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40934",
    "data-name": "Group 40934",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_189",
    "data-name": "Line 189",
    x1: 0.869,
    y2: 2.273,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40933",
    "data-name": "Group 40933",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73226",
    "data-name": "Path 73226",
    d: "M258.012,241.141l-14.627-5.6-3.131-1.2-.87,2.274c-.674,1.757,3.458,4.973,9.227,7.181s10.99,2.569,11.663.81l.868-2.273Z",
    transform: "translate(-239.313 -234.346)",
    fill: "url(#radial-gradient-65)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73227",
    "data-name": "Path 73227",
    d: "M261.373,242.044c-.672,1.759-5.894,1.4-11.663-.81s-9.9-5.423-9.225-7.183,5.894-1.395,11.662.812S262.046,240.286,261.373,242.044Z",
    transform: "translate(-239.543 -232.938)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73228",
    "data-name": "Path 73228",
    d: "M245.383,233.51s-4.423-.31-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.47-3.8-6.431-5.1S245.383,233.51,245.383,233.51Z",
    transform: "translate(-239.679 -233.052)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40935",
    "data-name": "Group 40935",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73229",
    "data-name": "Path 73229",
    d: "M264.4,242.525c.673-1.757-3.457-4.974-9.226-7.181-.1-.038-.2-.071-.295-.108a66.222,66.222,0,0,1,4.9,8.3C262.262,243.819,264.032,243.5,264.4,242.525Z",
    transform: "translate(-254.883 -235.237)",
    fill: "#ffee2f"
  })))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40940",
    "data-name": "Group 40940",
    transform: "translate(102.327 111.171)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40938",
    "data-name": "Group 40938",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_190",
    "data-name": "Line 190",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40937",
    "data-name": "Group 40937",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73230",
    "data-name": "Path 73230",
    d: "M220.024,235.611l15.536,1.973,3.327.421-.308,2.414c-.238,1.867-5.4,2.752-11.525,1.973s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-216.383 -235.189)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73231",
    "data-name": "Path 73231",
    d: "M216.779,234.591c-.236,1.867,4.538,4.014,10.665,4.792s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.792S217.018,232.723,216.779,234.591Z",
    transform: "translate(-216.464 -232.333)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73232",
    "data-name": "Path 73232",
    d: "M238.551,235.176s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.459S238.551,235.176,238.551,235.176Z",
    transform: "translate(-219.937 -232.929)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40939",
    "data-name": "Group 40939",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73233",
    "data-name": "Path 73233",
    d: "M216.779,234.591c.239-1.868,5.4-2.754,11.524-1.975.1.013.206.03.311.045a66.206,66.206,0,0,0-8.239,5.006C218.056,236.743,216.648,235.624,216.779,234.591Z",
    transform: "translate(-216.77 -232.333)",
    fill: "#ffee2f"
  })))), _g110 || (_g110 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40944",
    "data-name": "Group 40944",
    transform: "translate(111.5 104.533)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40942",
    "data-name": "Group 40942",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_191",
    "data-name": "Line 191",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.256)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40941",
    "data-name": "Group 40941",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73234",
    "data-name": "Path 73234",
    d: "M231.627,227.214l15.537,1.972,3.326.421-.307,2.414c-.238,1.868-5.4,2.753-11.526,1.974s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-227.986 -226.791)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73235",
    "data-name": "Path 73235",
    d: "M228.383,226.193c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.108,11.525-1.976-4.538-4.013-10.665-4.791S228.62,224.326,228.383,226.193Z",
    transform: "translate(-228.068 -223.936)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73236",
    "data-name": "Path 73236",
    d: "M250.155,226.778s4.045,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.077-1.459S250.155,226.778,250.155,226.778Z",
    transform: "translate(-231.541 -224.531)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40943",
    "data-name": "Group 40943",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73237",
    "data-name": "Path 73237",
    d: "M228.383,226.193c.237-1.867,5.4-2.753,11.523-1.974.105.013.206.029.312.043a66.244,66.244,0,0,0-8.24,5.007C229.66,228.345,228.251,227.227,228.383,226.193Z",
    transform: "translate(-228.374 -223.936)",
    fill: "#ffdf2f"
  })))), _g111 || (_g111 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40948",
    "data-name": "Group 40948",
    transform: "translate(88.458 102.458)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40946",
    "data-name": "Group 40946",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_192",
    "data-name": "Line 192",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40945",
    "data-name": "Group 40945",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73238",
    "data-name": "Path 73238",
    d: "M217.538,229.515l-14.626-5.6-3.131-1.2-.87,2.273c-.673,1.759,3.458,4.974,9.227,7.181s10.989,2.568,11.662.81l.869-2.271Z",
    transform: "translate(-198.839 -222.72)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73239",
    "data-name": "Path 73239",
    d: "M220.9,230.418c-.673,1.758-5.9,1.4-11.663-.811s-9.9-5.422-9.226-7.181,5.9-1.4,11.663.812S221.573,228.659,220.9,230.418Z",
    transform: "translate(-199.07 -221.312)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73240",
    "data-name": "Path 73240",
    d: "M204.91,221.883s-4.422-.309-4.322,1.087,6.558,5.2,6.864,5.177c0,0-6.47-3.8-6.431-5.1S204.91,221.883,204.91,221.883Z",
    transform: "translate(-199.205 -221.426)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40947",
    "data-name": "Group 40947",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73241",
    "data-name": "Path 73241",
    d: "M223.931,230.9c.673-1.759-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.295-.108a66.254,66.254,0,0,1,4.9,8.3C221.789,232.193,223.558,231.872,223.931,230.9Z",
    transform: "translate(-214.41 -223.611)",
    fill: "#ffee2f"
  })))), _g112 || (_g112 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40952",
    "data-name": "Group 40952",
    transform: "translate(73.035 104.438)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40950",
    "data-name": "Group 40950",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_193",
    "data-name": "Line 193",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40949",
    "data-name": "Group 40949",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73242",
    "data-name": "Path 73242",
    d: "M182.972,227.094l15.535,1.973,3.326.421-.307,2.414c-.237,1.869-5.4,2.753-11.524,1.975s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-179.33 -226.673)",
    fill: "url(#radial-gradient-111)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73243",
    "data-name": "Path 73243",
    d: "M179.727,226.075c-.237,1.867,4.538,4.013,10.665,4.792s11.287-.107,11.523-1.976-4.538-4.014-10.664-4.791S179.965,224.206,179.727,226.075Z",
    transform: "translate(-179.412 -223.817)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73244",
    "data-name": "Path 73244",
    d: "M201.5,226.66s4.045,1.814,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.077-1.46S201.5,226.66,201.5,226.66Z",
    transform: "translate(-182.885 -224.413)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40951",
    "data-name": "Group 40951",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73245",
    "data-name": "Path 73245",
    d: "M179.727,226.075c.238-1.869,5.4-2.753,11.524-1.975.1.013.206.03.311.043a66.437,66.437,0,0,0-8.239,5.007C181,228.227,179.6,227.107,179.727,226.075Z",
    transform: "translate(-179.718 -223.817)",
    fill: "#ffee2f"
  })))), _g113 || (_g113 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40956",
    "data-name": "Group 40956",
    transform: "translate(77.668 95.757)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40954",
    "data-name": "Group 40954",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_194",
    "data-name": "Line 194",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40953",
    "data-name": "Group 40953",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73246",
    "data-name": "Path 73246",
    d: "M188.831,216.113l15.536,1.973,3.327.422-.307,2.414c-.238,1.868-5.4,2.752-11.525,1.975s-10.9-2.924-10.664-4.792l.306-2.414Z",
    transform: "translate(-185.19 -215.691)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73247",
    "data-name": "Path 73247",
    d: "M185.586,215.093c-.236,1.868,4.538,4.014,10.664,4.792s11.288-.107,11.526-1.974-4.538-4.014-10.665-4.792S185.824,213.225,185.586,215.093Z",
    transform: "translate(-185.271 -212.836)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73248",
    "data-name": "Path 73248",
    d: "M207.358,215.678s4.045,1.815,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.077-1.459S207.358,215.678,207.358,215.678Z",
    transform: "translate(-188.745 -213.431)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40955",
    "data-name": "Group 40955",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73249",
    "data-name": "Path 73249",
    d: "M185.586,215.093c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.029.311.044a66.233,66.233,0,0,0-8.239,5.007C186.862,217.245,185.454,216.126,185.586,215.093Z",
    transform: "translate(-185.577 -212.836)",
    fill: "#ffdf2f"
  })))), _g114 || (_g114 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40960",
    "data-name": "Group 40960",
    transform: "translate(100.274 99.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40958",
    "data-name": "Group 40958",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_195",
    "data-name": "Line 195",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40957",
    "data-name": "Group 40957",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73250",
    "data-name": "Path 73250",
    d: "M217.427,221.145l15.536,1.973,3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-213.786 -220.722)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73251",
    "data-name": "Path 73251",
    d: "M214.183,220.124c-.237,1.868,4.538,4.015,10.665,4.792s11.287-.107,11.524-1.975-4.538-4.014-10.665-4.792S214.421,218.256,214.183,220.124Z",
    transform: "translate(-213.868 -217.867)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73252",
    "data-name": "Path 73252",
    d: "M235.954,220.71s4.045,1.816,3.3,3-8.234,1.483-8.495,1.323c0,0,7.5-.291,8.078-1.459S235.954,220.71,235.954,220.71Z",
    transform: "translate(-217.341 -218.462)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40959",
    "data-name": "Group 40959",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73253",
    "data-name": "Path 73253",
    d: "M214.183,220.124c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.045a66.383,66.383,0,0,0-8.239,5.005C215.46,222.277,214.052,221.158,214.183,220.124Z",
    transform: "translate(-214.174 -217.867)",
    fill: "#ffee2f"
  })))), _g115 || (_g115 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40964",
    "data-name": "Group 40964",
    transform: "translate(116.247 121.912)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40962",
    "data-name": "Group 40962",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_196",
    "data-name": "Line 196",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40961",
    "data-name": "Group 40961",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73254",
    "data-name": "Path 73254",
    d: "M252.69,254.122l-14.626-5.595-3.131-1.2-.87,2.273c-.673,1.758,3.459,4.974,9.227,7.181s10.989,2.569,11.663.81l.869-2.272Z",
    transform: "translate(-233.991 -247.328)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73255",
    "data-name": "Path 73255",
    d: "M256.052,255.025c-.673,1.759-5.894,1.4-11.663-.81s-9.9-5.423-9.226-7.181,5.9-1.4,11.662.811S256.724,253.267,256.052,255.025Z",
    transform: "translate(-234.221 -245.92)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73256",
    "data-name": "Path 73256",
    d: "M240.062,246.491s-4.423-.309-4.323,1.087,6.558,5.195,6.864,5.176c0,0-6.47-3.8-6.431-5.1S240.062,246.491,240.062,246.491Z",
    transform: "translate(-234.357 -246.033)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40963",
    "data-name": "Group 40963",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73257",
    "data-name": "Path 73257",
    d: "M259.082,255.506c.672-1.758-3.457-4.975-9.227-7.181-.1-.038-.2-.071-.295-.107a66.077,66.077,0,0,1,4.9,8.3C256.941,256.8,258.71,256.479,259.082,255.506Z",
    transform: "translate(-249.561 -248.219)",
    fill: "#ffee2f"
  })))), _g116 || (_g116 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40968",
    "data-name": "Group 40968",
    transform: "translate(98.12 121.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40966",
    "data-name": "Group 40966",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_197",
    "data-name": "Line 197",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40965",
    "data-name": "Group 40965",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73258",
    "data-name": "Path 73258",
    d: "M214.7,248.591l15.536,1.973,3.327.422-.307,2.414c-.238,1.867-5.4,2.751-11.525,1.973s-10.9-2.923-10.664-4.792l.307-2.413Z",
    transform: "translate(-211.061 -248.169)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73259",
    "data-name": "Path 73259",
    d: "M211.458,247.571c-.237,1.869,4.537,4.015,10.664,4.792s11.288-.107,11.525-1.975-4.539-4.014-10.665-4.792S211.7,245.7,211.458,247.571Z",
    transform: "translate(-211.143 -245.314)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73260",
    "data-name": "Path 73260",
    d: "M233.23,248.157s4.044,1.816,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.291,8.077-1.459S233.23,248.157,233.23,248.157Z",
    transform: "translate(-214.616 -245.91)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40967",
    "data-name": "Group 40967",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73261",
    "data-name": "Path 73261",
    d: "M211.458,247.571c.238-1.867,5.4-2.753,11.523-1.974.105.013.207.03.311.044a66.286,66.286,0,0,0-8.24,5.007C212.734,249.723,211.326,248.605,211.458,247.571Z",
    transform: "translate(-211.449 -245.314)",
    fill: "#ffee2f"
  })))), _g117 || (_g117 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40972",
    "data-name": "Group 40972",
    transform: "translate(107.294 114.794)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40970",
    "data-name": "Group 40970",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_198",
    "data-name": "Line 198",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40969",
    "data-name": "Group 40969",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73262",
    "data-name": "Path 73262",
    d: "M226.306,240.194l15.537,1.973,3.327.421L244.862,245c-.239,1.868-5.4,2.752-11.526,1.973s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-222.665 -239.771)",
    fill: "url(#radial-gradient-106)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73263",
    "data-name": "Path 73263",
    d: "M223.061,239.173c-.237,1.869,4.538,4.015,10.665,4.792s11.288-.108,11.525-1.976-4.538-4.013-10.665-4.791S223.3,237.306,223.061,239.173Z",
    transform: "translate(-222.746 -236.916)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73264",
    "data-name": "Path 73264",
    d: "M244.833,239.759s4.045,1.816,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.078-1.459S244.833,239.759,244.833,239.759Z",
    transform: "translate(-226.219 -237.512)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40971",
    "data-name": "Group 40971",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73265",
    "data-name": "Path 73265",
    d: "M223.061,239.173c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.045a66.112,66.112,0,0,0-8.239,5.006C224.337,241.325,222.93,240.206,223.061,239.173Z",
    transform: "translate(-223.052 -236.916)",
    fill: "#ffdf2f"
  })))), _g118 || (_g118 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40976",
    "data-name": "Group 40976",
    transform: "translate(133.985 108.452)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40974",
    "data-name": "Group 40974",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_199",
    "data-name": "Line 199",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40973",
    "data-name": "Group 40973",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73266",
    "data-name": "Path 73266",
    d: "M275.128,237.1,260.5,231.5l-3.131-1.2-.87,2.273c-.673,1.76,3.459,4.975,9.227,7.181s10.99,2.569,11.661.811l.87-2.272Z",
    transform: "translate(-256.428 -230.302)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73267",
    "data-name": "Path 73267",
    d: "M278.489,238c-.673,1.758-5.9,1.4-11.664-.811s-9.9-5.423-9.224-7.182,5.894-1.395,11.662.812S279.162,236.241,278.489,238Z",
    transform: "translate(-256.659 -228.894)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73268",
    "data-name": "Path 73268",
    d: "M262.5,229.466s-4.422-.31-4.323,1.086,6.559,5.2,6.864,5.177c0,0-6.471-3.795-6.431-5.1S262.5,229.466,262.5,229.466Z",
    transform: "translate(-256.794 -229.008)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40975",
    "data-name": "Group 40975",
    transform: "translate(12.308 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73269",
    "data-name": "Path 73269",
    d: "M281.519,238.482c.673-1.759-3.457-4.975-9.226-7.181-.1-.038-.2-.07-.3-.108a66.313,66.313,0,0,1,4.9,8.3C279.378,239.775,281.148,239.453,281.519,238.482Z",
    transform: "translate(-271.997 -231.192)",
    fill: "#ffee2f"
  })))), _g119 || (_g119 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40980",
    "data-name": "Group 40980",
    transform: "translate(115.858 107.973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40978",
    "data-name": "Group 40978",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40977",
    "data-name": "Group 40977",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73270",
    "data-name": "Path 73270",
    d: "M237.14,231.567l15.536,1.972,3.326.421-.307,2.414c-.236,1.867-5.4,2.752-11.524,1.974s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-233.499 -231.144)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73271",
    "data-name": "Path 73271",
    d: "M233.895,230.546c-.237,1.868,4.538,4.014,10.665,4.792s11.286-.108,11.523-1.976-4.537-4.013-10.665-4.791S234.133,228.679,233.895,230.546Z",
    transform: "translate(-233.58 -228.289)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73272",
    "data-name": "Path 73272",
    d: "M255.666,231.131s4.045,1.816,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.076-1.459S255.666,231.131,255.666,231.131Z",
    transform: "translate(-237.053 -228.884)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40979",
    "data-name": "Group 40979",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73273",
    "data-name": "Path 73273",
    d: "M233.895,230.546c.238-1.867,5.4-2.754,11.523-1.974.105.013.206.03.311.044a66.127,66.127,0,0,0-8.239,5.007C235.172,232.7,233.764,231.58,233.895,230.546Z",
    transform: "translate(-233.886 -228.289)",
    fill: "#ffee2f"
  })))), _g120 || (_g120 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40984",
    "data-name": "Group 40984",
    transform: "translate(111.672 124.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40982",
    "data-name": "Group 40982",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40981",
    "data-name": "Group 40981",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73274",
    "data-name": "Path 73274",
    d: "M246.9,256.868l-14.627-5.595-3.132-1.2-.869,2.273c-.673,1.758,3.458,4.973,9.227,7.181s10.99,2.569,11.662.811l.87-2.273Z",
    transform: "translate(-228.204 -250.074)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73275",
    "data-name": "Path 73275",
    d: "M250.265,257.771c-.674,1.759-5.9,1.4-11.664-.81s-9.9-5.424-9.227-7.181,5.9-1.4,11.664.811S250.937,256.012,250.265,257.771Z",
    transform: "translate(-228.434 -248.665)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73276",
    "data-name": "Path 73276",
    d: "M234.274,249.237s-4.423-.31-4.322,1.087,6.559,5.195,6.864,5.176c0,0-6.471-3.8-6.433-5.1S234.274,249.237,234.274,249.237Z",
    transform: "translate(-228.57 -248.779)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40983",
    "data-name": "Group 40983",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73277",
    "data-name": "Path 73277",
    d: "M253.3,258.252c.672-1.759-3.458-4.975-9.227-7.181-.1-.038-.2-.071-.295-.108a66.341,66.341,0,0,1,4.9,8.3C251.155,259.546,252.923,259.225,253.3,258.252Z",
    transform: "translate(-243.775 -250.964)",
    fill: "#ffee2f"
  })))), _g121 || (_g121 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40988",
    "data-name": "Group 40988",
    transform: "translate(93.545 123.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40986",
    "data-name": "Group 40986",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40985",
    "data-name": "Group 40985",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73278",
    "data-name": "Path 73278",
    d: "M208.915,251.336l15.535,1.974,3.327.422-.307,2.414c-.237,1.867-5.4,2.751-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-205.274 -250.915)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73279",
    "data-name": "Path 73279",
    d: "M205.67,250.317c-.236,1.869,4.538,4.014,10.665,4.792s11.288-.107,11.524-1.975-4.538-4.014-10.665-4.792S205.908,248.449,205.67,250.317Z",
    transform: "translate(-205.355 -248.059)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73280",
    "data-name": "Path 73280",
    d: "M227.442,250.9s4.044,1.816,3.3,3-8.234,1.483-8.495,1.322c0,0,7.5-.29,8.078-1.459S227.442,250.9,227.442,250.9Z",
    transform: "translate(-208.828 -248.655)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40987",
    "data-name": "Group 40987",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73281",
    "data-name": "Path 73281",
    d: "M205.67,250.317c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.044a66.189,66.189,0,0,0-8.239,5.007C206.947,252.469,205.539,251.351,205.67,250.317Z",
    transform: "translate(-205.661 -248.059)",
    fill: "#ffee2f"
  })))), _g122 || (_g122 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40992",
    "data-name": "Group 40992",
    transform: "translate(102.719 116.965)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40990",
    "data-name": "Group 40990",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_203",
    "data-name": "Line 203",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40989",
    "data-name": "Group 40989",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73282",
    "data-name": "Path 73282",
    d: "M220.519,242.939l15.536,1.974,3.327.421-.307,2.414c-.237,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-216.878 -242.517)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73283",
    "data-name": "Path 73283",
    d: "M217.274,241.919c-.236,1.869,4.538,4.014,10.665,4.792s11.288-.108,11.524-1.976-4.537-4.013-10.665-4.791S217.512,240.052,217.274,241.919Z",
    transform: "translate(-216.959 -239.662)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73284",
    "data-name": "Path 73284",
    d: "M239.046,242.5s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S239.046,242.5,239.046,242.5Z",
    transform: "translate(-220.433 -240.258)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40991",
    "data-name": "Group 40991",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73285",
    "data-name": "Path 73285",
    d: "M217.274,241.919c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.03.311.044a66.284,66.284,0,0,0-8.24,5.007C218.551,244.071,217.143,242.952,217.274,241.919Z",
    transform: "translate(-217.265 -239.662)",
    fill: "#ffdf2f"
  })))), _g123 || (_g123 = /*#__PURE__*/React.createElement("g", {
    id: "Group_40996",
    "data-name": "Group 40996",
    transform: "translate(133.296 129.209)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40994",
    "data-name": "Group 40994",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_204",
    "data-name": "Line 204",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40993",
    "data-name": "Group 40993",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73286",
    "data-name": "Path 73286",
    d: "M274.257,263.352l-14.627-5.595-3.131-1.2-.87,2.273c-.673,1.76,3.459,4.975,9.227,7.182s10.99,2.568,11.663.81l.87-2.271Z",
    transform: "translate(-255.557 -256.558)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73287",
    "data-name": "Path 73287",
    d: "M277.619,264.256c-.674,1.758-5.9,1.4-11.665-.811s-9.9-5.422-9.225-7.182,5.894-1.395,11.663.811S278.291,262.5,277.619,264.256Z",
    transform: "translate(-255.788 -255.15)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73288",
    "data-name": "Path 73288",
    d: "M261.627,255.722s-4.422-.31-4.322,1.086,6.558,5.2,6.864,5.177c0,0-6.471-3.8-6.432-5.1S261.627,255.722,261.627,255.722Z",
    transform: "translate(-255.923 -255.264)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40995",
    "data-name": "Group 40995",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73289",
    "data-name": "Path 73289",
    d: "M280.65,264.738c.671-1.76-3.459-4.976-9.227-7.182-.1-.038-.2-.07-.295-.106a66.222,66.222,0,0,1,4.9,8.3C278.507,266.032,280.277,265.711,280.65,264.738Z",
    transform: "translate(-271.128 -257.45)",
    fill: "#ffee2f"
  })))), _g124 || (_g124 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41000",
    "data-name": "Group 41000",
    transform: "translate(115.17 128.73)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_40998",
    "data-name": "Group 40998",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_205",
    "data-name": "Line 205",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_40997",
    "data-name": "Group 40997",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73290",
    "data-name": "Path 73290",
    d: "M236.269,257.823,251.8,259.8l3.327.421-.306,2.414c-.239,1.868-5.4,2.752-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-232.628 -257.4)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73291",
    "data-name": "Path 73291",
    d: "M233.024,256.8c-.237,1.869,4.537,4.014,10.664,4.792s11.287-.108,11.524-1.976-4.537-4.013-10.665-4.791S233.262,254.935,233.024,256.8Z",
    transform: "translate(-232.709 -254.545)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73292",
    "data-name": "Path 73292",
    d: "M254.8,257.388s4.045,1.814,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.078-1.459S254.8,257.388,254.8,257.388Z",
    transform: "translate(-236.182 -255.14)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_40999",
    "data-name": "Group 40999",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73293",
    "data-name": "Path 73293",
    d: "M233.024,256.8c.238-1.867,5.4-2.754,11.523-1.974.105.013.206.029.311.043a66.362,66.362,0,0,0-8.239,5.007C234.3,258.955,232.893,257.836,233.024,256.8Z",
    transform: "translate(-233.015 -254.545)",
    fill: "#ffee2f"
  })))), _g125 || (_g125 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41004",
    "data-name": "Group 41004",
    transform: "translate(124.343 122.091)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41002",
    "data-name": "Group 41002",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_206",
    "data-name": "Line 206",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41001",
    "data-name": "Group 41001",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73294",
    "data-name": "Path 73294",
    d: "M247.872,249.425l15.537,1.972,3.327.422-.307,2.414c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-244.231 -249.002)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73295",
    "data-name": "Path 73295",
    d: "M244.627,248.4c-.237,1.868,4.537,4.014,10.665,4.792s11.287-.107,11.525-1.975-4.539-4.014-10.666-4.792S244.865,246.537,244.627,248.4Z",
    transform: "translate(-244.312 -246.147)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73296",
    "data-name": "Path 73296",
    d: "M266.4,248.99s4.044,1.815,3.294,3-8.232,1.483-8.492,1.323c0,0,7.5-.291,8.076-1.46S266.4,248.99,266.4,248.99Z",
    transform: "translate(-247.786 -246.742)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41003",
    "data-name": "Group 41003",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73297",
    "data-name": "Path 73297",
    d: "M244.627,248.4c.238-1.867,5.4-2.754,11.523-1.974.105.013.206.029.311.044a66.253,66.253,0,0,0-8.239,5.007C245.9,250.556,244.5,249.438,244.627,248.4Z",
    transform: "translate(-244.618 -246.147)",
    fill: "#ffdf2f"
  })))), _g126 || (_g126 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41008",
    "data-name": "Group 41008",
    transform: "translate(102.8 133.303)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41006",
    "data-name": "Group 41006",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_207",
    "data-name": "Line 207",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41005",
    "data-name": "Group 41005",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73298",
    "data-name": "Path 73298",
    d: "M235.68,268.533l-14.626-5.6-3.132-1.2-.869,2.273c-.674,1.759,3.458,4.974,9.227,7.181s10.99,2.569,11.663.81l.869-2.271Z",
    transform: "translate(-216.981 -261.738)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73299",
    "data-name": "Path 73299",
    d: "M239.042,269.436c-.673,1.758-5.894,1.4-11.663-.811s-9.9-5.424-9.227-7.182,5.9-1.395,11.663.812S239.714,267.677,239.042,269.436Z",
    transform: "translate(-217.211 -260.33)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73300",
    "data-name": "Path 73300",
    d: "M223.052,260.9s-4.423-.31-4.322,1.086,6.558,5.2,6.864,5.177c0,0-6.471-3.8-6.431-5.1S223.052,260.9,223.052,260.9Z",
    transform: "translate(-217.347 -260.443)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41007",
    "data-name": "Group 41007",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73301",
    "data-name": "Path 73301",
    d: "M242.072,269.918c.672-1.76-3.457-4.977-9.227-7.181-.1-.039-.2-.07-.295-.108a66.34,66.34,0,0,1,4.9,8.3C239.931,271.211,241.7,270.89,242.072,269.918Z",
    transform: "translate(-232.551 -262.629)",
    fill: "#ffee2f"
  })))), _g127 || (_g127 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41012",
    "data-name": "Group 41012",
    transform: "translate(84.673 132.825)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41010",
    "data-name": "Group 41010",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_208",
    "data-name": "Line 208",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41009",
    "data-name": "Group 41009",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73302",
    "data-name": "Path 73302",
    d: "M197.692,263l15.536,1.973,3.327.421-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-194.051 -262.58)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73303",
    "data-name": "Path 73303",
    d: "M194.447,261.982c-.236,1.869,4.538,4.014,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.013-10.665-4.791S194.686,260.115,194.447,261.982Z",
    transform: "translate(-194.132 -259.725)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73304",
    "data-name": "Path 73304",
    d: "M216.219,262.568s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.292,8.077-1.46S216.219,262.568,216.219,262.568Z",
    transform: "translate(-197.605 -260.32)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41011",
    "data-name": "Group 41011",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73305",
    "data-name": "Path 73305",
    d: "M194.447,261.982c.239-1.867,5.4-2.754,11.524-1.974.1.013.206.03.311.043a66.482,66.482,0,0,0-8.239,5.007C195.724,264.134,194.316,263.015,194.447,261.982Z",
    transform: "translate(-194.438 -259.725)",
    fill: "#ffee2f"
  })))), _g128 || (_g128 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41016",
    "data-name": "Group 41016",
    transform: "translate(93.846 126.186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41014",
    "data-name": "Group 41014",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_209",
    "data-name": "Line 209",
    x1: 0.307,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41013",
    "data-name": "Group 41013",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73306",
    "data-name": "Path 73306",
    d: "M209.295,254.6l15.538,1.973,3.326.421-.307,2.414c-.238,1.869-5.4,2.752-11.525,1.974s-10.9-2.924-10.663-4.792l.307-2.414Z",
    transform: "translate(-205.654 -254.181)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73307",
    "data-name": "Path 73307",
    d: "M206.051,253.583c-.237,1.869,4.537,4.015,10.664,4.793S228,258.27,228.239,256.4s-4.538-4.014-10.665-4.791S206.289,251.716,206.051,253.583Z",
    transform: "translate(-205.736 -251.327)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73308",
    "data-name": "Path 73308",
    d: "M227.823,254.17s4.045,1.815,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.078-1.459S227.823,254.17,227.823,254.17Z",
    transform: "translate(-209.209 -251.922)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41015",
    "data-name": "Group 41015",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73309",
    "data-name": "Path 73309",
    d: "M206.051,253.583c.238-1.867,5.4-2.753,11.523-1.973.105.013.206.03.311.044a66.247,66.247,0,0,0-8.24,5.006C207.327,255.735,205.919,254.618,206.051,253.583Z",
    transform: "translate(-206.042 -251.327)",
    fill: "#ffdf2f"
  })))), _g129 || (_g129 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41020",
    "data-name": "Group 41020",
    transform: "translate(106.466 122.476)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41018",
    "data-name": "Group 41018",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_210",
    "data-name": "Line 210",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41017",
    "data-name": "Group 41017",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73310",
    "data-name": "Path 73310",
    d: "M240.318,254.838l-14.627-5.6-3.131-1.2-.87,2.273c-.673,1.759,3.458,4.974,9.227,7.182s10.99,2.568,11.662.81l.87-2.271Z",
    transform: "translate(-221.618 -248.042)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73311",
    "data-name": "Path 73311",
    d: "M243.68,255.74c-.674,1.757-5.9,1.4-11.664-.811s-9.9-5.423-9.226-7.182,5.9-1.395,11.663.812S244.352,253.981,243.68,255.74Z",
    transform: "translate(-221.849 -246.634)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73312",
    "data-name": "Path 73312",
    d: "M227.688,247.205s-4.422-.309-4.322,1.087,6.558,5.2,6.864,5.177c0,0-6.471-3.795-6.432-5.1S227.688,247.205,227.688,247.205Z",
    transform: "translate(-221.984 -246.747)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41019",
    "data-name": "Group 41019",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73313",
    "data-name": "Path 73313",
    d: "M246.71,256.222c.672-1.76-3.457-4.975-9.227-7.181-.1-.038-.2-.071-.295-.108a66.392,66.392,0,0,1,4.9,8.3C244.569,257.516,246.337,257.194,246.71,256.222Z",
    transform: "translate(-237.189 -248.932)",
    fill: "#ffee2f"
  })))), _g130 || (_g130 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41024",
    "data-name": "Group 41024",
    transform: "translate(88.339 121.998)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41022",
    "data-name": "Group 41022",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_211",
    "data-name": "Line 211",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41021",
    "data-name": "Group 41021",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73314",
    "data-name": "Path 73314",
    d: "M202.33,249.307l15.536,1.972,3.326.421-.306,2.414c-.238,1.867-5.4,2.751-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-198.689 -248.883)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73315",
    "data-name": "Path 73315",
    d: "M199.085,248.285c-.237,1.869,4.538,4.015,10.665,4.792s11.286-.106,11.523-1.975-4.538-4.013-10.665-4.791S199.323,246.418,199.085,248.285Z",
    transform: "translate(-198.77 -246.029)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73316",
    "data-name": "Path 73316",
    d: "M220.856,248.872s4.045,1.815,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.077-1.459S220.856,248.872,220.856,248.872Z",
    transform: "translate(-202.243 -246.624)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41023",
    "data-name": "Group 41023",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73317",
    "data-name": "Path 73317",
    d: "M199.085,248.285c.238-1.867,5.4-2.753,11.523-1.973.105.013.207.029.311.044a66.366,66.366,0,0,0-8.24,5.006C200.362,250.438,198.954,249.32,199.085,248.285Z",
    transform: "translate(-199.076 -246.029)",
    fill: "#ffee2f"
  })))), _g131 || (_g131 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41028",
    "data-name": "Group 41028",
    transform: "translate(97.512 115.358)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41026",
    "data-name": "Group 41026",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_212",
    "data-name": "Line 212",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41025",
    "data-name": "Group 41025",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73318",
    "data-name": "Path 73318",
    d: "M213.933,240.908l15.537,1.974,3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.526,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-210.292 -240.486)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73319",
    "data-name": "Path 73319",
    d: "M210.688,239.888c-.237,1.868,4.537,4.014,10.665,4.792s11.288-.107,11.525-1.975-4.539-4.014-10.666-4.792S210.926,238.02,210.688,239.888Z",
    transform: "translate(-210.373 -237.63)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73320",
    "data-name": "Path 73320",
    d: "M232.461,240.474s4.044,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.29,8.077-1.459S232.461,240.474,232.461,240.474Z",
    transform: "translate(-213.847 -238.226)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41027",
    "data-name": "Group 41027",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73321",
    "data-name": "Path 73321",
    d: "M210.688,239.888c.238-1.868,5.4-2.753,11.523-1.975.105.013.206.031.311.046a66.245,66.245,0,0,0-8.24,5C211.964,242.041,210.557,240.921,210.688,239.888Z",
    transform: "translate(-210.679 -237.63)",
    fill: "#ffdf2f"
  })))), _g132 || (_g132 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41032",
    "data-name": "Group 41032",
    transform: "translate(133.991 152.579)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41030",
    "data-name": "Group 41030",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_213",
    "data-name": "Line 213",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41029",
    "data-name": "Group 41029",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73322",
    "data-name": "Path 73322",
    d: "M275.133,292.916l-14.625-5.6-3.131-1.2-.87,2.273c-.673,1.76,3.458,4.975,9.227,7.181s10.99,2.569,11.662.811l.87-2.271Z",
    transform: "translate(-256.435 -286.12)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73323",
    "data-name": "Path 73323",
    d: "M278.5,293.818c-.674,1.757-5.9,1.395-11.664-.811s-9.9-5.422-9.225-7.182,5.894-1.4,11.662.811S279.169,292.059,278.5,293.818Z",
    transform: "translate(-256.666 -284.712)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73324",
    "data-name": "Path 73324",
    d: "M262.505,285.283s-4.422-.309-4.322,1.087,6.559,5.2,6.863,5.176c0,0-6.469-3.795-6.43-5.1S262.505,285.283,262.505,285.283Z",
    transform: "translate(-256.801 -284.825)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41031",
    "data-name": "Group 41031",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73325",
    "data-name": "Path 73325",
    d: "M281.527,294.3c.672-1.76-3.458-4.977-9.227-7.182-.1-.038-.2-.07-.3-.107a66.411,66.411,0,0,1,4.9,8.3C279.386,295.594,281.155,295.271,281.527,294.3Z",
    transform: "translate(-272.005 -287.011)",
    fill: "#ffee2f"
  })))), _g133 || (_g133 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41036",
    "data-name": "Group 41036",
    transform: "translate(113.903 154.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41034",
    "data-name": "Group 41034",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_214",
    "data-name": "Line 214",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41033",
    "data-name": "Group 41033",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73326",
    "data-name": "Path 73326",
    d: "M234.666,290.306,250.2,292.28l3.326.42-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-231.025 -289.883)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73327",
    "data-name": "Path 73327",
    d: "M231.421,289.285c-.236,1.867,4.538,4.015,10.665,4.792s11.288-.107,11.524-1.976-4.538-4.013-10.665-4.791S231.659,287.418,231.421,289.285Z",
    transform: "translate(-231.106 -287.028)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73328",
    "data-name": "Path 73328",
    d: "M253.193,289.87s4.045,1.816,3.3,3-8.233,1.484-8.493,1.322c0,0,7.5-.29,8.077-1.458S253.193,289.87,253.193,289.87Z",
    transform: "translate(-234.579 -287.623)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41035",
    "data-name": "Group 41035",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73329",
    "data-name": "Path 73329",
    d: "M231.421,289.285c.238-1.867,5.4-2.753,11.523-1.974.105.013.207.031.312.043a66.242,66.242,0,0,0-8.239,5.007C232.7,291.437,231.29,290.319,231.421,289.285Z",
    transform: "translate(-231.412 -287.028)",
    fill: "#ffee2f"
  })))), _g134 || (_g134 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41040",
    "data-name": "Group 41040",
    transform: "translate(125.037 145.462)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41038",
    "data-name": "Group 41038",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_215",
    "data-name": "Line 215",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41037",
    "data-name": "Group 41037",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73330",
    "data-name": "Path 73330",
    d: "M248.75,278.987l15.537,1.973,3.326.422-.308,2.413c-.238,1.867-5.4,2.753-11.525,1.974s-10.9-2.924-10.663-4.793l.306-2.412Z",
    transform: "translate(-245.109 -278.564)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73331",
    "data-name": "Path 73331",
    d: "M245.5,277.966c-.237,1.868,4.538,4.014,10.665,4.792s11.287-.106,11.525-1.973-4.539-4.014-10.665-4.792S245.743,276.1,245.5,277.966Z",
    transform: "translate(-245.19 -275.709)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73332",
    "data-name": "Path 73332",
    d: "M267.277,278.551s4.045,1.816,3.3,3-8.234,1.484-8.495,1.322c0,0,7.5-.289,8.077-1.457S267.277,278.551,267.277,278.551Z",
    transform: "translate(-248.663 -276.304)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41039",
    "data-name": "Group 41039",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73333",
    "data-name": "Path 73333",
    d: "M245.5,277.966c.238-1.869,5.4-2.753,11.524-1.974.105.012.206.029.311.044a66.407,66.407,0,0,0-8.239,5.006C246.782,280.117,245.374,279,245.5,277.966Z",
    transform: "translate(-245.496 -275.709)",
    fill: "#ffdf2f"
  })))), _g135 || (_g135 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41044",
    "data-name": "Group 41044",
    transform: "translate(104.699 145.846)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41042",
    "data-name": "Group 41042",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_216",
    "data-name": "Line 216",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41041",
    "data-name": "Group 41041",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73334",
    "data-name": "Path 73334",
    d: "M238.082,284.4,223.456,278.8l-3.131-1.2-.87,2.274c-.673,1.759,3.458,4.975,9.227,7.182s10.989,2.567,11.663.81l.869-2.272Z",
    transform: "translate(-219.383 -277.603)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73335",
    "data-name": "Path 73335",
    d: "M241.444,285.3c-.673,1.758-5.9,1.4-11.663-.813s-9.9-5.422-9.226-7.181,5.894-1.395,11.663.813S242.116,283.542,241.444,285.3Z",
    transform: "translate(-219.614 -276.195)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73336",
    "data-name": "Path 73336",
    d: "M225.453,276.766s-4.422-.309-4.323,1.087,6.559,5.2,6.864,5.177c0,0-6.47-3.8-6.431-5.1S225.453,276.766,225.453,276.766Z",
    transform: "translate(-219.749 -276.308)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41043",
    "data-name": "Group 41043",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73337",
    "data-name": "Path 73337",
    d: "M244.474,285.783c.672-1.759-3.458-4.976-9.226-7.181-.1-.04-.2-.072-.3-.108a66.379,66.379,0,0,1,4.9,8.3C242.333,287.077,244.1,286.754,244.474,285.783Z",
    transform: "translate(-234.953 -278.494)",
    fill: "#ffee2f"
  })))), _g136 || (_g136 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41048",
    "data-name": "Group 41048",
    transform: "translate(86.572 145.368)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41046",
    "data-name": "Group 41046",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_217",
    "data-name": "Line 217",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41045",
    "data-name": "Group 41045",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73338",
    "data-name": "Path 73338",
    d: "M200.094,278.867l15.536,1.974,3.327.422-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.973s-10.9-2.923-10.664-4.792l.306-2.412Z",
    transform: "translate(-196.453 -278.446)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73339",
    "data-name": "Path 73339",
    d: "M196.849,277.848c-.236,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.525-1.975-4.538-4.014-10.665-4.792S197.088,275.979,196.849,277.848Z",
    transform: "translate(-196.534 -275.59)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73340",
    "data-name": "Path 73340",
    d: "M218.621,278.433s4.045,1.816,3.3,3-8.234,1.482-8.495,1.322c0,0,7.5-.29,8.078-1.459S218.621,278.433,218.621,278.433Z",
    transform: "translate(-200.008 -276.186)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41047",
    "data-name": "Group 41047",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73341",
    "data-name": "Path 73341",
    d: "M196.849,277.848c.239-1.869,5.4-2.754,11.524-1.975.105.013.206.03.311.045a66.056,66.056,0,0,0-8.24,5.006C198.126,280,196.718,278.882,196.849,277.848Z",
    transform: "translate(-196.84 -275.59)",
    fill: "#ffee2f"
  })))), _g137 || (_g137 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41052",
    "data-name": "Group 41052",
    transform: "translate(95.744 138.729)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41050",
    "data-name": "Group 41050",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_218",
    "data-name": "Line 218",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41049",
    "data-name": "Group 41049",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73342",
    "data-name": "Path 73342",
    d: "M211.7,270.469l15.536,1.973,3.326.421-.306,2.415c-.239,1.867-5.4,2.753-11.526,1.973s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-208.056 -270.048)",
    fill: "url(#radial-gradient-34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73343",
    "data-name": "Path 73343",
    d: "M208.453,269.45c-.237,1.867,4.537,4.013,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.012-10.665-4.792S208.691,267.581,208.453,269.45Z",
    transform: "translate(-208.138 -267.192)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73344",
    "data-name": "Path 73344",
    d: "M230.225,270.035s4.044,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.077-1.459S230.225,270.035,230.225,270.035Z",
    transform: "translate(-211.611 -267.788)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41051",
    "data-name": "Group 41051",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73345",
    "data-name": "Path 73345",
    d: "M208.453,269.45c.238-1.869,5.4-2.753,11.524-1.976.1.014.206.031.311.045a66.143,66.143,0,0,0-8.239,5.007C209.73,271.6,208.322,270.482,208.453,269.45Z",
    transform: "translate(-208.444 -267.192)",
    fill: "#ffdf2f"
  })))), _g138 || (_g138 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41056",
    "data-name": "Group 41056",
    transform: "translate(131.938 141.143)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41054",
    "data-name": "Group 41054",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_219",
    "data-name": "Line 219",
    x1: 0.869,
    y2: 2.273,
    transform: "translate(20.961 9.104)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41053",
    "data-name": "Group 41053",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73346",
    "data-name": "Path 73346",
    d: "M272.537,278.448l-14.626-5.6-3.131-1.2-.87,2.272c-.674,1.759,3.458,4.973,9.227,7.181s10.989,2.569,11.662.811l.87-2.273Z",
    transform: "translate(-253.839 -271.655)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73347",
    "data-name": "Path 73347",
    d: "M275.9,279.351c-.673,1.76-5.9,1.4-11.664-.81s-9.9-5.423-9.225-7.181,5.894-1.4,11.663.811S276.571,277.594,275.9,279.351Z",
    transform: "translate(-254.069 -270.247)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73348",
    "data-name": "Path 73348",
    d: "M259.909,270.818s-4.422-.31-4.322,1.086,6.559,5.195,6.864,5.176c0,0-6.47-3.795-6.431-5.1S259.909,270.818,259.909,270.818Z",
    transform: "translate(-254.205 -270.36)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41055",
    "data-name": "Group 41055",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73349",
    "data-name": "Path 73349",
    d: "M278.93,279.832c.671-1.757-3.457-4.974-9.226-7.18-.1-.038-.2-.07-.3-.108a66.216,66.216,0,0,1,4.9,8.3C276.789,281.126,278.557,280.806,278.93,279.832Z",
    transform: "translate(-269.409 -272.545)",
    fill: "#ffee2f"
  })))), _g139 || (_g139 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41060",
    "data-name": "Group 41060",
    transform: "translate(113.811 140.664)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41058",
    "data-name": "Group 41058",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_220",
    "data-name": "Line 220",
    x1: 0.307,
    y2: 2.412,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41057",
    "data-name": "Group 41057",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73350",
    "data-name": "Path 73350",
    d: "M234.55,272.918l15.536,1.974,3.326.42-.307,2.415c-.237,1.867-5.4,2.752-11.524,1.974s-10.9-2.924-10.664-4.793l.307-2.411Z",
    transform: "translate(-230.909 -272.497)",
    fill: "url(#radial-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73351",
    "data-name": "Path 73351",
    d: "M231.306,271.9c-.237,1.867,4.537,4.013,10.664,4.791s11.287-.107,11.524-1.976-4.538-4.013-10.665-4.79S231.543,270.03,231.306,271.9Z",
    transform: "translate(-230.991 -269.641)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73352",
    "data-name": "Path 73352",
    d: "M253.077,272.483s4.045,1.815,3.3,3-8.234,1.485-8.494,1.322c0,0,7.5-.289,8.078-1.459S253.077,272.483,253.077,272.483Z",
    transform: "translate(-234.463 -270.236)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41059",
    "data-name": "Group 41059",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73353",
    "data-name": "Path 73353",
    d: "M231.306,271.9c.237-1.869,5.4-2.754,11.523-1.975.105.013.206.03.311.043a66.335,66.335,0,0,0-8.239,5.007C232.583,274.051,231.174,272.931,231.306,271.9Z",
    transform: "translate(-231.297 -269.641)",
    fill: "#ffee2f"
  })))), _g140 || (_g140 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41064",
    "data-name": "Group 41064",
    transform: "translate(122.984 134.025)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41062",
    "data-name": "Group 41062",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_221",
    "data-name": "Line 221",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41061",
    "data-name": "Group 41061",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73354",
    "data-name": "Path 73354",
    d: "M246.153,264.52l15.536,1.974,3.326.421-.307,2.414c-.237,1.868-5.4,2.752-11.524,1.975s-10.9-2.925-10.664-4.792l.306-2.414Z",
    transform: "translate(-242.512 -264.098)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73355",
    "data-name": "Path 73355",
    d: "M242.908,263.5c-.236,1.868,4.538,4.015,10.665,4.792s11.288-.107,11.524-1.974-4.537-4.014-10.665-4.792S243.147,261.632,242.908,263.5Z",
    transform: "translate(-242.593 -261.242)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73356",
    "data-name": "Path 73356",
    d: "M264.681,264.085s4.045,1.815,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.076-1.459S264.681,264.085,264.681,264.085Z",
    transform: "translate(-246.067 -261.838)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41063",
    "data-name": "Group 41063",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73357",
    "data-name": "Path 73357",
    d: "M242.908,263.5c.239-1.868,5.4-2.754,11.524-1.974.105.013.206.03.311.044a66.343,66.343,0,0,0-8.239,5.007C244.185,265.652,242.777,264.533,242.908,263.5Z",
    transform: "translate(-242.899 -261.242)",
    fill: "#ffdf2f"
  })))), _g141 || (_g141 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41068",
    "data-name": "Group 41068",
    transform: "translate(158.652 143.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41066",
    "data-name": "Group 41066",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_222",
    "data-name": "Line 222",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.96 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41065",
    "data-name": "Group 41065",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73358",
    "data-name": "Path 73358",
    d: "M306.329,281.438l-14.626-5.6-3.131-1.2-.87,2.273c-.674,1.759,3.457,4.974,9.227,7.181s10.988,2.568,11.661.81l.869-2.271Z",
    transform: "translate(-287.631 -274.643)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73359",
    "data-name": "Path 73359",
    d: "M309.69,282.341c-.672,1.757-5.9,1.4-11.663-.811s-9.9-5.423-9.224-7.181,5.9-1.395,11.661.811S310.363,280.581,309.69,282.341Z",
    transform: "translate(-287.861 -273.235)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73360",
    "data-name": "Path 73360",
    d: "M293.7,273.806s-4.423-.311-4.323,1.085,6.558,5.2,6.864,5.177c0,0-6.47-3.794-6.43-5.1S293.7,273.806,293.7,273.806Z",
    transform: "translate(-287.996 -273.348)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41067",
    "data-name": "Group 41067",
    transform: "translate(12.309 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73361",
    "data-name": "Path 73361",
    d: "M312.721,282.822c.673-1.76-3.457-4.976-9.226-7.181l-.294-.108a66.422,66.422,0,0,1,4.9,8.3C310.579,284.115,312.349,283.795,312.721,282.822Z",
    transform: "translate(-303.201 -275.532)",
    fill: "#ffee2f"
  })))), _g142 || (_g142 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41072",
    "data-name": "Group 41072",
    transform: "translate(140.525 143.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41070",
    "data-name": "Group 41070",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_223",
    "data-name": "Line 223",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41069",
    "data-name": "Group 41069",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73362",
    "data-name": "Path 73362",
    d: "M268.342,275.908l15.536,1.972,3.327.423-.308,2.413c-.238,1.867-5.395,2.753-11.523,1.974s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-264.701 -275.484)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73363",
    "data-name": "Path 73363",
    d: "M265.1,274.886c-.237,1.867,4.536,4.014,10.665,4.793s11.286-.108,11.524-1.975-4.539-4.014-10.666-4.792S265.335,273.018,265.1,274.886Z",
    transform: "translate(-264.782 -272.629)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73364",
    "data-name": "Path 73364",
    d: "M286.869,275.471s4.044,1.817,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.29,8.076-1.459S286.869,275.471,286.869,275.471Z",
    transform: "translate(-268.255 -273.224)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41071",
    "data-name": "Group 41071",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73365",
    "data-name": "Path 73365",
    d: "M265.1,274.886c.238-1.868,5.4-2.753,11.522-1.974.105.013.207.03.312.044a66.359,66.359,0,0,0-8.24,5.006C266.374,277.038,264.966,275.921,265.1,274.886Z",
    transform: "translate(-265.088 -272.629)",
    fill: "#ffee2f"
  })))), _g143 || (_g143 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41076",
    "data-name": "Group 41076",
    transform: "translate(149.697 136.388)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41074",
    "data-name": "Group 41074",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_224",
    "data-name": "Line 224",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41073",
    "data-name": "Group 41073",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73366",
    "data-name": "Path 73366",
    d: "M279.944,267.508l15.537,1.974,3.326.421-.306,2.415c-.238,1.867-5.4,2.751-11.526,1.973s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-276.303 -267.086)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73367",
    "data-name": "Path 73367",
    d: "M276.7,266.488c-.236,1.868,4.539,4.014,10.665,4.793s11.287-.108,11.525-1.976-4.539-4.013-10.665-4.791S276.937,264.62,276.7,266.488Z",
    transform: "translate(-276.384 -264.231)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73368",
    "data-name": "Path 73368",
    d: "M298.472,267.074s4.046,1.816,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.077-1.459S298.472,267.074,298.472,267.074Z",
    transform: "translate(-279.858 -264.827)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41075",
    "data-name": "Group 41075",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73369",
    "data-name": "Path 73369",
    d: "M276.7,266.488c.238-1.868,5.4-2.753,11.524-1.974.105.013.207.03.312.044a66.186,66.186,0,0,0-8.242,5.007C277.977,268.64,276.569,267.522,276.7,266.488Z",
    transform: "translate(-276.691 -264.231)",
    fill: "#ffdf2f"
  })))), _g144 || (_g144 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41080",
    "data-name": "Group 41080",
    transform: "translate(157.164 131.916)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41078",
    "data-name": "Group 41078",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_225",
    "data-name": "Line 225",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41077",
    "data-name": "Group 41077",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73370",
    "data-name": "Path 73370",
    d: "M304.447,266.777l-14.627-5.595-3.131-1.2-.87,2.273c-.674,1.758,3.458,4.973,9.227,7.181s10.99,2.569,11.663.811l.87-2.272Z",
    transform: "translate(-285.748 -259.983)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73371",
    "data-name": "Path 73371",
    d: "M307.81,267.681c-.674,1.758-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.182,5.9-1.4,11.662.811S308.481,265.922,307.81,267.681Z",
    transform: "translate(-285.978 -258.574)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73372",
    "data-name": "Path 73372",
    d: "M291.818,259.147s-4.423-.311-4.322,1.086,6.558,5.2,6.864,5.176c0,0-6.47-3.8-6.43-5.1S291.818,259.147,291.818,259.147Z",
    transform: "translate(-286.114 -258.688)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41079",
    "data-name": "Group 41079",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73373",
    "data-name": "Path 73373",
    d: "M310.84,268.162c.671-1.759-3.459-4.976-9.227-7.181-.1-.038-.2-.071-.295-.108a66.211,66.211,0,0,1,4.9,8.3C308.7,269.455,310.467,269.135,310.84,268.162Z",
    transform: "translate(-301.318 -260.873)",
    fill: "#ffee2f"
  })))), _g145 || (_g145 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41084",
    "data-name": "Group 41084",
    transform: "translate(139.038 131.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41082",
    "data-name": "Group 41082",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_226",
    "data-name": "Line 226",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41081",
    "data-name": "Group 41081",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73374",
    "data-name": "Path 73374",
    d: "M266.46,261.246,282,263.22l3.326.421-.306,2.414c-.238,1.869-5.4,2.754-11.526,1.975s-10.9-2.924-10.662-4.792l.305-2.413Z",
    transform: "translate(-262.819 -260.825)",
    fill: "url(#radial-gradient-26)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73375",
    "data-name": "Path 73375",
    d: "M263.214,260.227c-.237,1.867,4.538,4.014,10.665,4.792s11.286-.108,11.523-1.976-4.537-4.013-10.665-4.792S263.453,258.359,263.214,260.227Z",
    transform: "translate(-262.9 -257.969)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73376",
    "data-name": "Path 73376",
    d: "M284.987,260.812s4.044,1.815,3.3,3-8.234,1.485-8.493,1.323c0,0,7.5-.291,8.077-1.459S284.987,260.812,284.987,260.812Z",
    transform: "translate(-266.374 -258.564)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41083",
    "data-name": "Group 41083",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73377",
    "data-name": "Path 73377",
    d: "M263.214,260.227c.239-1.868,5.4-2.753,11.523-1.976l.312.045a66.38,66.38,0,0,0-8.24,5.007C264.491,262.379,263.083,261.26,263.214,260.227Z",
    transform: "translate(-263.205 -257.969)",
    fill: "#ffee2f"
  })))), _g146 || (_g146 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41088",
    "data-name": "Group 41088",
    transform: "translate(148.21 124.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41086",
    "data-name": "Group 41086",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_227",
    "data-name": "Line 227",
    x1: 0.305,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41085",
    "data-name": "Group 41085",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73378",
    "data-name": "Path 73378",
    d: "M278.062,252.85l15.538,1.972,3.326.421-.307,2.414c-.237,1.867-5.4,2.751-11.525,1.973s-10.9-2.923-10.663-4.792l.305-2.414Z",
    transform: "translate(-274.422 -252.426)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73379",
    "data-name": "Path 73379",
    d: "M274.817,251.828c-.236,1.868,4.539,4.014,10.665,4.792s11.288-.107,11.525-1.975-4.537-4.014-10.665-4.792S275.056,249.961,274.817,251.828Z",
    transform: "translate(-274.503 -249.571)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73380",
    "data-name": "Path 73380",
    d: "M296.59,252.414s4.044,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.078-1.459S296.59,252.414,296.59,252.414Z",
    transform: "translate(-277.977 -250.167)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41087",
    "data-name": "Group 41087",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73381",
    "data-name": "Path 73381",
    d: "M274.817,251.828c.24-1.867,5.4-2.753,11.524-1.974.1.013.207.03.311.044a66.32,66.32,0,0,0-8.238,5.007C276.1,253.98,274.687,252.862,274.817,251.828Z",
    transform: "translate(-274.809 -249.571)",
    fill: "#ffdf2f"
  })))), _g147 || (_g147 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41092",
    "data-name": "Group 41092",
    transform: "translate(127.986 158.838)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41090",
    "data-name": "Group 41090",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_228",
    "data-name": "Line 228",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.256)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41089",
    "data-name": "Group 41089",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73382",
    "data-name": "Path 73382",
    d: "M252.481,295.907l15.536,1.972,3.327.421-.307,2.414c-.239,1.869-5.4,2.753-11.526,1.974s-10.9-2.923-10.663-4.791l.306-2.415Z",
    transform: "translate(-248.84 -295.483)",
    fill: "url(#radial-gradient-146)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73383",
    "data-name": "Path 73383",
    d: "M249.236,294.885c-.236,1.869,4.538,4.015,10.665,4.794s11.287-.108,11.525-1.976-4.538-4.012-10.665-4.791S249.474,293.018,249.236,294.885Z",
    transform: "translate(-248.921 -292.63)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73384",
    "data-name": "Path 73384",
    d: "M271.008,295.472s4.045,1.815,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.29,8.079-1.459S271.008,295.472,271.008,295.472Z",
    transform: "translate(-252.394 -293.225)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41091",
    "data-name": "Group 41091",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73385",
    "data-name": "Path 73385",
    d: "M249.236,294.885c.238-1.867,5.4-2.751,11.524-1.973.1.013.206.03.311.045a66.394,66.394,0,0,0-8.239,5.005C250.513,297.039,249.105,295.92,249.236,294.885Z",
    transform: "translate(-249.227 -292.63)",
    fill: "#ffdf2f"
  })))), _g148 || (_g148 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41096",
    "data-name": "Group 41096",
    transform: "translate(147.522 149.381)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41094",
    "data-name": "Group 41094",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_229",
    "data-name": "Line 229",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41093",
    "data-name": "Group 41093",
    transform: "translate(0 1.115)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73386",
    "data-name": "Path 73386",
    d: "M292.249,288.871l-14.625-5.6-3.133-1.2-.869,2.271c-.673,1.761,3.457,4.975,9.227,7.182s10.988,2.569,11.662.81l.87-2.271Z",
    transform: "translate(-273.551 -282.077)",
    fill: "url(#radial-gradient-147)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73387",
    "data-name": "Path 73387",
    d: "M295.612,289.773c-.674,1.757-5.9,1.4-11.663-.811s-9.9-5.423-9.227-7.181,5.9-1.4,11.664.811S296.284,288.015,295.612,289.773Z",
    transform: "translate(-273.781 -280.667)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73388",
    "data-name": "Path 73388",
    d: "M279.622,281.238s-4.422-.309-4.321,1.087,6.558,5.2,6.862,5.177c0,0-6.47-3.795-6.43-5.1S279.622,281.238,279.622,281.238Z",
    transform: "translate(-273.917 -280.781)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41095",
    "data-name": "Group 41095",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73389",
    "data-name": "Path 73389",
    d: "M298.643,290.255c.673-1.758-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.295-.109a66.567,66.567,0,0,1,4.9,8.3C296.5,291.549,298.269,291.228,298.643,290.255Z",
    transform: "translate(-289.122 -282.965)",
    fill: "#ffee2f"
  })))), _g149 || (_g149 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41100",
    "data-name": "Group 41100",
    transform: "translate(129.394 148.903)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41098",
    "data-name": "Group 41098",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_230",
    "data-name": "Line 230",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41097",
    "data-name": "Group 41097",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73390",
    "data-name": "Path 73390",
    d: "M254.262,283.34l15.535,1.972,3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.525,1.976s-10.9-2.925-10.663-4.792l.306-2.414Z",
    transform: "translate(-250.621 -282.918)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73391",
    "data-name": "Path 73391",
    d: "M251.017,282.32c-.236,1.867,4.538,4.015,10.665,4.791s11.288-.106,11.525-1.975-4.539-4.014-10.665-4.789S251.255,280.451,251.017,282.32Z",
    transform: "translate(-250.702 -280.063)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73392",
    "data-name": "Path 73392",
    d: "M272.789,282.9s4.045,1.817,3.3,3-8.233,1.483-8.493,1.323c0,0,7.5-.292,8.077-1.46S272.789,282.9,272.789,282.9Z",
    transform: "translate(-254.175 -280.658)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41099",
    "data-name": "Group 41099",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73393",
    "data-name": "Path 73393",
    d: "M251.017,282.32c.239-1.869,5.4-2.754,11.524-1.973.105.011.206.028.311.043a66.441,66.441,0,0,0-8.24,5.005C252.294,284.472,250.886,283.355,251.017,282.32Z",
    transform: "translate(-251.008 -280.063)",
    fill: "#ffee2f"
  })))), _g150 || (_g150 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41104",
    "data-name": "Group 41104",
    transform: "translate(138.567 142.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41102",
    "data-name": "Group 41102",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_231",
    "data-name": "Line 231",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41101",
    "data-name": "Group 41101",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73394",
    "data-name": "Path 73394",
    d: "M265.865,274.941l15.536,1.973,3.326.422-.306,2.415c-.238,1.867-5.4,2.751-11.526,1.973s-10.9-2.925-10.663-4.793l.307-2.413Z",
    transform: "translate(-262.224 -274.519)",
    fill: "url(#radial-gradient-149)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73395",
    "data-name": "Path 73395",
    d: "M262.621,273.921c-.237,1.869,4.537,4.016,10.665,4.792s11.287-.105,11.523-1.974-4.537-4.012-10.664-4.792S262.859,272.053,262.621,273.921Z",
    transform: "translate(-262.306 -271.664)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73396",
    "data-name": "Path 73396",
    d: "M284.392,274.508s4.046,1.815,3.3,3-8.234,1.485-8.492,1.323c0,0,7.5-.292,8.076-1.459S284.392,274.508,284.392,274.508Z",
    transform: "translate(-265.779 -272.26)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41103",
    "data-name": "Group 41103",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73397",
    "data-name": "Path 73397",
    d: "M262.621,273.921c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.03.311.044a66.52,66.52,0,0,0-8.24,5.007C263.9,276.073,262.49,274.956,262.621,273.921Z",
    transform: "translate(-262.612 -271.664)",
    fill: "#ffdf2f"
  })))), _g151 || (_g151 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41108",
    "data-name": "Group 41108",
    transform: "translate(67.264 114.585)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41106",
    "data-name": "Group 41106",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_232",
    "data-name": "Line 232",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41105",
    "data-name": "Group 41105",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73398",
    "data-name": "Path 73398",
    d: "M190.73,244.854,176.1,239.259l-3.131-1.2-.87,2.273c-.672,1.759,3.458,4.974,9.228,7.181s10.989,2.569,11.662.81l.869-2.272Z",
    transform: "translate(-172.03 -238.06)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73399",
    "data-name": "Path 73399",
    d: "M194.092,245.757c-.674,1.76-5.9,1.4-11.664-.81s-9.9-5.422-9.226-7.181,5.9-1.4,11.664.811S194.764,244,194.092,245.757Z",
    transform: "translate(-172.261 -236.652)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73400",
    "data-name": "Path 73400",
    d: "M178.1,237.223s-4.423-.31-4.323,1.087,6.559,5.2,6.864,5.177c0,0-6.471-3.8-6.432-5.1S178.1,237.223,178.1,237.223Z",
    transform: "translate(-172.396 -236.765)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41107",
    "data-name": "Group 41107",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73401",
    "data-name": "Path 73401",
    d: "M197.122,246.238c.673-1.757-3.458-4.974-9.226-7.181-.1-.038-.2-.07-.3-.108a66.308,66.308,0,0,1,4.9,8.3C194.981,247.532,196.75,247.211,197.122,246.238Z",
    transform: "translate(-187.601 -238.95)",
    fill: "#ffee2f"
  })))), _g152 || (_g152 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41112",
    "data-name": "Group 41112",
    transform: "translate(49.136 114.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41110",
    "data-name": "Group 41110",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_233",
    "data-name": "Line 233",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41109",
    "data-name": "Group 41109",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73402",
    "data-name": "Path 73402",
    d: "M152.741,239.323l15.536,1.974,3.327.421-.307,2.414c-.238,1.868-5.4,2.753-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-149.1 -238.902)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73403",
    "data-name": "Path 73403",
    d: "M149.5,238.3c-.237,1.867,4.538,4.013,10.665,4.792s11.287-.108,11.524-1.976-4.539-4.012-10.665-4.792S149.735,236.436,149.5,238.3Z",
    transform: "translate(-149.182 -236.046)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73404",
    "data-name": "Path 73404",
    d: "M171.268,238.889s4.045,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.077-1.459S171.268,238.889,171.268,238.889Z",
    transform: "translate(-152.655 -236.641)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41111",
    "data-name": "Group 41111",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73405",
    "data-name": "Path 73405",
    d: "M149.5,238.3c.238-1.868,5.4-2.753,11.523-1.976.105.014.206.031.311.046a66.28,66.28,0,0,0-8.24,5.006C150.773,240.456,149.366,239.337,149.5,238.3Z",
    transform: "translate(-149.488 -236.046)",
    fill: "#ffee2f"
  })))), _g153 || (_g153 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41116",
    "data-name": "Group 41116",
    transform: "translate(58.311 107.467)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41114",
    "data-name": "Group 41114",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_234",
    "data-name": "Line 234",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41113",
    "data-name": "Group 41113",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73406",
    "data-name": "Path 73406",
    d: "M164.346,230.927l15.536,1.972,3.327.421-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.923-10.663-4.792l.305-2.413Z",
    transform: "translate(-160.705 -230.504)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73407",
    "data-name": "Path 73407",
    d: "M161.1,229.906c-.236,1.869,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.014-10.665-4.791S161.339,228.039,161.1,229.906Z",
    transform: "translate(-160.786 -227.649)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73408",
    "data-name": "Path 73408",
    d: "M182.873,230.491s4.044,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.077-1.459S182.873,230.491,182.873,230.491Z",
    transform: "translate(-164.259 -228.244)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41115",
    "data-name": "Group 41115",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73409",
    "data-name": "Path 73409",
    d: "M161.1,229.906c.239-1.867,5.4-2.754,11.524-1.974.105.013.206.029.311.043a66.54,66.54,0,0,0-8.239,5.007C162.377,232.058,160.969,230.939,161.1,229.906Z",
    transform: "translate(-161.091 -227.649)",
    fill: "#ffdf2f"
  })))), _g154 || (_g154 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41120",
    "data-name": "Group 41120",
    transform: "translate(88.888 119.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41118",
    "data-name": "Group 41118",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_235",
    "data-name": "Line 235",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.962 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41117",
    "data-name": "Group 41117",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73410",
    "data-name": "Path 73410",
    d: "M218.083,251.34l-14.627-5.6-3.131-1.2-.87,2.273c-.674,1.759,3.457,4.974,9.227,7.182s10.989,2.568,11.662.81l.87-2.271Z",
    transform: "translate(-199.384 -244.545)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73411",
    "data-name": "Path 73411",
    d: "M221.446,252.243c-.674,1.757-5.9,1.4-11.664-.811s-9.9-5.423-9.226-7.182,5.894-1.4,11.663.812S222.118,250.483,221.446,252.243Z",
    transform: "translate(-199.614 -243.136)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73412",
    "data-name": "Path 73412",
    d: "M205.454,243.708s-4.423-.309-4.323,1.087,6.559,5.2,6.864,5.177c0,0-6.47-3.8-6.431-5.1S205.454,243.708,205.454,243.708Z",
    transform: "translate(-199.75 -243.25)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41119",
    "data-name": "Group 41119",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73413",
    "data-name": "Path 73413",
    d: "M224.476,252.725c.672-1.76-3.458-4.976-9.227-7.181-.1-.038-.2-.071-.295-.108a66.337,66.337,0,0,1,4.9,8.3C222.334,254.018,224.1,253.7,224.476,252.725Z",
    transform: "translate(-214.955 -245.435)",
    fill: "#ffee2f"
  })))), _g155 || (_g155 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41124",
    "data-name": "Group 41124",
    transform: "translate(70.761 119.233)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41122",
    "data-name": "Group 41122",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_236",
    "data-name": "Line 236",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41121",
    "data-name": "Group 41121",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73414",
    "data-name": "Path 73414",
    d: "M180.095,245.81l15.537,1.972,3.326.421-.307,2.414c-.238,1.867-5.4,2.751-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-176.454 -245.386)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73415",
    "data-name": "Path 73415",
    d: "M176.85,244.788c-.236,1.868,4.538,4.015,10.665,4.792s11.288-.107,11.524-1.975-4.538-4.014-10.665-4.791S177.089,242.921,176.85,244.788Z",
    transform: "translate(-176.535 -242.532)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73416",
    "data-name": "Path 73416",
    d: "M198.622,245.374s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S198.622,245.374,198.622,245.374Z",
    transform: "translate(-180.008 -243.127)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41123",
    "data-name": "Group 41123",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73417",
    "data-name": "Path 73417",
    d: "M176.85,244.788c.239-1.867,5.4-2.753,11.523-1.973.106.012.207.029.312.043a66.322,66.322,0,0,0-8.239,5.007C178.127,246.94,176.719,245.822,176.85,244.788Z",
    transform: "translate(-176.841 -242.532)",
    fill: "#ffee2f"
  })))), _g156 || (_g156 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41128",
    "data-name": "Group 41128",
    transform: "translate(79.934 112.594)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41126",
    "data-name": "Group 41126",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_237",
    "data-name": "Line 237",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41125",
    "data-name": "Group 41125",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73418",
    "data-name": "Path 73418",
    d: "M191.7,237.411l15.536,1.972,3.327.422-.307,2.414c-.238,1.868-5.4,2.752-11.525,1.973s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-188.057 -236.988)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73419",
    "data-name": "Path 73419",
    d: "M188.454,236.39c-.237,1.869,4.537,4.015,10.664,4.792s11.288-.107,11.525-1.975-4.538-4.014-10.665-4.792S188.691,234.523,188.454,236.39Z",
    transform: "translate(-188.139 -234.133)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73420",
    "data-name": "Path 73420",
    d: "M210.226,236.976s4.044,1.816,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S210.226,236.976,210.226,236.976Z",
    transform: "translate(-191.612 -234.729)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41127",
    "data-name": "Group 41127",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73421",
    "data-name": "Path 73421",
    d: "M188.454,236.39c.237-1.867,5.4-2.753,11.523-1.974.105.013.206.031.311.045a66.361,66.361,0,0,0-8.239,5.006C189.73,238.542,188.323,237.425,188.454,236.39Z",
    transform: "translate(-188.445 -234.133)",
    fill: "#ffdf2f"
  })))), _g157 || (_g157 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41132",
    "data-name": "Group 41132",
    transform: "translate(58.391 123.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41130",
    "data-name": "Group 41130",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_238",
    "data-name": "Line 238",
    x1: 0.87,
    y2: 2.273,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41129",
    "data-name": "Group 41129",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73422",
    "data-name": "Path 73422",
    d: "M179.506,256.519l-14.626-5.595-3.131-1.2-.87,2.273c-.673,1.759,3.458,4.975,9.227,7.181s10.989,2.569,11.662.811l.87-2.273Z",
    transform: "translate(-160.807 -249.725)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73423",
    "data-name": "Path 73423",
    d: "M182.869,257.422c-.674,1.759-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.182,5.9-1.395,11.663.811S183.541,255.664,182.869,257.422Z",
    transform: "translate(-161.038 -248.317)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73424",
    "data-name": "Path 73424",
    d: "M166.878,248.888s-4.423-.309-4.323,1.086,6.559,5.2,6.864,5.177c0,0-6.47-3.795-6.431-5.1S166.878,248.888,166.878,248.888Z",
    transform: "translate(-161.173 -248.43)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41131",
    "data-name": "Group 41131",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73425",
    "data-name": "Path 73425",
    d: "M185.9,257.9c.672-1.758-3.458-4.974-9.227-7.181-.1-.038-.2-.07-.295-.107a66.078,66.078,0,0,1,4.9,8.3C183.757,259.2,185.526,258.876,185.9,257.9Z",
    transform: "translate(-176.378 -250.616)",
    fill: "#ffee2f"
  })))), _g158 || (_g158 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41136",
    "data-name": "Group 41136",
    transform: "translate(40.264 123.328)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41134",
    "data-name": "Group 41134",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_239",
    "data-name": "Line 239",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41133",
    "data-name": "Group 41133",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73426",
    "data-name": "Path 73426",
    d: "M141.518,250.99l15.536,1.972,3.327.422-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.973s-10.9-2.923-10.664-4.792l.307-2.414Z",
    transform: "translate(-137.877 -250.566)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73427",
    "data-name": "Path 73427",
    d: "M138.274,249.968c-.237,1.869,4.538,4.015,10.665,4.792s11.287-.108,11.524-1.975-4.538-4.014-10.665-4.791S138.512,248.1,138.274,249.968Z",
    transform: "translate(-137.959 -247.711)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73428",
    "data-name": "Path 73428",
    d: "M160.045,250.554s4.045,1.816,3.3,3-8.234,1.483-8.495,1.322c0,0,7.5-.29,8.078-1.459S160.045,250.554,160.045,250.554Z",
    transform: "translate(-141.432 -248.307)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41135",
    "data-name": "Group 41135",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73429",
    "data-name": "Path 73429",
    d: "M138.274,249.968c.238-1.867,5.4-2.753,11.524-1.973.1.013.206.03.311.043a66.285,66.285,0,0,0-8.24,5.007C139.551,252.12,138.143,251,138.274,249.968Z",
    transform: "translate(-138.265 -247.711)",
    fill: "#ffee2f"
  })))), _g159 || (_g159 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41140",
    "data-name": "Group 41140",
    transform: "translate(49.438 116.689)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41138",
    "data-name": "Group 41138",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_240",
    "data-name": "Line 240",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41137",
    "data-name": "Group 41137",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73430",
    "data-name": "Path 73430",
    d: "M153.122,242.591l15.537,1.972,3.327.422-.307,2.414c-.238,1.867-5.4,2.752-11.526,1.973s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-149.481 -242.168)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73431",
    "data-name": "Path 73431",
    d: "M149.877,241.57c-.236,1.869,4.538,4.015,10.665,4.792s11.288-.107,11.525-1.975-4.539-4.014-10.665-4.792S150.115,239.7,149.877,241.57Z",
    transform: "translate(-149.562 -239.313)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73432",
    "data-name": "Path 73432",
    d: "M171.649,242.157s4.045,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.077-1.459S171.649,242.157,171.649,242.157Z",
    transform: "translate(-153.036 -239.909)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41139",
    "data-name": "Group 41139",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73433",
    "data-name": "Path 73433",
    d: "M149.877,241.57c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.044a66.22,66.22,0,0,0-8.239,5.007C151.154,243.722,149.746,242.6,149.877,241.57Z",
    transform: "translate(-149.868 -239.313)",
    fill: "#ffdf2f"
  })))), _g160 || (_g160 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41144",
    "data-name": "Group 41144",
    transform: "translate(15.809 121.847)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41142",
    "data-name": "Group 41142",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_241",
    "data-name": "Line 241",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41141",
    "data-name": "Group 41141",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73434",
    "data-name": "Path 73434",
    d: "M125.642,254.04l-14.627-5.595-3.131-1.2-.869,2.273c-.674,1.759,3.458,4.974,9.227,7.181s10.989,2.569,11.662.811l.869-2.273Z",
    transform: "translate(-106.943 -247.247)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73435",
    "data-name": "Path 73435",
    d: "M129,254.944c-.674,1.759-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.181,5.9-1.4,11.663.811S129.676,253.185,129,254.944Z",
    transform: "translate(-107.173 -245.838)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73436",
    "data-name": "Path 73436",
    d: "M113.013,246.41s-4.423-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.471-3.8-6.431-5.1S113.013,246.41,113.013,246.41Z",
    transform: "translate(-107.309 -245.952)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41143",
    "data-name": "Group 41143",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73437",
    "data-name": "Path 73437",
    d: "M132.034,255.425c.672-1.758-3.458-4.975-9.227-7.181-.1-.038-.2-.07-.295-.107a66.361,66.361,0,0,1,4.9,8.3C129.893,256.72,131.662,256.4,132.034,255.425Z",
    transform: "translate(-122.513 -248.137)",
    fill: "#ffee2f"
  })))), _g161 || (_g161 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41148",
    "data-name": "Group 41148",
    transform: "translate(31.053 125.829)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41146",
    "data-name": "Group 41146",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_242",
    "data-name": "Line 242",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41145",
    "data-name": "Group 41145",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73438",
    "data-name": "Path 73438",
    d: "M144.925,259.077,130.3,253.482l-3.131-1.2-.87,2.273c-.673,1.76,3.458,4.975,9.227,7.181s10.989,2.569,11.662.81l.869-2.272Z",
    transform: "translate(-126.226 -252.283)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73439",
    "data-name": "Path 73439",
    d: "M148.287,259.98c-.674,1.758-5.9,1.4-11.663-.81s-9.9-5.423-9.226-7.182,5.894-1.395,11.662.811S148.959,258.222,148.287,259.98Z",
    transform: "translate(-126.457 -250.875)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73440",
    "data-name": "Path 73440",
    d: "M132.3,251.446s-4.424-.309-4.324,1.087,6.559,5.2,6.864,5.177c0,0-6.471-3.8-6.431-5.1S132.3,251.446,132.3,251.446Z",
    transform: "translate(-126.592 -250.988)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41147",
    "data-name": "Group 41147",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73441",
    "data-name": "Path 73441",
    d: "M151.317,260.462c.672-1.759-3.458-4.976-9.227-7.181-.1-.038-.2-.07-.295-.108a66.262,66.262,0,0,1,4.9,8.3C149.176,261.757,150.945,261.435,151.317,260.462Z",
    transform: "translate(-141.796 -253.173)",
    fill: "#ffee2f"
  })))), _g162 || (_g162 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41152",
    "data-name": "Group 41152",
    transform: "translate(42.778 129.718)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41150",
    "data-name": "Group 41150",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_243",
    "data-name": "Line 243",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41149",
    "data-name": "Group 41149",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73442",
    "data-name": "Path 73442",
    d: "M159.757,264,145.13,258.4,142,257.2l-.869,2.273c-.674,1.759,3.457,4.975,9.227,7.181s10.989,2.569,11.663.81l.869-2.272Z",
    transform: "translate(-141.058 -257.203)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73443",
    "data-name": "Path 73443",
    d: "M163.119,264.9c-.674,1.758-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.182,5.9-1.395,11.663.811S163.791,263.142,163.119,264.9Z",
    transform: "translate(-141.288 -255.795)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73444",
    "data-name": "Path 73444",
    d: "M147.128,256.366s-4.423-.309-4.323,1.087,6.559,5.2,6.864,5.176c0,0-6.471-3.795-6.431-5.1S147.128,256.366,147.128,256.366Z",
    transform: "translate(-141.424 -255.908)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41151",
    "data-name": "Group 41151",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73445",
    "data-name": "Path 73445",
    d: "M166.149,265.382c.672-1.759-3.458-4.976-9.227-7.181-.1-.038-.2-.07-.295-.108a66.359,66.359,0,0,1,4.9,8.3C164.008,266.676,165.776,266.354,166.149,265.382Z",
    transform: "translate(-156.628 -258.093)",
    fill: "#ffee2f"
  })))), _g163 || (_g163 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41156",
    "data-name": "Group 41156",
    transform: "translate(43.931 112.501)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41154",
    "data-name": "Group 41154",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_244",
    "data-name": "Line 244",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41153",
    "data-name": "Group 41153",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73446",
    "data-name": "Path 73446",
    d: "M146.156,237.292l15.535,1.973,3.327.422-.307,2.414c-.238,1.867-5.4,2.752-11.524,1.973s-10.9-2.923-10.664-4.792l.306-2.414Z",
    transform: "translate(-142.515 -236.87)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73447",
    "data-name": "Path 73447",
    d: "M142.911,236.272c-.236,1.869,4.538,4.015,10.665,4.792s11.288-.107,11.524-1.975-4.538-4.014-10.665-4.792S143.149,234.4,142.911,236.272Z",
    transform: "translate(-142.596 -234.015)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73448",
    "data-name": "Path 73448",
    d: "M164.683,236.859s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S164.683,236.859,164.683,236.859Z",
    transform: "translate(-146.069 -234.611)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41155",
    "data-name": "Group 41155",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73449",
    "data-name": "Path 73449",
    d: "M142.911,236.272c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.045a66.324,66.324,0,0,0-8.239,5.006C144.188,238.424,142.78,237.306,142.911,236.272Z",
    transform: "translate(-142.902 -234.015)",
    fill: "#ffee2f"
  })))), _g164 || (_g164 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41160",
    "data-name": "Group 41160",
    transform: "translate(53.104 105.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41158",
    "data-name": "Group 41158",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_245",
    "data-name": "Line 245",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41157",
    "data-name": "Group 41157",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73450",
    "data-name": "Path 73450",
    d: "M157.76,228.895l15.536,1.973,3.327.421-.306,2.414c-.238,1.869-5.4,2.752-11.526,1.974s-10.9-2.923-10.662-4.792l.305-2.414Z",
    transform: "translate(-154.119 -228.472)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73451",
    "data-name": "Path 73451",
    d: "M154.514,227.874c-.236,1.869,4.538,4.014,10.665,4.793s11.288-.107,11.524-1.976-4.538-4.012-10.665-4.791S154.752,226.007,154.514,227.874Z",
    transform: "translate(-154.2 -225.617)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73452",
    "data-name": "Path 73452",
    d: "M176.286,228.461s4.046,1.814,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.291,8.078-1.461S176.286,228.461,176.286,228.461Z",
    transform: "translate(-157.673 -226.213)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41159",
    "data-name": "Group 41159",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73453",
    "data-name": "Path 73453",
    d: "M154.514,227.874c.238-1.867,5.4-2.753,11.524-1.974.105.013.206.031.311.045a66.323,66.323,0,0,0-8.239,5.006C155.791,230.026,154.383,228.908,154.514,227.874Z",
    transform: "translate(-154.505 -225.617)",
    fill: "#ffdf2f"
  })))), _g165 || (_g165 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41164",
    "data-name": "Group 41164",
    transform: "translate(89.583 143.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41162",
    "data-name": "Group 41162",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_246",
    "data-name": "Line 246",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41161",
    "data-name": "Group 41161",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73454",
    "data-name": "Path 73454",
    d: "M218.961,280.9l-14.627-5.595-3.131-1.2-.87,2.274c-.674,1.757,3.458,4.973,9.227,7.181s10.989,2.569,11.661.81l.87-2.272Z",
    transform: "translate(-200.262 -274.107)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73455",
    "data-name": "Path 73455",
    d: "M222.323,281.8c-.674,1.758-5.9,1.4-11.664-.811s-9.9-5.423-9.225-7.181,5.9-1.4,11.663.812S222.995,280.044,222.323,281.8Z",
    transform: "translate(-200.492 -272.698)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73456",
    "data-name": "Path 73456",
    d: "M206.332,273.269s-4.423-.309-4.323,1.087,6.559,5.2,6.864,5.177c0,0-6.469-3.795-6.43-5.1S206.332,273.269,206.332,273.269Z",
    transform: "translate(-200.628 -272.812)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41163",
    "data-name": "Group 41163",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73457",
    "data-name": "Path 73457",
    d: "M225.353,282.286c.672-1.761-3.457-4.975-9.226-7.181-.1-.039-.2-.072-.3-.108a66.514,66.514,0,0,1,4.9,8.3C223.212,283.58,224.981,283.258,225.353,282.286Z",
    transform: "translate(-215.832 -274.997)",
    fill: "#ffee2f"
  })))), _g166 || (_g166 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41168",
    "data-name": "Group 41168",
    transform: "translate(71.455 142.603)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41166",
    "data-name": "Group 41166",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_247",
    "data-name": "Line 247",
    x1: 0.307,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41165",
    "data-name": "Group 41165",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73458",
    "data-name": "Path 73458",
    d: "M180.973,275.37l15.535,1.974,3.327.422-.307,2.414c-.238,1.867-5.4,2.753-11.524,1.974s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-177.332 -274.948)",
    fill: "url(#radial-gradient-165)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73459",
    "data-name": "Path 73459",
    d: "M177.729,274.35c-.237,1.868,4.537,4.015,10.664,4.792s11.287-.107,11.524-1.974-4.538-4.014-10.665-4.792S177.966,272.482,177.729,274.35Z",
    transform: "translate(-177.414 -272.093)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73460",
    "data-name": "Path 73460",
    d: "M199.5,274.936s4.044,1.815,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.29,8.078-1.458S199.5,274.936,199.5,274.936Z",
    transform: "translate(-180.886 -272.689)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41167",
    "data-name": "Group 41167",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73461",
    "data-name": "Path 73461",
    d: "M177.729,274.35c.237-1.868,5.4-2.753,11.523-1.974.105.013.206.03.311.045a66.2,66.2,0,0,0-8.239,5.006C179.006,276.5,177.6,275.384,177.729,274.35Z",
    transform: "translate(-177.72 -272.093)",
    fill: "#ffee2f"
  })))), _g167 || (_g167 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41172",
    "data-name": "Group 41172",
    transform: "translate(80.628 135.964)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41170",
    "data-name": "Group 41170",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_248",
    "data-name": "Line 248",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41169",
    "data-name": "Group 41169",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73462",
    "data-name": "Path 73462",
    d: "M192.576,266.972l15.537,1.974,3.326.421-.307,2.414c-.238,1.868-5.4,2.753-11.525,1.975s-10.9-2.924-10.664-4.792l.306-2.413Z",
    transform: "translate(-188.935 -266.551)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73463",
    "data-name": "Path 73463",
    d: "M189.331,265.953c-.236,1.867,4.538,4.014,10.665,4.792s11.288-.108,11.525-1.976-4.538-4.013-10.665-4.792S189.57,264.086,189.331,265.953Z",
    transform: "translate(-189.016 -263.695)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73464",
    "data-name": "Path 73464",
    d: "M211.1,266.538s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.078-1.459S211.1,266.538,211.1,266.538Z",
    transform: "translate(-192.49 -264.291)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41171",
    "data-name": "Group 41171",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73465",
    "data-name": "Path 73465",
    d: "M189.331,265.953c.239-1.867,5.4-2.753,11.524-1.976.105.014.206.031.311.046a66.218,66.218,0,0,0-8.24,5.006C190.608,268.1,189.2,266.985,189.331,265.953Z",
    transform: "translate(-189.322 -263.695)",
    fill: "#ffdf2f"
  })))), _g168 || (_g168 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41176",
    "data-name": "Group 41176",
    transform: "translate(60.29 136.348)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41174",
    "data-name": "Group 41174",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_249",
    "data-name": "Line 249",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41173",
    "data-name": "Group 41173",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73466",
    "data-name": "Path 73466",
    d: "M181.908,272.384l-14.626-5.6-3.131-1.2-.87,2.274c-.673,1.759,3.458,4.973,9.227,7.18s10.989,2.57,11.662.811l.87-2.271Z",
    transform: "translate(-163.209 -265.589)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73467",
    "data-name": "Path 73467",
    d: "M185.271,273.287c-.674,1.758-5.9,1.4-11.664-.811s-9.9-5.422-9.225-7.182,5.894-1.395,11.662.812S185.943,271.529,185.271,273.287Z",
    transform: "translate(-163.44 -264.181)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73468",
    "data-name": "Path 73468",
    d: "M169.28,264.753s-4.422-.309-4.323,1.087,6.558,5.2,6.864,5.176c0,0-6.47-3.795-6.43-5.1S169.28,264.753,169.28,264.753Z",
    transform: "translate(-163.575 -264.295)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41175",
    "data-name": "Group 41175",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73469",
    "data-name": "Path 73469",
    d: "M188.3,273.769c.672-1.758-3.458-4.976-9.227-7.181-.1-.038-.2-.07-.3-.107a66.207,66.207,0,0,1,4.9,8.3C186.159,275.063,187.928,274.742,188.3,273.769Z",
    transform: "translate(-178.779 -266.481)",
    fill: "#ffee2f"
  })))), _g169 || (_g169 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41180",
    "data-name": "Group 41180",
    transform: "translate(87.53 131.645)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41178",
    "data-name": "Group 41178",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_250",
    "data-name": "Line 250",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41177",
    "data-name": "Group 41177",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73470",
    "data-name": "Path 73470",
    d: "M216.364,266.436l-14.626-5.6-3.131-1.2-.87,2.273c-.673,1.759,3.459,4.973,9.227,7.181s10.989,2.569,11.662.81l.869-2.271Z",
    transform: "translate(-197.665 -259.641)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73471",
    "data-name": "Path 73471",
    d: "M219.726,267.338c-.673,1.758-5.9,1.4-11.663-.81s-9.9-5.424-9.226-7.182,5.9-1.4,11.663.812S220.4,265.579,219.726,267.338Z",
    transform: "translate(-197.896 -258.232)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73472",
    "data-name": "Path 73472",
    d: "M203.736,258.8s-4.423-.31-4.323,1.086,6.559,5.2,6.864,5.177c0,0-6.471-3.795-6.432-5.1S203.736,258.8,203.736,258.8Z",
    transform: "translate(-198.031 -258.346)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41179",
    "data-name": "Group 41179",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73473",
    "data-name": "Path 73473",
    d: "M222.757,267.82c.673-1.76-3.457-4.976-9.226-7.181-.1-.039-.2-.072-.295-.108a66.251,66.251,0,0,1,4.9,8.3C220.616,269.114,222.384,268.793,222.757,267.82Z",
    transform: "translate(-213.236 -260.531)",
    fill: "#ffee2f"
  })))), _g170 || (_g170 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41184",
    "data-name": "Group 41184",
    transform: "translate(69.402 131.167)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41182",
    "data-name": "Group 41182",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_251",
    "data-name": "Line 251",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41181",
    "data-name": "Group 41181",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73474",
    "data-name": "Path 73474",
    d: "M178.376,260.9l15.536,1.973,3.327.421-.308,2.414c-.237,1.867-5.4,2.753-11.524,1.974s-10.9-2.923-10.664-4.792l.307-2.414Z",
    transform: "translate(-174.735 -260.481)",
    fill: "url(#radial-gradient-165)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73475",
    "data-name": "Path 73475",
    d: "M175.132,259.883c-.237,1.869,4.538,4.015,10.665,4.794s11.287-.108,11.524-1.976-4.538-4.013-10.665-4.791S175.37,258.017,175.132,259.883Z",
    transform: "translate(-174.817 -257.627)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73476",
    "data-name": "Path 73476",
    d: "M196.9,260.47s4.044,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.291,8.077-1.46S196.9,260.47,196.9,260.47Z",
    transform: "translate(-178.29 -258.222)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41183",
    "data-name": "Group 41183",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73477",
    "data-name": "Path 73477",
    d: "M175.132,259.883c.238-1.866,5.4-2.753,11.523-1.973.105.013.207.03.311.045a66.441,66.441,0,0,0-8.24,5.005C176.409,262.035,175,260.918,175.132,259.883Z",
    transform: "translate(-175.123 -257.627)",
    fill: "#ffee2f"
  })))), _g171 || (_g171 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41188",
    "data-name": "Group 41188",
    transform: "translate(78.576 124.528)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41186",
    "data-name": "Group 41186",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41185",
    "data-name": "Group 41185",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73478",
    "data-name": "Path 73478",
    d: "M189.98,252.506l15.536,1.974,3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.526,1.975s-10.9-2.925-10.663-4.792l.306-2.414Z",
    transform: "translate(-186.339 -252.084)",
    fill: "url(#radial-gradient-106)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73479",
    "data-name": "Path 73479",
    d: "M186.735,251.486c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.013-10.665-4.791S186.973,249.618,186.735,251.486Z",
    transform: "translate(-186.42 -249.229)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73480",
    "data-name": "Path 73480",
    d: "M208.507,252.072s4.045,1.816,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.077-1.459S208.507,252.072,208.507,252.072Z",
    transform: "translate(-189.894 -249.824)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41187",
    "data-name": "Group 41187",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73481",
    "data-name": "Path 73481",
    d: "M186.735,251.486c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.045a66.21,66.21,0,0,0-8.239,5.006C188.012,253.637,186.6,252.52,186.735,251.486Z",
    transform: "translate(-186.726 -249.229)",
    fill: "#ffdf2f"
  })))), _g172 || (_g172 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41192",
    "data-name": "Group 41192",
    transform: "translate(114.244 134.008)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41190",
    "data-name": "Group 41190",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41189",
    "data-name": "Group 41189",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73482",
    "data-name": "Path 73482",
    d: "M250.155,269.423l-14.626-5.595-3.131-1.2-.869,2.274c-.674,1.757,3.457,4.973,9.227,7.18s10.989,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-231.457 -262.629)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73483",
    "data-name": "Path 73483",
    d: "M253.518,270.326c-.674,1.76-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.181,5.9-1.4,11.663.812S254.189,268.568,253.518,270.326Z",
    transform: "translate(-231.687 -261.22)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73484",
    "data-name": "Path 73484",
    d: "M237.527,261.792s-4.422-.309-4.321,1.087,6.558,5.195,6.864,5.176c0,0-6.471-3.8-6.432-5.1S237.527,261.792,237.527,261.792Z",
    transform: "translate(-231.823 -261.334)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41191",
    "data-name": "Group 41191",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73485",
    "data-name": "Path 73485",
    d: "M256.549,270.807c.671-1.758-3.458-4.974-9.227-7.18-.1-.038-.2-.071-.295-.108a66.418,66.418,0,0,1,4.9,8.3C254.407,272.1,256.175,271.78,256.549,270.807Z",
    transform: "translate(-247.027 -263.519)",
    fill: "#ffee2f"
  })))), _g173 || (_g173 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41196",
    "data-name": "Group 41196",
    transform: "translate(96.117 133.529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41194",
    "data-name": "Group 41194",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41193",
    "data-name": "Group 41193",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73486",
    "data-name": "Path 73486",
    d: "M212.168,263.892l15.536,1.974,3.326.421-.306,2.414c-.238,1.868-5.4,2.752-11.525,1.973s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-208.527 -263.471)",
    fill: "url(#radial-gradient-8)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73487",
    "data-name": "Path 73487",
    d: "M208.923,262.873c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.108,11.523-1.976-4.538-4.013-10.665-4.792S209.162,261.006,208.923,262.873Z",
    transform: "translate(-208.608 -260.616)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73488",
    "data-name": "Path 73488",
    d: "M230.695,263.458s4.044,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.077-1.459S230.695,263.458,230.695,263.458Z",
    transform: "translate(-212.081 -261.211)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41195",
    "data-name": "Group 41195",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73489",
    "data-name": "Path 73489",
    d: "M208.923,262.873c.239-1.867,5.4-2.754,11.523-1.975l.311.045a66.194,66.194,0,0,0-8.24,5.007C210.2,265.025,208.792,263.906,208.923,262.873Z",
    transform: "translate(-208.914 -260.616)",
    fill: "#ffee2f"
  })))), _g174 || (_g174 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41200",
    "data-name": "Group 41200",
    transform: "translate(105.29 126.891)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41198",
    "data-name": "Group 41198",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41197",
    "data-name": "Group 41197",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73490",
    "data-name": "Path 73490",
    d: "M223.771,255.5l15.537,1.973,3.326.421-.306,2.414c-.238,1.867-5.4,2.752-11.526,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-220.13 -255.073)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73491",
    "data-name": "Path 73491",
    d: "M220.526,254.475c-.236,1.868,4.537,4.014,10.665,4.792s11.288-.108,11.524-1.976-4.537-4.014-10.665-4.791S220.765,252.608,220.526,254.475Z",
    transform: "translate(-220.211 -252.218)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73492",
    "data-name": "Path 73492",
    d: "M242.3,255.06s4.044,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.077-1.459S242.3,255.06,242.3,255.06Z",
    transform: "translate(-223.685 -252.814)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41199",
    "data-name": "Group 41199",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73493",
    "data-name": "Path 73493",
    d: "M220.526,254.475c.239-1.867,5.4-2.753,11.524-1.974.105.013.206.03.311.043a66.31,66.31,0,0,0-8.24,5.007C221.8,256.627,220.4,255.508,220.526,254.475Z",
    transform: "translate(-220.517 -252.218)",
    fill: "#ffdf2f"
  })))), _g175 || (_g175 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41204",
    "data-name": "Group 41204",
    transform: "translate(112.755 122.418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41202",
    "data-name": "Group 41202",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41201",
    "data-name": "Group 41201",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73494",
    "data-name": "Path 73494",
    d: "M248.273,254.764l-14.626-5.6-3.131-1.2-.87,2.274c-.673,1.758,3.459,4.973,9.227,7.181s10.989,2.569,11.662.81l.87-2.271Z",
    transform: "translate(-229.574 -247.969)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73495",
    "data-name": "Path 73495",
    d: "M251.636,255.667c-.674,1.758-5.9,1.4-11.664-.811s-9.9-5.422-9.226-7.181,5.9-1.4,11.662.812S252.308,253.907,251.636,255.667Z",
    transform: "translate(-229.805 -246.561)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73496",
    "data-name": "Path 73496",
    d: "M235.645,247.132s-4.423-.309-4.323,1.087,6.558,5.2,6.864,5.177c0,0-6.47-3.8-6.431-5.1S235.645,247.132,235.645,247.132Z",
    transform: "translate(-229.94 -246.674)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41203",
    "data-name": "Group 41203",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73497",
    "data-name": "Path 73497",
    d: "M254.666,256.148c.672-1.76-3.458-4.975-9.227-7.181-.1-.038-.2-.072-.294-.108a66.367,66.367,0,0,1,4.9,8.3C252.524,257.442,254.293,257.121,254.666,256.148Z",
    transform: "translate(-245.145 -248.859)",
    fill: "#ffee2f"
  })))), _g176 || (_g176 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41208",
    "data-name": "Group 41208",
    transform: "translate(94.628 121.94)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41206",
    "data-name": "Group 41206",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41205",
    "data-name": "Group 41205",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73498",
    "data-name": "Path 73498",
    d: "M210.285,249.233l15.536,1.973,3.327.421-.307,2.414c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-206.644 -248.811)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73499",
    "data-name": "Path 73499",
    d: "M207.041,248.213c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.013-10.665-4.791S207.279,246.345,207.041,248.213Z",
    transform: "translate(-206.726 -245.956)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73500",
    "data-name": "Path 73500",
    d: "M228.813,248.8s4.044,1.815,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.291,8.077-1.459S228.813,248.8,228.813,248.8Z",
    transform: "translate(-210.199 -246.551)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41207",
    "data-name": "Group 41207",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73501",
    "data-name": "Path 73501",
    d: "M207.041,248.213c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.03.311.043a66.441,66.441,0,0,0-8.239,5.007C208.317,250.365,206.91,249.246,207.041,248.213Z",
    transform: "translate(-207.032 -245.956)",
    fill: "#ffee2f"
  })))), _g177 || (_g177 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41212",
    "data-name": "Group 41212",
    transform: "translate(103.802 115.301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41210",
    "data-name": "Group 41210",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41209",
    "data-name": "Group 41209",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73502",
    "data-name": "Path 73502",
    d: "M221.889,240.835l15.537,1.973,3.327.422-.307,2.414c-.238,1.867-5.4,2.751-11.526,1.973s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-218.248 -240.413)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73503",
    "data-name": "Path 73503",
    d: "M218.645,239.815c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.107,11.525-1.974-4.538-4.014-10.665-4.792S218.882,237.946,218.645,239.815Z",
    transform: "translate(-218.33 -237.558)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73504",
    "data-name": "Path 73504",
    d: "M240.417,240.4s4.044,1.815,3.3,3-8.234,1.485-8.495,1.323c0,0,7.5-.29,8.078-1.459S240.417,240.4,240.417,240.4Z",
    transform: "translate(-221.802 -238.153)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41211",
    "data-name": "Group 41211",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73505",
    "data-name": "Path 73505",
    d: "M218.645,239.815c.237-1.869,5.4-2.753,11.523-1.974.105.013.206.029.311.044a66.222,66.222,0,0,0-8.239,5.007C219.922,241.967,218.514,240.848,218.645,239.815Z",
    transform: "translate(-218.636 -237.558)",
    fill: "#ffdf2f"
  })))), _g178 || (_g178 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41216",
    "data-name": "Group 41216",
    transform: "translate(103.113 139.884)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41214",
    "data-name": "Group 41214",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    x1: 0.869,
    y2: 2.273,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41213",
    "data-name": "Group 41213",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73506",
    "data-name": "Path 73506",
    d: "M236.076,276.856l-14.626-5.595-3.131-1.2-.87,2.273c-.673,1.757,3.458,4.973,9.227,7.18s10.989,2.569,11.662.813l.869-2.274Z",
    transform: "translate(-217.377 -270.063)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73507",
    "data-name": "Path 73507",
    d: "M239.438,277.76c-.673,1.758-5.9,1.4-11.663-.81s-9.9-5.424-9.226-7.181,5.9-1.4,11.663.812S240.111,276,239.438,277.76Z",
    transform: "translate(-217.608 -268.654)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73508",
    "data-name": "Path 73508",
    d: "M223.447,269.225s-4.422-.31-4.322,1.088,6.558,5.195,6.864,5.176c0,0-6.47-3.8-6.43-5.1S223.447,269.225,223.447,269.225Z",
    transform: "translate(-217.743 -268.768)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41215",
    "data-name": "Group 41215",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73509",
    "data-name": "Path 73509",
    d: "M242.469,278.241c.673-1.76-3.457-4.975-9.226-7.18-.1-.039-.2-.072-.295-.109a66.36,66.36,0,0,1,4.9,8.3C240.327,279.534,242.1,279.214,242.469,278.241Z",
    transform: "translate(-232.948 -270.952)",
    fill: "#ffee2f"
  })))), _g179 || (_g179 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41220",
    "data-name": "Group 41220",
    transform: "translate(84.986 139.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41218",
    "data-name": "Group 41218",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41217",
    "data-name": "Group 41217",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73510",
    "data-name": "Path 73510",
    d: "M198.089,271.327l15.536,1.972,3.327.422-.307,2.413c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-194.448 -270.904)",
    fill: "url(#radial-gradient-178)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73511",
    "data-name": "Path 73511",
    d: "M194.844,270.306c-.237,1.868,4.538,4.015,10.665,4.792s11.287-.108,11.524-1.975-4.538-4.014-10.665-4.792S195.082,268.439,194.844,270.306Z",
    transform: "translate(-194.529 -268.048)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73512",
    "data-name": "Path 73512",
    d: "M216.615,270.891s4.045,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.077-1.459S216.615,270.891,216.615,270.891Z",
    transform: "translate(-198.002 -268.644)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41219",
    "data-name": "Group 41219",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73513",
    "data-name": "Path 73513",
    d: "M194.844,270.306c.238-1.867,5.4-2.754,11.524-1.975.1.013.206.03.311.045a66.227,66.227,0,0,0-8.239,5.007C196.121,272.458,194.713,271.339,194.844,270.306Z",
    transform: "translate(-194.835 -268.048)",
    fill: "#ffee2f"
  })))), _g180 || (_g180 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41224",
    "data-name": "Group 41224",
    transform: "translate(94.159 132.767)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41222",
    "data-name": "Group 41222",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41221",
    "data-name": "Group 41221",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73514",
    "data-name": "Path 73514",
    d: "M209.692,262.929l15.536,1.972,3.327.421-.307,2.414c-.238,1.869-5.4,2.754-11.526,1.975s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-206.051 -262.506)",
    fill: "url(#radial-gradient-106)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73515",
    "data-name": "Path 73515",
    d: "M206.447,261.908c-.237,1.868,4.538,4.014,10.665,4.792s11.288-.108,11.525-1.976-4.538-4.013-10.665-4.791S206.685,260.041,206.447,261.908Z",
    transform: "translate(-206.132 -259.651)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73516",
    "data-name": "Path 73516",
    d: "M228.219,262.493s4.045,1.816,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.077-1.459S228.219,262.493,228.219,262.493Z",
    transform: "translate(-209.606 -260.247)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41223",
    "data-name": "Group 41223",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73517",
    "data-name": "Path 73517",
    d: "M206.447,261.908c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.029.311.044a66.13,66.13,0,0,0-8.239,5.007C207.724,264.06,206.316,262.942,206.447,261.908Z",
    transform: "translate(-206.438 -259.651)",
    fill: "#ffdf2f"
  })))), _g181 || (_g181 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41225",
    "data-name": "Group 41225",
    transform: "translate(32.523 0.87)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73518",
    "data-name": "Path 73518",
    d: "M128.086,118.367l61.6,69.171s12.448-53.076-2.252-75.4S148.659,82.406,128.086,118.367Z",
    transform: "translate(-128.086 -92.933)",
    fill: "#82521d"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    x2: 60.036,
    y2: 64.935,
    transform: "translate(4.918 15.21)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    x2: 54.847,
    y2: 58.249,
    transform: "translate(11.632 4.397)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    x2: 41.762,
    y2: 43.96,
    transform: "translate(24.717)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73519",
    "data-name": "Path 73519",
    d: "M157.232,122.826s.686,1.489,1.7,3.577,4.609,5.822,4.609,5.822",
    transform: "translate(-134.19 -99.097)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73520",
    "data-name": "Path 73520",
    d: "M136.973,123.954s7.6,8.511,8.944,11.838,3.89,8.544,5.444,10.038",
    transform: "translate(-129.947 -99.333)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73521",
    "data-name": "Path 73521",
    d: "M179.74,146.649s.545,6.25,2.47,8.935a28.5,28.5,0,0,0,5.434,5.23",
    transform: "translate(-138.905 -104.086)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73522",
    "data-name": "Path 73522",
    d: "M190.674,137.2s9.775,11.346,10.5,13.432",
    transform: "translate(-141.195 -102.108)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73523",
    "data-name": "Path 73523",
    d: "M205,181.682s-3.4-3.089-4.5-6.366",
    transform: "translate(-143.252 -110.09)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73524",
    "data-name": "Path 73524",
    d: "M167.874,123.688s-15.98-19.526-18.272-19.868",
    transform: "translate(-132.592 -95.116)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73525",
    "data-name": "Path 73525",
    d: "M203.3,133.871s-2.891-2.372-2.967-3.392",
    transform: "translate(-143.217 -100.7)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73526",
    "data-name": "Path 73526",
    d: "M187.253,110.458s-.967-3.744-3.724-4.379-4.32-5.577-4.32-5.577-2.621-2.751-3.833-3.874",
    transform: "translate(-137.991 -93.61)",
    fill: "none",
    stroke: "#754511",
    strokeWidth: 0.709,
    opacity: 0.6
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73527",
    "data-name": "Path 73527",
    d: "M200.265,319.266",
    transform: "translate(-110.68 -139.37)",
    fill: "none",
    stroke: "#754511",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41229",
    "data-name": "Group 41229",
    transform: "translate(0 126.824)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41227",
    "data-name": "Group 41227"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73528",
    "data-name": "Path 73528",
    d: "M248.626,403.741l-139.857-62.4L87.66,252.478l170.917,59.243-6.723,83.568-.551,6.864A1.906,1.906,0,0,1,248.626,403.741Z",
    transform: "translate(-87.096 -252.206)",
    fill: "#b97429"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73529",
    "data-name": "Path 73529",
    d: "M251.087,404.839l-142.318-63.5L87.66,252.478,258.576,311.72l-6.722,83.569Z",
    transform: "translate(-87.096 -252.206)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41226",
    "data-name": "Group 41226",
    transform: "translate(0.546)",
    style: {
      mixBlendMode: "lighten",
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73530",
    "data-name": "Path 73530",
    d: "M87.637,252.134,108.746,341l20.273,9.045c15.527-8,51.327-22.922,125.792-39.963Z",
    transform: "translate(-87.637 -252.134)",
    fill: "#c9853a"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73531",
    "data-name": "Path 73531",
    d: "M118.444,316.873s-10.581-3.437-11.2-2.4,2.863,1.905,2.863,1.905l2.7.5,2.527,1.163s1.121.953-.124,1.2-1,.248.249.746,3.61,1.246,3.61,1.246l3.859,1.618",
    transform: "translate(-91.181 -265.149)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73532",
    "data-name": "Path 73532",
    d: "M129.463,306.38a46.545,46.545,0,0,0,4.98,1.494c1.867.373,5.1-.621,6.723,1.37s5.353,3.572,5.353,3.572l2.987,2.03",
    transform: "translate(-95.851 -263.496)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73533",
    "data-name": "Path 73533",
    d: "M137.573,333.859s13.071,6.349,13.632,8.029,5.976.934,5.976.934l10.27,3.921",
    transform: "translate(-97.55 -269.251)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73534",
    "data-name": "Path 73534",
    d: "M117.134,344.724s5.888,2.384,5.888,2.873,1.991,1.422,1.991,1.422l4.358.825",
    transform: "translate(-93.269 -271.526)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73535",
    "data-name": "Path 73535",
    d: "M96.079,275.988s5.354,1.992,7.47,1.992,4.606-3.736,6.971-3.112,6.847,5.726,6.847,5.726",
    transform: "translate(-88.859 -256.881)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73536",
    "data-name": "Path 73536",
    d: "M86.946,286.067",
    transform: "translate(-86.946 -259.241)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73537",
    "data-name": "Path 73537",
    d: "M144.9,372.046s17.429,5.975,19.047,7.344,13.819,6.6,13.819,6.6l1.742,2.365a10.694,10.694,0,0,1,3.112.582",
    transform: "translate(-99.083 -277.249)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73538",
    "data-name": "Path 73538",
    d: "M168.752,365.274s12.7,9.524,15.873,8.777a12.006,12.006,0,0,1,5.668,0l3.071,1.681,1.14,3.341,2.054.767",
    transform: "translate(-104.08 -275.83)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73539",
    "data-name": "Path 73539",
    d: "M171.666,300.4s17.18,8.091,19.793,8.464a67.007,67.007,0,0,1,8.839,2.7l3.361,1.034,2.988,1,2.739,1",
    transform: "translate(-104.69 -262.242)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73540",
    "data-name": "Path 73540",
    d: "M182.846,344.722s13.328,6.056,10.4,2.873.421-2.873.421-2.873l3.79,4.3,6.8,4.42",
    transform: "translate(-107.032 -271.524)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73541",
    "data-name": "Path 73541",
    d: "M231.5,362.912s3.611,1,6.847,1.867",
    transform: "translate(-117.223 -275.336)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73542",
    "data-name": "Path 73542",
    d: "M250.559,371.1s10.208,1.37,12.946.747",
    transform: "translate(-121.214 -277.051)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73543",
    "data-name": "Path 73543",
    d: "M154.028,325.12s10.208,2.614,13.321,2.863",
    transform: "translate(-100.996 -267.421)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73544",
    "data-name": "Path 73544",
    d: "M182.846,311.735s14.213,11.951,15.7,15.685",
    transform: "translate(-107.032 -264.617)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73545",
    "data-name": "Path 73545",
    d: "M258.747,328.742a75.964,75.964,0,0,1,6.473,4.045,34.543,34.543,0,0,0,5.1,2.938c1.307.8,4.294,2.1,4.294,2.1",
    transform: "translate(-122.929 -268.179)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73546",
    "data-name": "Path 73546",
    d: "M264.638,352.5s-9.68-4.388-7.936-3.595,1.743-2.56,1.743-2.56h-3.237l-4.979-2.569a2.515,2.515,0,0,0-1.246-3.54",
    transform: "translate(-120.884 -270.586)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73547",
    "data-name": "Path 73547",
    d: "M176.783,362.912s9.337,1.494,12.511,2.988a66.326,66.326,0,0,1,8.385,5.415",
    transform: "translate(-105.762 -275.336)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73548",
    "data-name": "Path 73548",
    d: "M299.228,341.98s-7.966-4.98-5.476-4.98,2.5-.721,2.5-2.1-.007-.51-1.251-2.44.031-3.672-1.727-4.543-6.475-3.126-6.475-3.126",
    transform: "translate(-128.803 -267.351)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73549",
    "data-name": "Path 73549",
    d: "M268.209,400.151s-6.846-2.614-6.473-3.486,1.742,0,1.742,0,4.482.221,3.237-.387-3.127-2.1-1.75-1.728a34.593,34.593,0,0,1,5.236,2.863,1.9,1.9,0,0,1,1.493,1.4,6.275,6.275,0,0,0,1.246,2.084s-3.361-1.244-2.116-.747",
    transform: "translate(-123.552 -281.95)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73550",
    "data-name": "Path 73550",
    d: "M222.371,382.584a13.372,13.372,0,0,0,5.976.767c2.614-.5.746-2.157,4.108-.767s5.976,6.12,5.976,6.12",
    transform: "translate(-115.31 -279.342)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73551",
    "data-name": "Path 73551",
    d: "M233.709,402.6s8.4,5.041,9.9,5.415",
    transform: "translate(-117.685 -283.647)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73552",
    "data-name": "Path 73552",
    d: "M256.857,412.515c2.054,1.121,8.264,2.241,9.455,3.548",
    transform: "translate(-122.533 -285.725)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73553",
    "data-name": "Path 73553",
    d: "M137.573,359.369s6.349,4.855,8.777,5.976",
    transform: "translate(-97.549 -274.594)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73554",
    "data-name": "Path 73554",
    d: "M125.013,364.037s-6.3-4.668-7.879-4.668",
    transform: "translate(-93.269 -274.594)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73555",
    "data-name": "Path 73555",
    d: "M215.534,406.12s-3.174-4.293-.934-3.547,7.1,2.707,7.1,2.707",
    transform: "translate(-113.515 -283.624)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    x2: 4.606,
    y2: 1.441,
    transform: "translate(104.696 74.63)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    id: "Line_266",
    "data-name": "Line 266",
    x2: 2.081,
    y2: 2.738,
    transform: "translate(104.233 80.232)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    id: "Line_267",
    "data-name": "Line 267",
    x2: 3.268,
    y2: 1.574,
    transform: "translate(120.973 79.36)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    id: "Line_268",
    "data-name": "Line 268",
    x2: 3.272,
    y2: 1.108,
    transform: "translate(100.961 67.546)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    id: "Line_269",
    "data-name": "Line 269",
    x2: 6.691,
    y2: 2.553,
    transform: "translate(114.281 56.578)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    id: "Line_270",
    "data-name": "Line 270",
    x2: 4.917,
    y2: 3.796,
    transform: "translate(62.058 81.913)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    id: "Line_271",
    "data-name": "Line 271",
    x2: 6.682,
    y2: 0.747,
    transform: "translate(87.868 87.763)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    id: "Line_272",
    "data-name": "Line 272",
    x2: 1.805,
    y2: 4.295,
    transform: "translate(126.295 104.009)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    id: "Line_273",
    "data-name": "Line 273",
    x2: 2.863,
    y2: 2.022,
    transform: "translate(98.098 104.009)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    id: "Line_274",
    "data-name": "Line 274",
    x2: 2.614,
    y2: 1.422,
    transform: "translate(58.51 35.851)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73556",
    "data-name": "Path 73556",
    d: "M160.957,284.492s5.415,3.735,6.162,4.855",
    transform: "translate(-102.447 -258.911)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    id: "Line_275",
    "data-name": "Line 275",
    x2: 6.722,
    y2: 0.871,
    transform: "translate(34.982 38.154)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    id: "Line_276",
    "data-name": "Line 276",
    x2: 5.291,
    y2: 2.708,
    transform: "translate(38.343 57.855)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    id: "Line_277",
    "data-name": "Line 277",
    x2: 7.052,
    y2: 3.54,
    transform: "translate(29.984 69.65)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    id: "Line_278",
    "data-name": "Line 278",
    x1: 5.291,
    y1: 1.057,
    transform: "translate(31.745 81.913)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    id: "Line_279",
    "data-name": "Line 279",
    x2: 4.295,
    y2: 1.058,
    transform: "translate(148.329 108.304)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73557",
    "data-name": "Path 73557",
    d: "M274.573,366.928a20.925,20.925,0,0,0,3.361,3.3",
    transform: "translate(-126.243 -276.177)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    id: "Line_280",
    "data-name": "Line 280",
    x2: 5.975,
    y2: 3.688,
    transform: "translate(153.931 74.63)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    id: "Line_281",
    "data-name": "Line 281",
    x2: 5.609,
    y2: 4.108,
    transform: "translate(138.17 134.073)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    id: "Line_282",
    "data-name": "Line 282",
    x2: 4.295,
    y2: 1.867,
    transform: "translate(148.329 124.363)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    id: "Line_283",
    "data-name": "Line 283",
    x2: 9.637,
    y2: 4.287,
    transform: "translate(131.337 49.126)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.6
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73558",
    "data-name": "Path 73558",
    d: "M256.954,416.76s-143.947-61.019-144.942-61.765",
    transform: "translate(-92.196 -273.678)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    id: "Line_284",
    "data-name": "Line 284",
    x1: 149.368,
    y1: 61.347,
    transform: "translate(16.636 67.929)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    id: "Line_285",
    "data-name": "Line 285",
    x2: 154.159,
    y2: 58.053,
    transform: "translate(13.154 53.27)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    id: "Line_286",
    "data-name": "Line 286",
    x2: 159.298,
    y2: 57.53,
    transform: "translate(9.445 37.656)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    id: "Line_287",
    "data-name": "Line 287",
    x2: 164.518,
    y2: 57.993,
    transform: "translate(5.419 20.707)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  }))), _g182 || (_g182 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41228",
    "data-name": "Group 41228",
    transform: "translate(164.02 4.862)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73559",
    "data-name": "Path 73559",
    d: "M349.067,349.464,294.42,405.131l7.49-93.119,67.219-53.574a.691.691,0,0,1,1.1.7Z",
    transform: "translate(-294.42 -258.285)",
    fill: "#b97429"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_288",
    "data-name": "Line 288",
    x1: 52.642,
    y2: 52.41,
    transform: "translate(2.655 82.545)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_289",
    "data-name": "Line 289",
    y1: 51.692,
    x2: 56.32,
    transform: "translate(2.809 68.2)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_290",
    "data-name": "Line 290",
    y1: 46.932,
    x2: 57.83,
    transform: "translate(4.309 55.158)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_291",
    "data-name": "Line 291",
    y1: 46.808,
    x2: 61.798,
    transform: "translate(5.052 37.232)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_292",
    "data-name": "Line 292",
    y1: 49.387,
    x2: 63.803,
    transform: "translate(5.755 21.857)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73560",
    "data-name": "Path 73560",
    d: "M325.177,405.854s7.1-5.6,8.091-8.092,4.109-4.606,4.109-4.606",
    transform: "translate(-300.862 -286.532)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73561",
    "data-name": "Path 73561",
    d: "M307.225,424.656a18.306,18.306,0,0,0,3.112-4.731",
    transform: "translate(-297.102 -292.139)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73562",
    "data-name": "Path 73562",
    d: "M303.175,414.871s1.245-3.486,0-3.237.5-4.855,1.867-5.1,1.245.747,1.245.747",
    transform: "translate(-296.164 -289.325)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73563",
    "data-name": "Path 73563",
    d: "M308.59,394.887s-4.357,4.969-4.731,3.724,3.61-2.738,2.365-2.738-4.712,2.24-3.538-.125a5.11,5.11,0,0,0,0-4.482",
    transform: "translate(-296.101 -286.137)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73564",
    "data-name": "Path 73564",
    d: "M318.091,386.017a29,29,0,0,0,4.357-5.1c1.742-2.738,3.112-4.6,4.233-4.6",
    transform: "translate(-299.378 -283.004)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73565",
    "data-name": "Path 73565",
    d: "M358.4,361.623s3.569-6.383,3.486-8.465",
    transform: "translate(-307.821 -278.155)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73566",
    "data-name": "Path 73566",
    d: "M320.611,363.49s7.951-5.328,8.27-6.71,2.809-2.455,2.809-2.455l3.611-1.167",
    transform: "translate(-299.906 -278.155)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73567",
    "data-name": "Path 73567",
    d: "M304.863,357.061s3.361-2.522,3.361-3.067,2.988-2.412,3.61-2.412",
    transform: "translate(-296.607 -277.825)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73568",
    "data-name": "Path 73568",
    d: "M309.273,336.852a13.569,13.569,0,0,0,1.618-4.482c.124-1.868-.747-5.1,0-5.354",
    transform: "translate(-297.531 -272.68)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73569",
    "data-name": "Path 73569",
    d: "M327.067,323.082s3.845-1.743,5.159-3.361a15.382,15.382,0,0,1,3.555-2.932l3.132-1.425",
    transform: "translate(-301.258 -270.24)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73570",
    "data-name": "Path 73570",
    d: "M355.255,301.869a3.278,3.278,0,0,0,2.489-2.863c.374-2.489.125-4.606,1.743-3.983s4.855.651,6.1-.111",
    transform: "translate(-307.161 -265.956)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73571",
    "data-name": "Path 73571",
    d: "M376.6,284.634s.747-5.1,0-8.34.332-4.233.332-4.233",
    transform: "translate(-311.577 -261.17)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73572",
    "data-name": "Path 73572",
    d: "M352.577,319.2s9.3-5.6,9.321-7.469c0,0,.888-3.61,2.008-3.61",
    transform: "translate(-306.601 -268.722)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73573",
    "data-name": "Path 73573",
    d: "M352.577,340.315s4.48-1.991,4.606-4.108-1.244,0-1.244,0a18.654,18.654,0,0,0,3.049-2.167",
    transform: "translate(-306.601 -274.151)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73574",
    "data-name": "Path 73574",
    d: "M329.153,339.037s2.725-1.121,3.51-1.587",
    transform: "translate(-301.695 -274.865)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73575",
    "data-name": "Path 73575",
    d: "M325.715,312.058s-4.294,3.548-5.1,4.855",
    transform: "translate(-299.906 -269.547)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_293",
    "data-name": "Line 293",
    y1: 1.431,
    x2: 2.054,
    transform: "translate(41.37 39.399)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73576",
    "data-name": "Path 73576",
    d: "M364.367,281.5s3-.187,3.128-.747a11.011,11.011,0,0,1,1.618-2.241",
    transform: "translate(-309.07 -262.522)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73577",
    "data-name": "Path 73577",
    d: "M313.682,341.239s2.96-1.712,4.467-2.785",
    transform: "translate(-298.454 -275.076)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73578",
    "data-name": "Path 73578",
    d: "M307.776,369.2s2.828-.374,2.814-1.867",
    transform: "translate(-297.217 -281.123)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_294",
    "data-name": "Line 294",
    y1: 3.859,
    x2: 3.548,
    transform: "translate(56.496 48.984)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73579",
    "data-name": "Path 73579",
    d: "M352.577,354.661s6.1-3.8,6.349-5.913",
    transform: "translate(-306.601 -277.232)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73580",
    "data-name": "Path 73580",
    d: "M335.412,368.031s2.243-1.931,2.989-1.806",
    transform: "translate(-303.005 -280.891)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73581",
    "data-name": "Path 73581",
    d: "M318.428,404.494s-2.988,1.867-3.486,2.365",
    transform: "translate(-298.718 -288.907)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73582",
    "data-name": "Path 73582",
    d: "M300.81,433.106a14.736,14.736,0,0,0,3.3-1.37",
    transform: "translate(-295.758 -294.613)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73583",
    "data-name": "Path 73583",
    d: "M336.446,386.545c.18-.7,4.163-3.31,4.163-3.31",
    transform: "translate(-303.222 -284.455)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73584",
    "data-name": "Path 73584",
    d: "M344.862,387.468s3.983-3.486,4.357-4.233",
    transform: "translate(-304.985 -284.455)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_295",
    "data-name": "Line 295",
    y1: 2.055,
    x2: 2.241,
    transform: "translate(46.848 87.14)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.378,
    opacity: 0.5
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_73585",
    "data-name": "Path 73585",
    d: "M113.892,122.916l10.282.867,62.543,69.939-9.17-.977Z",
    transform: "translate(-92.59 -98.246)",
    fill: "#f9d14e",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73586",
    "data-name": "Path 73586",
    d: "M325.143,258.488l1.956-10.315-10.831-2.4-61.8,46.48L104.811,242.011,181.1,212.221l-9.17-.978L89.14,241.6a3.134,3.134,0,0,0-1.974,3.652l20.244,87.216,7.8,4.131L98.165,253.537,248.127,306.7,242,390.651a2.715,2.715,0,0,0,1.638,2.692l5.626,2.41a2.712,2.712,0,0,0,2.95-.539l5.391-5.191a2.715,2.715,0,0,0,.819-1.691l7.9-81.057,54.437-45.767-18.617,81.576,3.344-2.645Z",
    transform: "translate(-86.975 -116.745)",
    fill: "#f9d14e"
  })), _g183 || (_g183 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41230",
    "data-name": "Group 41230",
    transform: "translate(188.274 184.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73587",
    "data-name": "Path 73587",
    d: "M329.65,351.5c0,1.674-1.691,2.166-2.708,2.166s-1.842-.492-1.842-2.166.824-3.035,1.842-3.035A3.267,3.267,0,0,1,329.65,351.5Z",
    transform: "translate(-325.1 -329.942)",
    fill: "#f9d14e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73588",
    "data-name": "Path 73588",
    d: "M361.125,327.85c0,1.556-1.643,1.95-2.6,1.95s-1.734-.395-1.734-1.95.778-2.817,1.734-2.817A3.094,3.094,0,0,1,361.125,327.85Z",
    transform: "translate(-331.737 -325.033)",
    fill: "#f9d14e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73589",
    "data-name": "Path 73589",
    d: "M326.334,349.541s17.841,17.573,26.7-19.06h-1.743c-7.035,32.01-22.973,18.793-22.973,18.793Z",
    transform: "translate(-325.358 -326.174)",
    fill: "#f9d14e"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73590",
    "data-name": "Path 73590",
    d: "M196.426,318.695l-25.278-9.461.074-20.657,28.468,10.2L199.1,316.9A1.984,1.984,0,0,1,196.426,318.695Z",
    transform: "translate(-104.582 -132.942)",
    fill: "#f9d14e"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73591",
    "data-name": "Path 73591",
    d: "M189.074,298.444a2.487,2.487,0,1,1-2.487-2.534A2.511,2.511,0,0,1,189.074,298.444Z",
    transform: "translate(-107.294 -134.478)",
    fill: "#ebc15b"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73592",
    "data-name": "Path 73592",
    d: "M190.025,310.316a2.488,2.488,0,1,1-2.488-2.534A2.512,2.512,0,0,1,190.025,310.316Z",
    transform: "translate(-107.493 -136.965)",
    fill: "#ebc15b"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73593",
    "data-name": "Path 73593",
    d: "M346.157,114.607s-3.244-2.1-5.7-.708-6.955-1.187-6.955-1.187-3.792-.255-5.443-.262",
    transform: "translate(-137.445 -96.054)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73594",
    "data-name": "Path 73594",
    d: "M265.671,313.2s24.065,10.269,24.572,11.391c.423.935,1.863.251,2.465,22.626,0,0-.513-21.351,1.83-23.093s12.53-10.3,13.556-10.925c0,0-13.5,8.932-15.386,9.057S290.941,323.282,265.671,313.2Z",
    transform: "translate(-124.379 -138.099)",
    fill: "#fff"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73595",
    "data-name": "Path 73595",
    d: "M348.4,283.3s37.175-24.857,23.426-25.346c0,0,6.653,1.033,6.965,2.092S351.75,282.718,348.4,283.3Z",
    transform: "translate(-141.707 -126.529)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41231",
    "data-name": "Group 41231",
    transform: "translate(222.069 157.972)",
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73596",
    "data-name": "Path 73596",
    d: "M372.018,312.941c-3.056,12.173-5.12,25.9-3.724,26.25.147.037.178-.024.372-.2l11.386-47.455C378.634,291.332,375.054,300.858,372.018,312.941Z",
    transform: "translate(-367.849 -291.534)",
    fill: "#f9d14e"
  }))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73597",
    "data-name": "Path 73597",
    d: "M105.945,245.328,91.5,250.681s-3.237.872-2.614,3.61L91.5,264.468s-1.742-10.426-.871-10.208S102.9,257.9,102.9,257.9s-12.449-5.478-10.582-6.162S105.945,245.328,105.945,245.328Z",
    transform: "translate(-87.337 -123.884)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73598",
    "data-name": "Path 73598",
    d: "M203.258,301.92l-4.8-1.7a22.585,22.585,0,0,0-4.722,4.839,25.172,25.172,0,0,0-5.183,11.793l11.419,4.274a2,2,0,0,0,2.707-1.811Z",
    transform: "translate(-108.226 -135.38)",
    fill: "#f9d14e",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _g184 || (_g184 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41234",
    "data-name": "Group 41234",
    transform: "translate(61.922 168.025)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73599",
    "data-name": "Path 73599",
    d: "M166.043,327.715l15.561,4.953,4.285-12.689-16.651-5.308-3.908,11.64A1.105,1.105,0,0,0,166.043,327.715Z",
    transform: "translate(-165.273 -306.433)",
    fill: "#aba6a0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73600",
    "data-name": "Path 73600",
    d: "M190.216,321.385l3.217.031-3.958,11.516a1.1,1.1,0,0,1-.877.733l-2.667.409Z",
    transform: "translate(-169.6 -307.839)",
    fill: "#b8b2ac"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73601",
    "data-name": "Path 73601",
    d: "M170.289,314.671h2.859l17.009,5.339-3.217-.031Z",
    transform: "translate(-166.324 -306.432)",
    fill: "#c7c1ba"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41233",
    "data-name": "Group 41233",
    transform: "translate(6.709)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41232",
    "data-name": "Group 41232",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73602",
    "data-name": "Path 73602",
    d: "M176,313.585a6.782,6.782,0,0,1,.281-2.157,6.087,6.087,0,0,1,7.395-4.38,5.92,5.92,0,0,1,4.04,6.036l2.433,0a8.294,8.294,0,0,0-5.652-8.517c-4.313-1.294-8.949,1.451-10.354,6.133a9.565,9.565,0,0,0-.381,2.21s.127.458.929.641A2.786,2.786,0,0,0,176,313.585Z",
    transform: "translate(-173.759 -304.25)",
    fill: "#dddfde"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73603",
    "data-name": "Path 73603",
    d: "M191.427,315.329c0,.439.551.79,1.222.783s1.212-.363,1.208-.8-.551-.79-1.221-.783S191.423,314.892,191.427,315.329Z",
    transform: "translate(-177.459 -306.402)",
    fill: "#cacccb"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73604",
    "data-name": "Path 73604",
    d: "M188.97,319.939c.048-.15.689-.092,1.43.13s1.3.526,1.256.676-.689.092-1.43-.13S188.922,320.09,188.97,319.939Z",
    transform: "translate(-170.236 -307.518)",
    fill: "#838584"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73605",
    "data-name": "Path 73605",
    d: "M186.18,297.809a1.442,1.442,0,0,1,0,2.159s-4.709,3.471.25,7.226c0,0,1.122,1.4.25,2.347C186.679,309.542,176.841,304.1,186.18,297.809Z",
    transform: "translate(-106.887 -134.876)",
    fill: "#c9962b"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73606",
    "data-name": "Path 73606",
    d: "M105.582,295.6l-7.541-37s-7.555-4.042-7.555-1.848S92.54,269.96,92.54,269.96l2.686,12.511A19.849,19.849,0,0,0,105.582,295.6Z",
    transform: "translate(-87.688 -126.14)",
    fill: "#f9d14e",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73607",
    "data-name": "Path 73607",
    d: "M345.846,288.542c4.684-4.53,5.509-3.735,8.31-11.765,0,0-.314-6.966-22.035,9.057-38.747,28.583-19.113,22.558-19.113,22.558s-2.968,8.608,12.484-3.138c5.084-3.865,14.159-10.167,20.354-16.712",
    transform: "translate(-133.251 -130.155)",
    fill: "#f9d14e",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73608",
    "data-name": "Path 73608",
    d: "M164.262,223.654s-12.922,2.254-17.785,1.485l37.9-13.9,9.17.978Z",
    transform: "translate(-99.415 -116.745)",
    fill: "#f9d14e",
    opacity: 0.6,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73609",
    "data-name": "Path 73609",
    d: "M116.986,263.178l1.032,5.6,35.516,12.476s8.737,3.4,11.786-.434.506-.636.506-.636Z",
    transform: "translate(-93.238 -127.623)",
    fill: "#f9d14e",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73610",
    "data-name": "Path 73610",
    d: "M142.543,272.05s47.416,17.2,67.9,22.819C210.441,294.869,145.983,271.968,142.543,272.05Z",
    transform: "translate(-98.591 -129.481)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41235",
    "data-name": "Group 41235",
    transform: "translate(213.327 184.459)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73611",
    "data-name": "Path 73611",
    d: "M358.5,325.038c-.945.018-1.712,1.268-1.712,2.813s.778,1.95,1.734,1.95a3.817,3.817,0,0,0,1.345-.251C357.292,328.857,358.1,326.078,358.5,325.038Z",
    transform: "translate(-356.79 -325.038)",
    fill: "#f9d14e"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41236",
    "data-name": "Group 41236",
    transform: "translate(188.274 202.997)",
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73612",
    "data-name": "Path 73612",
    d: "M326.771,348.488c-.945.018-1.671,1.6-1.671,3.142,0,1.451.781,2.045,1.737,2.045a3.7,3.7,0,0,0,1.342-.219C325.6,352.764,326.368,349.528,326.771,348.488Z",
    transform: "translate(-325.1 -348.488)",
    fill: "#f9d14e"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_73613",
    "data-name": "Path 73613",
    d: "M295.116,410.878l3.378-44.2s-7.251-4.5-7.86,6.678S287.381,408.217,295.116,410.878Z",
    transform: "translate(-129.413 -149.112)",
    fill: "#f9d14e",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73614",
    "data-name": "Path 73614",
    d: "M110.485,336.568s2.54,22.034,4.647,22.5a22.556,22.556,0,0,1,4.1,1.4s-3.3-1.369-3.61-2.054S114.468,358.789,110.485,336.568Z",
    transform: "translate(-91.876 -142.994)",
    fill: "#fff"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73615",
    "data-name": "Path 73615",
    d: "M354.937,138.158s3.92,10.714,3.944,14.3.462,9.377,1.355,11.339",
    transform: "translate(-143.075 -101.438)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41239",
    "data-name": "Group 41239",
    transform: "translate(191.692 9.422)"
  }, _g185 || (_g185 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41237",
    "data-name": "Group 41237",
    transform: "translate(13.606)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73616",
    "data-name": "Path 73616",
    d: "M346.658,137.193,380.7,225.378c.073.188,1.756-1.862,1.8-1.93a46.218,46.218,0,0,0,4.08-8.486,183.976,183.976,0,0,0,12.3-58.545c.783-15.762.206-32.961-8.306-46.792-7.8-12.673-21.821-2.546-28.511,5.488a154.461,154.461,0,0,0-9.465,12.943C351.806,129.251,346.228,136.08,346.658,137.193Z",
    transform: "translate(-346.634 -103.628)",
    fill: "#b97429"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_296",
    "data-name": "Line 296",
    x2: 32.014,
    y2: 89.11,
    transform: "translate(7.775 21.769)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_297",
    "data-name": "Line 297",
    x2: 29.204,
    y2: 76.514,
    transform: "translate(17.481 12.285)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_298",
    "data-name": "Line 298",
    x2: 22.79,
    y2: 54.885,
    transform: "translate(28.789 3.209)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.945
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73617",
    "data-name": "Path 73617",
    d: "M374.183,144.587s.087,1.638.261,3.953,2.136,7.112,2.136,7.112",
    transform: "translate(-352.404 -112.207)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73618",
    "data-name": "Path 73618",
    d: "M385.99,175.035s-1.8,6.01-1,9.216a28.512,28.512,0,0,0,3.121,6.865",
    transform: "translate(-354.624 -118.584)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73619",
    "data-name": "Path 73619",
    d: "M399.958,170.291s4.9,14.153,4.8,16.361",
    transform: "translate(-357.803 -117.59)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73620",
    "data-name": "Path 73620",
    d: "M400.637,223.531s-2.021-4.127-1.837-7.578",
    transform: "translate(-357.557 -127.154)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73621",
    "data-name": "Path 73621",
    d: "M383.755,149.315s-7.645-24.045-9.649-25.208",
    transform: "translate(-352.388 -107.917)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73622",
    "data-name": "Path 73622",
    d: "M392.727,111.511s-1.811-3.271-1.505-4.248",
    transform: "translate(-355.965 -104.389)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73623",
    "data-name": "Path 73623",
    d: "M406.648,144.171s.483-3.836-1.844-5.443-1.957-6.778-1.957-6.778-1.421-3.524-2.133-5.015",
    transform: "translate(-357.961 -108.509)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  }))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73624",
    "data-name": "Path 73624",
    d: "M377.855,234.347l-10.831-2.4-37.6-86.713,15.531,1.611Z",
    transform: "translate(-329.423 -112.342)",
    fill: "#f9d14e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41238",
    "data-name": "Group 41238",
    transform: "translate(0 32.892)",
    opacity: 0.5,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73625",
    "data-name": "Path 73625",
    d: "M364.1,199.034l-20.032-52.19-14.649-1.61,26.968,62.75a2.452,2.452,0,0,0,.568.136S363.747,208.884,364.1,199.034Z",
    transform: "translate(-329.423 -145.234)",
    fill: "#f9d14e"
  }))), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73626",
    "data-name": "Path 73626",
    d: "M373.292,220.29s9.788,25.894,10.718,27.014C384.01,247.3,377.453,223.776,373.292,220.29Z",
    transform: "translate(-338.611 -128.062)",
    fill: "#fff"
  }))), _g186 || (_g186 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41243",
    "data-name": "Group 41243",
    transform: "translate(177.818 144.622)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41241",
    "data-name": "Group 41241",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_299",
    "data-name": "Line 299",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41240",
    "data-name": "Group 41240",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73627",
    "data-name": "Path 73627",
    d: "M330.573,282.848l-14.625-5.594-3.132-1.2-.87,2.273c-.672,1.758,3.459,4.973,9.227,7.181s10.99,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-311.874 -276.056)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73628",
    "data-name": "Path 73628",
    d: "M333.936,283.753c-.674,1.76-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.182,5.9-1.4,11.664.81S334.608,281.994,333.936,283.753Z",
    transform: "translate(-312.105 -274.647)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73629",
    "data-name": "Path 73629",
    d: "M317.946,275.218s-4.423-.309-4.323,1.087,6.558,5.2,6.863,5.176c0,0-6.469-3.8-6.431-5.1S317.946,275.218,317.946,275.218Z",
    transform: "translate(-312.24 -274.761)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41242",
    "data-name": "Group 41242",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73630",
    "data-name": "Path 73630",
    d: "M336.967,284.234c.672-1.759-3.458-4.975-9.226-7.181-.1-.038-.2-.07-.295-.107a66.248,66.248,0,0,1,4.9,8.3C334.825,285.528,336.594,285.207,336.967,284.234Z",
    transform: "translate(-327.446 -276.946)",
    fill: "#ffee2f"
  })))), _g187 || (_g187 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41247",
    "data-name": "Group 41247",
    transform: "translate(157.538 165.842)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41245",
    "data-name": "Group 41245",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_300",
    "data-name": "Line 300",
    x1: 0.305,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41244",
    "data-name": "Group 41244",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73631",
    "data-name": "Path 73631",
    d: "M289.862,304.766l15.535,1.972,3.326.421-.306,2.414c-.24,1.869-5.4,2.754-11.526,1.974s-10.9-2.923-10.662-4.791l.3-2.413Z",
    transform: "translate(-286.221 -304.345)",
    fill: "url(#radial-gradient-181)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73632",
    "data-name": "Path 73632",
    d: "M286.615,303.747c-.236,1.867,4.539,4.013,10.666,4.791s11.287-.107,11.523-1.976-4.539-4.013-10.665-4.79S286.854,301.879,286.615,303.747Z",
    transform: "translate(-286.302 -301.489)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73633",
    "data-name": "Path 73633",
    d: "M308.389,304.332s4.044,1.816,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.076-1.459S308.389,304.332,308.389,304.332Z",
    transform: "translate(-289.776 -302.084)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41246",
    "data-name": "Group 41246",
    transform: "translate(0.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73634",
    "data-name": "Path 73634",
    d: "M286.615,303.747c.24-1.868,5.4-2.755,11.524-1.975.107.013.207.031.312.044a66.265,66.265,0,0,0-8.24,5.006C287.893,305.9,286.485,304.779,286.615,303.747Z",
    transform: "translate(-286.607 -301.489)",
    fill: "#ffee2f"
  })))), _g188 || (_g188 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41251",
    "data-name": "Group 41251",
    transform: "translate(175.275 152.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41249",
    "data-name": "Group 41249",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_301",
    "data-name": "Line 301",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41248",
    "data-name": "Group 41248",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73635",
    "data-name": "Path 73635",
    d: "M312.3,287.74l15.538,1.974,3.324.421-.3,2.414c-.24,1.867-5.4,2.751-11.525,1.972s-10.9-2.922-10.664-4.791l.306-2.413Z",
    transform: "translate(-308.657 -287.319)",
    fill: "url(#radial-gradient-182)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73636",
    "data-name": "Path 73636",
    d: "M309.053,286.721c-.236,1.868,4.537,4.013,10.665,4.792s11.287-.108,11.523-1.976-4.537-4.014-10.664-4.792S309.291,284.854,309.053,286.721Z",
    transform: "translate(-308.738 -284.464)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73637",
    "data-name": "Path 73637",
    d: "M330.825,287.307s4.045,1.814,3.3,3-8.234,1.485-8.5,1.323c0,0,7.5-.291,8.079-1.459S330.825,287.307,330.825,287.307Z",
    transform: "translate(-312.211 -285.059)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41250",
    "data-name": "Group 41250",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73638",
    "data-name": "Path 73638",
    d: "M309.053,286.721c.238-1.867,5.4-2.753,11.524-1.975.1.013.207.03.311.044a66.331,66.331,0,0,0-8.238,5.007C310.331,288.872,308.923,287.754,309.053,286.721Z",
    transform: "translate(-309.045 -284.464)",
    fill: "#ffee2f"
  })))), _g189 || (_g189 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41255",
    "data-name": "Group 41255",
    transform: "translate(164.786 154.161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41253",
    "data-name": "Group 41253",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_302",
    "data-name": "Line 302",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.96 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41252",
    "data-name": "Group 41252",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73639",
    "data-name": "Path 73639",
    d: "M314.087,294.915l-14.625-5.595-3.132-1.2-.868,2.274c-.674,1.759,3.457,4.973,9.226,7.18s10.988,2.57,11.662.811l.869-2.272Z",
    transform: "translate(-295.39 -288.121)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73640",
    "data-name": "Path 73640",
    d: "M317.449,295.819c-.674,1.759-5.9,1.4-11.663-.81s-9.9-5.422-9.226-7.182,5.9-1.395,11.663.812S318.122,294.06,317.449,295.819Z",
    transform: "translate(-295.62 -286.713)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73641",
    "data-name": "Path 73641",
    d: "M301.458,287.285s-4.422-.309-4.323,1.087,6.559,5.195,6.865,5.177c0,0-6.472-3.8-6.432-5.1S301.458,287.285,301.458,287.285Z",
    transform: "translate(-295.755 -286.827)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41254",
    "data-name": "Group 41254",
    transform: "translate(12.308 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73642",
    "data-name": "Path 73642",
    d: "M320.479,296.3c.673-1.758-3.457-4.975-9.226-7.181-.1-.039-.2-.07-.3-.107a66.131,66.131,0,0,1,4.9,8.3C318.338,297.594,320.106,297.274,320.479,296.3Z",
    transform: "translate(-310.958 -289.013)",
    fill: "#ffee2f"
  })))), _g190 || (_g190 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41259",
    "data-name": "Group 41259",
    transform: "translate(42.14 103.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41257",
    "data-name": "Group 41257",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_303",
    "data-name": "Line 303",
    x2: 0.857,
    y2: 2.276,
    transform: "translate(0.069 9.009)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41256",
    "data-name": "Group 41256",
    transform: "translate(0.07 1.13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73643",
    "data-name": "Path 73643",
    d: "M143.476,231.148l14.657-5.517,3.138-1.182.857,2.278c.662,1.761-3.485,4.955-9.266,7.131s-11,2.509-11.667.746l-.856-2.276Z",
    transform: "translate(-140.338 -224.449)",
    fill: "url(#radial-gradient-184)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73644",
    "data-name": "Path 73644",
    d: "M140.32,232.029c.663,1.763,5.887,1.429,11.668-.747s9.929-5.369,9.265-7.132-5.887-1.427-11.667.749S139.657,230.266,140.32,232.029Z",
    transform: "translate(-140.25 -223.02)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73645",
    "data-name": "Path 73645",
    d: "M160.113,223.582s4.425-.285,4.316,1.111-6.586,5.16-6.891,5.139c0,0,6.49-3.761,6.459-5.065S160.113,223.582,160.113,223.582Z",
    transform: "translate(-143.871 -223.132)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41258",
    "data-name": "Group 41258",
    transform: "translate(0 1.773)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73646",
    "data-name": "Path 73646",
    d: "M140.32,232.5c-.662-1.763,3.485-4.956,9.265-7.131.1-.037.2-.07.294-.106a66.357,66.357,0,0,0-4.943,8.276C142.454,233.8,140.687,233.474,140.32,232.5Z",
    transform: "translate(-140.25 -225.262)",
    fill: "#ffee2f"
  })))), _g191 || (_g191 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41263",
    "data-name": "Group 41263",
    transform: "translate(19.264 115.556)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41261",
    "data-name": "Group 41261",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_304",
    "data-name": "Line 304",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41260",
    "data-name": "Group 41260",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73647",
    "data-name": "Path 73647",
    d: "M114.955,241.158l15.536,1.973,3.326.421-.307,2.414c-.238,1.867-5.4,2.753-11.524,1.974s-10.9-2.923-10.664-4.792l.306-2.414Z",
    transform: "translate(-111.314 -240.735)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73648",
    "data-name": "Path 73648",
    d: "M111.71,240.137c-.236,1.869,4.538,4.014,10.665,4.792s11.287-.107,11.523-1.976-4.537-4.014-10.665-4.791S111.948,238.27,111.71,240.137Z",
    transform: "translate(-111.395 -237.88)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73649",
    "data-name": "Path 73649",
    d: "M133.482,240.724s4.044,1.814,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.46S133.482,240.724,133.482,240.724Z",
    transform: "translate(-114.869 -238.476)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41262",
    "data-name": "Group 41262",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73650",
    "data-name": "Path 73650",
    d: "M111.71,240.137c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.03.311.044a66.326,66.326,0,0,0-8.239,5.007C112.987,242.29,111.579,241.171,111.71,240.137Z",
    transform: "translate(-111.701 -237.88)",
    fill: "#ffee2f"
  })))), _g192 || (_g192 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41267",
    "data-name": "Group 41267",
    transform: "translate(64.114 98.372)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41265",
    "data-name": "Group 41265",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_305",
    "data-name": "Line 305",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41264",
    "data-name": "Group 41264",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73651",
    "data-name": "Path 73651",
    d: "M171.687,219.421l15.536,1.972,3.327.421-.307,2.414c-.238,1.869-5.4,2.753-11.525,1.976s-10.9-2.925-10.664-4.792l.307-2.413Z",
    transform: "translate(-168.046 -219)",
    fill: "url(#radial-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73652",
    "data-name": "Path 73652",
    d: "M168.443,218.4c-.237,1.867,4.537,4.014,10.664,4.791s11.288-.107,11.525-1.976-4.538-4.013-10.665-4.79S168.681,216.532,168.443,218.4Z",
    transform: "translate(-168.128 -216.144)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73653",
    "data-name": "Path 73653",
    d: "M190.215,218.987s4.045,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.292,8.077-1.461S190.215,218.987,190.215,218.987Z",
    transform: "translate(-171.601 -216.739)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41266",
    "data-name": "Group 41266",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73654",
    "data-name": "Path 73654",
    d: "M168.443,218.4c.238-1.87,5.4-2.754,11.523-1.975.105.013.206.029.311.043a66.42,66.42,0,0,0-8.24,5.007C169.72,220.553,168.312,219.434,168.443,218.4Z",
    transform: "translate(-168.434 -216.144)",
    fill: "#ffdf2f"
  })))), _g193 || (_g193 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41271",
    "data-name": "Group 41271",
    transform: "translate(150.959 108.168)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41269",
    "data-name": "Group 41269",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_306",
    "data-name": "Line 306",
    x1: 0.77,
    y2: 2.308,
    transform: "translate(21.271 8.336)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41268",
    "data-name": "Group 41268",
    transform: "translate(0 1.255)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73655",
    "data-name": "Path 73655",
    d: "M296.76,236.142,281.9,231.184l-3.18-1.062-.77,2.308c-.6,1.786,3.668,4.819,9.529,6.776s11.09,2.091,11.686.305l.771-2.308Z",
    transform: "translate(-277.898 -230.122)",
    fill: "url(#radial-gradient-187)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73656",
    "data-name": "Path 73656",
    d: "M300.144,236.871c-.6,1.787-5.829,1.65-11.688-.3s-10.124-4.992-9.528-6.777,5.83-1.65,11.688.306S300.739,235.085,300.144,236.871Z",
    transform: "translate(-278.103 -228.534)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73657",
    "data-name": "Path 73657",
    d: "M283.794,229.031s-4.431-.118-4.271,1.274,6.777,4.907,7.081,4.874c0,0-6.628-3.512-6.646-4.817S283.794,229.031,283.794,229.031Z",
    transform: "translate(-278.238 -228.638)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41270",
    "data-name": "Group 41270",
    transform: "translate(12.214 1.466)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73658",
    "data-name": "Path 73658",
    d: "M303.175,237.259c.6-1.786-3.669-4.821-9.528-6.775-.1-.033-.2-.062-.3-.095a66.4,66.4,0,0,1,5.254,8.083C301.091,238.645,302.845,238.248,303.175,237.259Z",
    transform: "translate(-293.348 -230.389)",
    fill: "#ffee2f"
  })))), _g194 || (_g194 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41275",
    "data-name": "Group 41275",
    transform: "translate(135.678 100.041)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41273",
    "data-name": "Group 41273",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_307",
    "data-name": "Line 307",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41272",
    "data-name": "Group 41272",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73659",
    "data-name": "Path 73659",
    d: "M262.21,221.532l15.535,1.974,3.327.421-.307,2.414c-.238,1.868-5.4,2.753-11.525,1.975s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-258.569 -221.111)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73660",
    "data-name": "Path 73660",
    d: "M258.965,220.513c-.236,1.867,4.537,4.014,10.665,4.792s11.288-.108,11.524-1.976-4.538-4.014-10.665-4.792S259.2,218.645,258.965,220.513Z",
    transform: "translate(-258.65 -218.255)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73661",
    "data-name": "Path 73661",
    d: "M280.737,221.1s4.045,1.815,3.3,3-8.234,1.485-8.493,1.323c0,0,7.5-.29,8.077-1.46S280.737,221.1,280.737,221.1Z",
    transform: "translate(-262.124 -218.851)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41274",
    "data-name": "Group 41274",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73662",
    "data-name": "Path 73662",
    d: "M258.965,220.513c.238-1.868,5.4-2.753,11.524-1.975l.311.044a66.369,66.369,0,0,0-8.24,5.007C260.241,222.665,258.834,221.545,258.965,220.513Z",
    transform: "translate(-258.956 -218.255)",
    fill: "#ffee2f"
  })))), _g195 || (_g195 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41279",
    "data-name": "Group 41279",
    transform: "translate(184.498 113.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41277",
    "data-name": "Group 41277",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_308",
    "data-name": "Line 308",
    x1: 1.096,
    y2: 2.172,
    transform: "translate(0.119 0.85)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41276",
    "data-name": "Group 41276",
    transform: "translate(0 0.851)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73663",
    "data-name": "Path 73663",
    d: "M324.532,237.891l13.983,7.051,2.995,1.508-1.095,2.173c-.848,1.682-6.006.791-11.522-1.991s-9.3-6.4-8.45-8.079l1.1-2.172Z",
    transform: "translate(-320.324 -236.382)",
    fill: "url(#radial-gradient-189)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73664",
    "data-name": "Path 73664",
    d: "M321.829,236.157c-.847,1.682,2.936,5.3,8.449,8.079s10.676,3.671,11.522,1.988-2.935-5.3-8.451-8.079S322.676,234.475,321.829,236.157Z",
    transform: "translate(-320.614 -235.306)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73665",
    "data-name": "Path 73665",
    d: "M342,244.1s3.207,3.063,2.1,3.928-8.256-1.353-8.447-1.591c0,0,7.162,2.231,8.1,1.324S342,244.1,342,244.1Z",
    transform: "translate(-323.536 -237.149)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41278",
    "data-name": "Group 41278",
    transform: "translate(1.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73666",
    "data-name": "Path 73666",
    d: "M321.829,236.157c.848-1.682,6.007-.793,11.521,1.988.095.047.184.1.278.147a66.284,66.284,0,0,0-9.439,1.965C322.313,238.611,321.36,237.086,321.829,236.157Z",
    transform: "translate(-321.71 -235.306)",
    fill: "#ffdf2f"
  })))), _g196 || (_g196 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41283",
    "data-name": "Group 41283",
    transform: "translate(140.875 101.389)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41281",
    "data-name": "Group 41281",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_309",
    "data-name": "Line 309",
    x1: 1.579,
    y2: 1.851,
    transform: "translate(17.304 14.964)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41280",
    "data-name": "Group 41280",
    transform: "translate(0 0.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73667",
    "data-name": "Path 73667",
    d: "M281.474,232.869l-11.917-10.16-2.55-2.176-1.578,1.851c-1.224,1.433,1.6,5.845,6.3,9.853s9.5,6.091,10.722,4.66l1.578-1.851Z",
    transform: "translate(-265.143 -220.532)",
    fill: "url(#radial-gradient-190)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73668",
    "data-name": "Path 73668",
    d: "M284.444,234.925c-1.222,1.432-6.022-.653-10.722-4.661s-7.517-8.419-6.3-9.851,6.022.655,10.721,4.661S285.664,233.491,284.444,234.925Z",
    transform: "translate(-265.562 -219.96)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73669",
    "data-name": "Path 73669",
    d: "M272.276,221.518s-4.066-1.769-4.437-.42,4.446,7.088,4.74,7.172c0,0-4.83-5.739-4.357-6.955S272.276,221.518,272.276,221.518Z",
    transform: "translate(-265.704 -220.093)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41282",
    "data-name": "Group 41282",
    transform: "translate(12.343 4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73670",
    "data-name": "Path 73670",
    d: "M287.3,236.226c1.221-1.433-1.6-5.844-6.3-9.851-.081-.069-.161-.132-.242-.2a66.365,66.365,0,0,1,1.844,9.464C284.845,236.729,286.62,237.018,287.3,236.226Z",
    transform: "translate(-280.757 -226.174)",
    fill: "#ffee2f"
  })))), _g197 || (_g197 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41287",
    "data-name": "Group 41287",
    transform: "translate(137.577 112.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41285",
    "data-name": "Group 41285",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_310",
    "data-name": "Line 310",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41284",
    "data-name": "Group 41284",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73671",
    "data-name": "Path 73671",
    d: "M264.612,237.4l15.537,1.972,3.326.422-.306,2.414c-.238,1.867-5.4,2.752-11.526,1.974s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-260.971 -236.976)",
    fill: "url(#radial-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73672",
    "data-name": "Path 73672",
    d: "M261.368,236.378c-.238,1.868,4.537,4.014,10.665,4.792s11.287-.107,11.523-1.975-4.538-4.014-10.664-4.791S261.606,234.51,261.368,236.378Z",
    transform: "translate(-261.053 -234.12)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73673",
    "data-name": "Path 73673",
    d: "M283.139,236.962s4.045,1.817,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.078-1.459S283.139,236.962,283.139,236.962Z",
    transform: "translate(-264.525 -234.716)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41286",
    "data-name": "Group 41286",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73674",
    "data-name": "Path 73674",
    d: "M261.368,236.378c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.044a66.318,66.318,0,0,0-8.24,5.007C262.645,238.529,261.237,237.412,261.368,236.378Z",
    transform: "translate(-261.359 -234.12)",
    fill: "#ffee2f"
  })))), _g198 || (_g198 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41291",
    "data-name": "Group 41291",
    transform: "translate(146.749 105.944)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41289",
    "data-name": "Group 41289",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_311",
    "data-name": "Line 311",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41288",
    "data-name": "Group 41288",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73675",
    "data-name": "Path 73675",
    d: "M276.215,229l15.537,1.972,3.327.421-.307,2.414c-.238,1.868-5.4,2.753-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.413Z",
    transform: "translate(-272.574 -228.578)",
    fill: "url(#radial-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73676",
    "data-name": "Path 73676",
    d: "M272.971,227.98c-.237,1.868,4.538,4.014,10.664,4.792s11.288-.107,11.525-1.976-4.537-4.011-10.665-4.791S273.208,226.112,272.971,227.98Z",
    transform: "translate(-272.656 -225.722)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73677",
    "data-name": "Path 73677",
    d: "M294.743,228.566s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.459S294.743,228.566,294.743,228.566Z",
    transform: "translate(-276.129 -226.318)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41290",
    "data-name": "Group 41290",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73678",
    "data-name": "Path 73678",
    d: "M272.971,227.98c.237-1.868,5.4-2.753,11.523-1.975.105.013.206.031.311.044a66.324,66.324,0,0,0-8.239,5.007C274.247,230.132,272.84,229.013,272.971,227.98Z",
    transform: "translate(-272.962 -225.722)",
    fill: "#ffdf2f"
  })))), _g199 || (_g199 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41295",
    "data-name": "Group 41295",
    transform: "translate(192.769 111.286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41293",
    "data-name": "Group 41293",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_312",
    "data-name": "Line 312",
    x1: 1.577,
    y2: 1.851,
    transform: "translate(17.305 14.964)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41292",
    "data-name": "Group 41292",
    transform: "translate(0 0.452)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73679",
    "data-name": "Path 73679",
    d: "M347.117,245.387,335.2,235.226l-2.55-2.176-1.579,1.852c-1.224,1.434,1.6,5.845,6.3,9.853s9.5,6.091,10.722,4.66l1.577-1.852Z",
    transform: "translate(-330.786 -233.05)",
    fill: "url(#radial-gradient-193)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73680",
    "data-name": "Path 73680",
    d: "M350.086,247.443c-1.221,1.432-6.022-.653-10.721-4.66s-7.518-8.419-6.3-9.852,6.022.655,10.721,4.662S351.307,246.009,350.086,247.443Z",
    transform: "translate(-331.204 -232.479)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73681",
    "data-name": "Path 73681",
    d: "M337.918,234.036s-4.066-1.769-4.437-.42,4.445,7.087,4.74,7.172c0,0-4.831-5.738-4.358-6.955S337.918,234.036,337.918,234.036Z",
    transform: "translate(-331.346 -232.611)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41294",
    "data-name": "Group 41294",
    transform: "translate(12.344 4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73682",
    "data-name": "Path 73682",
    d: "M352.938,248.744c1.221-1.433-1.6-5.844-6.3-9.85-.079-.07-.16-.133-.241-.2a66.687,66.687,0,0,1,1.844,9.465C350.488,249.248,352.262,249.536,352.938,248.744Z",
    transform: "translate(-346.4 -238.692)",
    fill: "#ffee2f"
  })))), _g200 || (_g200 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41299",
    "data-name": "Group 41299",
    transform: "translate(175.521 105.249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41297",
    "data-name": "Group 41297",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_313",
    "data-name": "Line 313",
    x1: 1.096,
    y2: 2.173,
    transform: "translate(0.118 0.85)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41296",
    "data-name": "Group 41296",
    transform: "translate(0 0.849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73683",
    "data-name": "Path 73683",
    d: "M313.175,227.427l13.985,7.05,2.995,1.508-1.1,2.173c-.848,1.682-6.006.791-11.522-1.99s-9.3-6.4-8.45-8.079l1.1-2.173Z",
    transform: "translate(-308.968 -225.917)",
    fill: "url(#radial-gradient-194)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73684",
    "data-name": "Path 73684",
    d: "M310.473,225.692c-.848,1.683,2.936,5.3,8.45,8.08s10.674,3.67,11.522,1.988-2.936-5.3-8.451-8.078S311.321,224.012,310.473,225.692Z",
    transform: "translate(-309.258 -224.843)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73685",
    "data-name": "Path 73685",
    d: "M330.644,233.64s3.207,3.062,2.1,3.927-8.257-1.353-8.447-1.592c0,0,7.162,2.23,8.1,1.323S330.644,233.64,330.644,233.64Z",
    transform: "translate(-312.18 -226.685)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41298",
    "data-name": "Group 41298",
    transform: "translate(1.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73686",
    "data-name": "Path 73686",
    d: "M310.473,225.692c.848-1.68,6.007-.791,11.521,1.991.094.047.185.1.278.145a66.268,66.268,0,0,0-9.438,1.966C310.957,228.147,310,226.624,310.473,225.692Z",
    transform: "translate(-310.354 -224.843)",
    fill: "#ffee2f"
  })))), _g201 || (_g201 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41303",
    "data-name": "Group 41303",
    transform: "translate(188.729 109.424)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41301",
    "data-name": "Group 41301",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_314",
    "data-name": "Line 314",
    x1: 1.095,
    y2: 2.172,
    transform: "translate(0.118 0.85)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41300",
    "data-name": "Group 41300",
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73687",
    "data-name": "Path 73687",
    d: "M329.883,232.709l13.984,7.05,3,1.509-1.1,2.173c-.847,1.68-6.006.791-11.522-1.991s-9.3-6.4-8.449-8.079l1.095-2.172Z",
    transform: "translate(-325.676 -231.199)",
    fill: "url(#radial-gradient-189)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73688",
    "data-name": "Path 73688",
    d: "M327.18,230.974c-.847,1.682,2.935,5.3,8.451,8.08s10.674,3.671,11.522,1.989-2.936-5.3-8.453-8.079S328.028,229.293,327.18,230.974Z",
    transform: "translate(-325.966 -230.124)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73689",
    "data-name": "Path 73689",
    d: "M347.351,238.922s3.206,3.062,2.1,3.927-8.257-1.353-8.448-1.591c0,0,7.162,2.23,8.1,1.323S347.351,238.922,347.351,238.922Z",
    transform: "translate(-328.887 -231.967)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41302",
    "data-name": "Group 41302",
    transform: "translate(1.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73690",
    "data-name": "Path 73690",
    d: "M327.18,230.974c.848-1.681,6.007-.791,11.521,1.99.094.047.185.1.278.145a66.206,66.206,0,0,0-9.438,1.966C327.664,233.429,326.711,231.905,327.18,230.974Z",
    transform: "translate(-327.061 -230.124)",
    fill: "#ffdf2f"
  })))), _g202 || (_g202 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41307",
    "data-name": "Group 41307",
    transform: "translate(119.836 109.212)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41305",
    "data-name": "Group 41305",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_315",
    "data-name": "Line 315",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41304",
    "data-name": "Group 41304",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73691",
    "data-name": "Path 73691",
    d: "M257.23,238.06l-14.627-5.6-3.131-1.2-.87,2.274c-.673,1.758,3.459,4.974,9.228,7.181s10.989,2.568,11.662.81l.87-2.271Z",
    transform: "translate(-238.53 -231.264)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73692",
    "data-name": "Path 73692",
    d: "M260.592,238.962c-.674,1.757-5.9,1.4-11.664-.81s-9.9-5.424-9.227-7.183,5.9-1.395,11.664.813S261.264,237.2,260.592,238.962Z",
    transform: "translate(-238.761 -229.856)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73693",
    "data-name": "Path 73693",
    d: "M244.6,230.427s-4.423-.309-4.322,1.087,6.558,5.2,6.864,5.177c0,0-6.471-3.795-6.432-5.1S244.6,230.427,244.6,230.427Z",
    transform: "translate(-238.896 -229.97)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41306",
    "data-name": "Group 41306",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73694",
    "data-name": "Path 73694",
    d: "M263.623,239.444c.672-1.76-3.458-4.975-9.227-7.181-.1-.038-.2-.071-.295-.108a66.493,66.493,0,0,1,4.9,8.3C261.482,240.737,263.25,240.416,263.623,239.444Z",
    transform: "translate(-254.102 -232.155)",
    fill: "#ffee2f"
  })))), _g203 || (_g203 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41311",
    "data-name": "Group 41311",
    transform: "translate(101.708 108.734)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41309",
    "data-name": "Group 41309",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_316",
    "data-name": "Line 316",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41308",
    "data-name": "Group 41308",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73695",
    "data-name": "Path 73695",
    d: "M219.241,232.529l15.536,1.972,3.327.422-.307,2.414c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-215.6 -232.106)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73696",
    "data-name": "Path 73696",
    d: "M216,231.508c-.237,1.868,4.537,4.014,10.665,4.792s11.287-.106,11.524-1.975-4.538-4.013-10.665-4.791S216.235,229.64,216,231.508Z",
    transform: "translate(-215.682 -229.251)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73697",
    "data-name": "Path 73697",
    d: "M237.768,232.094s4.045,1.815,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.078-1.459S237.768,232.094,237.768,232.094Z",
    transform: "translate(-219.155 -229.846)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41310",
    "data-name": "Group 41310",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73698",
    "data-name": "Path 73698",
    d: "M216,231.508c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.045a66.155,66.155,0,0,0-8.24,5.005C217.273,233.659,215.866,232.542,216,231.508Z",
    transform: "translate(-215.988 -229.251)",
    fill: "#ffee2f"
  })))), _g204 || (_g204 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41315",
    "data-name": "Group 41315",
    transform: "translate(110.882 102.095)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41313",
    "data-name": "Group 41313",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_317",
    "data-name": "Line 317",
    x1: 0.307,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41312",
    "data-name": "Group 41312",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73699",
    "data-name": "Path 73699",
    d: "M230.845,224.13l15.536,1.974,3.327.42-.307,2.415c-.238,1.869-5.4,2.753-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-227.204 -223.708)",
    fill: "url(#radial-gradient-106)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73700",
    "data-name": "Path 73700",
    d: "M227.6,223.11c-.237,1.868,4.537,4.014,10.665,4.793s11.287-.108,11.524-1.977-4.538-4.011-10.665-4.79S227.839,221.242,227.6,223.11Z",
    transform: "translate(-227.286 -220.853)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73701",
    "data-name": "Path 73701",
    d: "M249.373,223.7s4.045,1.815,3.3,3-8.235,1.484-8.5,1.323c0,0,7.5-.291,8.079-1.459S249.373,223.7,249.373,223.7Z",
    transform: "translate(-230.759 -221.448)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41314",
    "data-name": "Group 41314",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73702",
    "data-name": "Path 73702",
    d: "M227.6,223.11c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.045a66.157,66.157,0,0,0-8.239,5.006C228.877,225.263,227.469,224.144,227.6,223.11Z",
    transform: "translate(-227.592 -220.853)",
    fill: "#ffdf2f"
  })))), _g205 || (_g205 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41319",
    "data-name": "Group 41319",
    transform: "translate(141.46 114.339)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41317",
    "data-name": "Group 41317",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_318",
    "data-name": "Line 318",
    x1: 0.868,
    y2: 2.271,
    transform: "translate(20.963 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41316",
    "data-name": "Group 41316",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73703",
    "data-name": "Path 73703",
    d: "M284.584,244.544l-14.627-5.595-3.131-1.2-.87,2.273c-.673,1.758,3.459,4.973,9.228,7.181s10.989,2.569,11.663.81l.868-2.271Z",
    transform: "translate(-265.883 -237.75)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73704",
    "data-name": "Path 73704",
    d: "M287.945,245.447c-.673,1.76-5.894,1.4-11.663-.809s-9.9-5.424-9.226-7.182,5.894-1.4,11.663.811S288.617,243.689,287.945,245.447Z",
    transform: "translate(-266.114 -236.341)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73705",
    "data-name": "Path 73705",
    d: "M271.954,236.912s-4.422-.309-4.323,1.088,6.559,5.2,6.865,5.175c0,0-6.471-3.795-6.433-5.1S271.954,236.912,271.954,236.912Z",
    transform: "translate(-266.249 -236.455)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41318",
    "data-name": "Group 41318",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73706",
    "data-name": "Path 73706",
    d: "M290.976,245.928c.672-1.757-3.457-4.975-9.226-7.181-.1-.038-.2-.07-.295-.108a66.407,66.407,0,0,1,4.9,8.3C288.835,247.222,290.6,246.9,290.976,245.928Z",
    transform: "translate(-281.455 -238.64)",
    fill: "#ffee2f"
  })))), _g206 || (_g206 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41323",
    "data-name": "Group 41323",
    transform: "translate(123.333 113.861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41321",
    "data-name": "Group 41321",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_319",
    "data-name": "Line 319",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41320",
    "data-name": "Group 41320",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73707",
    "data-name": "Path 73707",
    d: "M246.6,239.013l15.535,1.974,3.327.421-.307,2.414c-.238,1.867-5.4,2.753-11.524,1.974s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-242.954 -238.592)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73708",
    "data-name": "Path 73708",
    d: "M243.35,237.994c-.236,1.867,4.538,4.013,10.665,4.791s11.287-.107,11.524-1.974S261,236.8,254.874,236.018,243.588,236.125,243.35,237.994Z",
    transform: "translate(-243.035 -235.736)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73709",
    "data-name": "Path 73709",
    d: "M265.121,238.579s4.045,1.814,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.29,8.077-1.459S265.121,238.579,265.121,238.579Z",
    transform: "translate(-246.508 -236.331)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41322",
    "data-name": "Group 41322",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73710",
    "data-name": "Path 73710",
    d: "M243.35,237.994c.238-1.869,5.4-2.753,11.524-1.976l.311.045a66.229,66.229,0,0,0-8.239,5.007C244.627,240.146,243.219,239.026,243.35,237.994Z",
    transform: "translate(-243.341 -235.736)",
    fill: "#ffee2f"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_41325",
    "data-name": "Group 41325",
    transform: "translate(21.302 0)"
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73711",
    "data-name": "Path 73711",
    d: "M113.892,122.916l10.282.867,62.543,69.939-9.17-.977Z",
    transform: "translate(-113.892 -98.246)",
    fill: "#f9d14e"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73712",
    "data-name": "Path 73712",
    d: "M330.453,101.225,146.508,92.466,119.06,114.441,293.8,132.724Z",
    transform: "translate(-114.974 -91.868)",
    fill: "#c9853a"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73713",
    "data-name": "Path 73713",
    d: "M254.394,100.915s-31.059-3.368-35.676-2.683-6.677-1.436-6.677-1.436",
    transform: "translate(-134.449 -92.775)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73714",
    "data-name": "Path 73714",
    d: "M340.828,137.383s-24.975-3.578-26.9-2.279",
    transform: "translate(-155.789 -100.739)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73715",
    "data-name": "Path 73715",
    d: "M310.7,112.923s-3.733.208-4.48-.493",
    transform: "translate(-154.174 -96.05)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73716",
    "data-name": "Path 73716",
    d: "M283.129,112.975l-9.234-2.251s-10.2-.984-10.823-.915",
    transform: "translate(-145.137 -95.5)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73717",
    "data-name": "Path 73717",
    d: "M288.01,123.4s-15.1,8.028-17.23,6.763",
    transform: "translate(-146.751 -98.348)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73718",
    "data-name": "Path 73718",
    d: "M168.992,114.844s-17.555,4.931-19.784,3.35-4.922-5.22-6.368-5.3",
    transform: "translate(-119.955 -96.146)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73719",
    "data-name": "Path 73719",
    d: "M173.257,99.864A14.088,14.088,0,0,1,163.2,98.119",
    transform: "translate(-124.219 -93.052)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73720",
    "data-name": "Path 73720",
    d: "M224.081,107.744a69.511,69.511,0,0,0-7.2-1c-1.308.073-11.017.259-12.542.085",
    transform: "translate(-132.836 -94.858)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73721",
    "data-name": "Path 73721",
    d: "M199.99,122.35s8.264-.422,11.224.744a12.366,12.366,0,0,0,5.23.945",
    transform: "translate(-131.925 -98.112)",
    fill: "none",
    stroke: "#866148",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.709,
    opacity: 0.6
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    id: "Line_320",
    "data-name": "Line 320",
    x1: 177.945,
    y1: 13.462,
    transform: "translate(15.879 12.384)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    id: "Line_321",
    "data-name": "Line 321",
    x2: 180.901,
    y2: 10.324,
    transform: "translate(26.958 3.514)",
    fill: "none",
    stroke: "#866148",
    strokeWidth: 0.945
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73722",
    "data-name": "Path 73722",
    d: "M330.383,100.676c-5.007-.31-10.6-1.364-15.253,1.127a51,51,0,0,0-8.834,5.859,80.811,80.811,0,0,0-7.408,7.679,72.947,72.947,0,0,0-5.317,6.638c-.666.931-1.364,1.843-1.991,2.8l-163.6-13.868c14.953-17.769,29.12-18.334,29.12-18.334l.811.054a1.193,1.193,0,0,0-.767-.353c-1.641-.119-4.6-.3-9.661-.545-17.745-.863-33.588,24.649-33.588,24.649l185.642,19.254c3.61-4.285,6.435-8.5,10.046-12.783,4.049-4.8,8.266-9.4,12.677-13.875,4.881-4.951,9.987-8.436,16.912-5.136-.2-.178-.544-.719-.914-1.055C336.071,100.808,333.14,100.846,330.383,100.676Z",
    transform: "translate(-113.892 -91.71)",
    fill: "#f9d14e"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41324",
    "data-name": "Group 41324",
    transform: "translate(0)",
    opacity: 0.7,
    style: {
      mixBlendMode: "screen",
      isolation: "isolate"
    }
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73723",
    "data-name": "Path 73723",
    d: "M127.977,110.91c14.953-17.769,29.12-18.334,29.12-18.334l.811.054a1.193,1.193,0,0,0-.767-.353c-1.641-.119-4.6-.3-9.661-.545-17.745-.863-33.588,24.649-33.588,24.649l31.922,3.311a84.045,84.045,0,0,0,10.127-6.411Z",
    transform: "translate(-113.892 -91.71)",
    fill: "#f9d14e"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73724",
    "data-name": "Path 73724",
    d: "M377.759,102.922c-5.008-.31-10.6-1.364-15.253,1.127a50.955,50.955,0,0,0-8.834,5.859,80.821,80.821,0,0,0-7.408,7.679,72.963,72.963,0,0,0-5.316,6.638c-.282.394-.57.785-.856,1.178,5.261-1.307,16.682-4.347,21.522-5.641q3.908-4.357,8.02-8.539c4.881-4.95,9.987-8.436,16.912-5.136-.2-.178-.544-.72-.914-1.055C383.447,103.055,380.516,103.093,377.759,102.922Z",
    transform: "translate(-161.268 -93.956)",
    fill: "#f9d14e"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73725",
    "data-name": "Path 73725",
    d: "M356.853,122.916S345.9,133.792,344.4,136.531s-2.49,2.738-4.731,2.738-16.682-1.245-16.682-1.245,15.81-.062,16.463-.156S351.656,126.73,356.853,122.916Z",
    transform: "translate(-157.687 -98.246)",
    fill: "#fff"
  }))), _g207 || (_g207 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41329",
    "data-name": "Group 41329",
    transform: "translate(132.506 107.222)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41327",
    "data-name": "Group 41327",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_322",
    "data-name": "Line 322",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41326",
    "data-name": "Group 41326",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73726",
    "data-name": "Path 73726",
    d: "M258.2,230.615l15.536,1.974,3.327.421-.307,2.414c-.238,1.867-5.4,2.751-11.525,1.974s-10.9-2.924-10.664-4.792l.306-2.413Z",
    transform: "translate(-254.557 -230.194)",
    fill: "url(#radial-gradient-72)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73727",
    "data-name": "Path 73727",
    d: "M254.953,229.6c-.236,1.867,4.539,4.014,10.665,4.792s11.287-.108,11.526-1.976-4.539-4.014-10.666-4.792S255.192,227.727,254.953,229.6Z",
    transform: "translate(-254.638 -227.338)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73728",
    "data-name": "Path 73728",
    d: "M276.726,230.181s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.078-1.46S276.726,230.181,276.726,230.181Z",
    transform: "translate(-258.112 -227.934)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41328",
    "data-name": "Group 41328",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73729",
    "data-name": "Path 73729",
    d: "M254.953,229.6c.239-1.869,5.4-2.754,11.524-1.975.105.013.206.03.311.044a66.3,66.3,0,0,0-8.24,5.007C256.23,231.748,254.822,230.629,254.953,229.6Z",
    transform: "translate(-254.945 -227.338)",
    fill: "#ffdf2f"
  })))), _g208 || (_g208 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41333",
    "data-name": "Group 41333",
    transform: "translate(110.964 118.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41331",
    "data-name": "Group 41331",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_323",
    "data-name": "Line 323",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41330",
    "data-name": "Group 41330",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73730",
    "data-name": "Path 73730",
    d: "M246.007,249.724l-14.627-5.6-3.131-1.2-.87,2.273c-.674,1.76,3.457,4.974,9.227,7.181s10.99,2.569,11.662.81l.869-2.272Z",
    transform: "translate(-227.308 -242.929)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73731",
    "data-name": "Path 73731",
    d: "M249.368,250.627c-.673,1.758-5.894,1.4-11.662-.81s-9.9-5.423-9.226-7.182,5.894-1.4,11.662.812S250.041,248.868,249.368,250.627Z",
    transform: "translate(-227.538 -241.521)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73732",
    "data-name": "Path 73732",
    d: "M233.378,242.093s-4.423-.31-4.323,1.086,6.559,5.2,6.864,5.176c0,0-6.471-3.795-6.432-5.1S233.378,242.093,233.378,242.093Z",
    transform: "translate(-227.674 -241.635)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41332",
    "data-name": "Group 41332",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73733",
    "data-name": "Path 73733",
    d: "M252.4,251.108c.673-1.758-3.456-4.974-9.226-7.181-.1-.038-.2-.071-.295-.107a66.3,66.3,0,0,1,4.9,8.3C250.258,252.4,252.026,252.081,252.4,251.108Z",
    transform: "translate(-242.878 -243.82)",
    fill: "#ffee2f"
  })))), _g209 || (_g209 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41337",
    "data-name": "Group 41337",
    transform: "translate(92.837 117.955)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41335",
    "data-name": "Group 41335",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_324",
    "data-name": "Line 324",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41334",
    "data-name": "Group 41334",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73734",
    "data-name": "Path 73734",
    d: "M208.019,244.193l15.536,1.974,3.327.42L226.574,249c-.238,1.868-5.4,2.753-11.525,1.975s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-204.378 -243.771)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73735",
    "data-name": "Path 73735",
    d: "M204.774,243.173c-.236,1.868,4.538,4.014,10.665,4.793s11.287-.108,11.524-1.977-4.538-4.011-10.665-4.791S205.012,241.3,204.774,243.173Z",
    transform: "translate(-204.459 -240.915)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73736",
    "data-name": "Path 73736",
    d: "M226.545,243.759s4.045,1.814,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.46S226.545,243.759,226.545,243.759Z",
    transform: "translate(-207.932 -241.511)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41336",
    "data-name": "Group 41336",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73737",
    "data-name": "Path 73737",
    d: "M204.774,243.173c.238-1.868,5.4-2.754,11.523-1.975.105.013.207.031.311.045a66.383,66.383,0,0,0-8.24,5.007C206.051,245.326,204.643,244.207,204.774,243.173Z",
    transform: "translate(-204.765 -240.915)",
    fill: "#ffee2f"
  })))), _g210 || (_g210 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41341",
    "data-name": "Group 41341",
    transform: "translate(102.01 111.317)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41339",
    "data-name": "Group 41339",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_325",
    "data-name": "Line 325",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41338",
    "data-name": "Group 41338",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73738",
    "data-name": "Path 73738",
    d: "M219.622,235.8l15.536,1.973,3.327.421-.307,2.414c-.238,1.867-5.4,2.751-11.526,1.973s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-215.981 -235.373)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73739",
    "data-name": "Path 73739",
    d: "M216.377,234.775c-.236,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.525-1.975-4.538-4.014-10.665-4.791S216.615,232.908,216.377,234.775Z",
    transform: "translate(-216.062 -232.518)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73740",
    "data-name": "Path 73740",
    d: "M238.149,235.361s4.046,1.815,3.3,3-8.234,1.482-8.495,1.322c0,0,7.5-.291,8.079-1.459S238.149,235.361,238.149,235.361Z",
    transform: "translate(-219.535 -233.114)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41340",
    "data-name": "Group 41340",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73741",
    "data-name": "Path 73741",
    d: "M216.377,234.775c.238-1.867,5.4-2.754,11.524-1.973.1.012.206.029.311.044a66.367,66.367,0,0,0-8.239,5.006C217.653,236.927,216.245,235.809,216.377,234.775Z",
    transform: "translate(-216.368 -232.518)",
    fill: "#ffdf2f"
  })))), _g211 || (_g211 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41345",
    "data-name": "Group 41345",
    transform: "translate(114.63 107.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41343",
    "data-name": "Group 41343",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_326",
    "data-name": "Line 326",
    x1: 0.87,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41342",
    "data-name": "Group 41342",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73742",
    "data-name": "Path 73742",
    d: "M250.644,236.028l-14.627-5.595-3.131-1.2-.87,2.273c-.674,1.758,3.458,4.974,9.227,7.181s10.989,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-231.945 -229.234)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73743",
    "data-name": "Path 73743",
    d: "M254.007,236.931c-.674,1.759-5.9,1.4-11.664-.81s-9.9-5.424-9.226-7.182,5.894-1.4,11.663.811S254.679,235.172,254.007,236.931Z",
    transform: "translate(-232.175 -227.825)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73744",
    "data-name": "Path 73744",
    d: "M238.015,228.4s-4.422-.309-4.323,1.088,6.559,5.195,6.864,5.177c0,0-6.47-3.8-6.431-5.1S238.015,228.4,238.015,228.4Z",
    transform: "translate(-232.311 -227.939)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41344",
    "data-name": "Group 41344",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73745",
    "data-name": "Path 73745",
    d: "M257.037,237.412c.672-1.759-3.458-4.975-9.227-7.181-.1-.038-.2-.07-.3-.108a66.251,66.251,0,0,1,4.9,8.3C254.895,238.706,256.664,238.385,257.037,237.412Z",
    transform: "translate(-247.515 -230.124)",
    fill: "#ffee2f"
  })))), _g212 || (_g212 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41349",
    "data-name": "Group 41349",
    transform: "translate(96.502 107.129)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41347",
    "data-name": "Group 41347",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_327",
    "data-name": "Line 327",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41346",
    "data-name": "Group 41346",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73746",
    "data-name": "Path 73746",
    d: "M212.656,230.5l15.536,1.973,3.326.421-.307,2.413c-.238,1.869-5.4,2.753-11.525,1.974s-10.9-2.922-10.663-4.791l.306-2.414Z",
    transform: "translate(-209.015 -230.075)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73747",
    "data-name": "Path 73747",
    d: "M209.411,229.477c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.107,11.524-1.975-4.538-4.014-10.665-4.792S209.649,227.609,209.411,229.477Z",
    transform: "translate(-209.096 -227.22)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73748",
    "data-name": "Path 73748",
    d: "M231.183,230.063s4.044,1.815,3.3,3-8.234,1.482-8.494,1.322c0,0,7.5-.291,8.078-1.459S231.183,230.063,231.183,230.063Z",
    transform: "translate(-212.569 -227.816)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41348",
    "data-name": "Group 41348",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73749",
    "data-name": "Path 73749",
    d: "M209.411,229.477c.239-1.868,5.4-2.753,11.524-1.974.105.013.206.031.311.044a66.324,66.324,0,0,0-8.239,5.007C210.688,231.629,209.28,230.51,209.411,229.477Z",
    transform: "translate(-209.402 -227.22)",
    fill: "#ffee2f"
  })))), _g213 || (_g213 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41353",
    "data-name": "Group 41353",
    transform: "translate(105.675 100.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41351",
    "data-name": "Group 41351",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_328",
    "data-name": "Line 328",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41350",
    "data-name": "Group 41350",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73750",
    "data-name": "Path 73750",
    d: "M224.259,222.1l15.537,1.972,3.327.422-.307,2.414c-.239,1.867-5.4,2.751-11.526,1.974s-10.9-2.924-10.664-4.793l.307-2.413Z",
    transform: "translate(-220.618 -221.677)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73751",
    "data-name": "Path 73751",
    d: "M221.015,221.079c-.237,1.868,4.538,4.015,10.664,4.792s11.288-.108,11.526-1.975-4.539-4.014-10.666-4.791S221.253,219.211,221.015,221.079Z",
    transform: "translate(-220.7 -218.823)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73752",
    "data-name": "Path 73752",
    d: "M242.787,221.664s4.045,1.817,3.3,3-8.234,1.484-8.495,1.322c0,0,7.5-.29,8.078-1.459S242.787,221.664,242.787,221.664Z",
    transform: "translate(-224.173 -219.418)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41352",
    "data-name": "Group 41352",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73753",
    "data-name": "Path 73753",
    d: "M221.015,221.079c.238-1.868,5.4-2.753,11.523-1.973.105.013.206.029.311.043a66.235,66.235,0,0,0-8.24,5.007C222.292,223.231,220.884,222.114,221.015,221.079Z",
    transform: "translate(-221.006 -218.823)",
    fill: "#ffdf2f"
  })))), _g214 || (_g214 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41357",
    "data-name": "Group 41357",
    transform: "translate(133.2 130.592)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41355",
    "data-name": "Group 41355",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_329",
    "data-name": "Line 329",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41354",
    "data-name": "Group 41354",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73754",
    "data-name": "Path 73754",
    d: "M259.076,260.178l15.536,1.972,3.327.422-.307,2.414c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-255.435 -259.755)",
    fill: "url(#radial-gradient-34)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73755",
    "data-name": "Path 73755",
    d: "M255.832,259.157c-.237,1.868,4.537,4.015,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.013-10.665-4.791S256.069,257.289,255.832,259.157Z",
    transform: "translate(-255.517 -256.9)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73756",
    "data-name": "Path 73756",
    d: "M277.6,259.743s4.045,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.292,8.078-1.46S277.6,259.743,277.6,259.743Z",
    transform: "translate(-258.99 -257.495)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41356",
    "data-name": "Group 41356",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73757",
    "data-name": "Path 73757",
    d: "M255.832,259.157c.237-1.868,5.4-2.753,11.523-1.974.105.013.206.03.311.043a66.449,66.449,0,0,0-8.24,5.007C257.108,261.309,255.7,260.191,255.832,259.157Z",
    transform: "translate(-255.823 -256.9)",
    fill: "#ffdf2f"
  })))), _g215 || (_g215 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41361",
    "data-name": "Group 41361",
    transform: "translate(112.863 130.977)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41359",
    "data-name": "Group 41359",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_330",
    "data-name": "Line 330",
    x1: 0.869,
    y2: 2.27,
    transform: "translate(20.961 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41358",
    "data-name": "Group 41358",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73758",
    "data-name": "Path 73758",
    d: "M248.409,265.589l-14.627-5.595-3.131-1.2-.869,2.273c-.674,1.758,3.457,4.974,9.227,7.181s10.99,2.569,11.662.81l.87-2.27Z",
    transform: "translate(-229.71 -258.795)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73759",
    "data-name": "Path 73759",
    d: "M251.771,266.493c-.674,1.757-5.9,1.4-11.664-.811s-9.9-5.424-9.226-7.182,5.9-1.4,11.663.812S252.443,264.733,251.771,266.493Z",
    transform: "translate(-229.94 -257.386)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73760",
    "data-name": "Path 73760",
    d: "M235.78,257.957s-4.423-.309-4.323,1.087,6.558,5.2,6.864,5.177c0,0-6.47-3.8-6.43-5.1S235.78,257.957,235.78,257.957Z",
    transform: "translate(-230.076 -257.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41360",
    "data-name": "Group 41360",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73761",
    "data-name": "Path 73761",
    d: "M254.8,266.975c.672-1.761-3.458-4.977-9.227-7.181-.1-.039-.2-.072-.295-.108a66.345,66.345,0,0,1,4.9,8.3C252.66,268.267,254.428,267.946,254.8,266.975Z",
    transform: "translate(-245.28 -259.685)",
    fill: "#ffee2f"
  })))), _g216 || (_g216 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41365",
    "data-name": "Group 41365",
    transform: "translate(94.736 130.498)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41363",
    "data-name": "Group 41363",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_331",
    "data-name": "Line 331",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41362",
    "data-name": "Group 41362",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73762",
    "data-name": "Path 73762",
    d: "M210.421,260.059l15.535,1.972,3.327.422-.307,2.414c-.238,1.867-5.4,2.751-11.525,1.974s-10.9-2.924-10.663-4.792l.307-2.414Z",
    transform: "translate(-206.78 -259.636)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73763",
    "data-name": "Path 73763",
    d: "M207.177,259.038c-.237,1.868,4.537,4.014,10.664,4.792s11.287-.107,11.524-1.975-4.538-4.014-10.665-4.792S207.414,257.171,207.177,259.038Z",
    transform: "translate(-206.862 -256.781)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73764",
    "data-name": "Path 73764",
    d: "M228.948,259.623s4.044,1.817,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.078-1.459S228.948,259.623,228.948,259.623Z",
    transform: "translate(-210.335 -257.376)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41364",
    "data-name": "Group 41364",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73765",
    "data-name": "Path 73765",
    d: "M207.177,259.038c.237-1.867,5.4-2.753,11.523-1.974.105.014.206.03.311.044a66.223,66.223,0,0,0-8.239,5.007C208.453,261.19,207.046,260.071,207.177,259.038Z",
    transform: "translate(-207.168 -256.781)",
    fill: "#ffee2f"
  })))), _g217 || (_g217 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41369",
    "data-name": "Group 41369",
    transform: "translate(103.908 123.859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41367",
    "data-name": "Group 41367",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_332",
    "data-name": "Line 332",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41366",
    "data-name": "Group 41366",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73766",
    "data-name": "Path 73766",
    d: "M222.024,251.66l15.536,1.973,3.327.421-.307,2.415c-.238,1.868-5.4,2.751-11.525,1.973s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-218.383 -251.238)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73767",
    "data-name": "Path 73767",
    d: "M218.779,250.64c-.236,1.869,4.538,4.015,10.665,4.792s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.791S219.018,248.773,218.779,250.64Z",
    transform: "translate(-218.464 -248.383)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73768",
    "data-name": "Path 73768",
    d: "M240.552,251.226s4.044,1.816,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.077-1.459S240.552,251.226,240.552,251.226Z",
    transform: "translate(-221.938 -248.979)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41368",
    "data-name": "Group 41368",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73769",
    "data-name": "Path 73769",
    d: "M218.779,250.64c.239-1.867,5.4-2.753,11.524-1.974.105.013.206.03.311.044a66.338,66.338,0,0,0-8.239,5.007C220.056,252.792,218.648,251.674,218.779,250.64Z",
    transform: "translate(-218.77 -248.383)",
    fill: "#ffdf2f"
  })))), _g218 || (_g218 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41373",
    "data-name": "Group 41373",
    transform: "translate(140.102 126.273)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41371",
    "data-name": "Group 41371",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_333",
    "data-name": "Line 333",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41370",
    "data-name": "Group 41370",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73770",
    "data-name": "Path 73770",
    d: "M282.865,259.639l-14.627-5.595-3.131-1.2-.87,2.273c-.673,1.759,3.458,4.974,9.227,7.181s10.99,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-264.165 -252.845)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73771",
    "data-name": "Path 73771",
    d: "M286.227,260.542c-.674,1.76-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.182,5.9-1.4,11.664.811S286.9,258.784,286.227,260.542Z",
    transform: "translate(-264.396 -251.437)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73772",
    "data-name": "Path 73772",
    d: "M270.236,252.008s-4.423-.308-4.323,1.088,6.558,5.195,6.864,5.176c0,0-6.47-3.8-6.431-5.1S270.236,252.008,270.236,252.008Z",
    transform: "translate(-264.531 -251.55)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41372",
    "data-name": "Group 41372",
    transform: "translate(12.31 1.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73773",
    "data-name": "Path 73773",
    d: "M289.257,261.024c.671-1.757-3.458-4.974-9.226-7.181-.1-.038-.2-.07-.3-.106a66.249,66.249,0,0,1,4.9,8.3C287.116,262.319,288.884,262,289.257,261.024Z",
    transform: "translate(-279.736 -253.737)",
    fill: "#ffee2f"
  })))), _g219 || (_g219 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41377",
    "data-name": "Group 41377",
    transform: "translate(121.975 125.795)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41375",
    "data-name": "Group 41375",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_334",
    "data-name": "Line 334",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41374",
    "data-name": "Group 41374",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73774",
    "data-name": "Path 73774",
    d: "M244.877,254.109l15.536,1.973,3.327.421-.307,2.414c-.237,1.867-5.4,2.752-11.524,1.974s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-241.236 -253.687)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73775",
    "data-name": "Path 73775",
    d: "M241.632,253.089c-.237,1.869,4.537,4.014,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.013-10.665-4.791S241.87,251.222,241.632,253.089Z",
    transform: "translate(-241.317 -250.832)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73776",
    "data-name": "Path 73776",
    d: "M263.4,253.675s4.045,1.815,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.29,8.077-1.459S263.4,253.675,263.4,253.675Z",
    transform: "translate(-244.79 -251.428)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41376",
    "data-name": "Group 41376",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73777",
    "data-name": "Path 73777",
    d: "M241.632,253.089c.238-1.867,5.4-2.753,11.523-1.974.106.013.206.03.312.044a66.19,66.19,0,0,0-8.24,5.007C242.909,255.241,241.5,254.122,241.632,253.089Z",
    transform: "translate(-241.623 -250.832)",
    fill: "#ffee2f"
  })))), _g220 || (_g220 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41381",
    "data-name": "Group 41381",
    transform: "translate(131.148 119.156)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41379",
    "data-name": "Group 41379",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_335",
    "data-name": "Line 335",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41378",
    "data-name": "Group 41378",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73778",
    "data-name": "Path 73778",
    d: "M256.48,245.712l15.537,1.974,3.327.42-.307,2.414c-.239,1.867-5.4,2.752-11.525,1.974s-10.9-2.923-10.663-4.792l.307-2.412Z",
    transform: "translate(-252.839 -245.29)",
    fill: "url(#radial-gradient-45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73779",
    "data-name": "Path 73779",
    d: "M253.236,244.692c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.108,11.525-1.976-4.538-4.014-10.665-4.791S253.473,242.824,253.236,244.692Z",
    transform: "translate(-252.921 -242.434)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73780",
    "data-name": "Path 73780",
    d: "M275.007,245.277s4.045,1.815,3.3,3-8.233,1.484-8.493,1.323c0,0,7.5-.292,8.077-1.459S275.007,245.277,275.007,245.277Z",
    transform: "translate(-256.394 -243.029)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41380",
    "data-name": "Group 41380",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73781",
    "data-name": "Path 73781",
    d: "M253.236,244.692c.237-1.868,5.4-2.754,11.523-1.975.105.013.206.031.311.045a66.173,66.173,0,0,0-8.24,5.006C254.513,246.843,253.1,245.725,253.236,244.692Z",
    transform: "translate(-253.227 -242.434)",
    fill: "#ffdf2f"
  })))), _g221 || (_g221 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41385",
    "data-name": "Group 41385",
    transform: "translate(148.689 128.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41383",
    "data-name": "Group 41383",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_336",
    "data-name": "Line 336",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41382",
    "data-name": "Group 41382",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73782",
    "data-name": "Path 73782",
    d: "M278.668,257.1l15.535,1.973,3.327.421-.306,2.414c-.239,1.869-5.4,2.753-11.526,1.975s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-275.027 -256.675)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73783",
    "data-name": "Path 73783",
    d: "M275.423,256.077c-.237,1.868,4.538,4.014,10.664,4.792s11.288-.107,11.525-1.975-4.538-4.015-10.665-4.792S275.661,254.21,275.423,256.077Z",
    transform: "translate(-275.108 -253.82)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73784",
    "data-name": "Path 73784",
    d: "M297.195,256.664s4.045,1.814,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.077-1.459S297.195,256.664,297.195,256.664Z",
    transform: "translate(-278.582 -254.416)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41384",
    "data-name": "Group 41384",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73785",
    "data-name": "Path 73785",
    d: "M275.423,256.077c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.044a66.328,66.328,0,0,0-8.239,5.007C276.7,258.229,275.292,257.111,275.423,256.077Z",
    transform: "translate(-275.414 -253.82)",
    fill: "#ffee2f"
  })))), _g222 || (_g222 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41389",
    "data-name": "Group 41389",
    transform: "translate(147.2 116.568)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41387",
    "data-name": "Group 41387",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_337",
    "data-name": "Line 337",
    x1: 0.306,
    y2: 2.412,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41386",
    "data-name": "Group 41386",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73786",
    "data-name": "Path 73786",
    d: "M276.785,242.438l15.537,1.973,3.326.421-.307,2.414c-.237,1.867-5.4,2.753-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.412Z",
    transform: "translate(-273.144 -242.016)",
    fill: "url(#radial-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73787",
    "data-name": "Path 73787",
    d: "M273.541,241.418c-.237,1.867,4.538,4.014,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.013-10.665-4.791S273.779,239.55,273.541,241.418Z",
    transform: "translate(-273.226 -239.16)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73788",
    "data-name": "Path 73788",
    d: "M295.312,242s4.045,1.817,3.3,3-8.234,1.484-8.494,1.322c0,0,7.5-.289,8.078-1.459S295.312,242,295.312,242Z",
    transform: "translate(-276.699 -239.756)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41388",
    "data-name": "Group 41388",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73789",
    "data-name": "Path 73789",
    d: "M273.541,241.418c.238-1.868,5.4-2.753,11.523-1.975.105.013.207.03.311.044a66.122,66.122,0,0,0-8.239,5.007C274.818,243.569,273.41,242.451,273.541,241.418Z",
    transform: "translate(-273.532 -239.16)",
    fill: "#ffee2f"
  })))), _g223 || (_g223 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41393",
    "data-name": "Group 41393",
    transform: "translate(166.879 104.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41391",
    "data-name": "Group 41391",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_338",
    "data-name": "Line 338",
    x1: 1.095,
    y2: 2.173,
    transform: "translate(0.118 0.85)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41390",
    "data-name": "Group 41390",
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73790",
    "data-name": "Path 73790",
    d: "M302.244,226.3l13.985,7.05,2.995,1.508-1.1,2.173c-.848,1.681-6.007.791-11.522-1.99s-9.3-6.4-8.45-8.079l1.095-2.173Z",
    transform: "translate(-298.037 -224.792)",
    fill: "url(#radial-gradient-217)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73791",
    "data-name": "Path 73791",
    d: "M299.541,224.567c-.847,1.682,2.936,5.3,8.451,8.079s10.674,3.671,11.522,1.989-2.937-5.3-8.452-8.079S300.39,222.886,299.541,224.567Z",
    transform: "translate(-298.327 -223.717)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73792",
    "data-name": "Path 73792",
    d: "M319.713,232.515s3.206,3.062,2.1,3.927-8.257-1.352-8.448-1.591c0,0,7.162,2.23,8.1,1.323S319.713,232.515,319.713,232.515Z",
    transform: "translate(-301.248 -225.56)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41392",
    "data-name": "Group 41392",
    transform: "translate(1.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73793",
    "data-name": "Path 73793",
    d: "M299.541,224.567c.849-1.681,6.007-.791,11.522,1.989.094.048.185.1.278.146a66.31,66.31,0,0,0-9.439,1.966C300.026,227.022,299.073,225.5,299.541,224.567Z",
    transform: "translate(-299.423 -223.717)",
    fill: "#ffdf2f"
  })))), _g224 || (_g224 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41397",
    "data-name": "Group 41397",
    transform: "translate(137.558 134.033)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41395",
    "data-name": "Group 41395",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_339",
    "data-name": "Line 339",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41394",
    "data-name": "Group 41394",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73794",
    "data-name": "Path 73794",
    d: "M264.588,264.531l15.536,1.973,3.327.421-.307,2.414c-.238,1.869-5.4,2.752-11.525,1.975s-10.9-2.924-10.663-4.792l.307-2.414Z",
    transform: "translate(-260.947 -264.109)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73795",
    "data-name": "Path 73795",
    d: "M261.344,263.511c-.236,1.867,4.537,4.014,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.012-10.665-4.791S261.582,261.643,261.344,263.511Z",
    transform: "translate(-261.029 -261.253)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73796",
    "data-name": "Path 73796",
    d: "M283.115,264.1s4.046,1.814,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.292,8.078-1.461S283.115,264.1,283.115,264.1Z",
    transform: "translate(-264.502 -261.849)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41396",
    "data-name": "Group 41396",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73797",
    "data-name": "Path 73797",
    d: "M261.344,263.511c.238-1.868,5.4-2.754,11.524-1.975.1.013.206.031.311.044a66.377,66.377,0,0,0-8.24,5.007C262.621,265.661,261.212,264.544,261.344,263.511Z",
    transform: "translate(-261.335 -261.253)",
    fill: "#ffee2f"
  })))), _g225 || (_g225 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41401",
    "data-name": "Group 41401",
    transform: "translate(146.731 127.394)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41399",
    "data-name": "Group 41399",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_340",
    "data-name": "Line 340",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41398",
    "data-name": "Group 41398",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73798",
    "data-name": "Path 73798",
    d: "M276.192,256.133l15.535,1.973,3.327.421-.308,2.414c-.238,1.868-5.4,2.753-11.525,1.975s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-272.551 -255.71)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73799",
    "data-name": "Path 73799",
    d: "M272.948,255.112c-.237,1.868,4.537,4.014,10.664,4.792s11.288-.106,11.525-1.974-4.538-4.013-10.665-4.792S273.185,253.245,272.948,255.112Z",
    transform: "translate(-272.633 -252.855)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73800",
    "data-name": "Path 73800",
    d: "M294.719,255.7s4.045,1.815,3.3,3-8.235,1.484-8.5,1.323c0,0,7.5-.29,8.079-1.459S294.719,255.7,294.719,255.7Z",
    transform: "translate(-276.105 -253.45)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41400",
    "data-name": "Group 41400",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73801",
    "data-name": "Path 73801",
    d: "M272.948,255.112c.237-1.867,5.4-2.753,11.523-1.974.105.013.206.03.311.045a66.249,66.249,0,0,0-8.239,5.006C274.224,257.264,272.816,256.146,272.948,255.112Z",
    transform: "translate(-272.939 -252.855)",
    fill: "#ffdf2f"
  })))), _g226 || (_g226 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41405",
    "data-name": "Group 41405",
    transform: "translate(150.463 104.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41403",
    "data-name": "Group 41403",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_341",
    "data-name": "Line 341",
    x1: 1.579,
    y2: 1.852,
    transform: "translate(17.304 14.964)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41402",
    "data-name": "Group 41402",
    transform: "translate(0 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73802",
    "data-name": "Path 73802",
    d: "M293.6,236.836l-11.917-10.161-2.55-2.176-1.58,1.853c-1.221,1.432,1.6,5.842,6.3,9.85s9.5,6.093,10.721,4.661l1.579-1.852Z",
    transform: "translate(-277.272 -224.499)",
    fill: "url(#radial-gradient-190)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73803",
    "data-name": "Path 73803",
    d: "M296.573,238.892c-1.222,1.433-6.023-.653-10.722-4.66s-7.518-8.419-6.3-9.853,6.022.655,10.721,4.662S297.794,237.46,296.573,238.892Z",
    transform: "translate(-277.69 -223.928)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73804",
    "data-name": "Path 73804",
    d: "M284.4,225.485s-4.065-1.769-4.438-.42,4.447,7.089,4.741,7.172c0,0-4.83-5.739-4.358-6.955S284.4,225.485,284.4,225.485Z",
    transform: "translate(-277.832 -224.06)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41404",
    "data-name": "Group 41404",
    transform: "translate(12.343 4.913)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73805",
    "data-name": "Path 73805",
    d: "M299.424,240.193c1.221-1.432-1.6-5.844-6.3-9.85-.08-.069-.161-.133-.242-.2a66.327,66.327,0,0,1,1.844,9.464C296.974,240.7,298.749,240.986,299.424,240.193Z",
    transform: "translate(-292.885 -230.143)",
    fill: "#ffee2f"
  })))), _g227 || (_g227 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41409",
    "data-name": "Group 41409",
    transform: "translate(123.013 107.108)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41407",
    "data-name": "Group 41407",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_342",
    "data-name": "Line 342",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41406",
    "data-name": "Group 41406",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73806",
    "data-name": "Path 73806",
    d: "M246.19,230.472l15.535,1.973,3.327.421-.308,2.414c-.237,1.868-5.4,2.753-11.525,1.974s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-242.549 -230.05)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73807",
    "data-name": "Path 73807",
    d: "M242.946,229.452c-.236,1.867,4.537,4.013,10.664,4.792s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.791S243.184,227.584,242.946,229.452Z",
    transform: "translate(-242.63 -227.194)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73808",
    "data-name": "Path 73808",
    d: "M264.717,230.037s4.045,1.814,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.459S264.717,230.037,264.717,230.037Z",
    transform: "translate(-246.103 -227.789)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41408",
    "data-name": "Group 41408",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73809",
    "data-name": "Path 73809",
    d: "M242.946,229.452c.238-1.868,5.4-2.754,11.523-1.975.105.013.206.03.311.044a66.383,66.383,0,0,0-8.239,5.007C244.222,231.6,242.814,230.485,242.946,229.452Z",
    transform: "translate(-242.937 -227.194)",
    fill: "#ffee2f"
  })))), _g228 || (_g228 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41413",
    "data-name": "Group 41413",
    transform: "translate(144.079 95.297)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41411",
    "data-name": "Group 41411",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_343",
    "data-name": "Line 343",
    x1: 1.095,
    y2: 2.172,
    transform: "translate(0.119 0.85)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41410",
    "data-name": "Group 41410",
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73810",
    "data-name": "Path 73810",
    d: "M273.4,214.839l13.984,7.05,2.994,1.508-1.095,2.172c-.848,1.681-6.006.791-11.522-1.991s-9.3-6.4-8.449-8.078l1.095-2.172Z",
    transform: "translate(-269.197 -213.329)",
    fill: "url(#radial-gradient-217)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73811",
    "data-name": "Path 73811",
    d: "M270.7,213.1c-.848,1.682,2.935,5.3,8.45,8.079s10.674,3.671,11.522,1.989-2.935-5.3-8.451-8.079S271.549,211.423,270.7,213.1Z",
    transform: "translate(-269.487 -212.254)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73812",
    "data-name": "Path 73812",
    d: "M290.872,221.05s3.206,3.063,2.1,3.928-8.256-1.353-8.448-1.592c0,0,7.162,2.231,8.1,1.324S290.872,221.05,290.872,221.05Z",
    transform: "translate(-272.408 -214.096)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41412",
    "data-name": "Group 41412",
    transform: "translate(1.095)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73813",
    "data-name": "Path 73813",
    d: "M270.7,213.1c.848-1.681,6.006-.791,11.521,1.99.095.047.184.1.278.145a66.243,66.243,0,0,0-9.439,1.967C271.184,215.559,270.231,214.035,270.7,213.1Z",
    transform: "translate(-270.582 -212.254)",
    fill: "#ffdf2f"
  })))), _g229 || (_g229 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41417",
    "data-name": "Group 41417",
    transform: "translate(136.497 106.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41415",
    "data-name": "Group 41415",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_344",
    "data-name": "Line 344",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41414",
    "data-name": "Group 41414",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73814",
    "data-name": "Path 73814",
    d: "M278.305,234.1,263.679,228.5l-3.131-1.2-.87,2.272c-.673,1.759,3.459,4.974,9.227,7.182s10.99,2.568,11.662.81l.87-2.272Z",
    transform: "translate(-259.606 -227.305)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73815",
    "data-name": "Path 73815",
    d: "M281.667,235c-.673,1.758-5.9,1.4-11.664-.81s-9.9-5.423-9.225-7.181,5.894-1.4,11.663.812S282.34,233.243,281.667,235Z",
    transform: "translate(-259.836 -225.897)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73816",
    "data-name": "Path 73816",
    d: "M265.677,226.467s-4.422-.309-4.322,1.088,6.558,5.195,6.864,5.176c0,0-6.471-3.8-6.432-5.1S265.677,226.467,265.677,226.467Z",
    transform: "translate(-259.972 -226.01)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41416",
    "data-name": "Group 41416",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73817",
    "data-name": "Path 73817",
    d: "M284.7,235.483c.673-1.759-3.458-4.974-9.226-7.18-.1-.038-.2-.072-.295-.108a66.314,66.314,0,0,1,4.9,8.3C282.556,236.777,284.325,236.456,284.7,235.483Z",
    transform: "translate(-275.177 -228.195)",
    fill: "#ffee2f"
  })))), _g230 || (_g230 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41421",
    "data-name": "Group 41421",
    transform: "translate(118.37 105.604)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41419",
    "data-name": "Group 41419",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_345",
    "data-name": "Line 345",
    x1: 0.307,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41418",
    "data-name": "Group 41418",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73818",
    "data-name": "Path 73818",
    d: "M240.317,228.568l15.536,1.973,3.326.421-.307,2.414c-.237,1.869-5.4,2.753-11.524,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-236.676 -228.147)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73819",
    "data-name": "Path 73819",
    d: "M237.073,227.549c-.237,1.867,4.537,4.014,10.665,4.792s11.286-.107,11.523-1.976-4.538-4.013-10.665-4.791S237.311,225.68,237.073,227.549Z",
    transform: "translate(-236.758 -225.291)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73820",
    "data-name": "Path 73820",
    d: "M258.844,228.134s4.045,1.815,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.29,8.078-1.46S258.844,228.134,258.844,228.134Z",
    transform: "translate(-240.231 -225.887)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41420",
    "data-name": "Group 41420",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73821",
    "data-name": "Path 73821",
    d: "M237.073,227.549c.238-1.869,5.4-2.754,11.523-1.975.105.013.206.03.311.044a66.325,66.325,0,0,0-8.24,5.007C238.35,229.7,236.941,228.581,237.073,227.549Z",
    transform: "translate(-237.064 -225.291)",
    fill: "#ffee2f"
  })))), _g231 || (_g231 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41425",
    "data-name": "Group 41425",
    transform: "translate(96.427 93.346)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41423",
    "data-name": "Group 41423",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_346",
    "data-name": "Line 346",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41422",
    "data-name": "Group 41422",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73822",
    "data-name": "Path 73822",
    d: "M212.561,213.063l15.536,1.974,3.327.421-.307,2.414c-.238,1.868-5.4,2.752-11.526,1.975s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-208.92 -212.641)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73823",
    "data-name": "Path 73823",
    d: "M209.316,212.043c-.237,1.868,4.538,4.014,10.664,4.792s11.288-.108,11.526-1.975-4.538-4.014-10.665-4.792S209.554,210.175,209.316,212.043Z",
    transform: "translate(-209.001 -209.786)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73824",
    "data-name": "Path 73824",
    d: "M231.088,212.628s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.291,8.077-1.459S231.088,212.628,231.088,212.628Z",
    transform: "translate(-212.475 -210.381)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41424",
    "data-name": "Group 41424",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73825",
    "data-name": "Path 73825",
    d: "M209.316,212.043c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.03.311.044a66.228,66.228,0,0,0-8.239,5.007C210.592,214.195,209.185,213.076,209.316,212.043Z",
    transform: "translate(-209.307 -209.786)",
    fill: "#ffdf2f"
  })))), _g232 || (_g232 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41429",
    "data-name": "Group 41429",
    transform: "translate(120.961 95.672)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41427",
    "data-name": "Group 41427",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_347",
    "data-name": "Line 347",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41426",
    "data-name": "Group 41426",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73826",
    "data-name": "Path 73826",
    d: "M243.594,216.005l15.535,1.974,3.326.421-.306,2.414c-.238,1.869-5.4,2.754-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-239.953 -215.583)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73827",
    "data-name": "Path 73827",
    d: "M240.349,214.985c-.237,1.868,4.537,4.014,10.665,4.792s11.288-.107,11.523-1.976-4.537-4.013-10.664-4.791S240.587,213.117,240.349,214.985Z",
    transform: "translate(-240.034 -212.728)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73828",
    "data-name": "Path 73828",
    d: "M262.121,215.571s4.045,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.291,8.077-1.459S262.121,215.571,262.121,215.571Z",
    transform: "translate(-243.507 -213.323)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41428",
    "data-name": "Group 41428",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73829",
    "data-name": "Path 73829",
    d: "M240.349,214.985c.238-1.868,5.4-2.754,11.524-1.974.105.013.206.03.311.044a66.4,66.4,0,0,0-8.239,5.006C241.626,217.138,240.218,216.018,240.349,214.985Z",
    transform: "translate(-240.34 -212.728)",
    fill: "#ffee2f"
  })))), _g233 || (_g233 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41433",
    "data-name": "Group 41433",
    transform: "translate(143.455 122.599)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41431",
    "data-name": "Group 41431",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_348",
    "data-name": "Line 348",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41430",
    "data-name": "Group 41430",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73830",
    "data-name": "Path 73830",
    d: "M272.047,250.066l15.536,1.973,3.327.421-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-268.406 -249.644)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73831",
    "data-name": "Path 73831",
    d: "M268.8,249.046c-.236,1.869,4.538,4.014,10.665,4.792s11.287-.108,11.525-1.976-4.539-4.013-10.665-4.791S269.042,247.179,268.8,249.046Z",
    transform: "translate(-268.488 -246.789)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73832",
    "data-name": "Path 73832",
    d: "M290.575,249.632s4.045,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.292,8.077-1.46S290.575,249.632,290.575,249.632Z",
    transform: "translate(-271.961 -247.385)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41432",
    "data-name": "Group 41432",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73833",
    "data-name": "Path 73833",
    d: "M268.8,249.046c.239-1.867,5.4-2.753,11.524-1.974.1.013.207.03.311.043a66.442,66.442,0,0,0-8.239,5.007C270.08,251.2,268.672,250.079,268.8,249.046Z",
    transform: "translate(-268.794 -246.789)",
    fill: "#ffee2f"
  })))), _g234 || (_g234 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41437",
    "data-name": "Group 41437",
    transform: "translate(152.628 115.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41435",
    "data-name": "Group 41435",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_349",
    "data-name": "Line 349",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41434",
    "data-name": "Group 41434",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73834",
    "data-name": "Path 73834",
    d: "M283.651,241.669l15.536,1.972,3.327.421-.307,2.414c-.239,1.869-5.4,2.752-11.526,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-280.01 -241.245)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73835",
    "data-name": "Path 73835",
    d: "M280.407,240.647c-.237,1.869,4.537,4.015,10.664,4.792s11.288-.107,11.526-1.975-4.539-4.014-10.666-4.791S280.644,238.78,280.407,240.647Z",
    transform: "translate(-280.092 -238.391)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73836",
    "data-name": "Path 73836",
    d: "M302.179,241.233s4.044,1.816,3.3,3-8.234,1.483-8.495,1.322c0,0,7.5-.291,8.078-1.459S302.179,241.233,302.179,241.233Z",
    transform: "translate(-283.565 -238.986)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41436",
    "data-name": "Group 41436",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73837",
    "data-name": "Path 73837",
    d: "M280.407,240.647c.237-1.867,5.4-2.753,11.523-1.973.105.013.206.03.311.045A66.155,66.155,0,0,0,284,243.724C281.683,242.8,280.276,241.681,280.407,240.647Z",
    transform: "translate(-280.398 -238.391)",
    fill: "#ffdf2f"
  })))), _g235 || (_g235 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41441",
    "data-name": "Group 41441",
    transform: "translate(170.456 108.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41439",
    "data-name": "Group 41439",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_350",
    "data-name": "Line 350",
    x1: 1.579,
    y2: 1.85,
    transform: "translate(17.304 14.965)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41438",
    "data-name": "Group 41438",
    transform: "translate(0 0.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73838",
    "data-name": "Path 73838",
    d: "M318.892,241.281l-11.917-10.16-2.55-2.177-1.579,1.852c-1.222,1.433,1.6,5.845,6.3,9.851s9.5,6.092,10.721,4.66l1.579-1.851Z",
    transform: "translate(-302.561 -228.944)",
    fill: "url(#radial-gradient-193)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73839",
    "data-name": "Path 73839",
    d: "M321.862,243.337c-1.222,1.432-6.023-.654-10.723-4.661s-7.517-8.419-6.3-9.852,6.022.655,10.722,4.663S323.083,241.9,321.862,243.337Z",
    transform: "translate(-302.98 -228.373)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73840",
    "data-name": "Path 73840",
    d: "M309.7,229.931s-4.066-1.77-4.437-.421S309.7,236.6,310,236.683c0,0-4.83-5.739-4.358-6.956S309.7,229.931,309.7,229.931Z",
    transform: "translate(-303.122 -228.505)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41440",
    "data-name": "Group 41440",
    transform: "translate(12.343 4.912)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73841",
    "data-name": "Path 73841",
    d: "M324.714,244.639c1.221-1.433-1.6-5.845-6.3-9.85-.081-.07-.162-.133-.243-.2a66.343,66.343,0,0,1,1.844,9.464C322.263,245.142,324.038,245.431,324.714,244.639Z",
    transform: "translate(-318.174 -234.587)",
    fill: "#ffee2f"
  })))), _g236 || (_g236 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41445",
    "data-name": "Group 41445",
    transform: "translate(147.037 99.996)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41443",
    "data-name": "Group 41443",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_351",
    "data-name": "Line 351",
    x1: 1.095,
    y2: 2.172,
    transform: "translate(0.119 0.85)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41442",
    "data-name": "Group 41442",
    transform: "translate(0 0.85)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73842",
    "data-name": "Path 73842",
    d: "M277.145,220.784l13.983,7.049,2.995,1.508-1.1,2.173c-.847,1.681-6,.791-11.522-1.99s-9.3-6.4-8.449-8.079l1.095-2.172Z",
    transform: "translate(-272.938 -219.274)",
    fill: "url(#radial-gradient-230)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73843",
    "data-name": "Path 73843",
    d: "M274.442,219.049c-.847,1.681,2.935,5.3,8.45,8.079s10.674,3.669,11.522,1.988-2.936-5.3-8.451-8.079S275.29,217.368,274.442,219.049Z",
    transform: "translate(-273.228 -218.199)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73844",
    "data-name": "Path 73844",
    d: "M294.613,226.995s3.206,3.062,2.1,3.928-8.257-1.353-8.448-1.592c0,0,7.163,2.231,8.1,1.323S294.613,226.995,294.613,226.995Z",
    transform: "translate(-276.149 -220.041)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41444",
    "data-name": "Group 41444",
    transform: "translate(1.096)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73845",
    "data-name": "Path 73845",
    d: "M274.442,219.049c.848-1.681,6.006-.793,11.521,1.989.095.047.183.1.278.145a66.3,66.3,0,0,0-9.439,1.966C274.927,221.5,273.974,219.979,274.442,219.049Z",
    transform: "translate(-274.324 -218.199)",
    fill: "#ffee2f"
  })))), _g237 || (_g237 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41449",
    "data-name": "Group 41449",
    transform: "translate(138.88 124.769)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41447",
    "data-name": "Group 41447",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_352",
    "data-name": "Line 352",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41446",
    "data-name": "Group 41446",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73846",
    "data-name": "Path 73846",
    d: "M266.26,252.811l15.536,1.974,3.326.421-.307,2.414c-.237,1.867-5.4,2.751-11.524,1.974s-10.9-2.923-10.664-4.792l.307-2.413Z",
    transform: "translate(-262.619 -252.39)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73847",
    "data-name": "Path 73847",
    d: "M263.016,251.792c-.236,1.869,4.537,4.014,10.665,4.792s11.287-.108,11.523-1.976-4.537-4.014-10.665-4.791S263.254,249.924,263.016,251.792Z",
    transform: "translate(-262.701 -249.534)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73848",
    "data-name": "Path 73848",
    d: "M284.787,252.377s4.045,1.815,3.3,3-8.235,1.483-8.5,1.322c0,0,7.5-.291,8.078-1.46S284.787,252.377,284.787,252.377Z",
    transform: "translate(-266.174 -250.129)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41448",
    "data-name": "Group 41448",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73849",
    "data-name": "Path 73849",
    d: "M263.016,251.792c.238-1.868,5.4-2.755,11.523-1.974.105.013.207.03.311.043a66.378,66.378,0,0,0-8.24,5.007C264.293,253.944,262.885,252.825,263.016,251.792Z",
    transform: "translate(-263.007 -249.534)",
    fill: "#ffee2f"
  })))), _g238 || (_g238 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41453",
    "data-name": "Group 41453",
    transform: "translate(148.053 118.13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41451",
    "data-name": "Group 41451",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_353",
    "data-name": "Line 353",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41450",
    "data-name": "Group 41450",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73850",
    "data-name": "Path 73850",
    d: "M277.864,244.414l15.535,1.973,3.327.421-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.414Z",
    transform: "translate(-274.223 -243.991)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73851",
    "data-name": "Path 73851",
    d: "M274.62,243.393c-.236,1.869,4.538,4.015,10.664,4.792s11.288-.107,11.525-1.975-4.538-4.014-10.665-4.791S274.857,241.526,274.62,243.393Z",
    transform: "translate(-274.305 -241.137)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73852",
    "data-name": "Path 73852",
    d: "M296.391,243.979s4.045,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.077-1.459S296.391,243.979,296.391,243.979Z",
    transform: "translate(-277.778 -241.732)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41452",
    "data-name": "Group 41452",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73853",
    "data-name": "Path 73853",
    d: "M274.62,243.393c.237-1.867,5.4-2.753,11.523-1.973.105.013.207.029.311.044a66.27,66.27,0,0,0-8.239,5.006C275.9,245.545,274.488,244.427,274.62,243.393Z",
    transform: "translate(-274.611 -241.137)",
    fill: "#ffdf2f"
  })))), _g239 || (_g239 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41457",
    "data-name": "Group 41457",
    transform: "translate(148.134 134.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41455",
    "data-name": "Group 41455",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_354",
    "data-name": "Line 354",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41454",
    "data-name": "Group 41454",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73854",
    "data-name": "Path 73854",
    d: "M293.026,270.007,278.4,264.412l-3.132-1.2-.87,2.273c-.673,1.758,3.458,4.973,9.227,7.181s10.99,2.569,11.662.81l.869-2.271Z",
    transform: "translate(-274.326 -263.213)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73855",
    "data-name": "Path 73855",
    d: "M296.387,270.911c-.672,1.758-5.894,1.4-11.663-.811s-9.9-5.424-9.226-7.181,5.9-1.395,11.663.812S297.06,269.152,296.387,270.911Z",
    transform: "translate(-274.557 -261.805)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73856",
    "data-name": "Path 73856",
    d: "M280.4,262.376s-4.423-.309-4.322,1.087,6.558,5.2,6.864,5.176c0,0-6.471-3.8-6.432-5.1S280.4,262.376,280.4,262.376Z",
    transform: "translate(-274.692 -261.918)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41456",
    "data-name": "Group 41456",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73857",
    "data-name": "Path 73857",
    d: "M299.418,271.392c.673-1.759-3.457-4.976-9.226-7.181-.1-.039-.2-.071-.295-.108a66.264,66.264,0,0,1,4.9,8.3C297.276,272.685,299.046,272.364,299.418,271.392Z",
    transform: "translate(-289.897 -264.103)",
    fill: "#ffee2f"
  })))), _g240 || (_g240 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41461",
    "data-name": "Group 41461",
    transform: "translate(130.008 133.991)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41459",
    "data-name": "Group 41459",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_355",
    "data-name": "Line 355",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41458",
    "data-name": "Group 41458",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73858",
    "data-name": "Path 73858",
    d: "M255.038,264.476l15.535,1.973,3.327.422-.307,2.414c-.239,1.867-5.4,2.752-11.525,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-251.397 -264.054)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73859",
    "data-name": "Path 73859",
    d: "M251.793,263.456c-.237,1.869,4.538,4.014,10.664,4.792s11.288-.108,11.525-1.975-4.539-4.014-10.665-4.792S252.031,261.589,251.793,263.456Z",
    transform: "translate(-251.478 -261.199)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73860",
    "data-name": "Path 73860",
    d: "M273.564,264.042s4.045,1.816,3.3,3-8.234,1.484-8.493,1.323c0,0,7.5-.291,8.077-1.459S273.564,264.042,273.564,264.042Z",
    transform: "translate(-254.951 -261.795)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41460",
    "data-name": "Group 41460",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73861",
    "data-name": "Path 73861",
    d: "M251.793,263.456c.238-1.867,5.4-2.753,11.523-1.974.105.013.207.03.312.044a66.276,66.276,0,0,0-8.24,5.007C253.07,265.608,251.661,264.49,251.793,263.456Z",
    transform: "translate(-251.784 -261.199)",
    fill: "#ffee2f"
  })))), _g241 || (_g241 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41465",
    "data-name": "Group 41465",
    transform: "translate(139.181 127.352)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41463",
    "data-name": "Group 41463",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_356",
    "data-name": "Line 356",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41462",
    "data-name": "Group 41462",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73862",
    "data-name": "Path 73862",
    d: "M266.641,256.078l15.538,1.974,3.326.421-.307,2.414c-.238,1.869-5.4,2.753-11.526,1.974s-10.9-2.923-10.662-4.792l.306-2.414Z",
    transform: "translate(-263 -255.656)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73863",
    "data-name": "Path 73863",
    d: "M263.4,255.058c-.236,1.869,4.537,4.014,10.665,4.793s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.791S263.634,253.191,263.4,255.058Z",
    transform: "translate(-263.081 -252.801)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73864",
    "data-name": "Path 73864",
    d: "M285.168,255.645s4.045,1.814,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.078-1.459S285.168,255.645,285.168,255.645Z",
    transform: "translate(-266.555 -253.397)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41464",
    "data-name": "Group 41464",
    transform: "translate(0.306 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73865",
    "data-name": "Path 73865",
    d: "M263.4,255.058c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.044a66.265,66.265,0,0,0-8.239,5.007C264.673,257.21,263.265,256.092,263.4,255.058Z",
    transform: "translate(-263.387 -252.801)",
    fill: "#ffdf2f"
  })))), _g242 || (_g242 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41469",
    "data-name": "Group 41469",
    transform: "translate(151.801 123.642)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41467",
    "data-name": "Group 41467",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_357",
    "data-name": "Line 357",
    x1: 0.869,
    y2: 2.271,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41466",
    "data-name": "Group 41466",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73866",
    "data-name": "Path 73866",
    d: "M297.664,256.312l-14.627-5.6-3.131-1.2-.87,2.273c-.674,1.76,3.458,4.974,9.227,7.182s10.99,2.568,11.663.81l.869-2.271Z",
    transform: "translate(-278.964 -249.516)",
    fill: "url(#radial-gradient-236)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73867",
    "data-name": "Path 73867",
    d: "M301.025,257.214c-.673,1.758-5.9,1.4-11.663-.811s-9.9-5.422-9.226-7.182,5.894-1.395,11.663.812S301.7,255.455,301.025,257.214Z",
    transform: "translate(-279.194 -248.108)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73868",
    "data-name": "Path 73868",
    d: "M285.034,248.68s-4.422-.309-4.323,1.087,6.559,5.2,6.865,5.176c0,0-6.471-3.795-6.433-5.1S285.034,248.68,285.034,248.68Z",
    transform: "translate(-279.33 -248.222)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41468",
    "data-name": "Group 41468",
    transform: "translate(12.31 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73869",
    "data-name": "Path 73869",
    d: "M304.056,257.7c.672-1.759-3.457-4.975-9.226-7.181-.1-.038-.2-.07-.295-.108a66.316,66.316,0,0,1,4.9,8.3C301.915,258.99,303.683,258.669,304.056,257.7Z",
    transform: "translate(-294.535 -250.407)",
    fill: "#ffee2f"
  })))), _g243 || (_g243 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41473",
    "data-name": "Group 41473",
    transform: "translate(133.674 123.164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41471",
    "data-name": "Group 41471",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_358",
    "data-name": "Line 358",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41470",
    "data-name": "Group 41470",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73870",
    "data-name": "Path 73870",
    d: "M259.675,250.781l15.536,1.973,3.327.421-.307,2.414c-.237,1.867-5.4,2.752-11.524,1.974s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-256.034 -250.358)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73871",
    "data-name": "Path 73871",
    d: "M256.43,249.76c-.236,1.869,4.539,4.014,10.665,4.792s11.287-.107,11.524-1.976-4.538-4.012-10.665-4.791S256.669,247.893,256.43,249.76Z",
    transform: "translate(-256.115 -247.503)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73872",
    "data-name": "Path 73872",
    d: "M278.2,250.347s4.045,1.814,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.078-1.459S278.2,250.347,278.2,250.347Z",
    transform: "translate(-259.588 -248.099)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41472",
    "data-name": "Group 41472",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73873",
    "data-name": "Path 73873",
    d: "M256.43,249.76c.239-1.867,5.4-2.753,11.523-1.974.105.013.207.03.311.044a66.285,66.285,0,0,0-8.239,5.007C257.707,251.913,256.3,250.794,256.43,249.76Z",
    transform: "translate(-256.421 -247.503)",
    fill: "#ffee2f"
  })))), _g244 || (_g244 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41477",
    "data-name": "Group 41477",
    transform: "translate(142.847 116.524)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41475",
    "data-name": "Group 41475",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_359",
    "data-name": "Line 359",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41474",
    "data-name": "Group 41474",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73874",
    "data-name": "Path 73874",
    d: "M271.278,242.383l15.537,1.974,3.326.421-.306,2.413c-.238,1.869-5.4,2.753-11.526,1.974s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-267.637 -241.961)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73875",
    "data-name": "Path 73875",
    d: "M268.033,241.363c-.236,1.868,4.538,4.014,10.665,4.792s11.288-.108,11.525-1.975-4.539-4.014-10.665-4.792S268.271,239.495,268.033,241.363Z",
    transform: "translate(-267.718 -239.105)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73876",
    "data-name": "Path 73876",
    d: "M289.807,241.949s4.044,1.814,3.3,3-8.234,1.482-8.493,1.322c0,0,7.5-.29,8.077-1.459S289.807,241.949,289.807,241.949Z",
    transform: "translate(-271.192 -239.701)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41476",
    "data-name": "Group 41476",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73877",
    "data-name": "Path 73877",
    d: "M268.033,241.363c.238-1.868,5.4-2.754,11.524-1.975.105.013.206.031.311.045a66.394,66.394,0,0,0-8.24,5C269.31,243.515,267.9,242.4,268.033,241.363Z",
    transform: "translate(-268.024 -239.105)",
    fill: "#ffdf2f"
  })))), _g245 || (_g245 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41481",
    "data-name": "Group 41481",
    transform: "translate(112.599 115.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41479",
    "data-name": "Group 41479",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_360",
    "data-name": "Line 360",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41478",
    "data-name": "Group 41478",
    transform: "translate(0 1.114)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73878",
    "data-name": "Path 73878",
    d: "M248.076,246.329l-14.627-5.595-3.131-1.2-.87,2.273c-.673,1.758,3.458,4.974,9.227,7.181s10.99,2.569,11.663.81l.868-2.272Z",
    transform: "translate(-229.376 -239.535)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73879",
    "data-name": "Path 73879",
    d: "M251.437,247.232c-.673,1.759-5.894,1.4-11.663-.81s-9.9-5.423-9.226-7.181,5.894-1.4,11.663.811S252.11,245.473,251.437,247.232Z",
    transform: "translate(-229.607 -238.126)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73880",
    "data-name": "Path 73880",
    d: "M235.447,238.7s-4.423-.31-4.323,1.088,6.559,5.195,6.864,5.176c0,0-6.471-3.8-6.432-5.1S235.447,238.7,235.447,238.7Z",
    transform: "translate(-229.742 -238.24)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41480",
    "data-name": "Group 41480",
    transform: "translate(12.31 1.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73881",
    "data-name": "Path 73881",
    d: "M254.468,247.713c.673-1.758-3.457-4.975-9.226-7.181-.1-.038-.2-.071-.295-.108a66.412,66.412,0,0,1,4.9,8.3C252.327,249.007,254.1,248.685,254.468,247.713Z",
    transform: "translate(-244.947 -240.424)",
    fill: "#ffee2f"
  })))), _g246 || (_g246 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41485",
    "data-name": "Group 41485",
    transform: "translate(94.472 115.271)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41483",
    "data-name": "Group 41483",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_361",
    "data-name": "Line 361",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41482",
    "data-name": "Group 41482",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73882",
    "data-name": "Path 73882",
    d: "M210.087,240.8l15.535,1.973,3.327.421-.306,2.414c-.238,1.868-5.4,2.752-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-206.446 -240.376)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73883",
    "data-name": "Path 73883",
    d: "M206.842,239.778c-.236,1.867,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.013-10.665-4.792S207.08,237.91,206.842,239.778Z",
    transform: "translate(-206.527 -237.52)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73884",
    "data-name": "Path 73884",
    d: "M228.614,240.363s4.045,1.815,3.3,3-8.234,1.483-8.495,1.322c0,0,7.5-.291,8.078-1.459S228.614,240.363,228.614,240.363Z",
    transform: "translate(-210 -238.116)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41484",
    "data-name": "Group 41484",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73885",
    "data-name": "Path 73885",
    d: "M206.842,239.778c.238-1.868,5.4-2.754,11.524-1.975.1.013.206.03.311.045a66.416,66.416,0,0,0-8.239,5.006C208.119,241.93,206.711,240.812,206.842,239.778Z",
    transform: "translate(-206.833 -237.52)",
    fill: "#ffee2f"
  })))), _g247 || (_g247 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41489",
    "data-name": "Group 41489",
    transform: "translate(103.645 108.633)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41487",
    "data-name": "Group 41487",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_362",
    "data-name": "Line 362",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41486",
    "data-name": "Group 41486",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73886",
    "data-name": "Path 73886",
    d: "M221.691,232.4l15.535,1.972,3.327.421-.306,2.415c-.239,1.867-5.4,2.752-11.526,1.973s-10.9-2.923-10.663-4.792l.306-2.413Z",
    transform: "translate(-218.05 -231.978)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73887",
    "data-name": "Path 73887",
    d: "M218.446,231.38c-.236,1.869,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.013-10.665-4.791S218.684,229.513,218.446,231.38Z",
    transform: "translate(-218.131 -229.123)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73888",
    "data-name": "Path 73888",
    d: "M240.218,231.965s4.045,1.817,3.3,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.076-1.459S240.218,231.965,240.218,231.965Z",
    transform: "translate(-221.605 -229.718)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41488",
    "data-name": "Group 41488",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73889",
    "data-name": "Path 73889",
    d: "M218.446,231.38c.238-1.867,5.4-2.753,11.524-1.974.1.013.206.029.311.044a66.287,66.287,0,0,0-8.239,5.007C219.723,233.532,218.315,232.413,218.446,231.38Z",
    transform: "translate(-218.437 -229.123)",
    fill: "#ffdf2f"
  })))), _g248 || (_g248 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41493",
    "data-name": "Group 41493",
    transform: "translate(134.223 120.877)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41491",
    "data-name": "Group 41491",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_363",
    "data-name": "Line 363",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.962 9.107)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41490",
    "data-name": "Group 41490",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73890",
    "data-name": "Path 73890",
    d: "M275.429,252.814l-14.627-5.6-3.131-1.2-.87,2.274c-.673,1.758,3.458,4.973,9.227,7.181s10.989,2.568,11.663.809l.87-2.271Z",
    transform: "translate(-256.729 -246.019)",
    fill: "url(#radial-gradient-236)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73891",
    "data-name": "Path 73891",
    d: "M278.791,253.717c-.674,1.758-5.9,1.4-11.665-.811s-9.9-5.422-9.226-7.182,5.894-1.4,11.663.812S279.462,251.958,278.791,253.717Z",
    transform: "translate(-256.96 -244.611)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73892",
    "data-name": "Path 73892",
    d: "M262.8,245.182s-4.423-.308-4.323,1.088,6.559,5.195,6.864,5.176c0,0-6.47-3.8-6.432-5.1S262.8,245.182,262.8,245.182Z",
    transform: "translate(-257.095 -244.724)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41492",
    "data-name": "Group 41492",
    transform: "translate(12.31 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73893",
    "data-name": "Path 73893",
    d: "M281.822,254.2c.671-1.759-3.459-4.975-9.227-7.181-.1-.038-.2-.07-.295-.108a66.373,66.373,0,0,1,4.9,8.3C279.68,255.492,281.448,255.17,281.822,254.2Z",
    transform: "translate(-272.3 -246.91)",
    fill: "#ffee2f"
  })))), _g249 || (_g249 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41497",
    "data-name": "Group 41497",
    transform: "translate(116.096 120.399)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41495",
    "data-name": "Group 41495",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_364",
    "data-name": "Line 364",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41494",
    "data-name": "Group 41494",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73894",
    "data-name": "Path 73894",
    d: "M237.44,247.284l15.536,1.972,3.327.421L256,252.092c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.924-10.664-4.792l.307-2.413Z",
    transform: "translate(-233.799 -246.861)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73895",
    "data-name": "Path 73895",
    d: "M234.2,246.263c-.237,1.868,4.537,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.013-10.665-4.791S234.434,244.4,234.2,246.263Z",
    transform: "translate(-233.881 -244.006)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73896",
    "data-name": "Path 73896",
    d: "M255.967,246.849s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.077-1.459S255.967,246.849,255.967,246.849Z",
    transform: "translate(-237.354 -244.602)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41496",
    "data-name": "Group 41496",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73897",
    "data-name": "Path 73897",
    d: "M234.2,246.263c.238-1.867,5.4-2.753,11.523-1.974.105.013.207.03.311.043a66.456,66.456,0,0,0-8.239,5.007C235.473,248.415,234.064,247.3,234.2,246.263Z",
    transform: "translate(-234.187 -244.006)",
    fill: "#ffee2f"
  })))), _g250 || (_g250 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41501",
    "data-name": "Group 41501",
    transform: "translate(125.269 113.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41499",
    "data-name": "Group 41499",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_365",
    "data-name": "Line 365",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41498",
    "data-name": "Group 41498",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73898",
    "data-name": "Path 73898",
    d: "M249.044,238.886l15.536,1.972,3.327.421-.307,2.414c-.239,1.868-5.4,2.752-11.525,1.974s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-245.403 -238.463)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73899",
    "data-name": "Path 73899",
    d: "M245.8,237.865c-.236,1.869,4.537,4.014,10.664,4.792s11.288-.108,11.525-1.976-4.539-4.014-10.666-4.791S246.037,236,245.8,237.865Z",
    transform: "translate(-245.484 -235.608)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73900",
    "data-name": "Path 73900",
    d: "M267.572,238.451s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.292,8.078-1.459S267.572,238.451,267.572,238.451Z",
    transform: "translate(-248.958 -236.203)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41500",
    "data-name": "Group 41500",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73901",
    "data-name": "Path 73901",
    d: "M245.8,237.865c.238-1.867,5.4-2.754,11.523-1.974.105.013.206.031.311.044a66.445,66.445,0,0,0-8.238,5.007C247.076,240.017,245.668,238.9,245.8,237.865Z",
    transform: "translate(-245.79 -235.608)",
    fill: "#ffdf2f"
  })))), _g251 || (_g251 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41505",
    "data-name": "Group 41505",
    transform: "translate(103.726 124.972)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41503",
    "data-name": "Group 41503",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_366",
    "data-name": "Line 366",
    x1: 0.87,
    y2: 2.273,
    transform: "translate(20.961 9.105)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41502",
    "data-name": "Group 41502",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73902",
    "data-name": "Path 73902",
    d: "M236.852,257.993,222.225,252.4l-3.131-1.2-.87,2.273c-.674,1.759,3.458,4.975,9.227,7.181s10.989,2.57,11.662.811l.869-2.273Z",
    transform: "translate(-218.153 -251.199)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73903",
    "data-name": "Path 73903",
    d: "M240.214,258.9c-.673,1.76-5.9,1.4-11.663-.81s-9.9-5.423-9.226-7.182,5.894-1.395,11.662.811S240.887,257.138,240.214,258.9Z",
    transform: "translate(-218.383 -249.791)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73904",
    "data-name": "Path 73904",
    d: "M224.223,250.363s-4.423-.309-4.323,1.086,6.559,5.2,6.864,5.177c0,0-6.471-3.8-6.431-5.1S224.223,250.363,224.223,250.363Z",
    transform: "translate(-218.519 -249.905)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41504",
    "data-name": "Group 41504",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73905",
    "data-name": "Path 73905",
    d: "M243.244,259.378c.673-1.757-3.458-4.974-9.227-7.181-.1-.038-.2-.07-.295-.106a66.017,66.017,0,0,1,4.9,8.3C241.1,260.672,242.872,260.351,243.244,259.378Z",
    transform: "translate(-233.723 -252.091)",
    fill: "#ffee2f"
  })))), _g252 || (_g252 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41509",
    "data-name": "Group 41509",
    transform: "translate(85.599 124.494)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41507",
    "data-name": "Group 41507",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_367",
    "data-name": "Line 367",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41506",
    "data-name": "Group 41506",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73906",
    "data-name": "Path 73906",
    d: "M198.864,252.464l15.535,1.972,3.327.421-.307,2.414c-.238,1.867-5.4,2.753-11.525,1.973s-10.9-2.923-10.663-4.792l.307-2.413Z",
    transform: "translate(-195.223 -252.041)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73907",
    "data-name": "Path 73907",
    d: "M195.62,251.443c-.237,1.869,4.537,4.014,10.664,4.792s11.288-.108,11.524-1.976-4.538-4.013-10.665-4.791S195.857,249.576,195.62,251.443Z",
    transform: "translate(-195.305 -249.186)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73908",
    "data-name": "Path 73908",
    d: "M217.391,252.028s4.044,1.816,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.29,8.078-1.459S217.391,252.028,217.391,252.028Z",
    transform: "translate(-198.778 -249.781)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41508",
    "data-name": "Group 41508",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73909",
    "data-name": "Path 73909",
    d: "M195.62,251.443c.237-1.867,5.4-2.754,11.523-1.974.105.013.206.031.311.043a66.246,66.246,0,0,0-8.239,5.007C196.9,253.595,195.488,252.476,195.62,251.443Z",
    transform: "translate(-195.611 -249.186)",
    fill: "#ffee2f"
  })))), _g253 || (_g253 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41513",
    "data-name": "Group 41513",
    transform: "translate(94.772 117.854)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41511",
    "data-name": "Group 41511",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_368",
    "data-name": "Line 368",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41510",
    "data-name": "Group 41510",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73910",
    "data-name": "Path 73910",
    d: "M210.467,244.066,226,246.038l3.327.421-.307,2.414c-.238,1.868-5.4,2.752-11.526,1.974s-10.9-2.923-10.663-4.792l.307-2.414Z",
    transform: "translate(-206.826 -243.643)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73911",
    "data-name": "Path 73911",
    d: "M207.223,243.045c-.237,1.869,4.537,4.014,10.664,4.792s11.288-.108,11.525-1.976-4.538-4.014-10.665-4.791S207.461,241.177,207.223,243.045Z",
    transform: "translate(-206.908 -240.788)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73912",
    "data-name": "Path 73912",
    d: "M228.995,243.632s4.045,1.814,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.292,8.078-1.46S228.995,243.632,228.995,243.632Z",
    transform: "translate(-210.381 -241.383)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41512",
    "data-name": "Group 41512",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73913",
    "data-name": "Path 73913",
    d: "M207.223,243.045c.238-1.868,5.4-2.754,11.523-1.974.105.013.206.031.311.044a66.433,66.433,0,0,0-8.239,5.007C208.5,245.2,207.092,244.079,207.223,243.045Z",
    transform: "translate(-207.214 -240.788)",
    fill: "#ffdf2f"
  })))), _g254 || (_g254 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41517",
    "data-name": "Group 41517",
    transform: "translate(107.393 114.144)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41515",
    "data-name": "Group 41515",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_369",
    "data-name": "Line 369",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41514",
    "data-name": "Group 41514",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73914",
    "data-name": "Path 73914",
    d: "M241.49,244.3,226.863,238.7l-3.131-1.2-.869,2.273c-.674,1.76,3.457,4.975,9.227,7.181s10.989,2.569,11.662.81l.87-2.272Z",
    transform: "translate(-222.791 -237.503)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73915",
    "data-name": "Path 73915",
    d: "M244.852,245.2c-.674,1.758-5.9,1.4-11.664-.81s-9.9-5.423-9.226-7.182,5.9-1.395,11.663.811S245.524,243.442,244.852,245.2Z",
    transform: "translate(-223.021 -236.095)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73916",
    "data-name": "Path 73916",
    d: "M228.861,236.667s-4.423-.31-4.323,1.086,6.559,5.2,6.864,5.177c0,0-6.471-3.8-6.432-5.1S228.861,236.667,228.861,236.667Z",
    transform: "translate(-223.157 -236.208)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41516",
    "data-name": "Group 41516",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73917",
    "data-name": "Path 73917",
    d: "M247.882,245.682c.672-1.759-3.458-4.976-9.227-7.181-.1-.038-.2-.07-.295-.108a66.45,66.45,0,0,1,4.9,8.3C245.741,246.977,247.509,246.655,247.882,245.682Z",
    transform: "translate(-238.361 -238.393)",
    fill: "#ffee2f"
  })))), _g255 || (_g255 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41521",
    "data-name": "Group 41521",
    transform: "translate(89.265 113.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41519",
    "data-name": "Group 41519",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_370",
    "data-name": "Line 370",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41518",
    "data-name": "Group 41518",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73918",
    "data-name": "Path 73918",
    d: "M203.5,238.767l15.536,1.973,3.327.421-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.923-10.664-4.792l.307-2.414Z",
    transform: "translate(-199.86 -238.345)",
    fill: "url(#radial-gradient-2)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73919",
    "data-name": "Path 73919",
    d: "M200.257,237.747c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.108,11.524-1.976-4.538-4.014-10.665-4.791S200.495,235.88,200.257,237.747Z",
    transform: "translate(-199.942 -235.49)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73920",
    "data-name": "Path 73920",
    d: "M222.029,238.333s4.044,1.815,3.3,3-8.234,1.483-8.494,1.322c0,0,7.5-.291,8.078-1.459S222.029,238.333,222.029,238.333Z",
    transform: "translate(-203.415 -236.085)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41520",
    "data-name": "Group 41520",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73921",
    "data-name": "Path 73921",
    d: "M200.257,237.747c.238-1.867,5.4-2.754,11.523-1.974.105.013.207.03.311.044a66.273,66.273,0,0,0-8.24,5.006C201.533,239.9,200.126,238.781,200.257,237.747Z",
    transform: "translate(-200.248 -235.49)",
    fill: "#ffee2f"
  })))), _g256 || (_g256 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41525",
    "data-name": "Group 41525",
    transform: "translate(98.439 107.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41523",
    "data-name": "Group 41523",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_371",
    "data-name": "Line 371",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41522",
    "data-name": "Group 41522",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73922",
    "data-name": "Path 73922",
    d: "M215.1,230.369l15.537,1.973,3.327.421-.307,2.414c-.238,1.869-5.4,2.752-11.526,1.973s-10.9-2.923-10.663-4.792l.306-2.414Z",
    transform: "translate(-211.464 -229.946)",
    fill: "url(#radial-gradient-9)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73923",
    "data-name": "Path 73923",
    d: "M211.86,229.348c-.236,1.869,4.538,4.015,10.665,4.793s11.288-.107,11.525-1.976-4.538-4.013-10.666-4.792S212.1,227.481,211.86,229.348Z",
    transform: "translate(-211.545 -227.091)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73924",
    "data-name": "Path 73924",
    d: "M233.632,229.935s4.045,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.291,8.078-1.46S233.632,229.935,233.632,229.935Z",
    transform: "translate(-215.019 -227.687)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41524",
    "data-name": "Group 41524",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73925",
    "data-name": "Path 73925",
    d: "M211.86,229.348c.238-1.867,5.4-2.753,11.523-1.974.105.013.207.031.311.046a66.186,66.186,0,0,0-8.239,5C213.137,231.5,211.729,230.383,211.86,229.348Z",
    transform: "translate(-211.851 -227.091)",
    fill: "#ffdf2f"
  })))), _g257 || (_g257 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41529",
    "data-name": "Group 41529",
    transform: "translate(96.671 130.397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41527",
    "data-name": "Group 41527",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_372",
    "data-name": "Line 372",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41526",
    "data-name": "Group 41526",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73926",
    "data-name": "Path 73926",
    d: "M212.869,259.93l15.537,1.974,3.326.421-.307,2.415c-.237,1.866-5.4,2.751-11.525,1.972s-10.9-2.923-10.664-4.792l.307-2.413Z",
    transform: "translate(-209.228 -259.508)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73927",
    "data-name": "Path 73927",
    d: "M209.625,258.91c-.236,1.868,4.537,4.014,10.665,4.792s11.288-.108,11.524-1.975-4.538-4.014-10.665-4.792S209.863,257.042,209.625,258.91Z",
    transform: "translate(-209.31 -256.653)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73928",
    "data-name": "Path 73928",
    d: "M231.4,259.5s4.045,1.815,3.3,3-8.234,1.483-8.495,1.323c0,0,7.5-.29,8.078-1.459S231.4,259.5,231.4,259.5Z",
    transform: "translate(-212.783 -257.248)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41528",
    "data-name": "Group 41528",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73929",
    "data-name": "Path 73929",
    d: "M209.625,258.91c.238-1.868,5.4-2.753,11.524-1.974.1.013.206.03.311.045a66.347,66.347,0,0,0-8.24,5C210.9,261.063,209.494,259.944,209.625,258.91Z",
    transform: "translate(-209.616 -256.653)",
    fill: "#ffdf2f"
  })))), _g258 || (_g258 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41533",
    "data-name": "Group 41533",
    transform: "translate(132.865 132.811)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41531",
    "data-name": "Group 41531",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_373",
    "data-name": "Line 373",
    x1: 0.87,
    y2: 2.271,
    transform: "translate(20.961 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41530",
    "data-name": "Group 41530",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73930",
    "data-name": "Path 73930",
    d: "M273.71,267.91l-14.626-5.6-3.131-1.2-.87,2.273c-.674,1.759,3.459,4.973,9.227,7.181s10.99,2.569,11.662.809l.87-2.271Z",
    transform: "translate(-255.011 -261.115)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73931",
    "data-name": "Path 73931",
    d: "M277.072,268.813c-.673,1.759-5.9,1.4-11.664-.81s-9.9-5.423-9.225-7.182,5.894-1.4,11.663.812S277.745,267.054,277.072,268.813Z",
    transform: "translate(-255.241 -259.707)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73932",
    "data-name": "Path 73932",
    d: "M261.081,260.279s-4.422-.31-4.322,1.086,6.558,5.2,6.864,5.176c0,0-6.471-3.795-6.432-5.1S261.081,260.279,261.081,260.279Z",
    transform: "translate(-255.377 -259.82)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41532",
    "data-name": "Group 41532",
    transform: "translate(12.309 1.818)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73933",
    "data-name": "Path 73933",
    d: "M280.1,269.294c.673-1.759-3.458-4.975-9.226-7.181-.1-.039-.2-.071-.3-.108a66.162,66.162,0,0,1,4.9,8.3C277.961,270.588,279.729,270.267,280.1,269.294Z",
    transform: "translate(-270.581 -262.006)",
    fill: "#ffee2f"
  })))), _g259 || (_g259 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41537",
    "data-name": "Group 41537",
    transform: "translate(114.738 132.332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41535",
    "data-name": "Group 41535",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_374",
    "data-name": "Line 374",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41534",
    "data-name": "Group 41534",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73934",
    "data-name": "Path 73934",
    d: "M235.722,262.379l15.536,1.973,3.326.421-.307,2.414c-.238,1.867-5.4,2.754-11.524,1.974s-10.9-2.923-10.664-4.792l.306-2.414Z",
    transform: "translate(-232.081 -261.956)",
    fill: "url(#radial-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73935",
    "data-name": "Path 73935",
    d: "M232.477,261.358c-.236,1.869,4.538,4.014,10.665,4.793s11.286-.107,11.523-1.976-4.538-4.012-10.665-4.791S232.716,259.491,232.477,261.358Z",
    transform: "translate(-232.162 -259.101)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73936",
    "data-name": "Path 73936",
    d: "M254.249,261.945s4.045,1.814,3.3,3-8.234,1.484-8.495,1.323c0,0,7.5-.291,8.077-1.46S254.249,261.945,254.249,261.945Z",
    transform: "translate(-235.636 -259.697)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41536",
    "data-name": "Group 41536",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73937",
    "data-name": "Path 73937",
    d: "M232.477,261.358c.239-1.867,5.4-2.753,11.524-1.974.1.013.206.031.311.045a66.4,66.4,0,0,0-8.24,5.006C233.754,263.51,232.346,262.392,232.477,261.358Z",
    transform: "translate(-232.468 -259.101)",
    fill: "#ffee2f"
  })))), _g260 || (_g260 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41541",
    "data-name": "Group 41541",
    transform: "translate(123.911 125.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41539",
    "data-name": "Group 41539",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_375",
    "data-name": "Line 375",
    x1: 0.306,
    y2: 2.414,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41538",
    "data-name": "Group 41538",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73938",
    "data-name": "Path 73938",
    d: "M247.325,253.981l15.536,1.974,3.327.42-.308,2.414c-.238,1.869-5.4,2.753-11.525,1.975s-10.9-2.924-10.663-4.792l.306-2.414Z",
    transform: "translate(-243.685 -253.559)",
    fill: "url(#radial-gradient-4)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73939",
    "data-name": "Path 73939",
    d: "M244.081,252.961c-.237,1.868,4.538,4.014,10.665,4.792s11.288-.108,11.525-1.976-4.538-4.012-10.666-4.791S244.319,251.093,244.081,252.961Z",
    transform: "translate(-243.766 -250.703)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73940",
    "data-name": "Path 73940",
    d: "M265.853,253.547s4.044,1.815,3.3,3-8.234,1.484-8.494,1.323c0,0,7.5-.292,8.077-1.46S265.853,253.547,265.853,253.547Z",
    transform: "translate(-247.24 -251.299)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41540",
    "data-name": "Group 41540",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73941",
    "data-name": "Path 73941",
    d: "M244.081,252.961c.238-1.868,5.4-2.754,11.523-1.975.105.013.206.031.311.045a66.387,66.387,0,0,0-8.239,5.007C245.357,255.112,243.95,253.995,244.081,252.961Z",
    transform: "translate(-244.072 -250.703)",
    fill: "#ffdf2f"
  })))), _g261 || (_g261 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41545",
    "data-name": "Group 41545",
    transform: "translate(141.452 134.695)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41543",
    "data-name": "Group 41543",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_376",
    "data-name": "Line 376",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41542",
    "data-name": "Group 41542",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73942",
    "data-name": "Path 73942",
    d: "M269.514,265.367l15.536,1.974,3.326.421-.306,2.414c-.238,1.867-5.4,2.751-11.526,1.973s-10.9-2.923-10.662-4.792l.306-2.414Z",
    transform: "translate(-265.873 -264.945)",
    fill: "url(#radial-gradient-14)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73943",
    "data-name": "Path 73943",
    d: "M266.269,264.347c-.237,1.868,4.537,4.014,10.665,4.792s11.287-.107,11.523-1.975-4.539-4.014-10.665-4.792S266.507,262.48,266.269,264.347Z",
    transform: "translate(-265.954 -262.09)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73944",
    "data-name": "Path 73944",
    d: "M288.041,264.933s4.044,1.815,3.295,3-8.234,1.484-8.493,1.322c0,0,7.5-.29,8.077-1.459S288.041,264.933,288.041,264.933Z",
    transform: "translate(-269.427 -262.685)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41544",
    "data-name": "Group 41544",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73945",
    "data-name": "Path 73945",
    d: "M266.269,264.347c.238-1.867,5.4-2.754,11.523-1.974.105.013.206.03.311.044a66.277,66.277,0,0,0-8.24,5.007C267.546,266.5,266.138,265.38,266.269,264.347Z",
    transform: "translate(-266.26 -262.09)",
    fill: "#ffee2f"
  })))), _g262 || (_g262 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41549",
    "data-name": "Group 41549",
    transform: "translate(150.624 128.056)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41547",
    "data-name": "Group 41547",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_377",
    "data-name": "Line 377",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41546",
    "data-name": "Group 41546",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73946",
    "data-name": "Path 73946",
    d: "M281.116,256.969l15.538,1.973,3.326.422-.306,2.414c-.238,1.867-5.4,2.751-11.526,1.973s-10.9-2.923-10.664-4.792l.307-2.413Z",
    transform: "translate(-277.475 -256.547)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73947",
    "data-name": "Path 73947",
    d: "M277.872,255.949c-.237,1.868,4.537,4.015,10.665,4.792s11.288-.108,11.524-1.975-4.537-4.014-10.665-4.792S278.111,254.082,277.872,255.949Z",
    transform: "translate(-277.557 -253.692)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73948",
    "data-name": "Path 73948",
    d: "M299.644,256.534s4.045,1.817,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.078-1.459S299.644,256.534,299.644,256.534Z",
    transform: "translate(-281.03 -254.287)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41548",
    "data-name": "Group 41548",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73949",
    "data-name": "Path 73949",
    d: "M277.872,255.949c.239-1.867,5.4-2.753,11.523-1.974.105.013.207.03.311.044a66.288,66.288,0,0,0-8.24,5.007C279.149,258.1,277.741,256.983,277.872,255.949Z",
    transform: "translate(-277.863 -253.692)",
    fill: "#ffdf2f"
  })))), _g263 || (_g263 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41553",
    "data-name": "Group 41553",
    transform: "translate(139.963 123.106)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41551",
    "data-name": "Group 41551",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_378",
    "data-name": "Line 378",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41550",
    "data-name": "Group 41550",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73950",
    "data-name": "Path 73950",
    d: "M267.631,250.707l15.536,1.973,3.326.421-.306,2.414c-.238,1.868-5.4,2.753-11.526,1.974s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-263.99 -250.286)",
    fill: "url(#radial-gradient-23)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73951",
    "data-name": "Path 73951",
    d: "M264.387,249.688c-.237,1.867,4.537,4.013,10.665,4.792s11.287-.107,11.523-1.976-4.537-4.012-10.664-4.791S264.625,247.819,264.387,249.688Z",
    transform: "translate(-264.072 -247.43)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73952",
    "data-name": "Path 73952",
    d: "M286.158,250.273s4.045,1.815,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.291,8.078-1.459S286.158,250.273,286.158,250.273Z",
    transform: "translate(-267.545 -248.026)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41552",
    "data-name": "Group 41552",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73953",
    "data-name": "Path 73953",
    d: "M264.387,249.688c.238-1.869,5.4-2.754,11.524-1.975.1.013.206.03.311.043a66.355,66.355,0,0,0-8.24,5.008C265.664,251.84,264.256,250.72,264.387,249.688Z",
    transform: "translate(-264.378 -247.43)",
    fill: "#ffee2f"
  })))), _g264 || (_g264 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41557",
    "data-name": "Group 41557",
    transform: "translate(124.488 111.238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41555",
    "data-name": "Group 41555",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_379",
    "data-name": "Line 379",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.258)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41554",
    "data-name": "Group 41554",
    transform: "translate(0 2.258)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73954",
    "data-name": "Path 73954",
    d: "M248.055,235.7l15.537,1.974,3.327.421-.307,2.414c-.238,1.867-5.4,2.752-11.525,1.974s-10.9-2.924-10.663-4.792l.306-2.413Z",
    transform: "translate(-244.415 -235.274)",
    fill: "url(#radial-gradient-36)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73955",
    "data-name": "Path 73955",
    d: "M244.811,234.676c-.237,1.868,4.538,4.014,10.665,4.792s11.288-.107,11.524-1.975-4.538-4.013-10.665-4.792S245.049,232.807,244.811,234.676Z",
    transform: "translate(-244.496 -232.418)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73956",
    "data-name": "Path 73956",
    d: "M266.583,235.261s4.044,1.815,3.295,3-8.234,1.485-8.493,1.323c0,0,7.5-.29,8.078-1.459S266.583,235.261,266.583,235.261Z",
    transform: "translate(-247.969 -233.014)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41556",
    "data-name": "Group 41556",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73957",
    "data-name": "Path 73957",
    d: "M244.811,234.676c.238-1.869,5.4-2.753,11.523-1.975.105.013.206.03.311.044a66.246,66.246,0,0,0-8.24,5.007C246.088,236.828,244.68,235.708,244.811,234.676Z",
    transform: "translate(-244.802 -232.418)",
    fill: "#ffdf2f"
  })))), _g265 || (_g265 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41561",
    "data-name": "Group 41561",
    transform: "translate(139.494 133.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41559",
    "data-name": "Group 41559",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_380",
    "data-name": "Line 380",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41558",
    "data-name": "Group 41558",
    transform: "translate(0 2.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73958",
    "data-name": "Path 73958",
    d: "M267.037,264.4l15.536,1.972,3.327.422-.308,2.414c-.238,1.869-5.4,2.754-11.525,1.975s-10.9-2.924-10.664-4.792l.307-2.414Z",
    transform: "translate(-263.396 -263.98)",
    fill: "url(#radial-gradient-146)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73959",
    "data-name": "Path 73959",
    d: "M263.793,263.382c-.237,1.868,4.537,4.015,10.664,4.792s11.288-.108,11.525-1.975-4.539-4.014-10.666-4.791S264.031,261.515,263.793,263.382Z",
    transform: "translate(-263.478 -261.126)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73960",
    "data-name": "Path 73960",
    d: "M285.564,263.967s4.045,1.816,3.3,3-8.234,1.483-8.494,1.321c0,0,7.5-.29,8.076-1.459S285.564,263.967,285.564,263.967Z",
    transform: "translate(-266.951 -261.721)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41560",
    "data-name": "Group 41560",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73961",
    "data-name": "Path 73961",
    d: "M263.793,263.382c.238-1.867,5.4-2.753,11.523-1.973.105.012.206.029.311.043a66.338,66.338,0,0,0-8.239,5.007C265.07,265.534,263.662,264.417,263.793,263.382Z",
    transform: "translate(-263.784 -261.126)",
    fill: "#ffdf2f"
  })))), _g266 || (_g266 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41565",
    "data-name": "Group 41565",
    transform: "translate(112.272 145.504)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41563",
    "data-name": "Group 41563",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_381",
    "data-name": "Line 381",
    x2: 1.574,
    y2: 1.855,
    transform: "translate(0.283 14.926)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41562",
    "data-name": "Group 41562",
    transform: "translate(0.283 0.455)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73962",
    "data-name": "Path 73962",
    d: "M231.877,288.638l11.941-10.131,2.556-2.17,1.575,1.855c1.217,1.436-1.613,5.84-6.321,9.837s-9.514,6.071-10.732,4.633l-1.574-1.855Z",
    transform: "translate(-229.321 -276.337)",
    fill: "url(#radial-gradient-260)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73963",
    "data-name": "Path 73963",
    d: "M229.246,290.688c1.219,1.437,6.024-.639,10.733-4.634s7.537-8.4,6.319-9.837-6.024.64-10.734,4.636S228.027,289.252,229.246,290.688Z",
    transform: "translate(-228.963 -275.762)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73964",
    "data-name": "Path 73964",
    d: "M244.847,277.311s4.069-1.761,4.437-.41-4.46,7.079-4.754,7.161c0,0,4.841-5.728,4.373-6.945S244.847,277.311,244.847,277.311Z",
    transform: "translate(-232.223 -275.894)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41564",
    "data-name": "Group 41564",
    transform: "translate(0 4.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73965",
    "data-name": "Path 73965",
    d: "M229.246,291.984c-1.219-1.436,1.61-5.84,6.318-9.835.081-.069.163-.132.244-.2a66.184,66.184,0,0,0-1.866,9.458C231.7,292.5,229.92,292.779,229.246,291.984Z",
    transform: "translate(-228.963 -281.95)",
    fill: "#ffee2f"
  })))), _g267 || (_g267 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41569",
    "data-name": "Group 41569",
    transform: "translate(136.638 159.26)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41567",
    "data-name": "Group 41567",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_382",
    "data-name": "Line 382",
    x2: 1.089,
    y2: 2.175,
    transform: "translate(20.114 0.855)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41566",
    "data-name": "Group 41566",
    transform: "translate(0.117 0.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73966",
    "data-name": "Path 73966",
    d: "M276.931,295.747l-14,7.016-3,1.5,1.092,2.176c.846,1.684,6,.806,11.526-1.963s9.311-6.375,8.468-8.058l-1.089-2.176Z",
    transform: "translate(-259.932 -294.244)",
    fill: "url(#radial-gradient-261)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73967",
    "data-name": "Path 73967",
    d: "M279.9,294.018c.843,1.684-2.95,5.292-8.47,8.06s-10.683,3.645-11.528,1.961,2.951-5.292,8.472-8.059S279.054,292.336,279.9,294.018Z",
    transform: "translate(-259.784 -293.163)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73968",
    "data-name": "Path 73968",
    d: "M262.768,301.915s-3.212,3.056-2.113,3.922,8.259-1.333,8.449-1.572c0,0-7.166,2.214-8.1,1.3S262.768,301.915,262.768,301.915Z",
    transform: "translate(-259.919 -294.996)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41568",
    "data-name": "Group 41568",
    transform: "translate(8.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73969",
    "data-name": "Path 73969",
    d: "M282.1,294.018c-.845-1.681-6.006-.806-11.526,1.962-.1.048-.185.1-.279.145a66.513,66.513,0,0,1,9.434,1.988C281.61,296.472,282.566,294.95,282.1,294.018Z",
    transform: "translate(-270.296 -293.163)",
    fill: "#ffee2f"
  })))), _g268 || (_g268 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41573",
    "data-name": "Group 41573",
    transform: "translate(115.44 152.45)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41571",
    "data-name": "Group 41571",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_383",
    "data-name": "Line 383",
    x2: 1.089,
    y2: 2.175,
    transform: "translate(20.113 0.855)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41570",
    "data-name": "Group 41570",
    transform: "translate(0.118 0.855)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73970",
    "data-name": "Path 73970",
    d: "M250.118,287.131l-14,7.019-3,1.5,1.089,2.176c.844,1.682,6,.8,11.526-1.964s9.314-6.374,8.469-8.058l-1.089-2.176Z",
    transform: "translate(-233.119 -285.63)",
    fill: "url(#radial-gradient-262)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73971",
    "data-name": "Path 73971",
    d: "M253.083,285.4c.843,1.685-2.948,5.292-8.469,8.06s-10.684,3.644-11.526,1.961,2.948-5.292,8.47-8.06S252.239,283.721,253.083,285.4Z",
    transform: "translate(-232.97 -284.549)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73972",
    "data-name": "Path 73972",
    d: "M235.952,293.3s-3.214,3.055-2.115,3.922,8.259-1.332,8.453-1.572c0,0-7.169,2.214-8.106,1.306S235.952,293.3,235.952,293.3Z",
    transform: "translate(-233.104 -286.382)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41572",
    "data-name": "Group 41572",
    transform: "translate(8.309)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73973",
    "data-name": "Path 73973",
    d: "M255.285,285.4c-.844-1.682-6.005-.806-11.526,1.962l-.278.145a66.388,66.388,0,0,1,9.433,1.989C254.794,287.857,255.75,286.336,255.285,285.4Z",
    transform: "translate(-243.481 -284.549)",
    fill: "#ffee2f"
  })))), _g269 || (_g269 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41577",
    "data-name": "Group 41577",
    transform: "translate(127.732 150.176)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41575",
    "data-name": "Group 41575",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_384",
    "data-name": "Line 384",
    x2: 1.575,
    y2: 1.855,
    transform: "translate(0.283 14.927)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41574",
    "data-name": "Group 41574",
    transform: "translate(0.283 0.454)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73974",
    "data-name": "Path 73974",
    d: "M251.433,294.55l11.94-10.132,2.556-2.171L267.5,284.1c1.219,1.436-1.612,5.838-6.321,9.834s-9.512,6.071-10.731,4.636l-1.575-1.855Z",
    transform: "translate(-248.876 -282.247)",
    fill: "url(#radial-gradient-263)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73975",
    "data-name": "Path 73975",
    d: "M248.8,296.6c1.22,1.435,6.026-.64,10.734-4.637s7.537-8.4,6.319-9.836-6.023.641-10.733,4.637S247.584,295.163,248.8,296.6Z",
    transform: "translate(-248.518 -281.672)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73976",
    "data-name": "Path 73976",
    d: "M264.4,283.222s4.068-1.76,4.438-.41-4.463,7.077-4.758,7.162c0,0,4.845-5.728,4.375-6.947S264.4,283.222,264.4,283.222Z",
    transform: "translate(-251.779 -281.804)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41576",
    "data-name": "Group 41576",
    transform: "translate(0 4.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73977",
    "data-name": "Path 73977",
    d: "M248.8,297.9c-1.217-1.436,1.61-5.841,6.32-9.836.081-.069.162-.132.244-.2a66.108,66.108,0,0,0-1.867,9.458C251.251,298.4,249.476,298.69,248.8,297.9Z",
    transform: "translate(-248.518 -287.86)",
    fill: "#ffee2f"
  })))), _g270 || (_g270 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41581",
    "data-name": "Group 41581",
    transform: "translate(69.298 140.833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41579",
    "data-name": "Group 41579",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_385",
    "data-name": "Line 385",
    x1: 0.869,
    y2: 2.272,
    transform: "translate(20.962 9.106)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41578",
    "data-name": "Group 41578",
    transform: "translate(0 1.113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73978",
    "data-name": "Path 73978",
    d: "M193.3,278.057l-14.626-5.595-3.131-1.2-.87,2.273c-.673,1.76,3.458,4.975,9.227,7.181s10.989,2.569,11.662.81l.869-2.272Z",
    transform: "translate(-174.603 -271.263)",
    fill: "url(#radial-gradient-5)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73979",
    "data-name": "Path 73979",
    d: "M196.664,278.96c-.674,1.758-5.9,1.4-11.663-.81s-9.9-5.423-9.226-7.182,5.894-1.395,11.662.811S197.336,277.2,196.664,278.96Z",
    transform: "translate(-174.834 -269.855)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73980",
    "data-name": "Path 73980",
    d: "M180.674,270.426s-4.423-.309-4.324,1.087,6.559,5.2,6.864,5.177c0,0-6.471-3.8-6.431-5.1S180.674,270.426,180.674,270.426Z",
    transform: "translate(-174.969 -269.968)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41580",
    "data-name": "Group 41580",
    transform: "translate(12.309 1.817)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73981",
    "data-name": "Path 73981",
    d: "M199.694,279.442c.672-1.759-3.458-4.976-9.227-7.181-.1-.038-.2-.07-.295-.108a66.262,66.262,0,0,1,4.9,8.3C197.553,280.737,199.322,280.415,199.694,279.442Z",
    transform: "translate(-190.173 -272.153)",
    fill: "#ffee2f"
  })))), _g271 || (_g271 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41585",
    "data-name": "Group 41585",
    transform: "translate(28.044 126.756)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41583",
    "data-name": "Group 41583",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_386",
    "data-name": "Line 386",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.008 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41582",
    "data-name": "Group 41582",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73982",
    "data-name": "Path 73982",
    d: "M126.06,255.325,141.6,257.3l3.326.421-.306,2.414c-.238,1.867-5.4,2.752-11.525,1.972s-10.9-2.923-10.664-4.792l.306-2.413Z",
    transform: "translate(-122.419 -254.903)",
    fill: "url(#radial-gradient-21)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73983",
    "data-name": "Path 73983",
    d: "M122.815,254.3c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.107,11.523-1.975-4.537-4.014-10.665-4.792S123.053,252.437,122.815,254.3Z",
    transform: "translate(-122.5 -252.048)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73984",
    "data-name": "Path 73984",
    d: "M122.815,254.3c-.236,1.868,4.538,4.014,10.665,4.792s11.287-.107,11.523-1.975-4.537-4.014-10.665-4.792S123.053,252.437,122.815,254.3Z",
    transform: "translate(-122.5 -252.048)",
    fill: "#ffef5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73985",
    "data-name": "Path 73985",
    d: "M144.587,254.891s4.045,1.815,3.3,3-8.234,1.483-8.494,1.323c0,0,7.5-.29,8.077-1.459S144.587,254.891,144.587,254.891Z",
    transform: "translate(-125.974 -252.643)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41584",
    "data-name": "Group 41584",
    transform: "translate(0.306)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73986",
    "data-name": "Path 73986",
    d: "M122.815,254.3c.238-1.868,5.4-2.754,11.524-1.974.1.013.206.03.311.044a66.406,66.406,0,0,0-8.239,5.006C124.092,256.458,122.684,255.338,122.815,254.3Z",
    transform: "translate(-122.806 -252.048)",
    fill: "#ffdf2f"
  })))), _g272 || (_g272 = /*#__PURE__*/React.createElement("g", {
    id: "Group_41589",
    "data-name": "Group 41589",
    transform: "translate(90.302 94.482)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_41587",
    "data-name": "Group 41587",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_387",
    "data-name": "Line 387",
    x1: 0.306,
    y2: 2.413,
    transform: "translate(0.009 2.257)",
    fill: "#fdb916"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_41586",
    "data-name": "Group 41586",
    transform: "translate(0 2.257)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73987",
    "data-name": "Path 73987",
    d: "M204.813,214.5l15.535,1.974,3.327.421-.307,2.414c-.239,1.868-5.4,2.753-11.526,1.975s-10.9-2.924-10.663-4.792l.307-2.413Z",
    transform: "translate(-201.172 -214.078)",
    fill: "url(#radial-gradient-20)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_73988",
    "data-name": "Path 73988",
    d: "M201.569,213.48c-.237,1.867,4.537,4.014,10.664,4.792s11.288-.108,11.525-1.976-4.539-4.013-10.665-4.792S201.807,211.612,201.569,213.48Z",
    transform: "translate(-201.254 -211.223)",
    fill: "#fffb75"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73989",
    "data-name": "Path 73989",
    d: "M223.34,214.065s4.045,1.816,3.3,3-8.234,1.485-8.494,1.323c0,0,7.5-.29,8.078-1.459S223.34,214.065,223.34,214.065Z",
    transform: "translate(-204.726 -211.818)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_41588",
    "data-name": "Group 41588",
    transform: "translate(0.307)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_73990",
    "data-name": "Path 73990",
    d: "M201.569,213.48c.238-1.868,5.4-2.753,11.523-1.975l.311.045a66.188,66.188,0,0,0-8.239,5.007C202.845,215.632,201.438,214.513,201.569,213.48Z",
    transform: "translate(-201.56 -211.223)",
    fill: "#ffee2f"
  })))), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73991",
    "data-name": "Path 73991",
    d: "M180.178,323.861c.517-1.682-.147-3.378-1.482-3.788s-2.838.619-3.355,2.3a3.261,3.261,0,0,0,.647,3.286l-.7,2.273a.82.82,0,0,0,.542,1.025l.243.074a.82.82,0,0,0,1.025-.542l.7-2.273A3.264,3.264,0,0,0,180.178,323.861Z",
    transform: "translate(-105.423 -139.52)",
    fill: "#ebe4db"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73992",
    "data-name": "Path 73992",
    d: "M179.622,324.319a1.965,1.965,0,1,0-3.659-1.126,2.469,2.469,0,0,0,.489,2.486l-.529,1.719a.62.62,0,0,0,.41.775l.184.056a.62.62,0,0,0,.775-.41l.529-1.72A2.467,2.467,0,0,0,179.622,324.319Z",
    transform: "translate(-105.562 -139.814)",
    fill: "#404025"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73993",
    "data-name": "Path 73993",
    d: "M198.766,222.949c-3.651.341-5.209,1.977-4.82,4.82-.127-2.565-1.881-4.077-4.819-4.82,3.126-.04,4.553-1.832,4.819-4.819C194.081,221.393,195.635,223.059,198.766,222.949Z",
    transform: "translate(-108.347 -118.188)",
    fill: "#fff"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73994",
    "data-name": "Path 73994",
    d: "M280.244,213.146c-3.651.341-5.209,1.977-4.82,4.82-.128-2.565-1.881-4.077-4.819-4.82,3.126-.04,4.553-1.832,4.819-4.82C275.559,211.589,277.113,213.255,280.244,213.146Z",
    transform: "translate(-125.412 -116.134)",
    fill: "#fff"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73995",
    "data-name": "Path 73995",
    d: "M169.251,248.1c-3.65.341-5.209,1.977-4.82,4.819-.127-2.565-1.881-4.077-4.819-4.819,3.126-.041,4.553-1.833,4.819-4.82C164.566,246.546,166.12,248.212,169.251,248.1Z",
    transform: "translate(-102.166 -123.456)",
    fill: "#fff"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73996",
    "data-name": "Path 73996",
    d: "M228.3,263.419c-3.65.341-5.208,6.459-4.819,9.3-.128-2.565-1.881-8.559-4.82-9.3,3.126-.04,4.553-1.832,4.82-4.819C223.613,261.863,225.167,263.529,228.3,263.419Z",
    transform: "translate(-114.533 -126.664)",
    fill: "#fff"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    id: "Path_73997",
    "data-name": "Path 73997",
    d: "M305.8,259.833c-3.65.34-5.208,6.458-4.819,9.3-.128-2.565-1.881-8.559-4.82-9.3,3.126-.041,4.554-1.832,4.82-4.82C301.11,258.276,302.664,259.942,305.8,259.833Z",
    transform: "translate(-130.764 -125.913)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferImgeInvite);
export default __webpack_public_path__ + "static/media/referImgeInvite.e0cd4aa627a148626e2220647c0916ac.svg";
export { ForwardRef as ReactComponent };